export const townCodes = [
  {
    town: 'Abertamy',
    townCode: 554979,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36235,
    lat: 50.368855,
    long: 12.818377,
  },
  {
    town: 'Adamov',
    townCode: 535826,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 49.000624,
    long: 14.539603,
  },
  {
    town: 'Adamov',
    townCode: 581291,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67904,
    lat: 49.295708,
    long: 16.663955,
  },
  {
    town: 'Adamov',
    townCode: 531367,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.857917,
    long: 15.409018,
  },
  {
    town: 'Adršpach',
    townCode: 547786,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54957,
    lat: 50.624387,
    long: 16.083501,
  },
  {
    town: 'Albrechtice',
    townCode: 598925,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73543,
    lat: 49.786552,
    long: 18.524545,
  },
  {
    town: 'Albrechtice',
    townCode: 547981,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.927643,
    long: 16.644801,
  },
  {
    town: 'Albrechtice nad Orlicí',
    townCode: 576077,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51722,
    lat: 50.139886,
    long: 16.064472,
  },
  {
    town: 'Albrechtice nad Vltavou',
    townCode: 549258,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39816,
    lat: 49.253337,
    long: 14.302929,
  },
  {
    town: 'Albrechtice v Jizerských horách',
    townCode: 563528,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46843,
    lat: 50.7624,
    long: 15.275813,
  },
  {
    town: 'Albrechtičky',
    townCode: 568741,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74255,
    lat: 49.70179,
    long: 18.095627,
  },
  {
    town: 'Alojzov',
    townCode: 506761,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79804,
    lat: 49.423541,
    long: 17.041589,
  },
  {
    town: 'Andělská Hora',
    townCode: 538001,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36471,
    lat: 50.20449,
    long: 12.962918,
  },
  {
    town: 'Andělská Hora',
    townCode: 551929,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79331,
    lat: 50.060911,
    long: 17.389192,
  },
  {
    town: 'Anenská Studánka',
    townCode: 573426,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.849856,
    long: 16.54033,
  },
  {
    town: 'Archlebov',
    townCode: 586030,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69633,
    lat: 49.043689,
    long: 17.004911,
  },
  {
    town: 'Arneštovice',
    townCode: 509388,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.53161,
    long: 15.117873,
  },
  {
    town: 'Arnolec',
    townCode: 586854,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.436298,
    long: 15.823702,
  },
  {
    town: 'Arnoltice',
    townCode: 562343,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40714,
    lat: 50.837124,
    long: 14.264055,
  },
  {
    town: 'Aš',
    townCode: 554499,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35201,
    lat: 50.223983,
    long: 12.195113,
  },
  {
    town: 'Babice',
    townCode: 537241,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.024865,
    long: 14.237677,
  },
  {
    town: 'Babice',
    townCode: 590274,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67544,
    lat: 49.135413,
    long: 15.770586,
  },
  {
    town: 'Babice',
    townCode: 569828,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.192196,
    long: 15.585617,
  },
  {
    town: 'Babice',
    townCode: 552356,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.737929,
    long: 17.260966,
  },
  {
    town: 'Babice',
    townCode: 538043,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 50.008089,
    long: 14.715907,
  },
  {
    town: 'Babice',
    townCode: 592013,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68703,
    lat: 49.123859,
    long: 17.476827,
  },
  {
    town: 'Babice nad Svitavou',
    townCode: 582794,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66401,
    lat: 49.283402,
    long: 16.696235,
  },
  {
    town: 'Babice u Rosic',
    townCode: 582808,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.173078,
    long: 16.358273,
  },
  {
    town: 'Babylon',
    townCode: 553433,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.398761,
    long: 12.862893,
  },
  {
    town: 'Bácovice',
    townCode: 561118,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.455771,
    long: 15.158118,
  },
  {
    town: 'Bačalky',
    townCode: 553701,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.385047,
    long: 15.15353,
  },
  {
    town: 'Bačetín',
    townCode: 576085,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.299877,
    long: 16.233416,
  },
  {
    town: 'Bačice',
    townCode: 590282,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.081736,
    long: 16.027802,
  },
  {
    town: 'Bačkov',
    townCode: 546194,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.735384,
    long: 15.462118,
  },
  {
    town: 'Bačkovice',
    townCode: 544833,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.965699,
    long: 15.589,
  },
  {
    town: 'Bakov nad Jizerou',
    townCode: 535427,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29401,
    lat: 50.482406,
    long: 14.941596,
  },
  {
    town: 'Baliny',
    townCode: 595217,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.332666,
    long: 15.952501,
  },
  {
    town: 'Balkova Lhota',
    townCode: 563251,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.452124,
    long: 14.608319,
  },
  {
    town: 'Banín',
    townCode: 572560,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.665712,
    long: 16.46203,
  },
  {
    town: 'Bánov',
    townCode: 592021,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68754,
    lat: 48.988113,
    long: 17.717631,
  },
  {
    town: 'Báňovice',
    townCode: 562726,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.011855,
    long: 15.49034,
  },
  {
    town: 'Bantice',
    townCode: 593729,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.883187,
    long: 16.182493,
  },
  {
    town: 'Barchov',
    townCode: 569836,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.197698,
    long: 15.56774,
  },
  {
    town: 'Barchov',
    townCode: 574724,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.999411,
    long: 15.68091,
  },
  {
    town: 'Barchovice',
    townCode: 533173,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.944355,
    long: 14.969206,
  },
  {
    town: 'Bartošovice',
    townCode: 599212,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74254,
    lat: 49.66894,
    long: 18.054715,
  },
  {
    town: 'Bartošovice v Orlických horách',
    townCode: 576093,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51761,
    lat: 50.16408,
    long: 16.547862,
  },
  {
    town: 'Bartoušov',
    townCode: 548260,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.601128,
    long: 15.618547,
  },
  {
    town: 'Bařice-Velké Těšany',
    townCode: 588300,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.245527,
    long: 17.426201,
  },
  {
    town: 'Baška',
    townCode: 598011,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73901,
    lat: 49.645943,
    long: 18.372443,
  },
  {
    town: 'Bašnice',
    townCode: 572667,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.334576,
    long: 15.605129,
  },
  {
    town: 'Bašť',
    townCode: 538051,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25065,
    lat: 50.205242,
    long: 14.477405,
  },
  {
    town: 'Batelov',
    townCode: 586862,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.290179,
    long: 15.410734,
  },
  {
    town: 'Batňovice',
    townCode: 579041,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54237,
    lat: 50.517692,
    long: 16.03674,
  },
  {
    town: 'Bavorov',
    townCode: 550809,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.121951,
    long: 14.079028,
  },
  {
    town: 'Bavory',
    townCode: 584304,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69201,
    lat: 48.834789,
    long: 16.622349,
  },
  {
    town: 'Bavoryně',
    townCode: 534421,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.895907,
    long: 13.961126,
  },
  {
    town: 'Bdeněves',
    townCode: 566756,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33032,
    lat: 49.76964,
    long: 13.235291,
  },
  {
    town: 'Bdín',
    townCode: 565423,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.214245,
    long: 13.858851,
  },
  {
    town: 'Bečice',
    townCode: 536156,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.215784,
    long: 14.501318,
  },
  {
    town: 'Bečice',
    townCode: 563366,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39175,
    lat: 49.381437,
    long: 14.539787,
  },
  {
    town: 'Bečov',
    townCode: 567043,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43526,
    lat: 50.449824,
    long: 13.717955,
  },
  {
    town: 'Bečov nad Teplou',
    townCode: 554995,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36464,
    lat: 50.083561,
    long: 12.838429,
  },
  {
    town: 'Bečváry',
    townCode: 533181,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28143,
    lat: 49.956809,
    long: 15.079916,
  },
  {
    town: 'Bedihošť',
    townCode: 589268,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79821,
    lat: 49.448359,
    long: 17.166534,
  },
  {
    town: 'Bednárec',
    townCode: 562548,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.195339,
    long: 15.093296,
  },
  {
    town: 'Bednáreček',
    townCode: 561053,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.210179,
    long: 15.144034,
  },
  {
    town: 'Bedřichov',
    townCode: 581313,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.461276,
    long: 16.465422,
  },
  {
    town: 'Bedřichov',
    townCode: 563536,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46812,
    lat: 50.791188,
    long: 15.142571,
  },
  {
    town: 'Běhařov',
    townCode: 541842,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.344879,
    long: 13.160291,
  },
  {
    town: 'Běhařovice',
    townCode: 593737,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67139,
    lat: 49.004036,
    long: 16.078723,
  },
  {
    town: 'Běchary',
    townCode: 572675,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50732,
    lat: 50.31413,
    long: 15.292617,
  },
  {
    town: 'Bechlín',
    townCode: 564575,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41186,
    lat: 50.416252,
    long: 14.341026,
  },
  {
    town: 'Bechyně',
    townCode: 552054,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.295336,
    long: 14.468202,
  },
  {
    town: 'Bělá',
    townCode: 573566,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.754546,
    long: 15.240686,
  },
  {
    town: 'Bělá',
    townCode: 561126,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.312617,
    long: 15.260715,
  },
  {
    town: 'Bělá',
    townCode: 576972,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51401,
    lat: 50.534417,
    long: 15.445427,
  },
  {
    town: 'Bělá',
    townCode: 512974,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74723,
    lat: 49.972429,
    long: 18.144995,
  },
  {
    town: 'Bělá nad Radbuzou',
    townCode: 553441,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34526,
    lat: 49.591261,
    long: 12.717718,
  },
  {
    town: 'Bělá nad Svitavou',
    townCode: 572586,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56905,
    lat: 49.640287,
    long: 16.482734,
  },
  {
    town: 'Bělá pod Bezdězem',
    townCode: 535443,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29421,
    lat: 50.501314,
    long: 14.80429,
  },
  {
    town: 'Bělá pod Pradědem',
    townCode: 523917,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79001,
    lat: 50.164036,
    long: 17.196677,
  },
  {
    town: 'Bělá u Jevíčka',
    townCode: 505391,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.639593,
    long: 16.646009,
  },
  {
    town: 'Bělčice',
    townCode: 550817,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38743,
    lat: 49.502517,
    long: 13.875856,
  },
  {
    town: 'Běleč',
    townCode: 560448,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.543779,
    long: 14.837357,
  },
  {
    town: 'Běleč',
    townCode: 581321,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.434036,
    long: 16.383235,
  },
  {
    town: 'Běleč',
    townCode: 535010,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27363,
    lat: 50.056269,
    long: 13.993082,
  },
  {
    town: 'Běleč nad Orlicí',
    townCode: 569852,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50346,
    lat: 50.198081,
    long: 15.942805,
  },
  {
    town: 'Bělkovice-Lašťany',
    townCode: 500526,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78316,
    lat: 49.668757,
    long: 17.317289,
  },
  {
    town: 'Běloky',
    townCode: 532070,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27353,
    lat: 50.131539,
    long: 14.220862,
  },
  {
    town: 'Bělotín',
    townCode: 512231,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75364,
    lat: 49.5913,
    long: 17.806648,
  },
  {
    town: 'Bělov',
    townCode: 588318,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.21609,
    long: 17.484879,
  },
  {
    town: 'Bělušice',
    townCode: 533190,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.069172,
    long: 15.322001,
  },
  {
    town: 'Bělušice',
    townCode: 567051,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.449262,
    long: 13.762928,
  },
  {
    town: 'Benátky',
    townCode: 569861,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.310292,
    long: 15.736096,
  },
  {
    town: 'Benátky',
    townCode: 577774,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.854287,
    long: 16.326847,
  },
  {
    town: 'Benátky nad Jizerou',
    townCode: 535451,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29471,
    lat: 50.289261,
    long: 14.824612,
  },
  {
    town: 'Benecko',
    townCode: 576981,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51237,
    lat: 50.666433,
    long: 15.548272,
  },
  {
    town: 'Benešov',
    townCode: 581330,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67953,
    lat: 49.509531,
    long: 16.770698,
  },
  {
    town: 'Benešov',
    townCode: 529303,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.783882,
    long: 14.68747,
  },
  {
    town: 'Benešov nad Černou',
    townCode: 545406,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38282,
    lat: 48.729507,
    long: 14.627471,
  },
  {
    town: 'Benešov nad Ploučnicí',
    townCode: 562351,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40722,
    lat: 50.741692,
    long: 14.3125,
  },
  {
    town: 'Benešov u Semil',
    townCode: 576999,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51206,
    lat: 50.603258,
    long: 15.368478,
  },
  {
    town: 'Benešovice',
    townCode: 560723,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.726964,
    long: 12.901799,
  },
  {
    town: 'Benetice',
    townCode: 590304,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67506,
    lat: 49.297738,
    long: 15.867436,
  },
  {
    town: 'Beňov',
    townCode: 512281,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75002,
    lat: 49.41746,
    long: 17.501452,
  },
  {
    town: 'Bernardov',
    townCode: 531111,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 50.014231,
    long: 15.398668,
  },
  {
    town: 'Bernartice',
    townCode: 549266,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.368999,
    long: 14.381118,
  },
  {
    town: 'Bernartice',
    townCode: 579050,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54204,
    lat: 50.644783,
    long: 15.965926,
  },
  {
    town: 'Bernartice',
    townCode: 524891,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79057,
    lat: 50.389907,
    long: 17.078379,
  },
  {
    town: 'Bernartice',
    townCode: 532568,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.675666,
    long: 15.129249,
  },
  {
    town: 'Bernartice nad Odrou',
    townCode: 568481,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74101,
    lat: 49.610207,
    long: 17.947885,
  },
  {
    town: 'Beroun',
    townCode: 531057,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 49.967305,
    long: 14.086384,
  },
  {
    town: 'Běrunice',
    townCode: 537021,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28908,
    lat: 50.185843,
    long: 15.333694,
  },
  {
    town: 'Beřovice',
    townCode: 532088,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27371,
    lat: 50.269119,
    long: 14.12366,
  },
  {
    town: 'Besednice',
    townCode: 545414,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38281,
    lat: 48.790089,
    long: 14.556987,
  },
  {
    town: 'Běstovice',
    townCode: 553760,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.020237,
    long: 16.211026,
  },
  {
    town: 'Běstvina',
    townCode: 571181,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53845,
    lat: 49.837134,
    long: 15.595868,
  },
  {
    town: 'Běšiny',
    townCode: 555797,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.301709,
    long: 13.312677,
  },
  {
    town: 'Běštín',
    townCode: 531073,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.807406,
    long: 14.01634,
  },
  {
    town: 'Bezděčí u Trnávky',
    townCode: 574309,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.692503,
    long: 16.763539,
  },
  {
    town: 'Bezdědovice',
    townCode: 598895,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.444294,
    long: 13.880068,
  },
  {
    town: 'Bezděkov',
    townCode: 548430,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.732931,
    long: 15.730501,
  },
  {
    town: 'Bezděkov',
    townCode: 574741,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.008869,
    long: 15.644768,
  },
  {
    town: 'Bezděkov',
    townCode: 555801,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.3795,
    long: 13.297971,
  },
  {
    town: 'Bezděkov',
    townCode: 541095,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.824389,
    long: 13.596645,
  },
  {
    town: 'Bezděkov nad Metují',
    townCode: 573884,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54964,
    lat: 50.509838,
    long: 16.229341,
  },
  {
    town: 'Bezděkov pod Třemšínem',
    townCode: 529672,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.577203,
    long: 13.878564,
  },
  {
    town: 'Bezděz',
    townCode: 561398,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.533742,
    long: 14.722084,
  },
  {
    town: 'Bezdružice',
    townCode: 560740,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34953,
    lat: 49.906771,
    long: 12.971351,
  },
  {
    town: 'Bezkov',
    townCode: 593745,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.871321,
    long: 15.951352,
  },
  {
    town: 'Bezměrov',
    townCode: 588326,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.329903,
    long: 17.334894,
  },
  {
    town: 'Bezno',
    townCode: 535478,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29429,
    lat: 50.367388,
    long: 14.795726,
  },
  {
    town: 'Bezuchov',
    townCode: 512401,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.462827,
    long: 17.608881,
  },
  {
    town: 'Bezvěrov',
    townCode: 558656,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33041,
    lat: 49.995118,
    long: 13.059113,
  },
  {
    town: 'Bílá',
    townCode: 563901,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46343,
    lat: 50.664931,
    long: 15.035522,
  },
  {
    town: 'Bílá',
    townCode: 598020,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73915,
    lat: 49.442171,
    long: 18.453037,
  },
  {
    town: 'Bílá Hlína',
    townCode: 565750,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.532604,
    long: 14.925357,
  },
  {
    town: 'Bílá Lhota',
    townCode: 500623,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78321,
    lat: 49.709629,
    long: 16.97518,
  },
  {
    town: 'Bílá Třemešná',
    townCode: 579068,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54472,
    lat: 50.444749,
    long: 15.74112,
  },
  {
    town: 'Bílá Voda',
    townCode: 525227,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79069,
    lat: 50.442133,
    long: 16.916515,
  },
  {
    town: 'Bílčice',
    townCode: 597198,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79368,
    lat: 49.869715,
    long: 17.565611,
  },
  {
    town: 'Bílé Podolí',
    townCode: 533971,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28572,
    lat: 49.956586,
    long: 15.491127,
  },
  {
    town: 'Bílé Poličany',
    townCode: 579076,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54452,
    lat: 50.390894,
    long: 15.731985,
  },
  {
    town: 'Bílence',
    townCode: 562980,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.424657,
    long: 13.50601,
  },
  {
    town: 'Bílichov',
    townCode: 535125,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27374,
    lat: 50.262151,
    long: 13.916459,
  },
  {
    town: 'Bílina',
    townCode: 567451,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41801,
    lat: 50.548647,
    long: 13.775459,
  },
  {
    town: 'Bílkovice',
    townCode: 530743,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.759822,
    long: 14.861056,
  },
  {
    town: 'Bílov',
    townCode: 546984,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74301,
    lat: 49.73417,
    long: 18.001712,
  },
  {
    town: 'Bílov',
    townCode: 530239,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 50.017964,
    long: 13.42495,
  },
  {
    town: 'Bílovec',
    townCode: 599247,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74301,
    lat: 49.756486,
    long: 18.015919,
  },
  {
    town: 'Bílovice',
    townCode: 592030,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.099749,
    long: 17.549716,
  },
  {
    town: 'Bílovice nad Svitavou',
    townCode: 582824,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66401,
    lat: 49.247178,
    long: 16.672575,
  },
  {
    town: 'Bílovice-Lutotín',
    townCode: 589276,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79841,
    lat: 49.511097,
    long: 17.043319,
  },
  {
    town: 'Bílsko',
    townCode: 550833,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.159145,
    long: 14.059108,
  },
  {
    town: 'Bílsko',
    townCode: 552062,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78322,
    lat: 49.644661,
    long: 17.019776,
  },
  {
    town: 'Bílsko u Hořic',
    townCode: 548901,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.369489,
    long: 15.600604,
  },
  {
    town: 'Bílý Kámen',
    townCode: 586889,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58841,
    lat: 49.417417,
    long: 15.560205,
  },
  {
    town: 'Bílý Kostel nad Nisou',
    townCode: 563919,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46331,
    lat: 50.823246,
    long: 14.924507,
  },
  {
    town: 'Bílý Potok',
    townCode: 546631,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46362,
    lat: 50.873842,
    long: 15.222203,
  },
  {
    town: 'Bílý Újezd',
    townCode: 576107,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.238541,
    long: 16.22537,
  },
  {
    town: 'Biřkov',
    townCode: 578088,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.518156,
    long: 13.230256,
  },
  {
    town: 'Biskoupky',
    townCode: 582832,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.097789,
    long: 16.281386,
  },
  {
    town: 'Biskupice',
    townCode: 589284,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79812,
    lat: 49.459774,
    long: 17.236699,
  },
  {
    town: 'Biskupice',
    townCode: 573949,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53843,
    lat: 49.872861,
    long: 15.512907,
  },
  {
    town: 'Biskupice',
    townCode: 572519,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.647572,
    long: 16.758148,
  },
  {
    town: 'Biskupice',
    townCode: 585076,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76341,
    lat: 49.083208,
    long: 17.710527,
  },
  {
    town: 'Biskupice-Pulkov',
    townCode: 590312,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67558,
    lat: 49.038255,
    long: 16.009555,
  },
  {
    town: 'Bítouchov',
    townCode: 535486,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29401,
    lat: 50.475882,
    long: 14.889523,
  },
  {
    town: 'Bítov',
    townCode: 593753,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67110,
    lat: 48.936395,
    long: 15.729075,
  },
  {
    town: 'Bítov',
    townCode: 554936,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74301,
    lat: 49.800422,
    long: 18.047592,
  },
  {
    town: 'Bítovany',
    townCode: 505005,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53851,
    lat: 49.897307,
    long: 15.86473,
  },
  {
    town: 'Bítovčice',
    townCode: 586897,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58822,
    lat: 49.368136,
    long: 15.734153,
  },
  {
    town: 'Bitozeves',
    townCode: 565997,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.37326,
    long: 13.640793,
  },
  {
    town: 'Blanné',
    townCode: 593761,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67154,
    lat: 48.992037,
    long: 15.883346,
  },
  {
    town: 'Blansko',
    townCode: 581283,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67801,
    lat: 49.36495,
    long: 16.647855,
  },
  {
    town: 'Blatce',
    townCode: 561401,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.502986,
    long: 14.603251,
  },
  {
    town: 'Blatec',
    townCode: 500801,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78375,
    lat: 49.528444,
    long: 17.238673,
  },
  {
    town: 'Blatná',
    townCode: 550850,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.424993,
    long: 13.881864,
  },
  {
    town: 'Blatnice',
    townCode: 590321,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67551,
    lat: 49.070235,
    long: 15.871431,
  },
  {
    town: 'Blatnice',
    townCode: 558672,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33025,
    lat: 49.719824,
    long: 13.156096,
  },
  {
    town: 'Blatnice pod Svatým Antonínkem',
    townCode: 586048,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69671,
    lat: 48.946824,
    long: 17.466069,
  },
  {
    town: 'Blatnička',
    townCode: 586056,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69671,
    lat: 48.935609,
    long: 17.530151,
  },
  {
    town: 'Blatno',
    townCode: 562998,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.511799,
    long: 13.358172,
  },
  {
    town: 'Blatno',
    townCode: 566004,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43984,
    lat: 50.097026,
    long: 13.389809,
  },
  {
    town: 'Blazice',
    townCode: 542318,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.44257,
    long: 17.645401,
  },
  {
    town: 'Blažejov',
    townCode: 561711,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37852,
    lat: 49.142295,
    long: 15.096553,
  },
  {
    town: 'Blažejovice',
    townCode: 532380,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.619897,
    long: 15.200036,
  },
  {
    town: 'Blažim',
    townCode: 566764,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33038,
    lat: 49.916024,
    long: 13.047724,
  },
  {
    town: 'Blažim',
    townCode: 566012,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.40695,
    long: 13.628683,
  },
  {
    town: 'Blažkov',
    townCode: 595241,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.473174,
    long: 16.185267,
  },
  {
    town: 'Blažovice',
    townCode: 582841,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66408,
    lat: 49.165785,
    long: 16.786216,
  },
  {
    town: 'Blešno',
    townCode: 569879,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50346,
    lat: 50.214011,
    long: 15.930746,
  },
  {
    town: 'Blevice',
    townCode: 532100,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27328,
    lat: 50.209825,
    long: 14.236267,
  },
  {
    town: 'Blízkov',
    townCode: 595250,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59442,
    lat: 49.400584,
    long: 15.90881,
  },
  {
    town: 'Blížejov',
    townCode: 553450,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34545,
    lat: 49.500115,
    long: 12.989366,
  },
  {
    town: 'Blíževedly',
    townCode: 561410,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47104,
    lat: 50.608503,
    long: 14.396598,
  },
  {
    town: 'Blížkovice',
    townCode: 593770,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67155,
    lat: 48.999862,
    long: 15.834918,
  },
  {
    town: 'Blovice',
    townCode: 557587,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.582303,
    long: 13.540199,
  },
  {
    town: 'Blšany',
    townCode: 566021,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43988,
    lat: 50.217441,
    long: 13.471313,
  },
  {
    town: 'Blšany u Loun',
    townCode: 542547,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.347086,
    long: 13.852757,
  },
  {
    town: 'Blučina',
    townCode: 582859,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66456,
    lat: 49.055066,
    long: 16.644601,
  },
  {
    town: 'Bludov',
    townCode: 525588,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78961,
    lat: 49.941116,
    long: 16.928111,
  },
  {
    town: 'Bludov',
    townCode: 530964,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.807592,
    long: 15.255286,
  },
  {
    town: 'Bobnice',
    townCode: 537039,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28931,
    lat: 50.219681,
    long: 15.053622,
  },
  {
    town: 'Bobrová',
    townCode: 595268,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.482402,
    long: 16.118399,
  },
  {
    town: 'Bobrůvka',
    townCode: 595276,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.44874,
    long: 16.093912,
  },
  {
    town: 'Bocanovice',
    townCode: 511633,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73991,
    lat: 49.569174,
    long: 18.738514,
  },
  {
    town: 'Boháňka',
    townCode: 572705,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.365894,
    long: 15.708485,
  },
  {
    town: 'Boharyně',
    townCode: 569887,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50323,
    lat: 50.203911,
    long: 15.630961,
  },
  {
    town: 'Bohaté Málkovice',
    townCode: 592897,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.189126,
    long: 17.014284,
  },
  {
    town: 'Bohatice',
    townCode: 561428,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47002,
    lat: 50.669033,
    long: 14.679426,
  },
  {
    town: 'Bohdalec',
    townCode: 595284,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.474379,
    long: 16.05987,
  },
  {
    town: 'Bohdalice-Pavlovice',
    townCode: 592901,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68341,
    lat: 49.214143,
    long: 17.030228,
  },
  {
    town: 'Bohdalín',
    townCode: 547549,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39491,
    lat: 49.307781,
    long: 15.015943,
  },
  {
    town: 'Bohdalov',
    townCode: 595292,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59213,
    lat: 49.480764,
    long: 15.876542,
  },
  {
    town: 'Bohdalovice',
    townCode: 536253,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38101,
    lat: 48.74294,
    long: 14.286864,
  },
  {
    town: 'Bohdaneč',
    townCode: 533980,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28525,
    lat: 49.778273,
    long: 15.222656,
  },
  {
    town: 'Bohdašín',
    townCode: 576115,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.338561,
    long: 16.225153,
  },
  {
    town: 'Bohdíkov',
    townCode: 525804,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78964,
    lat: 50.010058,
    long: 16.904438,
  },
  {
    town: 'Bohostice',
    townCode: 564559,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.602243,
    long: 14.138233,
  },
  {
    town: 'Bohumilice',
    townCode: 550116,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38481,
    lat: 49.09618,
    long: 13.816441,
  },
  {
    town: 'Bohumín',
    townCode: 599051,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73581,
    lat: 49.904426,
    long: 18.357074,
  },
  {
    town: 'Bohunice',
    townCode: 537527,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.132496,
    long: 13.973287,
  },
  {
    town: 'Bohuňov',
    townCode: 595306,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.560508,
    long: 16.202547,
  },
  {
    town: 'Bohuňov',
    townCode: 577812,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.599198,
    long: 16.463955,
  },
  {
    town: 'Bohuňovice',
    townCode: 500852,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78314,
    lat: 49.663112,
    long: 17.287037,
  },
  {
    town: 'Bohuňovice',
    townCode: 577821,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.907982,
    long: 16.262964,
  },
  {
    town: 'Bohuslavice',
    townCode: 586901,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.14953,
    long: 15.575917,
  },
  {
    town: 'Bohuslavice',
    townCode: 573892,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54906,
    lat: 50.312731,
    long: 16.088688,
  },
  {
    town: 'Bohuslavice',
    townCode: 506192,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74719,
    lat: 49.942415,
    long: 18.128764,
  },
  {
    town: 'Bohuslavice',
    townCode: 589292,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79856,
    lat: 49.620952,
    long: 16.957654,
  },
  {
    town: 'Bohuslavice',
    townCode: 525880,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78972,
    lat: 49.826153,
    long: 16.940636,
  },
  {
    town: 'Bohuslavice nad Vláří',
    townCode: 557102,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.090273,
    long: 17.926421,
  },
  {
    town: 'Bohuslavice u Zlína',
    townCode: 585092,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76351,
    lat: 49.163201,
    long: 17.636864,
  },
  {
    town: 'Bohuslávky',
    townCode: 569178,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.555256,
    long: 17.567886,
  },
  {
    town: 'Bohušice',
    townCode: 550400,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67551,
    lat: 49.085207,
    long: 15.852226,
  },
  {
    town: 'Bohušov',
    townCode: 597201,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.243389,
    long: 17.713963,
  },
  {
    town: 'Bohušovice nad Ohří',
    townCode: 564591,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41156,
    lat: 50.493264,
    long: 14.150595,
  },
  {
    town: 'Bohutice',
    townCode: 593788,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67176,
    lat: 48.991375,
    long: 16.357739,
  },
  {
    town: 'Bohutín',
    townCode: 525979,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78962,
    lat: 49.953611,
    long: 16.882039,
  },
  {
    town: 'Bohutín',
    townCode: 539953,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26241,
    lat: 49.65562,
    long: 13.943995,
  },
  {
    town: 'Bohy',
    townCode: 566471,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.937892,
    long: 13.575531,
  },
  {
    town: 'Bochoř',
    townCode: 512532,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75002,
    lat: 49.421475,
    long: 17.428459,
  },
  {
    town: 'Bochov',
    townCode: 555029,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36471,
    lat: 50.151007,
    long: 13.045282,
  },
  {
    town: 'Bochovice',
    townCode: 590347,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.320924,
    long: 15.896424,
  },
  {
    town: 'Bojanov',
    townCode: 571202,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53826,
    lat: 49.841414,
    long: 15.704985,
  },
  {
    town: 'Bojanovice',
    townCode: 593796,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.968259,
    long: 15.989159,
  },
  {
    town: 'Bojanovice',
    townCode: 539104,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25206,
    lat: 49.854542,
    long: 14.352145,
  },
  {
    town: 'Bojiště',
    townCode: 568457,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.667888,
    long: 15.286899,
  },
  {
    town: 'Bojkovice',
    townCode: 592048,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68771,
    lat: 49.038744,
    long: 17.814983,
  },
  {
    town: 'Bolatice',
    townCode: 506214,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74723,
    lat: 49.951819,
    long: 18.08369,
  },
  {
    town: 'Boleboř',
    townCode: 563005,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43121,
    lat: 50.540271,
    long: 13.413447,
  },
  {
    town: 'Bolehošť',
    townCode: 576123,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51731,
    lat: 50.213724,
    long: 16.077076,
  },
  {
    town: 'Boleradice',
    townCode: 584321,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69112,
    lat: 48.966776,
    long: 16.814026,
  },
  {
    town: 'Bolešiny',
    townCode: 555835,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.410002,
    long: 13.361712,
  },
  {
    town: 'Boletice (vojenský újezd)',
    townCode: 545422,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38229,
    lat: 48.824975,
    long: 14.217435,
  },
  {
    town: 'Bolkov',
    townCode: 540463,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.533675,
    long: 13.223973,
  },
  {
    town: 'Boňkov',
    townCode: 573558,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58255,
    lat: 49.54715,
    long: 15.447573,
  },
  {
    town: 'Bor',
    townCode: 560758,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34802,
    lat: 49.711706,
    long: 12.775276,
  },
  {
    town: 'Bor u Skutče',
    townCode: 547867,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53944,
    lat: 49.822412,
    long: 16.127052,
  },
  {
    town: 'Borač',
    townCode: 595314,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59261,
    lat: 49.400915,
    long: 16.361217,
  },
  {
    town: 'Bordovice',
    townCode: 568431,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74401,
    lat: 49.546979,
    long: 18.152729,
  },
  {
    town: 'Boreč',
    townCode: 535508,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29426,
    lat: 50.407453,
    long: 14.732498,
  },
  {
    town: 'Borek',
    townCode: 544272,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37367,
    lat: 49.023491,
    long: 14.500984,
  },
  {
    town: 'Borek',
    townCode: 568465,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.791915,
    long: 15.590083,
  },
  {
    town: 'Borek',
    townCode: 548979,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50771,
    lat: 50.438962,
    long: 15.654346,
  },
  {
    town: 'Borek',
    townCode: 574783,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.127301,
    long: 15.856639,
  },
  {
    town: 'Borek',
    townCode: 534684,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.222684,
    long: 14.647521,
  },
  {
    town: 'Borkovany',
    townCode: 584339,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69175,
    lat: 49.028264,
    long: 16.810211,
  },
  {
    town: 'Borkovice',
    townCode: 552097,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.208048,
    long: 14.643532,
  },
  {
    town: 'Borohrádek',
    townCode: 576131,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51724,
    lat: 50.09787,
    long: 16.093365,
  },
  {
    town: 'Borotice',
    townCode: 593800,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.857391,
    long: 16.242711,
  },
  {
    town: 'Borotice',
    townCode: 539970,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26215,
    lat: 49.735072,
    long: 14.279808,
  },
  {
    town: 'Borotín',
    townCode: 552101,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39135,
    lat: 49.505132,
    long: 14.61307,
  },
  {
    town: 'Borotín',
    townCode: 581356,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67937,
    lat: 49.581447,
    long: 16.671585,
  },
  {
    town: 'Borová',
    townCode: 573906,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54701,
    lat: 50.386091,
    long: 16.253287,
  },
  {
    town: 'Borová',
    townCode: 577839,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56982,
    lat: 49.741782,
    long: 16.162337,
  },
  {
    town: 'Borová Lada',
    townCode: 545902,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38492,
    lat: 48.989939,
    long: 13.659961,
  },
  {
    town: 'Borovany',
    townCode: 544281,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37312,
    lat: 48.898704,
    long: 14.642367,
  },
  {
    town: 'Borovany',
    townCode: 598780,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.343099,
    long: 14.392567,
  },
  {
    town: 'Borovná',
    townCode: 587184,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.164698,
    long: 15.394712,
  },
  {
    town: 'Borovnice',
    townCode: 535681,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37007,
    lat: 48.912174,
    long: 14.519089,
  },
  {
    town: 'Borovnice',
    townCode: 595322,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59242,
    lat: 49.667328,
    long: 16.202654,
  },
  {
    town: 'Borovnice',
    townCode: 576140,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.063008,
    long: 16.245418,
  },
  {
    town: 'Borovnice',
    townCode: 579092,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54477,
    lat: 50.509256,
    long: 15.617294,
  },
  {
    town: 'Borovnice',
    townCode: 532096,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.648835,
    long: 15.018438,
  },
  {
    town: 'Borovnička',
    townCode: 548821,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54475,
    lat: 50.500964,
    long: 15.667313,
  },
  {
    town: 'Borovník',
    townCode: 595331,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59451,
    lat: 49.355656,
    long: 16.229456,
  },
  {
    town: 'Borovno',
    townCode: 566705,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33561,
    lat: 49.622087,
    long: 13.690481,
  },
  {
    town: 'Borovy',
    townCode: 542156,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.525208,
    long: 13.302442,
  },
  {
    town: 'Boršice',
    townCode: 592064,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68709,
    lat: 49.062643,
    long: 17.350953,
  },
  {
    town: 'Boršice u Blatnice',
    townCode: 592056,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68763,
    lat: 48.934962,
    long: 17.571104,
  },
  {
    town: 'Boršov',
    townCode: 586927,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.404043,
    long: 15.434297,
  },
  {
    town: 'Boršov nad Vltavou',
    townCode: 544299,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37382,
    lat: 48.921882,
    long: 14.434092,
  },
  {
    town: 'Borušov',
    townCode: 572632,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.780652,
    long: 16.740556,
  },
  {
    town: 'Bory',
    townCode: 595641,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59461,
    lat: 49.425865,
    long: 16.026282,
  },
  {
    town: 'Bořanovice',
    townCode: 538086,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25065,
    lat: 50.178336,
    long: 14.478857,
  },
  {
    town: 'Bořenovice',
    townCode: 549690,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.361618,
    long: 17.564472,
  },
  {
    town: 'Bořetice',
    townCode: 584347,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69108,
    lat: 48.913124,
    long: 16.853168,
  },
  {
    town: 'Bořetice',
    townCode: 561240,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.496166,
    long: 15.11005,
  },
  {
    town: 'Bořetín',
    townCode: 562742,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.189321,
    long: 15.211941,
  },
  {
    town: 'Bořetín',
    townCode: 509418,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39470,
    lat: 49.310234,
    long: 14.947722,
  },
  {
    town: 'Bořice',
    townCode: 571229,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.97695,
    long: 15.925435,
  },
  {
    town: 'Bořislav',
    townCode: 567469,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.579462,
    long: 13.929313,
  },
  {
    town: 'Bořitov',
    townCode: 581364,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67921,
    lat: 49.425135,
    long: 16.591291,
  },
  {
    town: 'Boseň',
    townCode: 535516,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.504204,
    long: 15.022906,
  },
  {
    town: 'Boskovice',
    townCode: 581372,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.487612,
    long: 16.660076,
  },
  {
    town: 'Boskovštejn',
    townCode: 593818,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67154,
    lat: 48.982797,
    long: 15.929654,
  },
  {
    town: 'Bošice',
    townCode: 550124,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38481,
    lat: 49.089388,
    long: 13.840431,
  },
  {
    town: 'Bošilec',
    townCode: 535401,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37365,
    lat: 49.149418,
    long: 14.646319,
  },
  {
    town: 'Bošín',
    townCode: 548006,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.034233,
    long: 16.203069,
  },
  {
    town: 'Bošovice',
    townCode: 592919,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68354,
    lat: 49.053609,
    long: 16.836868,
  },
  {
    town: 'Boudy',
    townCode: 562122,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.448057,
    long: 14.035591,
  },
  {
    town: 'Bousín',
    townCode: 589306,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79861,
    lat: 49.455207,
    long: 16.889847,
  },
  {
    town: 'Bousov',
    townCode: 571237,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53843,
    lat: 49.901849,
    long: 15.535529,
  },
  {
    town: 'Bouzov',
    townCode: 500861,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78325,
    lat: 49.704361,
    long: 16.892988,
  },
  {
    town: 'Bozkov',
    townCode: 577006,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51213,
    lat: 50.640171,
    long: 15.337206,
  },
  {
    town: 'Božanov',
    townCode: 573914,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54974,
    lat: 50.526878,
    long: 16.365391,
  },
  {
    town: 'Božejov',
    townCode: 547581,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39461,
    lat: 49.362207,
    long: 15.155899,
  },
  {
    town: 'Božetice',
    townCode: 549291,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.45123,
    long: 14.444001,
  },
  {
    town: 'Boží Dar',
    townCode: 506486,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36301,
    lat: 50.409844,
    long: 12.924571,
  },
  {
    town: 'Božice',
    townCode: 593826,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67164,
    lat: 48.836967,
    long: 16.288856,
  },
  {
    town: 'Božičany',
    townCode: 555045,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36225,
    lat: 50.258843,
    long: 12.769752,
  },
  {
    town: 'Bradáčov',
    townCode: 552127,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.490902,
    long: 14.871519,
  },
  {
    town: 'Brada-Rybníček',
    townCode: 549100,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.465297,
    long: 15.337606,
  },
  {
    town: 'Bradlec',
    townCode: 570788,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29306,
    lat: 50.451452,
    long: 14.910293,
  },
  {
    town: 'Bradlecká Lhota',
    townCode: 577014,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 50713,
    lat: 50.488672,
    long: 15.396332,
  },
  {
    town: 'Brambory',
    townCode: 530832,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.97825,
    long: 15.470316,
  },
  {
    town: 'Braňany',
    townCode: 567060,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43522,
    lat: 50.543055,
    long: 13.700283,
  },
  {
    town: 'Brandov',
    townCode: 567078,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43547,
    lat: 50.63211,
    long: 13.390831,
  },
  {
    town: 'Brandýs nad Labem - Stará Boleslav',
    townCode: 538094,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25001,
    lat: 50.186426,
    long: 14.659344,
  },
  {
    town: 'Brandýs nad Orlicí',
    townCode: 579947,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56112,
    lat: 50.002042,
    long: 16.285384,
  },
  {
    town: 'Brandýsek',
    townCode: 532118,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27341,
    lat: 50.18933,
    long: 14.162098,
  },
  {
    town: 'Branice',
    townCode: 549304,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.402569,
    long: 14.33964,
  },
  {
    town: 'Braníškov',
    townCode: 582875,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66471,
    lat: 49.294469,
    long: 16.345762,
  },
  {
    town: 'Branišov',
    townCode: 551490,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.978807,
    long: 14.395791,
  },
  {
    town: 'Branišovice',
    townCode: 593834,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67177,
    lat: 48.962911,
    long: 16.431951,
  },
  {
    town: 'Branka u Opavy',
    townCode: 554197,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74741,
    lat: 49.888057,
    long: 17.882754,
  },
  {
    town: 'Brankovice',
    townCode: 592927,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.156081,
    long: 17.134911,
  },
  {
    town: 'Branky',
    townCode: 541648,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75645,
    lat: 49.461056,
    long: 17.89306,
  },
  {
    town: 'Branná',
    townCode: 526169,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78825,
    lat: 50.15336,
    long: 17.011954,
  },
  {
    town: 'Branov',
    townCode: 541672,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.012981,
    long: 13.843021,
  },
  {
    town: 'Bransouze',
    townCode: 590363,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.302776,
    long: 15.751924,
  },
  {
    town: 'Brantice',
    townCode: 597210,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79393,
    lat: 50.063603,
    long: 17.629214,
  },
  {
    town: 'Branžež',
    townCode: 571946,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29402,
    lat: 50.507685,
    long: 15.058005,
  },
  {
    town: 'Braškov',
    townCode: 532126,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.102133,
    long: 14.100859,
  },
  {
    town: 'Bratčice',
    townCode: 582883,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66467,
    lat: 49.065247,
    long: 16.523184,
  },
  {
    town: 'Bratčice',
    townCode: 531286,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.855317,
    long: 15.430482,
  },
  {
    town: 'Bratkovice',
    townCode: 539988,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.740519,
    long: 13.999043,
  },
  {
    town: 'Bratronice',
    townCode: 537063,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.365361,
    long: 13.842454,
  },
  {
    town: 'Bratronice',
    townCode: 532142,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27363,
    lat: 50.067851,
    long: 14.014265,
  },
  {
    town: 'Bratrušov',
    townCode: 569437,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78701,
    lat: 50.009487,
    long: 16.949028,
  },
  {
    town: 'Bratřejov',
    townCode: 585106,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76312,
    lat: 49.222558,
    long: 17.913427,
  },
  {
    town: 'Bratřice',
    townCode: 547603,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.516554,
    long: 15.001328,
  },
  {
    town: 'Bratříkovice',
    townCode: 553107,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74752,
    lat: 49.932674,
    long: 17.687641,
  },
  {
    town: 'Bratřínov',
    townCode: 571199,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25205,
    lat: 49.842681,
    long: 14.340242,
  },
  {
    town: 'Bravantice',
    townCode: 556858,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74281,
    lat: 49.757218,
    long: 18.082863,
  },
  {
    town: 'Brázdim',
    townCode: 538108,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.183633,
    long: 14.58829,
  },
  {
    town: 'Bražec',
    townCode: 500101,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36471,
    lat: 50.172681,
    long: 13.046575,
  },
  {
    town: 'Brdy (vojenský újezd)',
    townCode: 539996,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.789268,
    long: 13.903243,
  },
  {
    town: 'Brloh',
    townCode: 545431,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38206,
    lat: 48.92998,
    long: 14.218667,
  },
  {
    town: 'Brloh',
    townCode: 574791,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.000688,
    long: 15.557385,
  },
  {
    town: 'Brňany',
    townCode: 564613,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.481073,
    long: 14.141967,
  },
  {
    town: 'Brněnec',
    townCode: 577863,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.627449,
    long: 16.522125,
  },
  {
    town: 'Brníčko',
    townCode: 530727,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78975,
    lat: 49.894982,
    long: 16.968308,
  },
  {
    town: 'Brnířov',
    townCode: 566136,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.382698,
    long: 13.04969,
  },
  {
    town: 'Brniště',
    townCode: 561444,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47129,
    lat: 50.729288,
    long: 14.703495,
  },
  {
    town: 'Brno',
    townCode: 582786,
    district: 'Brno-město',
    lau: 'CZ0642',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 60200,
    lat: 49.19516,
    long: 16.606937,
  },
  {
    town: 'Brod nad Dyjí',
    townCode: 584355,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69181,
    lat: 48.875309,
    long: 16.535482,
  },
  {
    town: 'Brod nad Tichou',
    townCode: 541605,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34815,
    lat: 49.835396,
    long: 12.741203,
  },
  {
    town: 'Brodce',
    townCode: 535559,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29473,
    lat: 50.33078,
    long: 14.86928,
  },
  {
    town: 'Brodec',
    townCode: 546895,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.295025,
    long: 13.801725,
  },
  {
    town: 'Brodek u Konice',
    townCode: 589314,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79846,
    lat: 49.548791,
    long: 16.83297,
  },
  {
    town: 'Brodek u Prostějova',
    townCode: 589322,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79807,
    lat: 49.370064,
    long: 17.090164,
  },
  {
    town: 'Brodek u Přerova',
    townCode: 512800,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75103,
    lat: 49.484289,
    long: 17.338354,
  },
  {
    town: 'Brodeslavy',
    townCode: 566489,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.953778,
    long: 13.557097,
  },
  {
    town: 'Broumov',
    townCode: 573922,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55001,
    lat: 50.585758,
    long: 16.331915,
  },
  {
    town: 'Broumov',
    townCode: 541401,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34815,
    lat: 49.889478,
    long: 12.606805,
  },
  {
    town: 'Broumy',
    townCode: 531081,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26742,
    lat: 49.955171,
    long: 13.852368,
  },
  {
    town: 'Brozany nad Ohří',
    townCode: 564621,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41181,
    lat: 50.453763,
    long: 14.145512,
  },
  {
    town: 'Brtnice',
    townCode: 586943,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58832,
    lat: 49.307047,
    long: 15.676522,
  },
  {
    town: 'Brtnička',
    townCode: 590371,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67527,
    lat: 49.237281,
    long: 15.624317,
  },
  {
    town: 'Brťov-Jeneč',
    townCode: 581381,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67921,
    lat: 49.413781,
    long: 16.517076,
  },
  {
    town: 'Brumov',
    townCode: 581402,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.462484,
    long: 16.425856,
  },
  {
    town: 'Brumov-Bylnice',
    townCode: 585114,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76331,
    lat: 49.092465,
    long: 18.022809,
  },
  {
    town: 'Brumovice',
    townCode: 584363,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69111,
    lat: 48.960895,
    long: 16.89626,
  },
  {
    town: 'Brumovice',
    townCode: 506320,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74771,
    lat: 50.015393,
    long: 17.749685,
  },
  {
    town: 'Bruntál',
    townCode: 597180,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.988277,
    long: 17.463794,
  },
  {
    town: 'Brusné',
    townCode: 588377,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.36344,
    long: 17.660807,
  },
  {
    town: 'Brušperk',
    townCode: 598038,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73944,
    lat: 49.700196,
    long: 18.222205,
  },
  {
    town: 'Bruzovice',
    townCode: 598046,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73936,
    lat: 49.717092,
    long: 18.409749,
  },
  {
    town: 'Brzánky',
    townCode: 546755,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.461941,
    long: 14.301296,
  },
  {
    town: 'Brzice',
    townCode: 573931,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55205,
    lat: 50.444489,
    long: 15.958411,
  },
  {
    town: 'Brzkov',
    townCode: 586951,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.526068,
    long: 15.72724,
  },
  {
    town: 'Břasy',
    townCode: 559725,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.837107,
    long: 13.578439,
  },
  {
    town: 'Břeclav',
    townCode: 584291,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69002,
    lat: 48.75324,
    long: 16.882617,
  },
  {
    town: 'Břehov',
    townCode: 536059,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.022388,
    long: 14.330668,
  },
  {
    town: 'Břehy',
    townCode: 574805,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.051994,
    long: 15.577582,
  },
  {
    town: 'Břest',
    townCode: 588385,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76823,
    lat: 49.351167,
    long: 17.440825,
  },
  {
    town: 'Břestek',
    townCode: 592072,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68708,
    lat: 49.094985,
    long: 17.356023,
  },
  {
    town: 'Břevnice',
    townCode: 548278,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.631361,
    long: 15.612697,
  },
  {
    town: 'Březejc',
    townCode: 595349,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.346399,
    long: 16.091562,
  },
  {
    town: 'Březí',
    townCode: 530018,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 26242,
    lat: 49.507873,
    long: 13.797583,
  },
  {
    town: 'Březí',
    townCode: 584371,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69181,
    lat: 48.819377,
    long: 16.567583,
  },
  {
    town: 'Březí',
    townCode: 595357,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59453,
    lat: 49.343279,
    long: 16.216045,
  },
  {
    town: 'Březí',
    townCode: 564869,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 50.014766,
    long: 14.699389,
  },
  {
    town: 'Březí nad Oslavou',
    townCode: 595365,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.502993,
    long: 15.935697,
  },
  {
    town: 'Březina',
    townCode: 507733,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.290639,
    long: 14.90976,
  },
  {
    town: 'Březina',
    townCode: 549070,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.434394,
    long: 15.313367,
  },
  {
    town: 'Březina',
    townCode: 577871,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56923,
    lat: 49.651038,
    long: 16.619713,
  },
  {
    town: 'Březina',
    townCode: 559733,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.807642,
    long: 13.596901,
  },
  {
    town: 'Březina',
    townCode: 535567,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29411,
    lat: 50.548647,
    long: 15.032901,
  },
  {
    town: 'Březina',
    townCode: 581429,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67905,
    lat: 49.282167,
    long: 16.755163,
  },
  {
    town: 'Březina',
    townCode: 582891,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.281698,
    long: 16.749623,
  },
  {
    town: 'Březina (vojenský újezd)',
    townCode: 592935,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 79805,
    lat: 49.368199,
    long: 16.960939,
  },
  {
    town: 'Březinky',
    townCode: 572250,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.662787,
    long: 16.78703,
  },
  {
    town: 'Březiny',
    townCode: 577898,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.690726,
    long: 16.118233,
  },
  {
    town: 'Březnice',
    townCode: 552135,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39171,
    lat: 49.251874,
    long: 14.514089,
  },
  {
    town: 'Březnice',
    townCode: 540013,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.557739,
    long: 13.950734,
  },
  {
    town: 'Březnice',
    townCode: 538744,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76001,
    lat: 49.184965,
    long: 17.656742,
  },
  {
    town: 'Březník',
    townCode: 590380,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67574,
    lat: 49.172155,
    long: 16.194204,
  },
  {
    town: 'Březno',
    townCode: 535583,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29406,
    lat: 50.406292,
    long: 15.005584,
  },
  {
    town: 'Březno',
    townCode: 563013,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43145,
    lat: 50.40228,
    long: 13.420942,
  },
  {
    town: 'Březolupy',
    townCode: 592081,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68713,
    lat: 49.121484,
    long: 17.580451,
  },
  {
    town: 'Březová',
    townCode: 537870,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.197494,
    long: 12.870986,
  },
  {
    town: 'Březová',
    townCode: 560294,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.145752,
    long: 12.643488,
  },
  {
    town: 'Březová',
    townCode: 506451,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74744,
    lat: 49.791678,
    long: 17.865664,
  },
  {
    town: 'Březová',
    townCode: 531090,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.904184,
    long: 13.883116,
  },
  {
    town: 'Březová',
    townCode: 592099,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68767,
    lat: 48.922188,
    long: 17.742769,
  },
  {
    town: 'Březová',
    townCode: 585131,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 48.923332,
    long: 17.741218,
  },
  {
    town: 'Březová nad Svitavou',
    townCode: 505145,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56902,
    lat: 49.644277,
    long: 16.518096,
  },
  {
    town: 'Březová-Oleško',
    townCode: 599735,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25245,
    lat: 49.904148,
    long: 14.411028,
  },
  {
    town: 'Březovice',
    townCode: 599514,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29424,
    lat: 50.470818,
    long: 14.733711,
  },
  {
    town: 'Březské',
    townCode: 595381,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59453,
    lat: 49.330018,
    long: 16.238271,
  },
  {
    town: 'Březsko',
    townCode: 589331,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79852,
    lat: 49.608693,
    long: 16.892539,
  },
  {
    town: 'Březůvky',
    townCode: 585149,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76345,
    lat: 49.153427,
    long: 17.699728,
  },
  {
    town: 'Břežany',
    townCode: 593842,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67165,
    lat: 48.870023,
    long: 16.341852,
  },
  {
    town: 'Břežany',
    townCode: 541923,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.348864,
    long: 13.61746,
  },
  {
    town: 'Břežany',
    townCode: 565041,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27034,
    lat: 50.00696,
    long: 13.582896,
  },
  {
    town: 'Břežany I',
    townCode: 533211,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.035026,
    long: 15.079055,
  },
  {
    town: 'Břežany II',
    townCode: 533220,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.093862,
    long: 14.804403,
  },
  {
    town: 'Břidličná',
    townCode: 597228,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79351,
    lat: 49.911767,
    long: 17.371179,
  },
  {
    town: 'Bříství',
    townCode: 537047,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28915,
    lat: 50.134028,
    long: 14.841845,
  },
  {
    town: 'Bříšťany',
    townCode: 548855,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.316342,
    long: 15.620923,
  },
  {
    town: 'Bříza',
    townCode: 564648,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.360615,
    long: 14.216366,
  },
  {
    town: 'Břvany',
    townCode: 566063,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.401253,
    long: 13.721648,
  },
  {
    town: 'Bublava',
    townCode: 560308,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35801,
    lat: 50.374494,
    long: 12.505287,
  },
  {
    town: 'Bubovice',
    townCode: 531103,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 49.969761,
    long: 14.166601,
  },
  {
    town: 'Bučí',
    townCode: 558699,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.885275,
    long: 13.302879,
  },
  {
    town: 'Bučina',
    townCode: 579963,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.896972,
    long: 16.192941,
  },
  {
    town: 'Bučovice',
    townCode: 592943,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.149402,
    long: 17.003981,
  },
  {
    town: 'Budčeves',
    townCode: 548952,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50732,
    lat: 50.308573,
    long: 15.254641,
  },
  {
    town: 'Budeč',
    townCode: 546020,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37892,
    lat: 49.087277,
    long: 15.589973,
  },
  {
    town: 'Budeč',
    townCode: 595390,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.53647,
    long: 15.912421,
  },
  {
    town: 'Budětice',
    townCode: 555894,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.283469,
    long: 13.58477,
  },
  {
    town: 'Budětsko',
    townCode: 589349,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79852,
    lat: 49.587129,
    long: 16.92698,
  },
  {
    town: 'Budíkov',
    townCode: 547638,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.579243,
    long: 15.362705,
  },
  {
    town: 'Budiměřice',
    townCode: 537055,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.195426,
    long: 15.098869,
  },
  {
    town: 'Budislav',
    townCode: 552143,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.293941,
    long: 14.837518,
  },
  {
    town: 'Budislav',
    townCode: 577910,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56965,
    lat: 49.801511,
    long: 16.174739,
  },
  {
    town: 'Budíškovice',
    townCode: 546038,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37891,
    lat: 49.076348,
    long: 15.531006,
  },
  {
    town: 'Budišov',
    townCode: 590401,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.271484,
    long: 16.003938,
  },
  {
    town: 'Budišov nad Budišovkou',
    townCode: 506460,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74787,
    lat: 49.79521,
    long: 17.629792,
  },
  {
    town: 'Budišovice',
    townCode: 568261,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74764,
    lat: 49.861418,
    long: 18.039719,
  },
  {
    town: 'Budkov',
    townCode: 561576,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.070156,
    long: 14.007074,
  },
  {
    town: 'Budkov',
    townCode: 590410,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67542,
    lat: 49.054591,
    long: 15.65903,
  },
  {
    town: 'Budyně',
    townCode: 560171,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.14606,
    long: 14.071176,
  },
  {
    town: 'Budyně nad Ohří',
    townCode: 564656,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41118,
    lat: 50.404377,
    long: 14.126018,
  },
  {
    town: 'Buchlovice',
    townCode: 592102,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68708,
    lat: 49.086371,
    long: 17.338628,
  },
  {
    town: 'Bujanov',
    townCode: 545449,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38241,
    lat: 48.702429,
    long: 14.429747,
  },
  {
    town: 'Bujesily',
    townCode: 559741,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.914681,
    long: 13.574492,
  },
  {
    town: 'Buk',
    townCode: 537519,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.038011,
    long: 13.845247,
  },
  {
    town: 'Buk',
    townCode: 512826,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75121,
    lat: 49.504545,
    long: 17.468822,
  },
  {
    town: 'Bukov',
    townCode: 595403,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.454403,
    long: 16.223666,
  },
  {
    town: 'Buková',
    townCode: 589357,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79848,
    lat: 49.509838,
    long: 16.829233,
  },
  {
    town: 'Buková',
    townCode: 546372,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33452,
    lat: 49.537495,
    long: 13.158861,
  },
  {
    town: 'Buková u Příbramě',
    townCode: 540021,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.755238,
    long: 14.066683,
  },
  {
    town: 'Bukovany',
    townCode: 586072,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69631,
    lat: 49.042267,
    long: 17.100961,
  },
  {
    town: 'Bukovany',
    townCode: 560316,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35755,
    lat: 50.166437,
    long: 12.572766,
  },
  {
    town: 'Bukovany',
    townCode: 552402,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.60536,
    long: 17.343594,
  },
  {
    town: 'Bukovany',
    townCode: 532924,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25741,
    lat: 49.822898,
    long: 14.624388,
  },
  {
    town: 'Bukovany',
    townCode: 564664,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.574617,
    long: 14.10264,
  },
  {
    town: 'Bukovec',
    townCode: 511935,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73984,
    lat: 49.556686,
    long: 18.821553,
  },
  {
    town: 'Bukovec',
    townCode: 553506,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.586461,
    long: 12.995414,
  },
  {
    town: 'Bukovice',
    townCode: 581437,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.406829,
    long: 16.489825,
  },
  {
    town: 'Bukovice',
    townCode: 547751,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54954,
    lat: 50.549647,
    long: 16.228038,
  },
  {
    town: 'Bukovina',
    townCode: 581445,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67905,
    lat: 49.297608,
    long: 16.773268,
  },
  {
    town: 'Bukovina nad Labem',
    townCode: 574813,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53352,
    lat: 50.12496,
    long: 15.823385,
  },
  {
    town: 'Bukovina u Čisté',
    townCode: 577031,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51401,
    lat: 50.542694,
    long: 15.58394,
  },
  {
    town: 'Bukovina u Přelouče',
    townCode: 574821,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.948338,
    long: 15.562977,
  },
  {
    town: 'Bukovinka',
    townCode: 581453,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67905,
    lat: 49.294279,
    long: 16.805039,
  },
  {
    town: 'Bukovka',
    townCode: 574830,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.101131,
    long: 15.625408,
  },
  {
    town: 'Bukovník',
    townCode: 530085,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.222588,
    long: 13.661427,
  },
  {
    town: 'Bukovno',
    townCode: 535605,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.446863,
    long: 14.840687,
  },
  {
    town: 'Bukvice',
    townCode: 573353,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.412586,
    long: 15.294637,
  },
  {
    town: 'Bulhary',
    townCode: 584380,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69189,
    lat: 48.831565,
    long: 16.748843,
  },
  {
    town: 'Bulovka',
    townCode: 563935,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.971244,
    long: 15.12367,
  },
  {
    town: 'Buřenice',
    townCode: 561312,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.552815,
    long: 15.066329,
  },
  {
    town: 'Buš',
    townCode: 540048,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25208,
    lat: 49.80341,
    long: 14.384043,
  },
  {
    town: 'Bušanovice',
    townCode: 550159,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.115542,
    long: 13.934788,
  },
  {
    town: 'Bušín',
    townCode: 532894,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78962,
    lat: 49.976227,
    long: 16.837978,
  },
  {
    town: 'Bušovice',
    townCode: 559750,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.795629,
    long: 13.534766,
  },
  {
    town: 'Buštěhrad',
    townCode: 532169,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27343,
    lat: 50.156043,
    long: 14.189083,
  },
  {
    town: 'Butoves',
    townCode: 549282,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.386551,
    long: 15.427515,
  },
  {
    town: 'Buzice',
    townCode: 529966,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.42273,
    long: 13.932715,
  },
  {
    town: 'Býčkovice',
    townCode: 546780,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.559879,
    long: 14.213625,
  },
  {
    town: 'Býchory',
    townCode: 533238,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.067727,
    long: 15.273572,
  },
  {
    town: 'Býkev',
    townCode: 534714,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27601,
    lat: 50.347271,
    long: 14.418129,
  },
  {
    town: 'Bykoš',
    townCode: 534145,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26701,
    lat: 49.883057,
    long: 14.063765,
  },
  {
    town: 'Býkovice',
    townCode: 581461,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.430303,
    long: 16.538385,
  },
  {
    town: 'Býkov-Láryšov',
    townCode: 569607,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79401,
    lat: 50.052449,
    long: 17.687486,
  },
  {
    town: 'Bylany',
    townCode: 571245,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53801,
    lat: 49.957375,
    long: 15.733261,
  },
  {
    town: 'Bynovec',
    townCode: 544647,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.820934,
    long: 14.264287,
  },
  {
    town: 'Bystrá',
    townCode: 561801,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.50857,
    long: 15.371288,
  },
  {
    town: 'Bystrá nad Jizerou',
    townCode: 577049,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.604834,
    long: 15.401976,
  },
  {
    town: 'Bystré',
    townCode: 576166,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.321556,
    long: 16.255333,
  },
  {
    town: 'Bystré',
    townCode: 577928,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56992,
    lat: 49.628557,
    long: 16.346893,
  },
  {
    town: 'Bystročice',
    townCode: 500879,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.536347,
    long: 17.193626,
  },
  {
    town: 'Bystrovany',
    townCode: 547026,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.597116,
    long: 17.323754,
  },
  {
    town: 'Bystřany',
    townCode: 567477,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41761,
    lat: 50.628776,
    long: 13.8643,
  },
  {
    town: 'Bystřec',
    townCode: 579971,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56154,
    lat: 50.011781,
    long: 16.619105,
  },
  {
    town: 'Bystřice',
    townCode: 572772,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.392983,
    long: 15.244218,
  },
  {
    town: 'Bystřice',
    townCode: 598062,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73995,
    lat: 49.63667,
    long: 18.720488,
  },
  {
    town: 'Bystřice',
    townCode: 529451,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25751,
    lat: 49.732235,
    long: 14.667506,
  },
  {
    town: 'Bystřice nad Pernštejnem',
    townCode: 595411,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.523046,
    long: 16.261571,
  },
  {
    town: 'Bystřice pod Hostýnem',
    townCode: 588393,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.399337,
    long: 17.674121,
  },
  {
    town: 'Bystřice pod Lopeníkem',
    townCode: 592111,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68755,
    lat: 48.974921,
    long: 17.764159,
  },
  {
    town: 'Bystřička',
    townCode: 541711,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75624,
    lat: 49.415411,
    long: 17.974099,
  },
  {
    town: 'Byšice',
    townCode: 534722,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27732,
    lat: 50.310544,
    long: 14.61147,
  },
  {
    town: 'Býškovice',
    townCode: 512877,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.467566,
    long: 17.714164,
  },
  {
    town: 'Býšovec',
    townCode: 595420,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.475308,
    long: 16.289398,
  },
  {
    town: 'Býšť',
    townCode: 574848,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53322,
    lat: 50.132532,
    long: 15.911265,
  },
  {
    town: 'Byzhradec',
    townCode: 576174,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.215939,
    long: 16.1903,
  },
  {
    town: 'Bzenec',
    townCode: 586081,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69681,
    lat: 48.973463,
    long: 17.266959,
  },
  {
    town: 'Bzová',
    townCode: 531120,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26743,
    lat: 49.897991,
    long: 13.862507,
  },
  {
    town: 'Bžany',
    townCode: 567485,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.589151,
    long: 13.879624,
  },
  {
    town: 'Cebiv',
    townCode: 560782,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34952,
    lat: 49.829449,
    long: 12.979175,
  },
  {
    town: 'Cehnice',
    townCode: 550906,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38752,
    lat: 49.215169,
    long: 14.029493,
  },
  {
    town: 'Cejle',
    townCode: 586978,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.3694,
    long: 15.472878,
  },
  {
    town: 'Cekov',
    townCode: 559768,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.821968,
    long: 13.763901,
  },
  {
    town: 'Cep',
    townCode: 509191,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 48.919602,
    long: 14.807457,
  },
  {
    town: 'Cerekvice nad Bystřicí',
    townCode: 572781,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50777,
    lat: 50.333348,
    long: 15.723633,
  },
  {
    town: 'Cerekvice nad Loučnou',
    townCode: 577936,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56953,
    lat: 49.898991,
    long: 16.215295,
  },
  {
    town: 'Cerekvička-Rosice',
    townCode: 586986,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58833,
    lat: 49.334875,
    long: 15.587278,
  },
  {
    town: 'Cerhenice',
    townCode: 533246,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28102,
    lat: 50.071376,
    long: 15.07214,
  },
  {
    town: 'Cerhonice',
    townCode: 549321,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.418097,
    long: 14.055739,
  },
  {
    town: 'Cerhovice',
    townCode: 531138,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26761,
    lat: 49.849643,
    long: 13.834934,
  },
  {
    town: 'Cetechovice',
    townCode: 588407,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76802,
    lat: 49.172391,
    long: 17.261484,
  },
  {
    town: 'Cetenov',
    townCode: 563943,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46348,
    lat: 50.644523,
    long: 14.917705,
  },
  {
    town: 'Cetkovice',
    townCode: 581470,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67938,
    lat: 49.578884,
    long: 16.721351,
  },
  {
    town: 'Cetoraz',
    townCode: 547662,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39411,
    lat: 49.455335,
    long: 14.957412,
  },
  {
    town: 'Cetyně',
    townCode: 564419,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.599728,
    long: 14.121455,
  },
  {
    town: 'Cidlina',
    townCode: 590428,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67544,
    lat: 49.128295,
    long: 15.735638,
  },
  {
    town: 'Cikháj',
    townCode: 588016,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59102,
    lat: 49.644947,
    long: 15.96749,
  },
  {
    town: 'Církvice',
    townCode: 599476,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28144,
    lat: 49.909456,
    long: 15.015818,
  },
  {
    town: 'Církvice',
    townCode: 533998,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28533,
    lat: 49.945703,
    long: 15.335153,
  },
  {
    town: 'Císařov',
    townCode: 569135,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75103,
    lat: 49.466135,
    long: 17.352711,
  },
  {
    town: 'Citice',
    townCode: 560324,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.162671,
    long: 12.61344,
  },
  {
    town: 'Cítoliby',
    townCode: 542571,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43902,
    lat: 50.332834,
    long: 13.812247,
  },
  {
    town: 'Citonice',
    townCode: 593851,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67101,
    lat: 48.884055,
    long: 15.964567,
  },
  {
    town: 'Citov',
    townCode: 512982,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75103,
    lat: 49.467819,
    long: 17.325561,
  },
  {
    town: 'Cítov',
    townCode: 534731,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27704,
    lat: 50.372354,
    long: 14.398243,
  },
  {
    town: 'Cizkrajov',
    townCode: 546054,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37881,
    lat: 49.03065,
    long: 15.389754,
  },
  {
    town: 'Cotkytle',
    townCode: 579980,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56132,
    lat: 49.936282,
    long: 16.72414,
  },
  {
    town: 'Crhov',
    townCode: 554162,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.545112,
    long: 16.434827,
  },
  {
    town: 'Ctětín',
    townCode: 571253,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53825,
    lat: 49.830355,
    long: 15.839524,
  },
  {
    town: 'Ctiboř',
    townCode: 579459,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.82733,
    long: 12.61012,
  },
  {
    town: 'Ctiboř',
    townCode: 532690,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.736767,
    long: 14.904302,
  },
  {
    town: 'Ctidružice',
    townCode: 593869,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67154,
    lat: 48.982616,
    long: 15.86009,
  },
  {
    town: 'Ctiměřice',
    townCode: 570991,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29446,
    lat: 50.377891,
    long: 14.993465,
  },
  {
    town: 'Ctiněves',
    townCode: 564672,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.374801,
    long: 14.307223,
  },
  {
    town: 'Cvikov',
    townCode: 561479,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47154,
    lat: 50.777293,
    long: 14.633019,
  },
  {
    town: 'Cvrčovice',
    townCode: 550272,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69123,
    lat: 48.993768,
    long: 16.514581,
  },
  {
    town: 'Cvrčovice',
    townCode: 532185,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27341,
    lat: 50.179896,
    long: 14.154895,
  },
  {
    town: 'Čachotín',
    townCode: 568490,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.695303,
    long: 15.608696,
  },
  {
    town: 'Čachovice',
    townCode: 535621,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29443,
    lat: 50.27557,
    long: 14.946032,
  },
  {
    town: 'Čachrov',
    townCode: 555941,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.265538,
    long: 13.302687,
  },
  {
    town: 'Čakov',
    townCode: 535541,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.980659,
    long: 14.307773,
  },
  {
    town: 'Čakov',
    townCode: 529478,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25724,
    lat: 49.825696,
    long: 14.836436,
  },
  {
    town: 'Čaková',
    townCode: 552003,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79316,
    lat: 50.051137,
    long: 17.548483,
  },
  {
    town: 'Čakovičky',
    townCode: 598291,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.231701,
    long: 14.531487,
  },
  {
    town: 'Čankovice',
    townCode: 571270,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.963804,
    long: 15.937395,
  },
  {
    town: 'Čáslav',
    townCode: 534005,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.910995,
    long: 15.390894,
  },
  {
    town: 'Čáslavice',
    townCode: 590436,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67524,
    lat: 49.152316,
    long: 15.772506,
  },
  {
    town: 'Čáslavsko',
    townCode: 547689,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.592512,
    long: 15.00285,
  },
  {
    town: 'Částkov',
    townCode: 560804,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34801,
    lat: 49.756077,
    long: 12.673799,
  },
  {
    town: 'Částkov',
    townCode: 592137,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.10453,
    long: 17.619917,
  },
  {
    town: 'Častohostice',
    townCode: 553964,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67602,
    lat: 49.014482,
    long: 15.819302,
  },
  {
    town: 'Častolovice',
    townCode: 576182,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51750,
    lat: 50.129194,
    long: 16.181387,
  },
  {
    town: 'Častrov',
    townCode: 547719,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39463,
    lat: 49.307899,
    long: 15.180392,
  },
  {
    town: 'Časy',
    townCode: 572799,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.069473,
    long: 15.898214,
  },
  {
    town: 'Čavisov',
    townCode: 569119,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74764,
    lat: 49.829577,
    long: 18.080797,
  },
  {
    town: 'Čebín',
    townCode: 582913,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66423,
    lat: 49.313339,
    long: 16.478018,
  },
  {
    town: 'Čečelice',
    townCode: 534749,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27732,
    lat: 50.294103,
    long: 14.618687,
  },
  {
    town: 'Čečelovice',
    townCode: 510068,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.374116,
    long: 13.794971,
  },
  {
    town: 'Čečkovice',
    townCode: 548375,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.784709,
    long: 15.664069,
  },
  {
    town: 'Čečovice',
    townCode: 566080,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.585171,
    long: 13.021847,
  },
  {
    town: 'Čehovice',
    townCode: 589365,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79821,
    lat: 49.43255,
    long: 17.175182,
  },
  {
    town: 'Čechočovice',
    townCode: 590444,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.202965,
    long: 15.793702,
  },
  {
    town: 'Čechtice',
    townCode: 529486,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.624128,
    long: 15.048346,
  },
  {
    town: 'Čechtín',
    townCode: 590452,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.293149,
    long: 15.819975,
  },
  {
    town: 'Čechy',
    townCode: 552771,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75115,
    lat: 49.429155,
    long: 17.534434,
  },
  {
    town: 'Čechy pod Kosířem',
    townCode: 589381,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79858,
    lat: 49.551061,
    long: 17.037775,
  },
  {
    town: 'Čejč',
    townCode: 586099,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69614,
    lat: 48.946631,
    long: 16.965214,
  },
  {
    town: 'Čejetice',
    townCode: 550922,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.25292,
    long: 14.020488,
  },
  {
    town: 'Čejkovice',
    townCode: 544329,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.014436,
    long: 14.383008,
  },
  {
    town: 'Čejkovice',
    townCode: 586102,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69615,
    lat: 48.906019,
    long: 16.942409,
  },
  {
    town: 'Čejkovice',
    townCode: 593877,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.877801,
    long: 16.287428,
  },
  {
    town: 'Čejkovice',
    townCode: 529524,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.791923,
    long: 15.349767,
  },
  {
    town: 'Čejov',
    townCode: 547735,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.565751,
    long: 15.379353,
  },
  {
    town: 'Čeladná',
    townCode: 598071,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73912,
    lat: 49.548829,
    long: 18.337697,
  },
  {
    town: 'Čelákovice',
    townCode: 538132,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25088,
    lat: 50.162803,
    long: 14.751089,
  },
  {
    town: 'Čelčice',
    townCode: 589390,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79823,
    lat: 49.412429,
    long: 17.19374,
  },
  {
    town: 'Čelechovice',
    townCode: 513059,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75103,
    lat: 49.510136,
    long: 17.372246,
  },
  {
    town: 'Čelechovice na Hané',
    townCode: 589403,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79816,
    lat: 49.516364,
    long: 17.093902,
  },
  {
    town: 'Čelistná',
    townCode: 529826,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.360262,
    long: 15.206421,
  },
  {
    town: 'Čeložnice',
    townCode: 586111,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69651,
    lat: 49.051964,
    long: 17.15476,
  },
  {
    town: 'Čeminy',
    townCode: 558711,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33033,
    lat: 49.80007,
    long: 13.253217,
  },
  {
    town: 'Čenkov',
    townCode: 540072,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.777803,
    long: 14.00086,
  },
  {
    town: 'Čenkov u Bechyně',
    townCode: 598976,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.233538,
    long: 14.500943,
  },
  {
    town: 'Čenkovice',
    townCode: 579998,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56164,
    lat: 50.011481,
    long: 16.682509,
  },
  {
    town: 'Čeperka',
    townCode: 574856,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.13312,
    long: 15.773339,
  },
  {
    town: 'Čepí',
    townCode: 574864,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53332,
    lat: 49.985238,
    long: 15.717675,
  },
  {
    town: 'Čepřovice',
    townCode: 550949,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38756,
    lat: 49.155339,
    long: 13.975181,
  },
  {
    town: 'Čeradice',
    townCode: 530581,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.308851,
    long: 13.494015,
  },
  {
    town: 'Čerčany',
    townCode: 529516,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25722,
    lat: 49.853032,
    long: 14.703093,
  },
  {
    town: 'Čermákovice',
    townCode: 593885,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67173,
    lat: 49.032153,
    long: 16.195072,
  },
  {
    town: 'Čermná',
    townCode: 579106,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54377,
    lat: 50.550083,
    long: 15.769729,
  },
  {
    town: 'Čermná',
    townCode: 553514,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.531701,
    long: 13.116707,
  },
  {
    town: 'Čermná nad Orlicí',
    townCode: 576191,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51725,
    lat: 50.080411,
    long: 16.144089,
  },
  {
    town: 'Čermná ve Slezsku',
    townCode: 569950,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74901,
    lat: 49.782431,
    long: 17.702213,
  },
  {
    town: 'Černá',
    townCode: 595438,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59442,
    lat: 49.426181,
    long: 15.86393,
  },
  {
    town: 'Černá Hora',
    townCode: 581496,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67921,
    lat: 49.413707,
    long: 16.581502,
  },
  {
    town: 'Černá u Bohdanče',
    townCode: 572896,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.05613,
    long: 15.671936,
  },
  {
    town: 'Černá v Pošumaví',
    townCode: 545457,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38223,
    lat: 48.738072,
    long: 14.110637,
  },
  {
    town: 'Černá Voda',
    townCode: 533491,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79054,
    lat: 50.308312,
    long: 17.1471,
  },
  {
    town: 'Černava',
    townCode: 538019,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36221,
    lat: 50.291365,
    long: 12.711084,
  },
  {
    town: 'Černčice',
    townCode: 573957,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.335841,
    long: 16.102688,
  },
  {
    town: 'Černčice',
    townCode: 542628,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43901,
    lat: 50.361485,
    long: 13.845324,
  },
  {
    town: 'Černé Voděrady',
    townCode: 533254,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.941659,
    long: 14.80689,
  },
  {
    town: 'Černěves',
    townCode: 546852,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.454495,
    long: 14.243217,
  },
  {
    town: 'Černíč',
    townCode: 587001,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.127972,
    long: 15.45943,
  },
  {
    town: 'Černíkov',
    townCode: 553531,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.422778,
    long: 13.13013,
  },
  {
    town: 'Černíkovice',
    townCode: 576204,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51704,
    lat: 50.186688,
    long: 16.207062,
  },
  {
    town: 'Černíkovice',
    townCode: 566632,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.975551,
    long: 13.56701,
  },
  {
    town: 'Černíky',
    townCode: 599301,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28915,
    lat: 50.102118,
    long: 14.820104,
  },
  {
    town: 'Černilov',
    townCode: 569917,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50343,
    lat: 50.262743,
    long: 15.922644,
  },
  {
    town: 'Černín',
    townCode: 593893,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.983053,
    long: 16.021013,
  },
  {
    town: 'Černíny',
    townCode: 534013,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.840116,
    long: 15.218931,
  },
  {
    town: 'Černiv',
    townCode: 564699,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.445046,
    long: 14.059049,
  },
  {
    town: 'Černolice',
    townCode: 539121,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.90979,
    long: 14.299358,
  },
  {
    town: 'Černošice',
    townCode: 539139,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25228,
    lat: 49.960184,
    long: 14.319902,
  },
  {
    town: 'Černošín',
    townCode: 560812,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34958,
    lat: 49.816245,
    long: 12.883925,
  },
  {
    town: 'Černotín',
    townCode: 513067,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75368,
    lat: 49.531975,
    long: 17.772231,
  },
  {
    town: 'Černouček',
    townCode: 542423,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.360924,
    long: 14.307446,
  },
  {
    town: 'Černousy',
    townCode: 545996,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46373,
    lat: 51.004564,
    long: 15.050573,
  },
  {
    town: 'Černov',
    townCode: 561142,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.344066,
    long: 15.314148,
  },
  {
    town: 'Černovice',
    townCode: 581500,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67975,
    lat: 49.48363,
    long: 16.423018,
  },
  {
    town: 'Černovice',
    townCode: 547760,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39494,
    lat: 49.372757,
    long: 14.960993,
  },
  {
    town: 'Černovice',
    townCode: 566098,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.615661,
    long: 12.99704,
  },
  {
    town: 'Černovice',
    townCode: 563021,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.447783,
    long: 13.359354,
  },
  {
    town: 'Čerňovice',
    townCode: 530328,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33036,
    lat: 49.813006,
    long: 13.103784,
  },
  {
    town: 'Černožice',
    townCode: 569925,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50304,
    lat: 50.318732,
    long: 15.874133,
  },
  {
    town: 'Černuc',
    townCode: 532207,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27323,
    lat: 50.301245,
    long: 14.202603,
  },
  {
    town: 'Černvír',
    townCode: 595446,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59262,
    lat: 49.445413,
    long: 16.346286,
  },
  {
    town: 'Černý Důl',
    townCode: 579114,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54344,
    lat: 50.635059,
    long: 15.710701,
  },
  {
    town: 'Černýšovice',
    townCode: 563722,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.325232,
    long: 14.520546,
  },
  {
    town: 'Červená Hora',
    townCode: 505099,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54941,
    lat: 50.450166,
    long: 16.058927,
  },
  {
    town: 'Červená Lhota',
    townCode: 590461,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.284564,
    long: 15.806208,
  },
  {
    town: 'Červená Řečice',
    townCode: 547778,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39446,
    lat: 49.511334,
    long: 15.178468,
  },
  {
    town: 'Červená Třemešná',
    townCode: 548995,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.39943,
    long: 15.643602,
  },
  {
    town: 'Červená Voda',
    townCode: 580015,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56161,
    lat: 50.040389,
    long: 16.742787,
  },
  {
    town: 'Červené Janovice',
    townCode: 534021,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28542,
    lat: 49.834712,
    long: 15.253438,
  },
  {
    town: 'Červené Pečky',
    townCode: 533262,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28121,
    lat: 49.978318,
    long: 15.208666,
  },
  {
    town: 'Červené Poříčí',
    townCode: 542172,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.501992,
    long: 13.294553,
  },
  {
    town: 'Červenka',
    townCode: 552186,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78401,
    lat: 49.718889,
    long: 17.083808,
  },
  {
    town: 'Červený Hrádek',
    townCode: 509116,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.122981,
    long: 15.539027,
  },
  {
    town: 'Červený Kostelec',
    townCode: 573965,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54941,
    lat: 50.476361,
    long: 16.093,
  },
  {
    town: 'Červený Újezd',
    townCode: 529532,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25788,
    lat: 49.555506,
    long: 14.604165,
  },
  {
    town: 'Červený Újezd',
    townCode: 532215,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.069809,
    long: 14.166017,
  },
  {
    town: 'Česká',
    townCode: 582921,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66431,
    lat: 49.280178,
    long: 16.56551,
  },
  {
    town: 'Česká Bělá',
    townCode: 568503,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58261,
    lat: 49.643015,
    long: 15.691066,
  },
  {
    town: 'Česká Bříza',
    townCode: 558745,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.828513,
    long: 13.429819,
  },
  {
    town: 'Česká Čermná',
    townCode: 573973,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54921,
    lat: 50.400822,
    long: 16.229527,
  },
  {
    town: 'Česká Kamenice',
    townCode: 562394,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40721,
    lat: 50.797908,
    long: 14.417784,
  },
  {
    town: 'Česká Kubice',
    townCode: 553549,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34532,
    lat: 49.369488,
    long: 12.858904,
  },
  {
    town: 'Česká Lípa',
    townCode: 561380,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47001,
    lat: 50.67862,
    long: 14.539799,
  },
  {
    town: 'Česká Metuje',
    townCode: 573981,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54956,
    lat: 50.545672,
    long: 16.180328,
  },
  {
    town: 'Česká Rybná',
    townCode: 580023,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56185,
    lat: 50.071923,
    long: 16.392345,
  },
  {
    town: 'Česká Skalice',
    townCode: 573990,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55203,
    lat: 50.394767,
    long: 16.042868,
  },
  {
    town: 'Česká Třebová',
    townCode: 580031,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56002,
    lat: 49.901982,
    long: 16.447385,
  },
  {
    town: 'Česká Ves',
    townCode: 569356,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79081,
    lat: 50.257454,
    long: 17.228153,
  },
  {
    town: 'ČESKÉ BUDĚJOVICE',
    townCode: 544256,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.975758,
    long: 14.480355,
  },
  {
    town: 'České Heřmanice',
    townCode: 580040,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56552,
    lat: 49.931529,
    long: 16.253203,
  },
  {
    town: 'České Lhotice',
    townCode: 571296,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53825,
    lat: 49.847036,
    long: 15.777938,
  },
  {
    town: 'České Libchavy',
    townCode: 580058,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56114,
    lat: 50.029927,
    long: 16.371803,
  },
  {
    town: 'České Meziříčí',
    townCode: 576212,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.286898,
    long: 16.044385,
  },
  {
    town: 'České Petrovice',
    townCode: 580066,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.119374,
    long: 16.605474,
  },
  {
    town: 'České Velenice',
    townCode: 546089,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37810,
    lat: 48.768608,
    long: 14.963775,
  },
  {
    town: 'Český Brod',
    townCode: 533271,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.074304,
    long: 14.860919,
  },
  {
    town: 'Český Dub',
    townCode: 563960,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46343,
    lat: 50.661116,
    long: 14.996287,
  },
  {
    town: 'Český Jiřetín',
    townCode: 567108,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43601,
    lat: 50.70759,
    long: 13.547489,
  },
  {
    town: 'Český Krumlov',
    townCode: 545392,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38101,
    lat: 48.812835,
    long: 14.317566,
  },
  {
    town: 'Český Rudolec',
    townCode: 546097,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37883,
    lat: 49.068454,
    long: 15.324472,
  },
  {
    town: 'Český Šternberk',
    townCode: 529541,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.810991,
    long: 14.928256,
  },
  {
    town: 'Český Těšín',
    townCode: 598933,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73701,
    lat: 49.747144,
    long: 18.623896,
  },
  {
    town: 'Čestice',
    townCode: 550957,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.167929,
    long: 13.8038,
  },
  {
    town: 'Čestice',
    townCode: 576221,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.127918,
    long: 16.145832,
  },
  {
    town: 'Čestín',
    townCode: 534030,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28510,
    lat: 49.807713,
    long: 15.104503,
  },
  {
    town: 'Čestlice',
    townCode: 538141,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 50.002617,
    long: 14.583719,
  },
  {
    town: 'Češov',
    townCode: 572811,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.339204,
    long: 15.360429,
  },
  {
    town: 'Číčenice',
    townCode: 550965,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38771,
    lat: 49.153152,
    long: 14.230951,
  },
  {
    town: 'Číčovice',
    townCode: 539147,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25268,
    lat: 50.156814,
    long: 14.249483,
  },
  {
    town: 'Číhalín',
    townCode: 590479,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.268545,
    long: 15.812163,
  },
  {
    town: 'Číhaň',
    townCode: 542024,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34142,
    lat: 49.34251,
    long: 13.425893,
  },
  {
    town: 'Číhošť',
    townCode: 568520,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58287,
    lat: 49.741853,
    long: 15.33518,
  },
  {
    town: 'Čichalov',
    townCode: 506621,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36452,
    lat: 50.12436,
    long: 13.17119,
  },
  {
    town: 'Číchov',
    townCode: 590487,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.284719,
    long: 15.762199,
  },
  {
    town: 'Čikov',
    townCode: 590495,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67578,
    lat: 49.269605,
    long: 16.141012,
  },
  {
    town: 'Čilá',
    townCode: 540927,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.961766,
    long: 13.742166,
  },
  {
    town: 'Čilec',
    townCode: 599671,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28925,
    lat: 50.219494,
    long: 14.981754,
  },
  {
    town: 'Čím',
    townCode: 540081,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26203,
    lat: 49.77862,
    long: 14.377907,
  },
  {
    town: 'Čimelice',
    townCode: 549339,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.465681,
    long: 14.069328,
  },
  {
    town: 'Číměř',
    townCode: 546101,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37832,
    lat: 49.060706,
    long: 15.073772,
  },
  {
    town: 'Číměř',
    townCode: 590509,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67501,
    lat: 49.200243,
    long: 15.998557,
  },
  {
    town: 'Čímice',
    townCode: 578495,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.253746,
    long: 13.605991,
  },
  {
    town: 'Činěves',
    townCode: 537080,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28901,
    lat: 50.230096,
    long: 15.213992,
  },
  {
    town: 'Čisovice',
    townCode: 539155,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25204,
    lat: 49.86348,
    long: 14.314883,
  },
  {
    town: 'Čistá',
    townCode: 577944,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56956,
    lat: 49.827322,
    long: 16.328783,
  },
  {
    town: 'Čistá',
    townCode: 535630,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29423,
    lat: 50.472083,
    long: 14.843595,
  },
  {
    town: 'Čistá',
    townCode: 541699,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27034,
    lat: 50.099047,
    long: 13.733683,
  },
  {
    town: 'Čistá u Horek',
    townCode: 577057,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51235,
    lat: 50.5317,
    long: 15.60765,
  },
  {
    town: 'Čistěves',
    townCode: 569933,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.28893,
    long: 15.731935,
  },
  {
    town: 'Čižice',
    townCode: 557641,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33209,
    lat: 49.648043,
    long: 13.397992,
  },
  {
    town: 'Čížkov',
    townCode: 598704,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.440552,
    long: 15.118556,
  },
  {
    town: 'Čížkov',
    townCode: 557650,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33564,
    lat: 49.540479,
    long: 13.683496,
  },
  {
    town: 'Čížkovice',
    townCode: 564711,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41112,
    lat: 50.484284,
    long: 14.028506,
  },
  {
    town: 'Čížkrajice',
    townCode: 551503,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.806592,
    long: 14.636226,
  },
  {
    town: 'Čížov',
    townCode: 587117,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58601,
    lat: 49.38725,
    long: 15.575048,
  },
  {
    town: 'Čížová',
    townCode: 549347,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39831,
    lat: 49.356861,
    long: 14.093158,
  },
  {
    town: 'Čkyně',
    townCode: 550167,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38481,
    lat: 49.115134,
    long: 13.829161,
  },
  {
    town: 'Člunek',
    townCode: 561703,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37861,
    lat: 49.111546,
    long: 15.12686,
  },
  {
    town: 'Čmelíny',
    townCode: 578568,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.488923,
    long: 13.654594,
  },
  {
    town: 'Čtveřín',
    townCode: 544531,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46345,
    lat: 50.592605,
    long: 15.100281,
  },
  {
    town: 'Čtyřkoly',
    townCode: 529567,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25722,
    lat: 49.868613,
    long: 14.719742,
  },
  {
    town: 'Čučice',
    townCode: 582930,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.137181,
    long: 16.278687,
  },
  {
    town: 'Dačice',
    townCode: 546127,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.07992,
    long: 15.434304,
  },
  {
    town: 'Dalečín',
    townCode: 595454,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59241,
    lat: 49.59137,
    long: 16.240185,
  },
  {
    town: 'Daleké Dušníky',
    townCode: 540099,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.727533,
    long: 14.186636,
  },
  {
    town: 'Dalešice',
    townCode: 590517,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67554,
    lat: 49.129105,
    long: 16.08201,
  },
  {
    town: 'Dalešice',
    townCode: 530425,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46802,
    lat: 50.681858,
    long: 15.184679,
  },
  {
    town: 'Dalovice',
    townCode: 537918,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36263,
    lat: 50.247898,
    long: 12.895923,
  },
  {
    town: 'Dalovice',
    townCode: 570818,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.425788,
    long: 14.880041,
  },
  {
    town: 'Dambořice',
    townCode: 586129,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69635,
    lat: 49.038383,
    long: 16.917678,
  },
  {
    town: 'Damnice',
    townCode: 593907,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.920412,
    long: 16.374203,
  },
  {
    town: 'Damníkov',
    townCode: 580074,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56123,
    lat: 49.871344,
    long: 16.560355,
  },
  {
    town: 'Daňkovice',
    townCode: 595462,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.654082,
    long: 16.148711,
  },
  {
    town: 'Darkovice',
    townCode: 568228,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74717,
    lat: 49.936016,
    long: 18.222234,
  },
  {
    town: 'Daskabát',
    townCode: 552445,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.578642,
    long: 17.447349,
  },
  {
    town: 'Dasnice',
    townCode: 560332,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35709,
    lat: 50.146566,
    long: 12.567344,
  },
  {
    town: 'Dasný',
    townCode: 535249,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.019337,
    long: 14.407512,
  },
  {
    town: 'Dašice',
    townCode: 574899,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53303,
    lat: 50.028543,
    long: 15.912545,
  },
  {
    town: 'Davle',
    townCode: 539163,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25206,
    lat: 49.89228,
    long: 14.400478,
  },
  {
    town: 'Deblín',
    townCode: 582948,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66475,
    lat: 49.320459,
    long: 16.346542,
  },
  {
    town: 'Děčany',
    townCode: 564729,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.438699,
    long: 13.908578,
  },
  {
    town: 'DĚČÍN',
    townCode: 562335,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.772656,
    long: 14.212861,
  },
  {
    town: 'Dědice',
    townCode: 590525,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67541,
    lat: 49.029803,
    long: 15.727855,
  },
  {
    town: 'Dědová',
    townCode: 571300,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.761203,
    long: 15.986569,
  },
  {
    town: 'Dehtáře',
    townCode: 561924,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.486202,
    long: 15.275386,
  },
  {
    town: 'Děhylov',
    townCode: 568236,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74794,
    lat: 49.869481,
    long: 18.163431,
  },
  {
    town: 'Děkanovice',
    townCode: 532746,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.618789,
    long: 15.148645,
  },
  {
    town: 'Děkov',
    townCode: 565181,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27004,
    lat: 50.171283,
    long: 13.554483,
  },
  {
    town: 'Děpoltovice',
    townCode: 538116,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36225,
    lat: 50.294681,
    long: 12.814015,
  },
  {
    town: 'Desná',
    townCode: 563552,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46861,
    lat: 50.75481,
    long: 15.313862,
  },
  {
    town: 'Desná',
    townCode: 572357,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.807641,
    long: 16.224152,
  },
  {
    town: 'Dešenice',
    townCode: 556041,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34022,
    lat: 49.27441,
    long: 13.171052,
  },
  {
    town: 'Dešná',
    townCode: 546143,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37873,
    lat: 48.957675,
    long: 15.542926,
  },
  {
    town: 'Dešná',
    townCode: 585157,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 49.266709,
    long: 17.846028,
  },
  {
    town: 'Dešov',
    townCode: 590533,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67533,
    lat: 48.985724,
    long: 15.70151,
  },
  {
    town: 'Deštná',
    townCode: 546151,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37825,
    lat: 49.265237,
    long: 14.924058,
  },
  {
    town: 'Deštná',
    townCode: 581518,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.612653,
    long: 16.563659,
  },
  {
    town: 'Deštné v Orlických horách',
    townCode: 576247,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51791,
    lat: 50.304743,
    long: 16.350751,
  },
  {
    town: 'Deštnice',
    townCode: 566128,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.230738,
    long: 13.609915,
  },
  {
    town: 'Dětenice',
    townCode: 572829,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50724,
    lat: 50.36818,
    long: 15.170627,
  },
  {
    town: 'Dětkovice',
    townCode: 592978,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68323,
    lat: 49.272783,
    long: 17.144316,
  },
  {
    town: 'Dětkovice',
    townCode: 589420,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79804,
    lat: 49.415458,
    long: 17.082286,
  },
  {
    town: 'Dětmarovice',
    townCode: 598941,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73571,
    lat: 49.894214,
    long: 18.460901,
  },
  {
    town: 'Dětřichov',
    townCode: 546607,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.892748,
    long: 15.036676,
  },
  {
    town: 'Dětřichov',
    townCode: 577961,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.80007,
    long: 16.532701,
  },
  {
    town: 'Dětřichov nad Bystřicí',
    townCode: 597252,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79303,
    lat: 49.834288,
    long: 17.401831,
  },
  {
    town: 'Dětřichov u Moravské Třebové',
    townCode: 572683,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.787241,
    long: 16.710609,
  },
  {
    town: 'Dílce',
    townCode: 549118,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.467293,
    long: 15.359434,
  },
  {
    town: 'Díly',
    townCode: 553557,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.446373,
    long: 12.786498,
  },
  {
    town: 'Dírná',
    townCode: 552208,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39127,
    lat: 49.242967,
    long: 14.844867,
  },
  {
    town: 'Diváky',
    townCode: 584401,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69171,
    lat: 48.988794,
    long: 16.791869,
  },
  {
    town: 'Dívčí Hrad',
    townCode: 551864,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.243942,
    long: 17.633923,
  },
  {
    town: 'Dívčí Kopy',
    townCode: 529753,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.260383,
    long: 15.046007,
  },
  {
    town: 'Dívčice',
    townCode: 544361,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37348,
    lat: 49.108733,
    long: 14.309399,
  },
  {
    town: 'Divec',
    townCode: 569941,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50003,
    lat: 50.239875,
    long: 15.921759,
  },
  {
    town: 'Divišov',
    townCode: 529621,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.788592,
    long: 14.875895,
  },
  {
    town: 'Dlažkovice',
    townCode: 564737,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.465654,
    long: 13.96506,
  },
  {
    town: 'Dlažov',
    townCode: 556068,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.365855,
    long: 13.16645,
  },
  {
    town: 'Dlouhá Brtnice',
    townCode: 587010,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58834,
    lat: 49.236176,
    long: 15.604269,
  },
  {
    town: 'Dlouhá Lhota',
    townCode: 563650,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39155,
    lat: 49.352618,
    long: 14.789052,
  },
  {
    town: 'Dlouhá Lhota',
    townCode: 581526,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.428757,
    long: 16.5097,
  },
  {
    town: 'Dlouhá Lhota',
    townCode: 535656,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29405,
    lat: 50.420201,
    long: 15.054223,
  },
  {
    town: 'Dlouhá Lhota',
    townCode: 513504,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.721224,
    long: 14.120705,
  },
  {
    town: 'Dlouhá Loučka',
    townCode: 501476,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78386,
    lat: 49.816357,
    long: 17.179781,
  },
  {
    town: 'Dlouhá Loučka',
    townCode: 577987,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.700947,
    long: 16.641393,
  },
  {
    town: 'Dlouhá Stráň',
    townCode: 551708,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.960143,
    long: 17.500561,
  },
  {
    town: 'Dlouhá Třebová',
    townCode: 548014,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56117,
    lat: 49.940498,
    long: 16.423397,
  },
  {
    town: 'Dlouhá Ves',
    townCode: 568538,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.578654,
    long: 15.67485,
  },
  {
    town: 'Dlouhá Ves',
    townCode: 556076,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.196383,
    long: 13.50936,
  },
  {
    town: 'Dlouhé',
    townCode: 595471,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.509081,
    long: 16.123148,
  },
  {
    town: 'Dlouhomilov',
    townCode: 533688,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.906997,
    long: 16.991411,
  },
  {
    town: 'Dlouhoňovice',
    townCode: 548031,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.070296,
    long: 16.441645,
  },
  {
    town: 'Dlouhopolsko',
    townCode: 537098,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28903,
    lat: 50.175313,
    long: 15.306231,
  },
  {
    town: 'Dlouhý Most',
    townCode: 530468,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46312,
    lat: 50.711714,
    long: 15.075978,
  },
  {
    town: 'Dlouhý Újezd',
    townCode: 560839,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.768405,
    long: 12.62858,
  },
  {
    town: 'Dnešice',
    townCode: 557668,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33443,
    lat: 49.60493,
    long: 13.264653,
  },
  {
    town: 'Dobelice',
    townCode: 593923,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.017342,
    long: 16.27873,
  },
  {
    town: 'Dobev',
    townCode: 549363,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.29535,
    long: 14.048531,
  },
  {
    town: 'Dobkovice',
    townCode: 562408,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40703,
    lat: 50.714949,
    long: 14.193259,
  },
  {
    town: 'Dobrá',
    townCode: 598089,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.673927,
    long: 18.414037,
  },
  {
    town: 'Dobrá Voda',
    townCode: 561932,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.358246,
    long: 15.270103,
  },
  {
    town: 'Dobrá Voda',
    townCode: 595489,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.393997,
    long: 16.065144,
  },
  {
    town: 'Dobrá Voda u Českých Budějovic',
    townCode: 535206,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37316,
    lat: 48.968311,
    long: 14.525035,
  },
  {
    town: 'Dobrá Voda u Hořic',
    townCode: 572837,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50773,
    lat: 50.348096,
    long: 15.602674,
  },
  {
    town: 'Dobrá Voda u Pacova',
    townCode: 561762,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.40438,
    long: 15.02781,
  },
  {
    town: 'Dobratice',
    townCode: 552542,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.660491,
    long: 18.492374,
  },
  {
    town: 'Dobrčice',
    townCode: 513105,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75002,
    lat: 49.402129,
    long: 17.480594,
  },
  {
    town: 'Dobré',
    townCode: 576263,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51793,
    lat: 50.269855,
    long: 16.263866,
  },
  {
    town: 'Dobré Pole',
    townCode: 584410,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69181,
    lat: 48.824436,
    long: 16.535282,
  },
  {
    town: 'Dobrkovice',
    townCode: 585165,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76307,
    lat: 49.094555,
    long: 17.669619,
  },
  {
    town: 'Dobrná',
    townCode: 545783,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40741,
    lat: 50.769646,
    long: 14.293376,
  },
  {
    town: 'Dobročkovice',
    townCode: 592986,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.163035,
    long: 17.109099,
  },
  {
    town: 'Dobročovice',
    townCode: 565008,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25082,
    lat: 50.056421,
    long: 14.700015,
  },
  {
    town: 'Dobrohošť',
    townCode: 562416,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.078488,
    long: 15.488583,
  },
  {
    town: 'Dobrochov',
    townCode: 589438,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79807,
    lat: 49.385961,
    long: 17.105673,
  },
  {
    town: 'Dobroměřice',
    townCode: 546861,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.370197,
    long: 13.794844,
  },
  {
    town: 'Dobromilice',
    townCode: 589446,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79825,
    lat: 49.35854,
    long: 17.141647,
  },
  {
    town: 'Dobronice u Bechyně',
    townCode: 552224,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.343411,
    long: 14.496837,
  },
  {
    town: 'Dobronín',
    townCode: 587028,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58812,
    lat: 49.478429,
    long: 15.650023,
  },
  {
    town: 'Dobroslavice',
    townCode: 569895,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74794,
    lat: 49.880434,
    long: 18.141029,
  },
  {
    town: 'Dobroutov',
    townCode: 587036,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.462343,
    long: 15.73659,
  },
  {
    town: 'Dobrovice',
    townCode: 535672,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29441,
    lat: 50.369427,
    long: 14.962439,
  },
  {
    town: 'Dobrovítov',
    townCode: 529559,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.787634,
    long: 15.328817,
  },
  {
    town: 'Dobrovíz',
    townCode: 539171,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25261,
    lat: 50.113163,
    long: 14.217841,
  },
  {
    town: 'Dobršín',
    townCode: 530123,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.261401,
    long: 13.561152,
  },
  {
    town: 'Dobruška',
    townCode: 576271,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.292111,
    long: 16.160118,
  },
  {
    town: 'Dobřany',
    townCode: 576280,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.322221,
    long: 16.285397,
  },
  {
    town: 'Dobřany',
    townCode: 557676,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33441,
    lat: 49.654933,
    long: 13.293177,
  },
  {
    town: 'Dobřejovice',
    townCode: 538167,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.981717,
    long: 14.57837,
  },
  {
    town: 'Dobřeň',
    townCode: 531570,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.479505,
    long: 14.556812,
  },
  {
    town: 'Dobřenice',
    townCode: 569968,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50325,
    lat: 50.147821,
    long: 15.641146,
  },
  {
    town: 'Dobříč',
    townCode: 558770,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33005,
    lat: 49.88466,
    long: 13.468475,
  },
  {
    town: 'Dobříč',
    townCode: 539180,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25225,
    lat: 50.020021,
    long: 14.259017,
  },
  {
    town: 'Dobřichov',
    townCode: 533289,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28911,
    lat: 50.079731,
    long: 15.032473,
  },
  {
    town: 'Dobřichovice',
    townCode: 539198,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25229,
    lat: 49.927597,
    long: 14.274802,
  },
  {
    town: 'Dobříkov',
    townCode: 580091,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 50.002605,
    long: 16.133921,
  },
  {
    town: 'Dobříň',
    townCode: 564745,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.437691,
    long: 14.29389,
  },
  {
    town: 'Dobřínsko',
    townCode: 593931,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.052312,
    long: 16.26177,
  },
  {
    town: 'Dobříš',
    townCode: 540111,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.781238,
    long: 14.167273,
  },
  {
    town: 'Dobřív',
    townCode: 559776,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33844,
    lat: 49.715763,
    long: 13.686921,
  },
  {
    town: 'Dobšice',
    townCode: 536199,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.216003,
    long: 14.483885,
  },
  {
    town: 'Dobšice',
    townCode: 546941,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67182,
    lat: 48.848447,
    long: 16.085512,
  },
  {
    town: 'Dobšice',
    townCode: 537101,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28905,
    lat: 50.132535,
    long: 15.268716,
  },
  {
    town: 'Dobšín',
    townCode: 571989,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.483425,
    long: 15.116761,
  },
  {
    town: 'Dohalice',
    townCode: 569976,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50313,
    lat: 50.287371,
    long: 15.694605,
  },
  {
    town: 'Doksany',
    townCode: 564753,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41182,
    lat: 50.454991,
    long: 14.16124,
  },
  {
    town: 'Doksy',
    townCode: 561495,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.565945,
    long: 14.654377,
  },
  {
    town: 'Doksy',
    townCode: 532223,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27364,
    lat: 50.119102,
    long: 14.04793,
  },
  {
    town: 'Dolánky nad Ohří',
    townCode: 553646,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.472956,
    long: 14.162716,
  },
  {
    town: 'Dolany',
    townCode: 574015,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55201,
    lat: 50.380098,
    long: 15.96138,
  },
  {
    town: 'Dolany',
    townCode: 501646,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78316,
    lat: 49.649973,
    long: 17.322508,
  },
  {
    town: 'Dolany',
    townCode: 574902,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.113474,
    long: 15.691707,
  },
  {
    town: 'Dolany',
    townCode: 556106,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.443368,
    long: 13.248222,
  },
  {
    town: 'Dolany',
    townCode: 558788,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.807924,
    long: 13.472466,
  },
  {
    town: 'Dolany',
    townCode: 513130,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.115571,
    long: 14.149791,
  },
  {
    town: 'Dolany',
    townCode: 539201,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27801,
    lat: 50.22214,
    long: 14.349629,
  },
  {
    town: 'Dolce',
    townCode: 539945,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.552967,
    long: 13.393513,
  },
  {
    town: 'Dolenice',
    townCode: 593958,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.909233,
    long: 16.365753,
  },
  {
    town: 'Dolní Bečva',
    townCode: 541800,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75655,
    lat: 49.455076,
    long: 18.194298,
  },
  {
    town: 'Dolní Bělá',
    townCode: 558796,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.896264,
    long: 13.273369,
  },
  {
    town: 'Dolní Benešov',
    townCode: 506702,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74722,
    lat: 49.923215,
    long: 18.101406,
  },
  {
    town: 'Dolní Beřkovice',
    townCode: 534765,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27701,
    lat: 50.393236,
    long: 14.450352,
  },
  {
    town: 'Dolní Bezděkov',
    townCode: 505030,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.960537,
    long: 15.883877,
  },
  {
    town: 'Dolní Bojanovice',
    townCode: 586137,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69617,
    lat: 48.858707,
    long: 17.028691,
  },
  {
    town: 'Dolní Bousov',
    townCode: 535702,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.438348,
    long: 15.128232,
  },
  {
    town: 'Dolní Branná',
    townCode: 579122,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54362,
    lat: 50.593265,
    long: 15.593924,
  },
  {
    town: 'Dolní Brusnice',
    townCode: 554863,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54472,
    lat: 50.458843,
    long: 15.726876,
  },
  {
    town: 'Dolní Břežany',
    townCode: 539210,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25241,
    lat: 49.963314,
    long: 14.458611,
  },
  {
    town: 'Dolní Bukovsko',
    townCode: 544388,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37365,
    lat: 49.170963,
    long: 14.58137,
  },
  {
    town: 'Dolní Cerekev',
    townCode: 587044,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58845,
    lat: 49.344588,
    long: 15.456651,
  },
  {
    town: 'Dolní Čermná',
    townCode: 580112,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56153,
    lat: 49.979635,
    long: 16.564857,
  },
  {
    town: 'Dolní Dobrouč',
    townCode: 580121,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56102,
    lat: 49.992831,
    long: 16.497763,
  },
  {
    town: 'Dolní Domaslavice',
    townCode: 598101,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73938,
    lat: 49.712825,
    long: 18.481063,
  },
  {
    town: 'Dolní Dubňany',
    townCode: 593966,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67173,
    lat: 49.055887,
    long: 16.2268,
  },
  {
    town: 'Dolní Dunajovice',
    townCode: 584428,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69185,
    lat: 48.854571,
    long: 16.592933,
  },
  {
    town: 'Dolní Dvořiště',
    townCode: 545465,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38272,
    lat: 48.656521,
    long: 14.452309,
  },
  {
    town: 'Dolní Dvůr',
    townCode: 579149,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54342,
    lat: 50.652348,
    long: 15.655683,
  },
  {
    town: 'Dolní Habartice',
    townCode: 545856,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.747281,
    long: 14.333391,
  },
  {
    town: 'Dolní Hbity',
    townCode: 540129,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26262,
    lat: 49.657558,
    long: 14.169935,
  },
  {
    town: 'Dolní Heřmanice',
    townCode: 595501,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.304851,
    long: 16.060208,
  },
  {
    town: 'Dolní Hořice',
    townCode: 552241,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39155,
    lat: 49.435483,
    long: 14.850632,
  },
  {
    town: 'Dolní Hradiště',
    townCode: 558800,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.913843,
    long: 13.49632,
  },
  {
    town: 'Dolní Hrachovice',
    townCode: 560529,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.486182,
    long: 14.797204,
  },
  {
    town: 'Dolní Chvatliny',
    townCode: 533297,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28144,
    lat: 49.980602,
    long: 15.06939,
  },
  {
    town: 'Dolní Kalná',
    townCode: 579157,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54374,
    lat: 50.538973,
    long: 15.6393,
  },
  {
    town: 'Dolní Kounice',
    townCode: 582956,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.070212,
    long: 16.465024,
  },
  {
    town: 'Dolní Kralovice',
    townCode: 529648,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.644223,
    long: 15.177648,
  },
  {
    town: 'Dolní Krupá',
    townCode: 568597,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58271,
    lat: 49.660734,
    long: 15.60314,
  },
  {
    town: 'Dolní Krupá',
    townCode: 535711,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.546419,
    long: 14.86727,
  },
  {
    town: 'Dolní Lánov',
    townCode: 579165,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54341,
    lat: 50.587095,
    long: 15.664426,
  },
  {
    town: 'Dolní Lažany',
    townCode: 587664,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67551,
    lat: 49.100034,
    long: 15.822815,
  },
  {
    town: 'Dolní Lhota',
    townCode: 506711,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74766,
    lat: 49.842458,
    long: 18.092517,
  },
  {
    town: 'Dolní Lhota',
    townCode: 585173,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76323,
    lat: 49.137271,
    long: 17.812463,
  },
  {
    town: 'Dolní Libochová',
    townCode: 595519,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59253,
    lat: 49.408387,
    long: 16.184706,
  },
  {
    town: 'Dolní Lochov',
    townCode: 549088,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.452243,
    long: 15.286389,
  },
  {
    town: 'Dolní Lomná',
    townCode: 511951,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73991,
    lat: 49.547928,
    long: 18.706198,
  },
  {
    town: 'Dolní Loučky',
    townCode: 595527,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.361092,
    long: 16.358812,
  },
  {
    town: 'Dolní Lukavice',
    townCode: 557684,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33444,
    lat: 49.602031,
    long: 13.34434,
  },
  {
    town: 'Dolní Lutyně',
    townCode: 598968,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73553,
    lat: 49.898856,
    long: 18.428262,
  },
  {
    town: 'Dolní Město',
    townCode: 568601,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58233,
    lat: 49.627806,
    long: 15.382401,
  },
  {
    town: 'Dolní Morava',
    townCode: 580163,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56169,
    lat: 50.122417,
    long: 16.799687,
  },
  {
    town: 'Dolní Moravice',
    townCode: 597287,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79501,
    lat: 49.978038,
    long: 17.32237,
  },
  {
    town: 'Dolní Němčí',
    townCode: 592145,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68762,
    lat: 48.968468,
    long: 17.585962,
  },
  {
    town: 'Dolní Nětčice',
    townCode: 569259,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.476274,
    long: 17.675121,
  },
  {
    town: 'Dolní Nivy',
    townCode: 560341,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.243218,
    long: 12.637158,
  },
  {
    town: 'Dolní Novosedly',
    townCode: 562301,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.329225,
    long: 14.196093,
  },
  {
    town: 'Dolní Olešnice',
    townCode: 579173,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54375,
    lat: 50.524045,
    long: 15.712271,
  },
  {
    town: 'Dolní Pěna',
    townCode: 562467,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.110604,
    long: 15.022153,
  },
  {
    town: 'Dolní Podluží',
    townCode: 562432,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40755,
    lat: 50.879988,
    long: 14.595146,
  },
  {
    town: 'Dolní Pohleď',
    townCode: 531260,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.743519,
    long: 15.133625,
  },
  {
    town: 'Dolní Poustevna',
    townCode: 562441,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40782,
    lat: 50.982619,
    long: 14.286956,
  },
  {
    town: 'Dolní Přím',
    townCode: 569984,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50316,
    lat: 50.239725,
    long: 15.708601,
  },
  {
    town: 'Dolní Radechová',
    townCode: 574023,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54911,
    lat: 50.438436,
    long: 16.151339,
  },
  {
    town: 'Dolní Roveň',
    townCode: 574911,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53371,
    lat: 50.029373,
    long: 15.967844,
  },
  {
    town: 'Dolní Rožínka',
    townCode: 595535,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.47711,
    long: 16.210566,
  },
  {
    town: 'Dolní Rychnov',
    townCode: 538591,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35604,
    lat: 50.164731,
    long: 12.645192,
  },
  {
    town: 'Dolní Řasnice',
    townCode: 563994,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.945787,
    long: 15.168786,
  },
  {
    town: 'Dolní Ředice',
    townCode: 574929,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53375,
    lat: 50.077906,
    long: 15.924033,
  },
  {
    town: 'Dolní Slivno',
    townCode: 535729,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29478,
    lat: 50.308882,
    long: 14.732843,
  },
  {
    town: 'Dolní Sokolovec',
    townCode: 548448,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.726648,
    long: 15.715276,
  },
  {
    town: 'Dolní Stakory',
    townCode: 570940,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.437396,
    long: 14.972584,
  },
  {
    town: 'Dolní Studénky',
    townCode: 553379,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78820,
    lat: 49.93516,
    long: 16.971178,
  },
  {
    town: 'Dolní Těšice',
    townCode: 552984,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.495466,
    long: 17.806908,
  },
  {
    town: 'Dolní Tošanovice',
    townCode: 552607,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73953,
    lat: 49.684257,
    long: 18.488568,
  },
  {
    town: 'Dolní Třebonín',
    townCode: 545473,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38201,
    lat: 48.855526,
    long: 14.409805,
  },
  {
    town: 'Dolní Újezd',
    townCode: 513199,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75123,
    lat: 49.546068,
    long: 17.535582,
  },
  {
    town: 'Dolní Újezd',
    townCode: 577995,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56961,
    lat: 49.82572,
    long: 16.25471,
  },
  {
    town: 'Dolní Věstonice',
    townCode: 584436,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69129,
    lat: 48.888324,
    long: 16.643792,
  },
  {
    town: 'Dolní Vilémovice',
    townCode: 590550,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.153662,
    long: 15.977292,
  },
  {
    town: 'Dolní Vilímeč',
    townCode: 587061,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.135989,
    long: 15.520541,
  },
  {
    town: 'Dolní Zálezly',
    townCode: 567931,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40301,
    lat: 50.597423,
    long: 14.04319,
  },
  {
    town: 'Dolní Zimoř',
    townCode: 531987,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.426717,
    long: 14.501473,
  },
  {
    town: 'Dolní Žandov',
    townCode: 554502,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35493,
    lat: 50.018055,
    long: 12.551125,
  },
  {
    town: 'Dolní Žďár',
    townCode: 562602,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37802,
    lat: 49.101227,
    long: 14.988276,
  },
  {
    town: 'Dolní Životice',
    townCode: 553051,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74756,
    lat: 49.897418,
    long: 17.779797,
  },
  {
    town: 'Doloplazy',
    townCode: 568392,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78356,
    lat: 49.567276,
    long: 17.411581,
  },
  {
    town: 'Doloplazy',
    townCode: 589454,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79826,
    lat: 49.350312,
    long: 17.160101,
  },
  {
    town: 'Domamil',
    townCode: 590568,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67543,
    lat: 49.083336,
    long: 15.695675,
  },
  {
    town: 'Domanín',
    townCode: 562840,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 48.971783,
    long: 14.739869,
  },
  {
    town: 'Domanín',
    townCode: 586145,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69683,
    lat: 49.00177,
    long: 17.284869,
  },
  {
    town: 'Dománovice',
    townCode: 513181,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.111955,
    long: 15.322621,
  },
  {
    town: 'Domašín',
    townCode: 563048,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43151,
    lat: 50.420806,
    long: 13.172313,
  },
  {
    town: 'Domašov',
    townCode: 582964,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.245429,
    long: 16.343924,
  },
  {
    town: 'Domašov nad Bystřicí',
    townCode: 545279,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78306,
    lat: 49.742397,
    long: 17.445404,
  },
  {
    town: 'Domašov u Šternberka',
    townCode: 552313,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.705886,
    long: 17.338,
  },
  {
    town: 'Domaželice',
    townCode: 513211,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75115,
    lat: 49.427781,
    long: 17.545867,
  },
  {
    town: 'Domažlice',
    townCode: 553425,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.439803,
    long: 12.931243,
  },
  {
    town: 'Domoraz',
    townCode: 578517,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.250731,
    long: 13.662108,
  },
  {
    town: 'Domousnice',
    townCode: 535745,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29448,
    lat: 50.394302,
    long: 15.101704,
  },
  {
    town: 'Domoušice',
    townCode: 566152,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43968,
    lat: 50.234257,
    long: 13.729627,
  },
  {
    town: 'Doňov',
    townCode: 507610,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.21318,
    long: 14.776207,
  },
  {
    town: 'Doubek',
    townCode: 564885,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 50.017715,
    long: 14.737871,
  },
  {
    town: 'Doubice',
    townCode: 530417,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40747,
    lat: 50.888706,
    long: 14.461724,
  },
  {
    town: 'Doubrava',
    townCode: 568864,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73533,
    lat: 49.858829,
    long: 18.480287,
  },
  {
    town: 'Doubravčice',
    townCode: 533301,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.022153,
    long: 14.793181,
  },
  {
    town: 'Doubravice',
    townCode: 535664,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37006,
    lat: 48.935899,
    long: 14.510822,
  },
  {
    town: 'Doubravice',
    townCode: 550981,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38735,
    lat: 49.352117,
    long: 13.862024,
  },
  {
    town: 'Doubravice',
    townCode: 579181,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54451,
    lat: 50.405574,
    long: 15.761986,
  },
  {
    town: 'Doubravice nad Svitavou',
    townCode: 581542,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67911,
    lat: 49.436736,
    long: 16.629473,
  },
  {
    town: 'Doubravička',
    townCode: 571067,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29430,
    lat: 50.395208,
    long: 14.776212,
  },
  {
    town: 'Doubravník',
    townCode: 595551,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59261,
    lat: 49.424208,
    long: 16.352799,
  },
  {
    town: 'Doubravy',
    townCode: 585181,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76345,
    lat: 49.142547,
    long: 17.668211,
  },
  {
    town: 'Doudleby',
    townCode: 544400,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37007,
    lat: 48.893631,
    long: 14.501587,
  },
  {
    town: 'Doudleby nad Orlicí',
    townCode: 576301,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51742,
    lat: 50.107644,
    long: 16.261846,
  },
  {
    town: 'Doupě',
    townCode: 587079,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.236937,
    long: 15.434721,
  },
  {
    town: 'Doupovské Hradiště',
    townCode: 500127,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36272,
    lat: 50.25,
    long: 13,
  },
  {
    town: 'Drahanovice',
    townCode: 501751,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78344,
    lat: 49.578656,
    long: 17.077119,
  },
  {
    town: 'Drahany',
    townCode: 589462,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79861,
    lat: 49.433359,
    long: 16.897488,
  },
  {
    town: 'Drahelčice',
    townCode: 531146,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25219,
    lat: 50.031926,
    long: 14.203056,
  },
  {
    town: 'Drahenice',
    townCode: 599298,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26285,
    lat: 49.520949,
    long: 13.95851,
  },
  {
    town: 'Drahkov',
    townCode: 540251,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.557261,
    long: 13.47254,
  },
  {
    town: 'Drahlín',
    townCode: 540145,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.732317,
    long: 13.968974,
  },
  {
    town: 'Drahňovice',
    townCode: 532151,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.822575,
    long: 14.90175,
  },
  {
    town: 'Drahobudice',
    townCode: 564681,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28144,
    lat: 49.937579,
    long: 15.066361,
  },
  {
    town: 'Drahobuz',
    townCode: 564770,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41145,
    lat: 50.525222,
    long: 14.320808,
  },
  {
    town: 'Drahonice',
    townCode: 551015,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.200853,
    long: 14.074682,
  },
  {
    town: 'Drahonín',
    townCode: 595560,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59261,
    lat: 49.414161,
    long: 16.277005,
  },
  {
    town: 'Drahoňův Újezd',
    townCode: 530379,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.877208,
    long: 13.725945,
  },
  {
    town: 'Drahotěšice',
    townCode: 535958,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.124437,
    long: 14.546683,
  },
  {
    town: 'Drahotín',
    townCode: 553573,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.52424,
    long: 12.758259,
  },
  {
    town: 'Drahouš',
    townCode: 529711,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27033,
    lat: 50.080232,
    long: 13.47577,
  },
  {
    town: 'Drahov',
    townCode: 563765,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.175466,
    long: 14.754277,
  },
  {
    town: 'Drachkov',
    townCode: 560219,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.242924,
    long: 13.84157,
  },
  {
    town: 'Dráchov',
    townCode: 552275,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.226539,
    long: 14.706724,
  },
  {
    town: 'Drásov',
    townCode: 582972,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66424,
    lat: 49.331934,
    long: 16.47809,
  },
  {
    town: 'Drásov',
    townCode: 540153,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.702186,
    long: 14.117807,
  },
  {
    town: 'Dražeň',
    townCode: 578665,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33101,
    lat: 49.926953,
    long: 13.287978,
  },
  {
    town: 'Draženov',
    townCode: 553581,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.455812,
    long: 12.872799,
  },
  {
    town: 'Dražice',
    townCode: 552283,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.415254,
    long: 14.640682,
  },
  {
    town: 'Dražíč',
    townCode: 549371,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.305974,
    long: 14.383923,
  },
  {
    town: 'Dražičky',
    townCode: 552291,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39175,
    lat: 49.399131,
    long: 14.59882,
  },
  {
    town: 'Drážov',
    townCode: 551023,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.167415,
    long: 13.740707,
  },
  {
    town: 'Dražovice',
    townCode: 592994,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.194842,
    long: 16.943484,
  },
  {
    town: 'Dražovice',
    townCode: 566683,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.224775,
    long: 13.607113,
  },
  {
    town: 'Dražůvky',
    townCode: 586153,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69633,
    lat: 49.030633,
    long: 17.019078,
  },
  {
    town: 'Drevníky',
    townCode: 540170,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.72026,
    long: 14.274132,
  },
  {
    town: 'Drhovice',
    townCode: 563307,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.432915,
    long: 14.558481,
  },
  {
    town: 'Drhovle',
    townCode: 549380,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.333979,
    long: 14.04237,
  },
  {
    town: 'Drhovy',
    townCode: 540188,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.739163,
    long: 14.232487,
  },
  {
    town: 'Drmoul',
    townCode: 554511,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.93907,
    long: 12.665618,
  },
  {
    town: 'Drnek',
    townCode: 512991,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27377,
    lat: 50.195744,
    long: 13.972514,
  },
  {
    town: 'Drnholec',
    townCode: 584444,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69183,
    lat: 48.857558,
    long: 16.485962,
  },
  {
    town: 'Drnovice',
    townCode: 581551,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67976,
    lat: 49.469406,
    long: 16.542335,
  },
  {
    town: 'Drnovice',
    townCode: 593001,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68304,
    lat: 49.276395,
    long: 16.951569,
  },
  {
    town: 'Drnovice',
    townCode: 585190,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76325,
    lat: 49.17899,
    long: 17.957414,
  },
  {
    town: 'Drobovice',
    townCode: 531341,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.889628,
    long: 15.413523,
  },
  {
    town: 'Droužetice',
    townCode: 560243,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.289184,
    long: 13.89812,
  },
  {
    town: 'Droužkovice',
    townCode: 563056,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43144,
    lat: 50.430887,
    long: 13.429205,
  },
  {
    town: 'Drozdov',
    townCode: 570141,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.907835,
    long: 16.78745,
  },
  {
    town: 'Drozdov',
    townCode: 531154,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26761,
    lat: 49.863241,
    long: 13.840685,
  },
  {
    town: 'Drslavice',
    townCode: 537187,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.025427,
    long: 13.920865,
  },
  {
    town: 'Drslavice',
    townCode: 592153,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68733,
    lat: 49.047152,
    long: 17.600184,
  },
  {
    town: 'Druhanov',
    townCode: 568619,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.69888,
    long: 15.410323,
  },
  {
    town: 'Drunče',
    townCode: 560987,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.296949,
    long: 14.936562,
  },
  {
    town: 'Druztová',
    townCode: 558834,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33007,
    lat: 49.797516,
    long: 13.448829,
  },
  {
    town: 'Družec',
    townCode: 532274,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27362,
    lat: 50.103086,
    long: 14.04551,
  },
  {
    town: 'Drysice',
    townCode: 593010,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68321,
    lat: 49.334642,
    long: 17.057846,
  },
  {
    town: 'Držkov',
    townCode: 563561,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46824,
    lat: 50.68764,
    long: 15.303285,
  },
  {
    town: 'Držková',
    townCode: 585203,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76319,
    lat: 49.319242,
    long: 17.78562,
  },
  {
    town: 'Držovice',
    townCode: 558419,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79607,
    lat: 49.491208,
    long: 17.134108,
  },
  {
    town: 'Dřenice',
    townCode: 504301,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.982634,
    long: 15.745503,
  },
  {
    town: 'Dřešín',
    townCode: 551040,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.161244,
    long: 13.775775,
  },
  {
    town: 'Dřetovice',
    townCode: 532282,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27342,
    lat: 50.182789,
    long: 14.210368,
  },
  {
    town: 'Dřevčice',
    townCode: 538191,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25001,
    lat: 50.167854,
    long: 14.628327,
  },
  {
    town: 'Dřevěnice',
    townCode: 573337,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50713,
    lat: 50.45237,
    long: 15.447215,
  },
  {
    town: 'Dřevnovice',
    townCode: 589489,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79826,
    lat: 49.328187,
    long: 17.143364,
  },
  {
    town: 'Dřevohostice',
    townCode: 513229,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.426043,
    long: 17.592153,
  },
  {
    town: 'Dřínov',
    townCode: 532291,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27371,
    lat: 50.275664,
    long: 14.069855,
  },
  {
    town: 'Dřínov',
    townCode: 534773,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27745,
    lat: 50.273754,
    long: 14.39761,
  },
  {
    town: 'Dřínov',
    townCode: 588431,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76833,
    lat: 49.292989,
    long: 17.233486,
  },
  {
    town: 'Dřísy',
    townCode: 534781,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.256089,
    long: 14.643653,
  },
  {
    town: 'Dříteč',
    townCode: 574953,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53305,
    lat: 50.105191,
    long: 15.808857,
  },
  {
    town: 'Dříteň',
    townCode: 544426,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37351,
    lat: 49.142904,
    long: 14.346061,
  },
  {
    town: 'Dub',
    townCode: 550183,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38425,
    lat: 49.108339,
    long: 14.012153,
  },
  {
    town: 'Dub nad Moravou',
    townCode: 501794,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78375,
    lat: 49.482585,
    long: 17.27734,
  },
  {
    town: 'Dubá',
    townCode: 561533,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47141,
    lat: 50.540444,
    long: 14.540343,
  },
  {
    town: 'Dubany',
    townCode: 572977,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.993164,
    long: 15.725091,
  },
  {
    town: 'Dubčany',
    townCode: 552071,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78322,
    lat: 49.649318,
    long: 17.078926,
  },
  {
    town: 'Dubenec',
    townCode: 579190,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54455,
    lat: 50.37772,
    long: 15.795177,
  },
  {
    town: 'Dubenec',
    townCode: 598381,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.695809,
    long: 14.07934,
  },
  {
    town: 'Dubí',
    townCode: 567507,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41701,
    lat: 50.681139,
    long: 13.788947,
  },
  {
    town: 'Dubicko',
    townCode: 534927,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78972,
    lat: 49.828159,
    long: 16.962769,
  },
  {
    town: 'Dubičné',
    townCode: 535788,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 48.981174,
    long: 14.538863,
  },
  {
    town: 'Dublovice',
    townCode: 540218,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26251,
    lat: 49.671881,
    long: 14.360998,
  },
  {
    town: 'Dubňany',
    townCode: 586161,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69603,
    lat: 48.917038,
    long: 17.090148,
  },
  {
    town: 'Dubné',
    townCode: 544442,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.976295,
    long: 14.360478,
  },
  {
    town: 'Dubnice',
    townCode: 561541,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47126,
    lat: 50.726074,
    long: 14.808823,
  },
  {
    town: 'Dubno',
    townCode: 564508,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.695958,
    long: 14.051851,
  },
  {
    town: 'Dubovice',
    townCode: 551546,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.424582,
    long: 15.216681,
  },
  {
    town: 'Dudín',
    townCode: 587087,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.451107,
    long: 15.39771,
  },
  {
    town: 'Duchcov',
    townCode: 567515,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41901,
    lat: 50.603871,
    long: 13.746322,
  },
  {
    town: 'Dukovany',
    townCode: 590576,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67556,
    lat: 49.081352,
    long: 16.192279,
  },
  {
    town: 'Důl',
    townCode: 529869,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.452191,
    long: 15.030185,
  },
  {
    town: 'Dunajovice',
    townCode: 562815,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.035149,
    long: 14.695348,
  },
  {
    town: 'Dunice',
    townCode: 532843,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.603247,
    long: 15.152746,
  },
  {
    town: 'Dušejov',
    townCode: 587095,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.408817,
    long: 15.432836,
  },
  {
    town: 'Dušníky',
    townCode: 564818,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.424637,
    long: 14.190273,
  },
  {
    town: 'Dvakačovice',
    townCode: 504955,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.979022,
    long: 15.894469,
  },
  {
    town: 'Dvorce',
    townCode: 506729,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.375465,
    long: 15.490478,
  },
  {
    town: 'Dvorce',
    townCode: 597317,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79368,
    lat: 49.833416,
    long: 17.547725,
  },
  {
    town: 'Dvory',
    townCode: 537144,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.039499,
    long: 13.946255,
  },
  {
    town: 'Dvory',
    townCode: 537110,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.21175,
    long: 14.995558,
  },
  {
    town: 'Dvory nad Lužnicí',
    townCode: 509141,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37808,
    lat: 48.852822,
    long: 14.900629,
  },
  {
    town: 'Dvůr Králové nad Labem',
    townCode: 579203,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.43182,
    long: 15.814127,
  },
  {
    town: 'Dyjákovice',
    townCode: 593974,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67126,
    lat: 48.771975,
    long: 16.301068,
  },
  {
    town: 'Dyjákovičky',
    townCode: 593982,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.7824,
    long: 16.095728,
  },
  {
    town: 'Dyje',
    townCode: 593991,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.847219,
    long: 16.1166,
  },
  {
    town: 'Dyjice',
    townCode: 587109,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.174727,
    long: 15.493972,
  },
  {
    town: 'Dymokury',
    townCode: 537128,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28901,
    lat: 50.245776,
    long: 15.202652,
  },
  {
    town: 'Dynín',
    townCode: 544451,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37364,
    lat: 49.137304,
    long: 14.631296,
  },
  {
    town: 'Dýšina',
    townCode: 558851,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33002,
    lat: 49.777455,
    long: 13.491611,
  },
  {
    town: 'Dzbel',
    townCode: 589497,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79853,
    lat: 49.612993,
    long: 16.850985,
  },
  {
    town: 'Džbánice',
    townCode: 594008,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67171,
    lat: 49.001361,
    long: 16.211038,
  },
  {
    town: 'Džbánov',
    townCode: 580210,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.916456,
    long: 16.159605,
  },
  {
    town: 'Ejpovice',
    townCode: 559792,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.74619,
    long: 13.514367,
  },
  {
    town: 'Erpužice',
    townCode: 560855,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.807058,
    long: 13.036075,
  },
  {
    town: 'Eš',
    townCode: 561754,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.434699,
    long: 15.001399,
  },
  {
    town: 'Evaň',
    townCode: 564834,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.384155,
    long: 14.028989,
  },
  {
    town: 'Felbabka',
    townCode: 531162,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26801,
    lat: 49.813487,
    long: 13.942011,
  },
  {
    town: 'Frahelž',
    townCode: 562637,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.117232,
    long: 14.732029,
  },
  {
    town: 'Francova Lhota',
    townCode: 542644,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75614,
    lat: 49.201841,
    long: 18.11186,
  },
  {
    town: 'Františkov nad Ploučnicí',
    townCode: 545899,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40723,
    lat: 50.725809,
    long: 14.327018,
  },
  {
    town: 'Františkovy Lázně',
    townCode: 554529,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35101,
    lat: 50.120159,
    long: 12.349781,
  },
  {
    town: 'Frenštát pod Radhoštěm',
    townCode: 599344,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74401,
    lat: 49.548445,
    long: 18.21089,
  },
  {
    town: 'Fryčovice',
    townCode: 598135,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73945,
    lat: 49.666867,
    long: 18.223315,
  },
  {
    town: 'FRÝDEK-MÍSTEK',
    townCode: 598003,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73801,
    lat: 49.682031,
    long: 18.367422,
  },
  {
    town: 'Frýdlant',
    townCode: 564028,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.921496,
    long: 15.079851,
  },
  {
    town: 'Frýdlant nad Ostravicí',
    townCode: 598143,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73911,
    lat: 49.591902,
    long: 18.358605,
  },
  {
    town: 'Frýdštejn',
    townCode: 563579,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46342,
    lat: 50.652357,
    long: 15.158867,
  },
  {
    town: 'Frymburk',
    townCode: 545481,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38279,
    lat: 48.661044,
    long: 14.165732,
  },
  {
    town: 'Frymburk',
    townCode: 578525,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.249661,
    long: 13.707375,
  },
  {
    town: 'Fryšava pod Žákovou horou',
    townCode: 595578,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59204,
    lat: 49.630512,
    long: 16.044434,
  },
  {
    town: 'Fryšták',
    townCode: 585211,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76316,
    lat: 49.285304,
    long: 17.683572,
  },
  {
    town: 'Fulnek',
    townCode: 599352,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74245,
    lat: 49.712474,
    long: 17.903301,
  },
  {
    town: 'Golčův Jeníkov',
    townCode: 568635,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.816361,
    long: 15.476967,
  },
  {
    town: 'Grešlové Mýto',
    townCode: 594016,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67156,
    lat: 48.980854,
    long: 15.886269,
  },
  {
    town: 'Gruna',
    townCode: 574325,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.762991,
    long: 16.742872,
  },
  {
    town: 'Grunta',
    townCode: 599450,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.974214,
    long: 15.255089,
  },
  {
    town: 'Grygov',
    townCode: 501841,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78373,
    lat: 49.537953,
    long: 17.310944,
  },
  {
    town: 'Grymov',
    townCode: 569194,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75121,
    lat: 49.481108,
    long: 17.498114,
  },
  {
    town: 'Habartice',
    townCode: 564036,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46373,
    lat: 51.019134,
    long: 15.065266,
  },
  {
    town: 'Habartov',
    townCode: 560359,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35709,
    lat: 50.183078,
    long: 12.550653,
  },
  {
    town: 'Habrovany',
    townCode: 593028,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.232934,
    long: 16.878393,
  },
  {
    town: 'Habrovany',
    townCode: 567957,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.598676,
    long: 13.981796,
  },
  {
    town: 'Habrůvka',
    townCode: 581569,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67905,
    lat: 49.3036,
    long: 16.72362,
  },
  {
    town: 'Habry',
    townCode: 568651,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58281,
    lat: 49.756128,
    long: 15.484963,
  },
  {
    town: 'Habří',
    townCode: 535575,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.948248,
    long: 14.334947,
  },
  {
    town: 'Habřina',
    townCode: 569992,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.326035,
    long: 15.826971,
  },
  {
    town: 'Hačky',
    townCode: 549967,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79855,
    lat: 49.622521,
    long: 16.937715,
  },
  {
    town: 'Hadravova Rosička',
    townCode: 562696,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.250953,
    long: 15.047507,
  },
  {
    town: 'Háj u Duchcova',
    townCode: 567523,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41722,
    lat: 50.630921,
    long: 13.712691,
  },
  {
    town: 'Háj ve Slezsku',
    townCode: 506753,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74792,
    lat: 49.899842,
    long: 18.089995,
  },
  {
    town: 'Hajany',
    townCode: 551597,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.446654,
    long: 13.835973,
  },
  {
    town: 'Hajany',
    townCode: 582999,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66443,
    lat: 49.110916,
    long: 16.55509,
  },
  {
    town: 'Háje',
    townCode: 598402,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.672735,
    long: 14.047452,
  },
  {
    town: 'Háje nad Jizerou',
    townCode: 577073,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.613238,
    long: 15.421312,
  },
  {
    town: 'Hájek',
    townCode: 561690,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.11119,
    long: 14.061257,
  },
  {
    town: 'Hájek',
    townCode: 538159,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36301,
    lat: 50.283247,
    long: 12.919811,
  },
  {
    town: 'Hajnice',
    townCode: 579211,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54466,
    lat: 50.487956,
    long: 15.908701,
  },
  {
    town: 'Halámky',
    townCode: 562807,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37806,
    lat: 48.85324,
    long: 14.915223,
  },
  {
    town: 'Halenkov',
    townCode: 542679,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75603,
    lat: 49.317501,
    long: 18.1476,
  },
  {
    town: 'Halenkovice',
    townCode: 585220,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76363,
    lat: 49.171122,
    long: 17.471664,
  },
  {
    town: 'Haluzice',
    townCode: 585238,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76324,
    lat: 49.137973,
    long: 17.897406,
  },
  {
    town: 'Halže',
    townCode: 560863,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.831133,
    long: 12.579508,
  },
  {
    town: 'Hamr',
    townCode: 562386,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37806,
    lat: 48.949506,
    long: 14.913529,
  },
  {
    town: 'Hamr na Jezeře',
    townCode: 544337,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47128,
    lat: 50.702975,
    long: 14.838293,
  },
  {
    town: 'Hamry',
    townCode: 571377,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.739067,
    long: 15.926515,
  },
  {
    town: 'Hamry',
    townCode: 578240,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34022,
    lat: 49.215418,
    long: 13.160547,
  },
  {
    town: 'Hamry nad Sázavou',
    townCode: 595586,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.566124,
    long: 15.901791,
  },
  {
    town: 'Haňovice',
    townCode: 552178,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78321,
    lat: 49.681155,
    long: 17.045152,
  },
  {
    town: 'Hanušovice',
    townCode: 535532,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78833,
    lat: 50.080583,
    long: 16.936514,
  },
  {
    town: 'Harrachov',
    townCode: 577081,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51246,
    lat: 50.772186,
    long: 15.431521,
  },
  {
    town: 'Hartinkov',
    townCode: 572284,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.679202,
    long: 16.814035,
  },
  {
    town: 'Hartmanice',
    townCode: 536075,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37365,
    lat: 49.208049,
    long: 14.565216,
  },
  {
    town: 'Hartmanice',
    townCode: 578037,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56992,
    lat: 49.625328,
    long: 16.373032,
  },
  {
    town: 'Hartmanice',
    townCode: 556181,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.169587,
    long: 13.454657,
  },
  {
    town: 'Hartvíkovice',
    townCode: 590584,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67576,
    lat: 49.171199,
    long: 16.090438,
  },
  {
    town: 'Haškovcova Lhota',
    townCode: 563625,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.332597,
    long: 14.466726,
  },
  {
    town: 'Hať',
    townCode: 568210,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74716,
    lat: 49.94654,
    long: 18.23942,
  },
  {
    town: 'Hatín',
    townCode: 546291,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.108751,
    long: 14.911134,
  },
  {
    town: 'HAVÍŘOV',
    townCode: 555088,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73601,
    lat: 49.780492,
    long: 18.430725,
  },
  {
    town: 'Havlíčkova Borová',
    townCode: 568660,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58223,
    lat: 49.635883,
    long: 15.781671,
  },
  {
    town: 'Havlíčkův Brod',
    townCode: 568414,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.604436,
    long: 15.579755,
  },
  {
    town: 'Havlovice',
    townCode: 579220,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54232,
    lat: 50.487625,
    long: 16.029428,
  },
  {
    town: 'Havraň',
    townCode: 567141,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43501,
    lat: 50.450149,
    long: 13.598881,
  },
  {
    town: 'Havraníky',
    townCode: 594024,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.811525,
    long: 16.008488,
  },
  {
    town: 'Hazlov',
    townCode: 554545,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35132,
    lat: 50.156457,
    long: 12.272617,
  },
  {
    town: 'Hejná',
    townCode: 541796,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.28948,
    long: 13.6748,
  },
  {
    town: 'Hejnice',
    townCode: 564044,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46362,
    lat: 50.877301,
    long: 15.181785,
  },
  {
    town: 'Hejnice',
    townCode: 580228,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.055981,
    long: 16.399519,
  },
  {
    town: 'Hejtmánkovice',
    townCode: 574031,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55001,
    lat: 50.599352,
    long: 16.299544,
  },
  {
    town: 'Helvíkovice',
    townCode: 548049,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.092319,
    long: 16.43105,
  },
  {
    town: 'Herálec',
    townCode: 568678,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58255,
    lat: 49.530935,
    long: 15.457184,
  },
  {
    town: 'Herálec',
    townCode: 595594,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59201,
    lat: 49.689015,
    long: 15.994419,
  },
  {
    town: 'Heraltice',
    townCode: 590592,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.230933,
    long: 15.730648,
  },
  {
    town: 'Herink',
    townCode: 564915,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.966961,
    long: 14.575012,
  },
  {
    town: 'Heroltice',
    townCode: 583014,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.311457,
    long: 16.412898,
  },
  {
    town: 'Heršpice',
    townCode: 550213,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.119869,
    long: 16.913668,
  },
  {
    town: 'Heřmaň',
    townCode: 598593,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37007,
    lat: 48.91146,
    long: 14.503761,
  },
  {
    town: 'Heřmaň',
    townCode: 549398,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39811,
    lat: 49.232575,
    long: 14.13555,
  },
  {
    town: 'Heřmaneč',
    townCode: 546305,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.129602,
    long: 15.28546,
  },
  {
    town: 'Heřmanice',
    townCode: 548596,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.82401,
    long: 15.54733,
  },
  {
    town: 'Heřmanice',
    townCode: 574040,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55212,
    lat: 50.379697,
    long: 15.91865,
  },
  {
    town: 'Heřmanice',
    townCode: 544353,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.897,
    long: 15.006457,
  },
  {
    town: 'Heřmanice u Oder',
    townCode: 568562,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74235,
    lat: 49.713775,
    long: 17.805443,
  },
  {
    town: 'Heřmaničky',
    townCode: 529702,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25789,
    lat: 49.605411,
    long: 14.582592,
  },
  {
    town: 'Heřmánkovice',
    townCode: 574058,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54984,
    lat: 50.620004,
    long: 16.323954,
  },
  {
    town: 'Heřmánky',
    townCode: 568571,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74235,
    lat: 49.707069,
    long: 17.768413,
  },
  {
    town: 'Heřmanov',
    townCode: 595608,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59458,
    lat: 49.379465,
    long: 16.181332,
  },
  {
    town: 'Heřmanov',
    townCode: 562483,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.726587,
    long: 14.291315,
  },
  {
    town: 'Heřmanova Huť',
    townCode: 558869,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.709118,
    long: 13.089275,
  },
  {
    town: 'Heřmanovice',
    townCode: 597325,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79374,
    lat: 50.193392,
    long: 17.397871,
  },
  {
    town: 'Heřmanův Městec',
    townCode: 571385,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.94717,
    long: 15.665028,
  },
  {
    town: 'Hevlín',
    townCode: 594032,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67169,
    lat: 48.75219,
    long: 16.381414,
  },
  {
    town: 'Hladké Životice',
    townCode: 569666,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74247,
    lat: 49.683,
    long: 17.957475,
  },
  {
    town: 'Hladov',
    townCode: 587125,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58833,
    lat: 49.214727,
    long: 15.611458,
  },
  {
    town: 'Hlasivo',
    townCode: 560481,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.498562,
    long: 14.750424,
  },
  {
    town: 'Hlásná Třebaň',
    townCode: 531171,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 49.922344,
    long: 14.198762,
  },
  {
    town: 'Hlásnice',
    townCode: 552330,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.753458,
    long: 17.294675,
  },
  {
    town: 'Hlavatce',
    townCode: 535851,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37348,
    lat: 49.067405,
    long: 14.263279,
  },
  {
    town: 'Hlavatce',
    townCode: 552321,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39173,
    lat: 49.295598,
    long: 14.621315,
  },
  {
    town: 'Hlavečník',
    townCode: 574961,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53315,
    lat: 50.075555,
    long: 15.426616,
  },
  {
    town: 'Hlavenec',
    townCode: 565989,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29474,
    lat: 50.238392,
    long: 14.701862,
  },
  {
    town: 'Hlavice',
    townCode: 564052,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46348,
    lat: 50.631998,
    long: 14.926704,
  },
  {
    town: 'Hlavnice',
    townCode: 553093,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74752,
    lat: 49.924487,
    long: 17.727963,
  },
  {
    town: 'Hlavňovice',
    townCode: 556203,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34142,
    lat: 49.237952,
    long: 13.395157,
  },
  {
    town: 'Hlína',
    townCode: 583022,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.113718,
    long: 16.426268,
  },
  {
    town: 'Hlince',
    townCode: 566390,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.948335,
    long: 13.625133,
  },
  {
    town: 'Hlincová Hora',
    townCode: 598607,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 48.983725,
    long: 14.56456,
  },
  {
    town: 'Hlinka',
    townCode: 551872,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.280106,
    long: 17.672253,
  },
  {
    town: 'Hlinná',
    townCode: 564842,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.572465,
    long: 14.10679,
  },
  {
    town: 'Hlinsko',
    townCode: 569267,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.49464,
    long: 17.579251,
  },
  {
    town: 'Hlinsko',
    townCode: 571393,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.762231,
    long: 15.907661,
  },
  {
    town: 'Hlízov',
    townCode: 531197,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28532,
    lat: 49.985096,
    long: 15.295206,
  },
  {
    town: 'Hlohová',
    townCode: 553620,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.53414,
    long: 13.074684,
  },
  {
    town: 'Hlohovčice',
    townCode: 566641,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.52085,
    long: 13.113875,
  },
  {
    town: 'Hlohovec',
    townCode: 584452,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69143,
    lat: 48.774086,
    long: 16.762404,
  },
  {
    town: 'Hlohovice',
    townCode: 559806,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.889578,
    long: 13.643448,
  },
  {
    town: 'Hlubočany',
    townCode: 593036,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.230519,
    long: 17.000469,
  },
  {
    town: 'Hlubočec',
    townCode: 568368,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74769,
    lat: 49.840666,
    long: 17.97043,
  },
  {
    town: 'Hlubočky',
    townCode: 502146,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78361,
    lat: 49.627673,
    long: 17.402638,
  },
  {
    town: 'Hluboká',
    townCode: 571407,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53973,
    lat: 49.84568,
    long: 16.071649,
  },
  {
    town: 'Hluboká nad Vltavou',
    townCode: 544485,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.052354,
    long: 14.434371,
  },
  {
    town: 'Hluboké',
    townCode: 590614,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.226034,
    long: 16.227607,
  },
  {
    town: 'Hluboké Dvory',
    townCode: 581577,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.383241,
    long: 16.514309,
  },
  {
    town: 'Hluboké Mašůvky',
    townCode: 594041,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67152,
    lat: 48.923757,
    long: 16.025651,
  },
  {
    town: 'Hluboš',
    townCode: 540242,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26222,
    lat: 49.746325,
    long: 14.020299,
  },
  {
    town: 'Hlubyně',
    townCode: 564605,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.559767,
    long: 13.923345,
  },
  {
    town: 'Hlučín',
    townCode: 507016,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74801,
    lat: 49.896627,
    long: 18.190649,
  },
  {
    town: 'Hluchov',
    townCode: 589501,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79841,
    lat: 49.541496,
    long: 16.996747,
  },
  {
    town: 'Hluk',
    townCode: 592170,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68725,
    lat: 48.988219,
    long: 17.526788,
  },
  {
    town: 'Hlupín',
    townCode: 536628,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.334796,
    long: 13.806877,
  },
  {
    town: 'Hlušice',
    townCode: 570001,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50356,
    lat: 50.264697,
    long: 15.403364,
  },
  {
    town: 'Hlušovice',
    townCode: 552020,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78314,
    lat: 49.638193,
    long: 17.277495,
  },
  {
    town: 'Hnačov',
    townCode: 542083,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34034,
    lat: 49.361927,
    long: 13.48178,
  },
  {
    town: 'Hnanice',
    townCode: 594059,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.798587,
    long: 15.98678,
  },
  {
    town: 'Hnátnice',
    townCode: 580261,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56101,
    lat: 50.020435,
    long: 16.438656,
  },
  {
    town: 'Hněvčeves',
    townCode: 570010,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.314969,
    long: 15.71623,
  },
  {
    town: 'Hněvkovice',
    townCode: 568694,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58294,
    lat: 49.685299,
    long: 15.202877,
  },
  {
    town: 'Hněvnice',
    townCode: 530221,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.728607,
    long: 13.103241,
  },
  {
    town: 'Hněvošice',
    townCode: 507105,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74735,
    lat: 50.00309,
    long: 18.008393,
  },
  {
    town: 'Hněvotín',
    townCode: 502235,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78347,
    lat: 49.572151,
    long: 17.179642,
  },
  {
    town: 'Hnojice',
    townCode: 502405,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.716409,
    long: 17.224227,
  },
  {
    town: 'Hnojník',
    townCode: 598160,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73953,
    lat: 49.682383,
    long: 18.541393,
  },
  {
    town: 'Hobšovice',
    townCode: 513075,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27321,
    lat: 50.270647,
    long: 14.162268,
  },
  {
    town: 'Hodějice',
    townCode: 593044,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.141595,
    long: 16.913792,
  },
  {
    town: 'Hodětín',
    townCode: 598992,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.252274,
    long: 14.548733,
  },
  {
    town: 'Hodice',
    townCode: 587141,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58901,
    lat: 49.270172,
    long: 15.480092,
  },
  {
    town: 'Hodíškov',
    townCode: 595624,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.503592,
    long: 16.038149,
  },
  {
    town: 'Hodkovice nad Mohelkou',
    townCode: 564061,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46342,
    lat: 50.665963,
    long: 15.08996,
  },
  {
    town: 'Hodonice',
    townCode: 562904,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.268626,
    long: 14.487466,
  },
  {
    town: 'Hodonice',
    townCode: 594067,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67125,
    lat: 48.8369,
    long: 16.163476,
  },
  {
    town: 'Hodonín',
    townCode: 581593,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.501284,
    long: 16.410379,
  },
  {
    town: 'Hodonín',
    townCode: 586021,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69501,
    lat: 48.853039,
    long: 17.126102,
  },
  {
    town: 'Hodonín',
    townCode: 547794,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53825,
    lat: 49.837054,
    long: 15.78717,
  },
  {
    town: 'Hodov',
    townCode: 590622,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67504,
    lat: 49.29408,
    long: 15.983949,
  },
  {
    town: 'Hodslavice',
    townCode: 599409,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74271,
    lat: 49.53866,
    long: 18.023783,
  },
  {
    town: 'Hojanovice',
    townCode: 547883,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.597358,
    long: 15.265616,
  },
  {
    town: 'Hojkov',
    townCode: 587150,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.389244,
    long: 15.413786,
  },
  {
    town: 'Hojovice',
    townCode: 561096,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.32846,
    long: 14.919872,
  },
  {
    town: 'Holany',
    townCode: 561584,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47002,
    lat: 50.618099,
    long: 14.493073,
  },
  {
    town: 'Holasice',
    townCode: 583031,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66461,
    lat: 49.075956,
    long: 16.607667,
  },
  {
    town: 'Holasovice',
    townCode: 507113,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74774,
    lat: 49.998525,
    long: 17.808573,
  },
  {
    town: 'Holčovice',
    townCode: 597341,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79371,
    lat: 50.156849,
    long: 17.486079,
  },
  {
    town: 'Holedeč',
    townCode: 566187,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.277534,
    long: 13.563098,
  },
  {
    town: 'Holenice',
    townCode: 577111,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 50601,
    lat: 50.520473,
    long: 15.300548,
  },
  {
    town: 'Holešov',
    townCode: 588458,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.33341,
    long: 17.57843,
  },
  {
    town: 'Holetín',
    townCode: 571440,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53971,
    lat: 49.794858,
    long: 15.923513,
  },
  {
    town: 'Holice',
    townCode: 574988,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.06611,
    long: 15.986005,
  },
  {
    town: 'Holín',
    townCode: 572900,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.451706,
    long: 15.320807,
  },
  {
    town: 'Holohlavy',
    townCode: 570028,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.308038,
    long: 15.860186,
  },
  {
    town: 'Holotín',
    townCode: 573019,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.945993,
    long: 15.580349,
  },
  {
    town: 'Holoubkov',
    townCode: 559814,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33801,
    lat: 49.776089,
    long: 13.692566,
  },
  {
    town: 'Holovousy',
    townCode: 572918,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.375381,
    long: 15.577533,
  },
  {
    town: 'Holovousy',
    townCode: 566730,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.96798,
    long: 13.614819,
  },
  {
    town: 'Holštejn',
    townCode: 581615,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67913,
    lat: 49.406486,
    long: 16.777804,
  },
  {
    town: 'Holubice',
    townCode: 550825,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68351,
    lat: 49.177588,
    long: 16.812243,
  },
  {
    town: 'Holubice',
    townCode: 539228,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25265,
    lat: 50.203189,
    long: 14.292949,
  },
  {
    town: 'Holubov',
    townCode: 545490,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38203,
    lat: 48.890096,
    long: 14.321188,
  },
  {
    town: 'Holýšov',
    townCode: 553654,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.593721,
    long: 13.101403,
  },
  {
    town: 'Homole',
    townCode: 544493,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.939,
    long: 14.429572,
  },
  {
    town: 'Homole u Panny',
    townCode: 567973,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.62938,
    long: 14.186494,
  },
  {
    town: 'Honbice',
    townCode: 571458,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.933561,
    long: 15.893093,
  },
  {
    town: 'Honětice',
    townCode: 542342,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76813,
    lat: 49.203806,
    long: 17.253216,
  },
  {
    town: 'Honezovice',
    townCode: 540668,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.638318,
    long: 13.062664,
  },
  {
    town: 'Hora Svaté Kateřiny',
    townCode: 567167,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43546,
    lat: 50.606416,
    long: 13.436834,
  },
  {
    town: 'Hora Svatého Šebestiána',
    townCode: 563064,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43182,
    lat: 50.510328,
    long: 13.251454,
  },
  {
    town: 'Hora Svatého Václava',
    townCode: 566276,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.518986,
    long: 12.739958,
  },
  {
    town: 'Horažďovice',
    townCode: 556254,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.320794,
    long: 13.701106,
  },
  {
    town: 'Horčápsko',
    townCode: 564257,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.584502,
    long: 13.984557,
  },
  {
    town: 'Horka',
    townCode: 571466,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53851,
    lat: 49.887322,
    long: 15.916873,
  },
  {
    town: 'Horka I',
    townCode: 531430,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.982795,
    long: 15.44004,
  },
  {
    town: 'Horka II',
    townCode: 534056,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.732179,
    long: 15.13385,
  },
  {
    town: 'Horka nad Moravou',
    townCode: 502545,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78335,
    lat: 49.640186,
    long: 17.210806,
  },
  {
    town: 'Horka u Staré Paky',
    townCode: 574201,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51234,
    lat: 50.52618,
    long: 15.57583,
  },
  {
    town: 'Horky',
    townCode: 578053,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.920822,
    long: 16.243471,
  },
  {
    town: 'Horky',
    townCode: 531359,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.868864,
    long: 15.439898,
  },
  {
    town: 'Horky nad Jizerou',
    townCode: 535818,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29473,
    lat: 50.327164,
    long: 14.856169,
  },
  {
    town: 'Horní Bečva',
    townCode: 542687,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75657,
    lat: 49.43226,
    long: 18.288701,
  },
  {
    town: 'Horní Bělá',
    townCode: 558877,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.889081,
    long: 13.264218,
  },
  {
    town: 'Horní Benešov',
    townCode: 597350,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79312,
    lat: 49.966918,
    long: 17.60273,
  },
  {
    town: 'Horní Beřkovice',
    townCode: 564851,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41185,
    lat: 50.358792,
    long: 14.346588,
  },
  {
    town: 'Horní Bezděkov',
    townCode: 532312,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.082352,
    long: 14.067597,
  },
  {
    town: 'Horní Blatná',
    townCode: 555169,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36235,
    lat: 50.390493,
    long: 12.771048,
  },
  {
    town: 'Horní Bludovice',
    townCode: 598178,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73937,
    lat: 49.749749,
    long: 18.436881,
  },
  {
    town: 'Horní Bojanovice',
    townCode: 584461,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69301,
    lat: 48.949805,
    long: 16.800252,
  },
  {
    town: 'Horní Bradlo',
    townCode: 571474,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53953,
    lat: 49.802435,
    long: 15.744393,
  },
  {
    town: 'Horní Branná',
    townCode: 577120,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51236,
    lat: 50.608357,
    long: 15.571571,
  },
  {
    town: 'Horní Brusnice',
    townCode: 579238,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54474,
    lat: 50.473162,
    long: 15.68114,
  },
  {
    town: 'Horní Břečkov',
    townCode: 594075,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.890055,
    long: 15.898559,
  },
  {
    town: 'Horní Bříza',
    townCode: 558885,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33012,
    lat: 49.84023,
    long: 13.355689,
  },
  {
    town: 'Horní Bukovina',
    townCode: 535834,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.543257,
    long: 14.926231,
  },
  {
    town: 'Horní Cerekev',
    townCode: 547913,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39403,
    lat: 49.320362,
    long: 15.327794,
  },
  {
    town: 'Horní Čermná',
    townCode: 580279,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56156,
    lat: 49.970628,
    long: 16.607822,
  },
  {
    town: 'Horní Domaslavice',
    townCode: 512192,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.694745,
    long: 18.461438,
  },
  {
    town: 'Horní Dubenky',
    townCode: 587168,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58852,
    lat: 49.259681,
    long: 15.317105,
  },
  {
    town: 'Horní Dubňany',
    townCode: 594083,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67173,
    lat: 49.06346,
    long: 16.201379,
  },
  {
    town: 'Horní Dunajovice',
    townCode: 594091,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67134,
    lat: 48.950344,
    long: 16.161627,
  },
  {
    town: 'Horní Dvořiště',
    townCode: 545503,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38293,
    lat: 48.603883,
    long: 14.405822,
  },
  {
    town: 'Horní Habartice',
    townCode: 545929,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.762175,
    long: 14.340721,
  },
  {
    town: 'Horní Heřmanice',
    townCode: 590631,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.329454,
    long: 15.920489,
  },
  {
    town: 'Horní Heřmanice',
    townCode: 580295,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56133,
    lat: 49.961095,
    long: 16.711296,
  },
  {
    town: 'Horní Jelení',
    townCode: 574996,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53374,
    lat: 50.049109,
    long: 16.084069,
  },
  {
    town: 'Horní Jiřetín',
    townCode: 567175,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43543,
    lat: 50.5732,
    long: 13.547284,
  },
  {
    town: 'Horní Kalná',
    townCode: 579254,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54371,
    lat: 50.562856,
    long: 15.62487,
  },
  {
    town: 'Horní Kamenice',
    townCode: 553662,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.569701,
    long: 13.101163,
  },
  {
    town: 'Horní Kněžeklady',
    townCode: 536105,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.193834,
    long: 14.481489,
  },
  {
    town: 'Horní Kounice',
    townCode: 594105,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67140,
    lat: 49.026094,
    long: 16.152366,
  },
  {
    town: 'Horní Kozolupy',
    townCode: 541290,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34952,
    lat: 49.837622,
    long: 12.941751,
  },
  {
    town: 'Horní Krupá',
    townCode: 568708,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.672094,
    long: 15.588589,
  },
  {
    town: 'Horní Kruty',
    townCode: 533327,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28146,
    lat: 49.919546,
    long: 14.959813,
  },
  {
    town: 'Horní Lapač',
    townCode: 588474,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.301023,
    long: 17.617522,
  },
  {
    town: 'Horní Lhota',
    townCode: 569500,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74764,
    lat: 49.853142,
    long: 18.068485,
  },
  {
    town: 'Horní Lhota',
    townCode: 585246,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76323,
    lat: 49.154412,
    long: 17.80455,
  },
  {
    town: 'Horní Libchava',
    townCode: 561592,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47111,
    lat: 50.712584,
    long: 14.493538,
  },
  {
    town: 'Horní Libochová',
    townCode: 595659,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.407729,
    long: 16.148981,
  },
  {
    town: 'Horní Lideč',
    townCode: 542725,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75612,
    lat: 49.181314,
    long: 18.061103,
  },
  {
    town: 'Horní Loděnice',
    townCode: 569798,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78305,
    lat: 49.771108,
    long: 17.37728,
  },
  {
    town: 'Horní Lomná',
    townCode: 511986,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73991,
    lat: 49.527977,
    long: 18.637844,
  },
  {
    town: 'Horní Loučky',
    townCode: 595667,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.366906,
    long: 16.341499,
  },
  {
    town: 'Horní Lukavice',
    townCode: 539821,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.612427,
    long: 13.32708,
  },
  {
    town: 'Horní Maršov',
    townCode: 579262,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54226,
    lat: 50.658659,
    long: 15.819859,
  },
  {
    town: 'Horní Město',
    townCode: 597368,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79344,
    lat: 49.908546,
    long: 17.211221,
  },
  {
    town: 'Horní Meziříčko',
    townCode: 598658,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.156684,
    long: 15.244609,
  },
  {
    town: 'Horní Moštěnice',
    townCode: 513491,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75117,
    lat: 49.412225,
    long: 17.4589,
  },
  {
    town: 'Horní Myslová',
    townCode: 587206,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.165516,
    long: 15.422663,
  },
  {
    town: 'Horní Němčí',
    townCode: 592188,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68764,
    lat: 48.933273,
    long: 17.624276,
  },
  {
    town: 'Horní Němčice',
    townCode: 562785,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.1579,
    long: 15.27978,
  },
  {
    town: 'Horní Nětčice',
    townCode: 569275,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.470245,
    long: 17.684498,
  },
  {
    town: 'Horní Olešnice',
    townCode: 579271,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54371,
    lat: 50.53276,
    long: 15.677502,
  },
  {
    town: 'Horní Paseka',
    townCode: 548243,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.629757,
    long: 15.293283,
  },
  {
    town: 'Horní Pěna',
    townCode: 546364,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37831,
    lat: 49.104515,
    long: 15.042397,
  },
  {
    town: 'Horní Planá',
    townCode: 545511,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38226,
    lat: 48.767465,
    long: 14.032672,
  },
  {
    town: 'Horní Počaply',
    townCode: 534790,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27703,
    lat: 50.424505,
    long: 14.390039,
  },
  {
    town: 'Horní Podluží',
    townCode: 562505,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40757,
    lat: 50.881485,
    long: 14.545731,
  },
  {
    town: 'Horní Police',
    townCode: 561606,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47106,
    lat: 50.704219,
    long: 14.404106,
  },
  {
    town: 'Horní Poříčí',
    townCode: 536881,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.286063,
    long: 13.782924,
  },
  {
    town: 'Horní Poříčí',
    townCode: 581631,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.587696,
    long: 16.477436,
  },
  {
    town: 'Horní Radechová',
    townCode: 574066,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54946,
    lat: 50.46743,
    long: 16.144576,
  },
  {
    town: 'Horní Radouň',
    townCode: 546381,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37843,
    lat: 49.25718,
    long: 15.005828,
  },
  {
    town: 'Horní Radslavice',
    townCode: 595675,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.338339,
    long: 15.902364,
  },
  {
    town: 'Horní Rápotice',
    townCode: 551589,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.575426,
    long: 15.320586,
  },
  {
    town: 'Horní Rožínka',
    townCode: 595683,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.5001,
    long: 16.193,
  },
  {
    town: 'Horní Řasnice',
    townCode: 564079,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.965564,
    long: 15.201599,
  },
  {
    town: 'Horní Ředice',
    townCode: 575011,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53375,
    lat: 50.076611,
    long: 15.958886,
  },
  {
    town: 'Horní Řepčice',
    townCode: 546763,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41145,
    lat: 50.556722,
    long: 14.253325,
  },
  {
    town: 'Horní Skrýchov',
    townCode: 561061,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.172879,
    long: 15.028473,
  },
  {
    town: 'Horní Slatina',
    townCode: 562319,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.090577,
    long: 15.568834,
  },
  {
    town: 'Horní Slavkov',
    townCode: 560367,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35731,
    lat: 50.138742,
    long: 12.807697,
  },
  {
    town: 'Horní Slivno',
    townCode: 599531,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29479,
    lat: 50.304132,
    long: 14.704984,
  },
  {
    town: 'Horní Smrčné',
    townCode: 550612,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.32869,
    long: 15.756199,
  },
  {
    town: 'Horní Smržov',
    townCode: 513695,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.618358,
    long: 16.577085,
  },
  {
    town: 'Horní Stropnice',
    townCode: 544515,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37335,
    lat: 48.761347,
    long: 14.735114,
  },
  {
    town: 'Horní Studénky',
    townCode: 535770,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.952757,
    long: 16.811723,
  },
  {
    town: 'Horní Suchá',
    townCode: 552739,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73535,
    lat: 49.797901,
    long: 18.481997,
  },
  {
    town: 'Horní Štěpánov',
    townCode: 589519,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79847,
    lat: 49.549106,
    long: 16.790882,
  },
  {
    town: 'Horní Těšice',
    townCode: 552968,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.495759,
    long: 17.786086,
  },
  {
    town: 'Horní Tošanovice',
    townCode: 552631,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73953,
    lat: 49.692472,
    long: 18.505428,
  },
  {
    town: 'Horní Třešňovec',
    townCode: 580333,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.939321,
    long: 16.602641,
  },
  {
    town: 'Horní Újezd',
    townCode: 590649,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.142893,
    long: 15.842256,
  },
  {
    town: 'Horní Újezd',
    townCode: 569542,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.448387,
    long: 17.727285,
  },
  {
    town: 'Horní Újezd',
    townCode: 572365,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.803578,
    long: 16.233042,
  },
  {
    town: 'Horní Ves',
    townCode: 547930,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.293507,
    long: 15.307554,
  },
  {
    town: 'Horní Věstonice',
    townCode: 584479,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69181,
    lat: 48.874651,
    long: 16.62566,
  },
  {
    town: 'Horní Vilémovice',
    townCode: 590657,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.29166,
    long: 15.880909,
  },
  {
    town: 'Horní Vltavice',
    townCode: 550205,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38491,
    lat: 48.957149,
    long: 13.758797,
  },
  {
    town: 'Horní Životice',
    townCode: 551805,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79312,
    lat: 49.968984,
    long: 17.6409,
  },
  {
    town: 'Hornice',
    townCode: 590665,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.995287,
    long: 15.680464,
  },
  {
    town: 'Hornosín',
    townCode: 536369,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38742,
    lat: 49.482857,
    long: 13.839873,
  },
  {
    town: 'Horoměřice',
    townCode: 539236,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25262,
    lat: 50.131831,
    long: 14.338894,
  },
  {
    town: 'Horosedly',
    townCode: 561525,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.512896,
    long: 14.054107,
  },
  {
    town: 'Horoušany',
    townCode: 538221,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25082,
    lat: 50.106504,
    long: 14.74068,
  },
  {
    town: 'Horská Kvilda',
    townCode: 542091,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 38501,
    lat: 49.057721,
    long: 13.558075,
  },
  {
    town: 'Horšice',
    townCode: 557722,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33455,
    lat: 49.531575,
    long: 13.386298,
  },
  {
    town: 'Horšovský Týn',
    townCode: 553671,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.530286,
    long: 12.944527,
  },
  {
    town: 'Horušice',
    townCode: 531481,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28573,
    lat: 49.996584,
    long: 15.429043,
  },
  {
    town: 'Hory',
    townCode: 551651,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.213854,
    long: 12.789994,
  },
  {
    town: 'Hořany',
    townCode: 534854,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28914,
    lat: 50.09771,
    long: 14.945897,
  },
  {
    town: 'Hořátev',
    townCode: 537152,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28913,
    lat: 50.150278,
    long: 15.039418,
  },
  {
    town: 'Hořenice',
    townCode: 547531,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.369279,
    long: 15.910937,
  },
  {
    town: 'Hořepník',
    townCode: 547948,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39421,
    lat: 49.512566,
    long: 15.107097,
  },
  {
    town: 'Hořesedly',
    townCode: 541729,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27004,
    lat: 50.16239,
    long: 13.602769,
  },
  {
    town: 'Hořešovice',
    townCode: 532321,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27374,
    lat: 50.27169,
    long: 13.966906,
  },
  {
    town: 'Hořešovičky',
    townCode: 535150,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27374,
    lat: 50.274989,
    long: 13.95589,
  },
  {
    town: 'Hořice',
    townCode: 547956,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.599362,
    long: 15.185502,
  },
  {
    town: 'Hořice',
    townCode: 572926,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.366189,
    long: 15.63194,
  },
  {
    town: 'Hořice na Šumavě',
    townCode: 545520,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38222,
    lat: 48.766018,
    long: 14.178522,
  },
  {
    town: 'Hořičky',
    townCode: 574074,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55205,
    lat: 50.444856,
    long: 15.993634,
  },
  {
    town: 'Hořín',
    townCode: 534803,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27601,
    lat: 50.34492,
    long: 14.464285,
  },
  {
    town: 'Hořiněves',
    townCode: 570044,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50306,
    lat: 50.309639,
    long: 15.767421,
  },
  {
    town: 'Hořovice',
    townCode: 531189,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26801,
    lat: 49.836078,
    long: 13.902789,
  },
  {
    town: 'Hořovičky',
    townCode: 541737,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27004,
    lat: 50.155721,
    long: 13.531515,
  },
  {
    town: 'Hosín',
    townCode: 544523,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.037403,
    long: 14.476024,
  },
  {
    town: 'Hoslovice',
    townCode: 551104,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.191286,
    long: 13.763173,
  },
  {
    town: 'Hospozín',
    townCode: 532339,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27322,
    lat: 50.306981,
    long: 14.17187,
  },
  {
    town: 'Hospříz',
    townCode: 546402,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.128663,
    long: 15.085627,
  },
  {
    town: 'Hostašovice',
    townCode: 568511,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74101,
    lat: 49.534363,
    long: 17.997408,
  },
  {
    town: 'Hostějov',
    townCode: 592196,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68741,
    lat: 49.040274,
    long: 17.257265,
  },
  {
    town: 'Hostěnice',
    townCode: 583057,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66404,
    lat: 49.236641,
    long: 16.776652,
  },
  {
    town: 'Hostěradice',
    townCode: 594113,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67171,
    lat: 48.950156,
    long: 16.259416,
  },
  {
    town: 'Hostěrádky-Rešov',
    townCode: 593052,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68352,
    lat: 49.117751,
    long: 16.784406,
  },
  {
    town: 'Hostětice',
    townCode: 587192,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.191764,
    long: 15.414157,
  },
  {
    town: 'Hostětín',
    townCode: 550736,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68771,
    lat: 49.050017,
    long: 17.879516,
  },
  {
    town: 'Hostim',
    townCode: 594121,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67154,
    lat: 49.018691,
    long: 15.894995,
  },
  {
    town: 'Hostín',
    townCode: 531499,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27732,
    lat: 50.340525,
    long: 14.588998,
  },
  {
    town: 'Hostín u Vojkovic',
    townCode: 531928,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27744,
    lat: 50.297177,
    long: 14.397072,
  },
  {
    town: 'Hostinné',
    townCode: 579297,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54371,
    lat: 50.540762,
    long: 15.723442,
  },
  {
    town: 'Hostišová',
    townCode: 585254,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76301,
    lat: 49.253781,
    long: 17.591153,
  },
  {
    town: 'Hostivice',
    townCode: 539244,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25301,
    lat: 50.081679,
    long: 14.25867,
  },
  {
    town: 'Hostomice',
    townCode: 531201,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.825363,
    long: 14.045712,
  },
  {
    town: 'Hostomice',
    townCode: 567531,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41752,
    lat: 50.587806,
    long: 13.808142,
  },
  {
    town: 'Hostouň',
    townCode: 553689,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34525,
    lat: 49.559821,
    long: 12.771578,
  },
  {
    town: 'Hostouň',
    townCode: 532347,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27353,
    lat: 50.11449,
    long: 14.201384,
  },
  {
    town: 'Hostovlice',
    townCode: 534064,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28562,
    lat: 49.860355,
    long: 15.466403,
  },
  {
    town: 'Hosty',
    townCode: 535524,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.260396,
    long: 14.393359,
  },
  {
    town: 'Hošťálková',
    townCode: 542750,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75622,
    lat: 49.354774,
    long: 17.869548,
  },
  {
    town: 'Hošťálkovy',
    townCode: 597392,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79401,
    lat: 50.111701,
    long: 17.599627,
  },
  {
    town: 'Hošťalovice',
    townCode: 571482,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.934901,
    long: 15.57603,
  },
  {
    town: 'Hoštejn',
    townCode: 535885,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.874482,
    long: 16.774872,
  },
  {
    town: 'Hoštice',
    townCode: 551121,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.194319,
    long: 13.909569,
  },
  {
    town: 'Hoštice',
    townCode: 588482,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76813,
    lat: 49.208645,
    long: 17.233888,
  },
  {
    town: 'Hoštice-Heroltice',
    townCode: 593061,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.287107,
    long: 17.062864,
  },
  {
    town: 'Hoštka',
    townCode: 564877,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41172,
    lat: 50.488694,
    long: 14.33511,
  },
  {
    town: 'Hošťka',
    townCode: 560898,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34806,
    lat: 49.696306,
    long: 12.597568,
  },
  {
    town: 'Hovězí',
    townCode: 542768,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75601,
    lat: 49.303745,
    long: 18.060734,
  },
  {
    town: 'Hovorany',
    townCode: 586170,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69612,
    lat: 48.95503,
    long: 16.993562,
  },
  {
    town: 'Hovorčovice',
    townCode: 538230,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25064,
    lat: 50.178764,
    long: 14.517993,
  },
  {
    town: 'Hraběšice',
    townCode: 553387,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78815,
    lat: 49.97673,
    long: 17.079623,
  },
  {
    town: 'Hraběšín',
    townCode: 531413,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.852623,
    long: 15.331919,
  },
  {
    town: 'Hrabětice',
    townCode: 594130,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67168,
    lat: 48.797751,
    long: 16.393527,
  },
  {
    town: 'Hrabišín',
    townCode: 536091,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78804,
    lat: 49.91415,
    long: 17.036459,
  },
  {
    town: 'Hrabová',
    townCode: 553221,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.845548,
    long: 16.953951,
  },
  {
    town: 'Hrabůvka',
    townCode: 513636,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.578604,
    long: 17.691361,
  },
  {
    town: 'Hrabyně',
    townCode: 507261,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74763,
    lat: 49.882583,
    long: 18.054935,
  },
  {
    town: 'Hradce',
    townCode: 535460,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.933382,
    long: 14.359977,
  },
  {
    town: 'Hradčany',
    townCode: 583065,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66603,
    lat: 49.327964,
    long: 16.442271,
  },
  {
    town: 'Hradčany',
    townCode: 513733,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75111,
    lat: 49.452714,
    long: 17.571737,
  },
  {
    town: 'Hradčany',
    townCode: 537161,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28905,
    lat: 50.158082,
    long: 15.269964,
  },
  {
    town: 'Hradčany-Kobeřice',
    townCode: 589527,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79807,
    lat: 49.364185,
    long: 17.128429,
  },
  {
    town: 'Hradčovice',
    townCode: 592200,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68733,
    lat: 49.049868,
    long: 17.582201,
  },
  {
    town: 'Hradec',
    townCode: 568724,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.707329,
    long: 15.295565,
  },
  {
    town: 'Hradec',
    townCode: 557731,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33211,
    lat: 49.635159,
    long: 13.121483,
  },
  {
    town: 'HRADEC KRÁLOVÉ',
    townCode: 569810,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50002,
    lat: 50.210461,
    long: 15.825311,
  },
  {
    town: 'Hradec nad Moravicí',
    townCode: 507270,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74741,
    lat: 49.871107,
    long: 17.875924,
  },
  {
    town: 'Hradec nad Svitavou',
    townCode: 572691,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56901,
    lat: 49.71153,
    long: 16.480687,
  },
  {
    town: 'Hradec-Nová Ves',
    townCode: 553301,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79084,
    lat: 50.283247,
    long: 17.281327,
  },
  {
    town: 'Hradečno',
    townCode: 532355,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27304,
    lat: 50.188435,
    long: 13.991367,
  },
  {
    town: 'Hrádek',
    townCode: 594148,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67127,
    lat: 48.772933,
    long: 16.268293,
  },
  {
    town: 'Hrádek',
    townCode: 570052,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.218662,
    long: 15.675654,
  },
  {
    town: 'Hrádek',
    townCode: 512176,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73997,
    lat: 49.616708,
    long: 18.737315,
  },
  {
    town: 'Hrádek',
    townCode: 547972,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 49.968309,
    long: 16.338406,
  },
  {
    town: 'Hrádek',
    townCode: 556301,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.261381,
    long: 13.498603,
  },
  {
    town: 'Hrádek',
    townCode: 559822,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33842,
    lat: 49.710027,
    long: 13.65421,
  },
  {
    town: 'Hrádek nad Nisou',
    townCode: 564095,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46334,
    lat: 50.852892,
    long: 14.844658,
  },
  {
    town: 'Hradešice',
    townCode: 556319,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.323206,
    long: 13.596547,
  },
  {
    town: 'Hradešín',
    townCode: 564800,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.038947,
    long: 14.756771,
  },
  {
    town: 'Hradiště',
    townCode: 566179,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.464875,
    long: 13.051832,
  },
  {
    town: 'Hradiště',
    townCode: 557749,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33544,
    lat: 49.439432,
    long: 13.756199,
  },
  {
    town: 'Hradiště',
    townCode: 541001,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.963121,
    long: 13.717739,
  },
  {
    town: 'Hradiště',
    townCode: 532932,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.684271,
    long: 14.848805,
  },
  {
    town: 'Hradiště (vojenský újezd)',
    townCode: 555177,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36006,
    lat: 50.174549,
    long: 13.046831,
  },
  {
    town: 'Hradištko',
    townCode: 537179,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28912,
    lat: 50.165593,
    long: 14.935157,
  },
  {
    town: 'Hradištko',
    townCode: 539252,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25209,
    lat: 49.870321,
    long: 14.407963,
  },
  {
    town: 'Hracholusky',
    townCode: 550221,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.0589,
    long: 14.088637,
  },
  {
    town: 'Hracholusky',
    townCode: 565202,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27041,
    lat: 50.003379,
    long: 13.773965,
  },
  {
    town: 'Hrachoviště',
    townCode: 562831,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 48.929471,
    long: 14.77121,
  },
  {
    town: 'Hranice',
    townCode: 544540,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.83852,
    long: 14.868392,
  },
  {
    town: 'Hranice',
    townCode: 554553,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35124,
    lat: 50.304702,
    long: 12.175894,
  },
  {
    town: 'Hranice',
    townCode: 513750,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.549764,
    long: 17.735022,
  },
  {
    town: 'Hraničné Petrovice',
    townCode: 546976,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78306,
    lat: 49.740948,
    long: 17.405043,
  },
  {
    town: 'Hrazany',
    townCode: 549410,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.52294,
    long: 14.33498,
  },
  {
    town: 'Hrčava',
    townCode: 598232,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73998,
    lat: 49.520116,
    long: 18.833235,
  },
  {
    town: 'Hrdějovice',
    townCode: 544558,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37361,
    lat: 49.019035,
    long: 14.478672,
  },
  {
    town: 'Hrdibořice',
    townCode: 589535,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79812,
    lat: 49.478575,
    long: 17.220521,
  },
  {
    town: 'Hrdlív',
    townCode: 532363,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27306,
    lat: 50.199356,
    long: 14.072592,
  },
  {
    town: 'Hrdlořezy',
    townCode: 535869,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29307,
    lat: 50.451494,
    long: 14.875505,
  },
  {
    town: 'Hrejkovice',
    townCode: 549428,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39859,
    lat: 49.474473,
    long: 14.290912,
  },
  {
    town: 'Hrob',
    townCode: 567558,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41704,
    lat: 50.659299,
    long: 13.726873,
  },
  {
    town: 'Hrobce',
    townCode: 564893,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41183,
    lat: 50.462572,
    long: 14.230906,
  },
  {
    town: 'Hrobčice',
    townCode: 567566,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41757,
    lat: 50.517448,
    long: 13.785716,
  },
  {
    town: 'Hrobice',
    townCode: 575046,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53352,
    lat: 50.103527,
    long: 15.78888,
  },
  {
    town: 'Hrobice',
    townCode: 585262,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 49.277494,
    long: 17.788329,
  },
  {
    town: 'Hrochův Týnec',
    townCode: 571491,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.959563,
    long: 15.910648,
  },
  {
    town: 'Hromnice',
    townCode: 558915,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.849175,
    long: 13.44157,
  },
  {
    town: 'Hronov',
    townCode: 574082,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54931,
    lat: 50.480164,
    long: 16.181777,
  },
  {
    town: 'Hrotovice',
    townCode: 590673,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.1078,
    long: 16.060777,
  },
  {
    town: 'Hroubovice',
    townCode: 571504,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53854,
    lat: 49.882632,
    long: 15.990827,
  },
  {
    town: 'Hroznatín',
    townCode: 550639,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.29784,
    long: 15.908371,
  },
  {
    town: 'Hroznětín',
    townCode: 555185,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36233,
    lat: 50.309508,
    long: 12.871918,
  },
  {
    town: 'Hroznová Lhota',
    townCode: 586188,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69663,
    lat: 48.90794,
    long: 17.417082,
  },
  {
    town: 'Hrubá Skála',
    townCode: 577146,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.544906,
    long: 15.200342,
  },
  {
    town: 'Hrubá Vrbka',
    townCode: 586196,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69673,
    lat: 48.871977,
    long: 17.477119,
  },
  {
    town: 'Hrubčice',
    townCode: 589543,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79821,
    lat: 49.450115,
    long: 17.193197,
  },
  {
    town: 'Hrubý Jeseník',
    townCode: 599638,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28932,
    lat: 50.251247,
    long: 15.094151,
  },
  {
    town: 'Hrusice',
    townCode: 538248,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25166,
    lat: 49.909951,
    long: 14.738162,
  },
  {
    town: 'Hruška',
    townCode: 543543,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79827,
    lat: 49.358882,
    long: 17.22677,
  },
  {
    town: 'Hrušky',
    townCode: 584487,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69156,
    lat: 48.792823,
    long: 16.97415,
  },
  {
    town: 'Hrušky',
    townCode: 593079,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68352,
    lat: 49.129301,
    long: 16.833583,
  },
  {
    town: 'Hrušov',
    townCode: 565733,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29473,
    lat: 50.344973,
    long: 14.846482,
  },
  {
    town: 'Hrušová',
    townCode: 580341,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56555,
    lat: 49.91361,
    long: 16.197832,
  },
  {
    town: 'Hrušovany',
    townCode: 563072,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43143,
    lat: 50.387359,
    long: 13.498471,
  },
  {
    town: 'Hrušovany u Brna',
    townCode: 583081,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66462,
    lat: 49.038731,
    long: 16.59439,
  },
  {
    town: 'Hrušovany nad Jevišovkou',
    townCode: 594156,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67167,
    lat: 48.830008,
    long: 16.40281,
  },
  {
    town: 'Hrutov',
    townCode: 590681,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67527,
    lat: 49.255545,
    long: 15.680298,
  },
  {
    town: 'Hřebeč',
    townCode: 532371,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27345,
    lat: 50.136054,
    long: 14.164571,
  },
  {
    town: 'Hřebečníky',
    townCode: 541761,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27041,
    lat: 49.984643,
    long: 13.753332,
  },
  {
    town: 'Hředle',
    townCode: 531219,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.903899,
    long: 13.920708,
  },
  {
    town: 'Hředle',
    townCode: 541770,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27008,
    lat: 50.188106,
    long: 13.749524,
  },
  {
    town: 'Hřensko',
    townCode: 562513,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40717,
    lat: 50.87451,
    long: 14.242617,
  },
  {
    town: 'Hřibiny-Ledská',
    townCode: 548642,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.148079,
    long: 16.175968,
  },
  {
    town: 'Hřibojedy',
    townCode: 579301,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.392163,
    long: 15.834831,
  },
  {
    town: 'Hřiměždice',
    townCode: 540285,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26214,
    lat: 49.686956,
    long: 14.275016,
  },
  {
    town: 'Hříšice',
    townCode: 546445,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.103431,
    long: 15.495538,
  },
  {
    town: 'Hříškov',
    townCode: 566195,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43904,
    lat: 50.291438,
    long: 13.864363,
  },
  {
    town: 'Hřivice',
    townCode: 566217,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43965,
    lat: 50.288215,
    long: 13.730349,
  },
  {
    town: 'Hřivínův Újezd',
    townCode: 585271,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76307,
    lat: 49.121057,
    long: 17.690424,
  },
  {
    town: 'Hubenov',
    townCode: 587222,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.392193,
    long: 15.469125,
  },
  {
    town: 'Hudčice',
    townCode: 513580,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.531789,
    long: 13.922614,
  },
  {
    town: 'Hudlice',
    townCode: 531227,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26703,
    lat: 49.961069,
    long: 13.970742,
  },
  {
    town: 'Hukvaldy',
    townCode: 598691,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73946,
    lat: 49.623907,
    long: 18.221998,
  },
  {
    town: 'Hulice',
    townCode: 529737,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25763,
    lat: 49.709703,
    long: 15.087693,
  },
  {
    town: 'Hulín',
    townCode: 588491,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76824,
    lat: 49.316992,
    long: 17.463848,
  },
  {
    town: 'Humburky',
    townCode: 570087,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.226124,
    long: 15.511631,
  },
  {
    town: 'Humpolec',
    townCode: 547999,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.541624,
    long: 15.359423,
  },
  {
    town: 'Huntířov',
    townCode: 562521,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.789539,
    long: 14.303537,
  },
  {
    town: 'Hůrky',
    townCode: 559849,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.745983,
    long: 13.683207,
  },
  {
    town: 'Hurtova Lhota',
    townCode: 530646,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.596462,
    long: 15.508912,
  },
  {
    town: 'Hůry',
    townCode: 535753,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 49.006592,
    long: 14.541183,
  },
  {
    town: 'Husí Lhota',
    townCode: 599522,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29406,
    lat: 50.435646,
    long: 15.00482,
  },
  {
    town: 'Husinec',
    townCode: 550230,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38421,
    lat: 49.055065,
    long: 13.987074,
  },
  {
    town: 'Husinec',
    townCode: 538256,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25068,
    lat: 50.173845,
    long: 14.375186,
  },
  {
    town: 'Huslenky',
    townCode: 542784,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75602,
    lat: 49.303274,
    long: 18.090479,
  },
  {
    town: 'Hustopeče',
    townCode: 584495,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69301,
    lat: 48.940946,
    long: 16.737726,
  },
  {
    town: 'Hustopeče nad Bečvou',
    townCode: 513768,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75366,
    lat: 49.530631,
    long: 17.870046,
  },
  {
    town: 'Huštěnovice',
    townCode: 592218,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68703,
    lat: 49.108271,
    long: 17.464577,
  },
  {
    town: 'Hutisko-Solanec',
    townCode: 542814,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75662,
    lat: 49.429584,
    long: 18.217836,
  },
  {
    town: 'Huzová',
    townCode: 597414,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79351,
    lat: 49.820063,
    long: 17.298064,
  },
  {
    town: 'Hvězdlice',
    townCode: 593087,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68341,
    lat: 49.193463,
    long: 17.083627,
  },
  {
    town: 'Hvězdonice',
    townCode: 529745,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25724,
    lat: 49.872921,
    long: 14.777379,
  },
  {
    town: 'Hvězdoňovice',
    townCode: 590690,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.220011,
    long: 15.762318,
  },
  {
    town: 'Hvozd',
    townCode: 589560,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79855,
    lat: 49.636303,
    long: 16.910181,
  },
  {
    town: 'Hvozd',
    townCode: 558931,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33101,
    lat: 49.939841,
    long: 13.26323,
  },
  {
    town: 'Hvozd',
    townCode: 565334,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.051606,
    long: 13.698511,
  },
  {
    town: 'Hvozdec',
    townCode: 535613,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37372,
    lat: 48.99242,
    long: 14.62741,
  },
  {
    town: 'Hvozdec',
    townCode: 583090,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66471,
    lat: 49.247005,
    long: 16.425292,
  },
  {
    town: 'Hvozdec',
    townCode: 531235,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26762,
    lat: 49.807152,
    long: 13.880406,
  },
  {
    town: 'Hvozdná',
    townCode: 585289,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76311,
    lat: 49.248581,
    long: 17.751742,
  },
  {
    town: 'Hvozdnice',
    townCode: 573621,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.191374,
    long: 15.711346,
  },
  {
    town: 'Hvozdnice',
    townCode: 539261,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25205,
    lat: 49.872607,
    long: 14.3712,
  },
  {
    town: 'Hvožďany',
    townCode: 566331,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.505677,
    long: 12.771387,
  },
  {
    town: 'Hvožďany',
    townCode: 540315,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26244,
    lat: 49.528354,
    long: 13.805216,
  },
  {
    town: 'Hybrálec',
    townCode: 550281,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58601,
    lat: 49.409551,
    long: 15.589163,
  },
  {
    town: 'Hynčice',
    townCode: 574163,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54983,
    lat: 50.623831,
    long: 16.285403,
  },
  {
    town: 'Hynčina',
    townCode: 536113,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.848884,
    long: 16.793108,
  },
  {
    town: 'Hýskov',
    townCode: 531243,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26706,
    lat: 49.990829,
    long: 14.050654,
  },
  {
    town: 'Hýsly',
    townCode: 586200,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69650,
    lat: 49.023388,
    long: 17.179934,
  },
  {
    town: 'Chabařovice',
    townCode: 568007,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40317,
    lat: 50.673287,
    long: 13.941955,
  },
  {
    town: 'Chabeřice',
    townCode: 534081,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.750246,
    long: 15.073898,
  },
  {
    town: 'Chaloupky',
    townCode: 531251,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26762,
    lat: 49.791959,
    long: 13.868465,
  },
  {
    town: 'Chanovice',
    townCode: 556335,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.405001,
    long: 13.717463,
  },
  {
    town: 'Charvatce',
    townCode: 565784,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29445,
    lat: 50.322727,
    long: 14.998718,
  },
  {
    town: 'Charváty',
    townCode: 568872,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78375,
    lat: 49.518462,
    long: 17.254067,
  },
  {
    town: 'Chářovice',
    townCode: 532886,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25741,
    lat: 49.820354,
    long: 14.577967,
  },
  {
    town: 'Chbany',
    townCode: 563081,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43157,
    lat: 50.332881,
    long: 13.430488,
  },
  {
    town: 'Cheb',
    townCode: 554481,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.079633,
    long: 12.369964,
  },
  {
    town: 'Chelčice',
    townCode: 551139,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.121887,
    long: 14.169215,
  },
  {
    town: 'Cheznovice',
    townCode: 559857,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33806,
    lat: 49.779032,
    long: 13.785491,
  },
  {
    town: 'Chlebičov',
    townCode: 512923,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74731,
    lat: 49.959517,
    long: 17.967589,
  },
  {
    town: 'Chleby',
    townCode: 532878,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25741,
    lat: 49.827106,
    long: 14.556986,
  },
  {
    town: 'Chleby',
    townCode: 599620,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28931,
    lat: 50.222917,
    long: 15.089496,
  },
  {
    town: 'Chleny',
    townCode: 576310,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51745,
    lat: 50.077977,
    long: 16.243846,
  },
  {
    town: 'Chlistov',
    townCode: 556343,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.320001,
    long: 13.360983,
  },
  {
    town: 'Chlístov',
    townCode: 590703,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.202158,
    long: 15.743777,
  },
  {
    town: 'Chlístov',
    townCode: 548791,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.322469,
    long: 16.169563,
  },
  {
    town: 'Chlístov',
    townCode: 532045,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.801625,
    long: 14.654822,
  },
  {
    town: 'Chlístovice',
    townCode: 534099,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.885817,
    long: 15.202598,
  },
  {
    town: 'Chlum',
    townCode: 529982,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.447303,
    long: 13.851194,
  },
  {
    town: 'Chlum',
    townCode: 590711,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.313525,
    long: 15.767159,
  },
  {
    town: 'Chlum',
    townCode: 561614,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.578538,
    long: 14.562772,
  },
  {
    town: 'Chlum',
    townCode: 557773,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.605305,
    long: 13.479305,
  },
  {
    town: 'Chlum',
    townCode: 540803,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.935789,
    long: 13.65979,
  },
  {
    town: 'Chlum',
    townCode: 529770,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25763,
    lat: 49.693104,
    long: 14.99586,
  },
  {
    town: 'Chlum Svaté Maří',
    townCode: 560375,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35709,
    lat: 50.149949,
    long: 12.535762,
  },
  {
    town: 'Chlum u Třeboně',
    townCode: 546461,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37804,
    lat: 48.96245,
    long: 14.928089,
  },
  {
    town: 'Chlumany',
    townCode: 550248,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.06667,
    long: 13.965462,
  },
  {
    town: 'Chlumčany',
    townCode: 557781,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33442,
    lat: 49.632666,
    long: 13.313337,
  },
  {
    town: 'Chlumčany',
    townCode: 566233,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43903,
    lat: 50.335042,
    long: 13.843328,
  },
  {
    town: 'Chlumec',
    townCode: 536229,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.870362,
    long: 14.395976,
  },
  {
    town: 'Chlumec',
    townCode: 568015,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40339,
    lat: 50.699825,
    long: 13.939752,
  },
  {
    town: 'Chlumec nad Cidlinou',
    townCode: 570109,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.154506,
    long: 15.460363,
  },
  {
    town: 'Chlumek',
    townCode: 595713,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59442,
    lat: 49.374585,
    long: 15.854861,
  },
  {
    town: 'Chlumětín',
    townCode: 595721,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59202,
    lat: 49.727586,
    long: 16.003178,
  },
  {
    town: 'Chlumín',
    townCode: 534820,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27743,
    lat: 50.289218,
    long: 14.449384,
  },
  {
    town: 'Chlum-Korouhvice',
    townCode: 595705,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.575317,
    long: 16.320783,
  },
  {
    town: 'Chlumy',
    townCode: 540307,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.43786,
    long: 13.638713,
  },
  {
    town: 'Chlustina',
    townCode: 534455,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.878043,
    long: 13.919627,
  },
  {
    town: 'Chmelík',
    townCode: 572730,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.773488,
    long: 16.332883,
  },
  {
    town: 'Chmelná',
    townCode: 529788,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.648205,
    long: 14.988457,
  },
  {
    town: 'Chobot',
    townCode: 536903,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.462516,
    long: 13.93382,
  },
  {
    town: 'Choceň',
    townCode: 580350,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.001704,
    long: 16.223131,
  },
  {
    town: 'Chocenice',
    townCode: 557803,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.547648,
    long: 13.520152,
  },
  {
    town: 'Chocerady',
    townCode: 529796,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25724,
    lat: 49.873005,
    long: 14.802174,
  },
  {
    town: 'Chocnějovice',
    townCode: 535923,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29413,
    lat: 50.577007,
    long: 14.971496,
  },
  {
    town: 'Chocomyšl',
    townCode: 553727,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.467282,
    long: 13.13077,
  },
  {
    town: 'Chodouň',
    townCode: 534447,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.898288,
    long: 13.986668,
  },
  {
    town: 'Chodouny',
    townCode: 564923,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41171,
    lat: 50.47327,
    long: 14.250171,
  },
  {
    town: 'Chodov',
    townCode: 578011,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36464,
    lat: 50.068626,
    long: 12.863016,
  },
  {
    town: 'Chodov',
    townCode: 560383,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35735,
    lat: 50.23983,
    long: 12.747709,
  },
  {
    town: 'Chodov',
    townCode: 553735,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34533,
    lat: 49.418088,
    long: 12.830346,
  },
  {
    town: 'Chodová Planá',
    townCode: 560901,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34813,
    lat: 49.893323,
    long: 12.730254,
  },
  {
    town: 'Chodovlice',
    townCode: 564931,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.463209,
    long: 13.993372,
  },
  {
    town: 'Chodská Lhota',
    townCode: 553743,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.358456,
    long: 13.083271,
  },
  {
    town: 'Chodský Újezd',
    townCode: 560910,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34815,
    lat: 49.864425,
    long: 12.650047,
  },
  {
    town: 'Cholenice',
    townCode: 549355,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50732,
    lat: 50.324828,
    long: 15.280763,
  },
  {
    town: 'Cholina',
    townCode: 502839,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78322,
    lat: 49.656198,
    long: 17.054513,
  },
  {
    town: 'Choltice',
    townCode: 575054,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53361,
    lat: 49.987822,
    long: 15.619515,
  },
  {
    town: 'Chomle',
    townCode: 541141,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33828,
    lat: 49.86238,
    long: 13.63461,
  },
  {
    town: 'Chomutice',
    townCode: 572969,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50753,
    lat: 50.359371,
    long: 15.496287,
  },
  {
    town: 'Chomutov',
    townCode: 562971,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43004,
    lat: 50.463598,
    long: 13.410837,
  },
  {
    town: 'Chomýž',
    townCode: 588504,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.362473,
    long: 17.645513,
  },
  {
    town: 'Choratice',
    townCode: 532606,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.83943,
    long: 14.874791,
  },
  {
    town: 'Chornice',
    townCode: 578096,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56942,
    lat: 49.667478,
    long: 16.742731,
  },
  {
    town: 'Chorušice',
    townCode: 534838,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27737,
    lat: 50.390682,
    long: 14.670873,
  },
  {
    town: 'Choryně',
    townCode: 542831,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75642,
    lat: 49.495846,
    long: 17.898722,
  },
  {
    town: 'Choťánky',
    townCode: 537217,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.138263,
    long: 15.16254,
  },
  {
    town: 'Chotěboř',
    townCode: 568759,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.720714,
    long: 15.671142,
  },
  {
    town: 'Chotěbudice',
    townCode: 550477,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 49.058086,
    long: 15.574099,
  },
  {
    town: 'Chotěbuz',
    townCode: 555291,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73561,
    lat: 49.768592,
    long: 18.569232,
  },
  {
    town: 'Choteč',
    townCode: 549037,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50781,
    lat: 50.432957,
    long: 15.516036,
  },
  {
    town: 'Choteč',
    townCode: 575062,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53304,
    lat: 50.083128,
    long: 15.880341,
  },
  {
    town: 'Choteč',
    townCode: 539287,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25226,
    lat: 49.986657,
    long: 14.283022,
  },
  {
    town: 'Chotěmice',
    townCode: 552453,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.275324,
    long: 14.877036,
  },
  {
    town: 'Chotěnov',
    townCode: 578100,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.823356,
    long: 16.189972,
  },
  {
    town: 'Chotěšice',
    townCode: 537225,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28901,
    lat: 50.278663,
    long: 15.273164,
  },
  {
    town: 'Chotěšov',
    townCode: 557838,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33214,
    lat: 49.65419,
    long: 13.202822,
  },
  {
    town: 'Chotěšov',
    townCode: 564940,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.439891,
    long: 14.085254,
  },
  {
    town: 'Chotětov',
    townCode: 535931,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29428,
    lat: 50.337534,
    long: 14.801624,
  },
  {
    town: 'Chotěvice',
    townCode: 579319,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54371,
    lat: 50.521498,
    long: 15.766799,
  },
  {
    town: 'Chotíkov',
    townCode: 558940,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33017,
    lat: 49.793052,
    long: 13.317774,
  },
  {
    town: 'Chotilsko',
    townCode: 540323,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26203,
    lat: 49.770587,
    long: 14.352585,
  },
  {
    town: 'Chotiměř',
    townCode: 564958,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.548326,
    long: 14.000996,
  },
  {
    town: 'Chotiněves',
    townCode: 564966,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41145,
    lat: 50.552187,
    long: 14.279353,
  },
  {
    town: 'Chotovice',
    townCode: 561622,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47301,
    lat: 50.74039,
    long: 14.559384,
  },
  {
    town: 'Chotovice',
    townCode: 578118,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.851152,
    long: 16.171354,
  },
  {
    town: 'Choťovice',
    townCode: 534994,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28905,
    lat: 50.142489,
    long: 15.31978,
  },
  {
    town: 'Chotoviny',
    townCode: 552461,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39137,
    lat: 49.478132,
    long: 14.677049,
  },
  {
    town: 'Chotusice',
    townCode: 534102,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28576,
    lat: 49.949241,
    long: 15.394385,
  },
  {
    town: 'Chotutice',
    townCode: 533343,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28103,
    lat: 50.070077,
    long: 14.989985,
  },
  {
    town: 'Chotýčany',
    townCode: 535907,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37362,
    lat: 49.067394,
    long: 14.520691,
  },
  {
    town: 'Chotyně',
    townCode: 564109,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46334,
    lat: 50.83632,
    long: 14.869039,
  },
  {
    town: 'Chotýšany',
    townCode: 529818,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25728,
    lat: 49.744203,
    long: 14.814683,
  },
  {
    town: 'Choustník',
    townCode: 552470,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39118,
    lat: 49.333045,
    long: 14.838492,
  },
  {
    town: 'Choustníkovo Hradiště',
    townCode: 579327,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54442,
    lat: 50.426514,
    long: 15.878682,
  },
  {
    town: 'Chožov',
    townCode: 566241,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43922,
    lat: 50.39887,
    long: 13.859103,
  },
  {
    town: 'Chraberce',
    townCode: 546429,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.408357,
    long: 13.829608,
  },
  {
    town: 'Chrast',
    townCode: 571539,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53851,
    lat: 49.902149,
    long: 15.934067,
  },
  {
    town: 'Chrást',
    townCode: 558966,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33003,
    lat: 49.793305,
    long: 13.49369,
  },
  {
    town: 'Chrást',
    townCode: 537233,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28914,
    lat: 50.119017,
    long: 14.898236,
  },
  {
    town: 'Chrást',
    townCode: 564249,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.594513,
    long: 13.956768,
  },
  {
    town: 'Chrastava',
    townCode: 564117,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46331,
    lat: 50.817027,
    long: 14.968947,
  },
  {
    town: 'Chrastavec',
    townCode: 578126,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.617858,
    long: 16.503245,
  },
  {
    town: 'Chrastavice',
    townCode: 553751,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.453663,
    long: 12.956921,
  },
  {
    town: 'Chrášťany',
    townCode: 544591,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37304,
    lat: 49.296087,
    long: 14.387621,
  },
  {
    town: 'Chrášťany',
    townCode: 532037,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.792155,
    long: 14.582032,
  },
  {
    town: 'Chrášťany',
    townCode: 533351,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.065584,
    long: 14.930251,
  },
  {
    town: 'Chrášťany',
    townCode: 539295,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25219,
    lat: 50.046148,
    long: 14.261423,
  },
  {
    town: 'Chrášťany',
    townCode: 541818,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27001,
    lat: 50.146543,
    long: 13.667388,
  },
  {
    town: 'Chraštice',
    townCode: 540358,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.576891,
    long: 14.071933,
  },
  {
    town: 'Chrášťovice',
    townCode: 551155,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.333292,
    long: 13.89714,
  },
  {
    town: 'Chrbonín',
    townCode: 563145,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39155,
    lat: 49.358766,
    long: 14.864401,
  },
  {
    town: 'Chroboly',
    townCode: 550264,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38404,
    lat: 48.956632,
    long: 14.067078,
  },
  {
    town: 'Chromeč',
    townCode: 569305,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.933846,
    long: 16.893779,
  },
  {
    town: 'Chropyně',
    townCode: 588512,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76811,
    lat: 49.35654,
    long: 17.364618,
  },
  {
    town: 'Chroustov',
    townCode: 534706,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28902,
    lat: 50.28669,
    long: 15.347273,
  },
  {
    town: 'Chroustovice',
    townCode: 571547,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53863,
    lat: 49.955625,
    long: 15.991536,
  },
  {
    town: 'Chrtníč',
    townCode: 568767,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.767642,
    long: 15.443719,
  },
  {
    town: 'Chrtníky',
    townCode: 572764,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.9819,
    long: 15.604954,
  },
  {
    town: 'Chrudichromy',
    townCode: 581534,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.502996,
    long: 16.628098,
  },
  {
    town: 'Chrudim',
    townCode: 571164,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.949824,
    long: 15.795158,
  },
  {
    town: 'Chrustenice',
    townCode: 533670,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26712,
    lat: 50.006145,
    long: 14.152325,
  },
  {
    town: 'Chržín',
    townCode: 532398,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27324,
    lat: 50.295476,
    long: 14.270238,
  },
  {
    town: 'Chřenovice',
    townCode: 573574,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.716741,
    long: 15.216372,
  },
  {
    town: 'Chřibská',
    townCode: 562530,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40744,
    lat: 50.863346,
    long: 14.483083,
  },
  {
    town: 'Chříč',
    townCode: 558974,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.97192,
    long: 13.646002,
  },
  {
    town: 'Chudčice',
    townCode: 583111,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66471,
    lat: 49.288591,
    long: 16.458829,
  },
  {
    town: 'Chudenice',
    townCode: 556378,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.466785,
    long: 13.17397,
  },
  {
    town: 'Chudenín',
    townCode: 556386,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34022,
    lat: 49.29315,
    long: 13.100904,
  },
  {
    town: 'Chuderov',
    townCode: 568023,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.68875,
    long: 14.046285,
  },
  {
    town: 'Chudeřice',
    townCode: 570125,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.149139,
    long: 15.550972,
  },
  {
    town: 'Chudíř',
    townCode: 571849,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29445,
    lat: 50.308893,
    long: 15.013907,
  },
  {
    town: 'Chudoslavice',
    townCode: 546810,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.583028,
    long: 14.187346,
  },
  {
    town: 'Chuchelna',
    townCode: 577154,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.602387,
    long: 15.300449,
  },
  {
    town: 'Chuchelná',
    townCode: 507334,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74724,
    lat: 49.986735,
    long: 18.116667,
  },
  {
    town: 'Chvalatice',
    townCode: 594164,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.947809,
    long: 15.751157,
  },
  {
    town: 'Chvalčov',
    townCode: 506737,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76872,
    lat: 49.389281,
    long: 17.711595,
  },
  {
    town: 'Chvaleč',
    townCode: 579335,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54211,
    lat: 50.595999,
    long: 16.03941,
  },
  {
    town: 'Chválenice',
    townCode: 557846,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33205,
    lat: 49.643095,
    long: 13.476053,
  },
  {
    town: 'Chvaletice',
    townCode: 575071,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53312,
    lat: 50.034532,
    long: 15.418562,
  },
  {
    town: 'Chvalíkovice',
    townCode: 569909,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74706,
    lat: 49.885738,
    long: 17.911052,
  },
  {
    town: 'Chvalkovice',
    townCode: 593095,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68341,
    lat: 49.187125,
    long: 17.110212,
  },
  {
    town: 'Chvalkovice',
    townCode: 574112,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55204,
    lat: 50.414437,
    long: 15.978392,
  },
  {
    town: 'Chvalnov-Lísky',
    townCode: 588547,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76805,
    lat: 49.166079,
    long: 17.231009,
  },
  {
    town: 'Chvalovice',
    townCode: 537420,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.01045,
    long: 14.231802,
  },
  {
    town: 'Chvalovice',
    townCode: 594172,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.786677,
    long: 16.082449,
  },
  {
    town: 'Chvalšiny',
    townCode: 545546,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38208,
    lat: 48.854119,
    long: 14.211239,
  },
  {
    town: 'Chvatěruby',
    townCode: 534846,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27801,
    lat: 50.232842,
    long: 14.342788,
  },
  {
    town: 'Chvojenec',
    townCode: 575089,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.109676,
    long: 15.937327,
  },
  {
    town: 'Chyjice',
    townCode: 549223,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.387734,
    long: 15.29557,
  },
  {
    town: 'Chyňava',
    townCode: 531294,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26707,
    lat: 50.027467,
    long: 14.074092,
  },
  {
    town: 'Chýně',
    townCode: 539309,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25301,
    lat: 50.060826,
    long: 14.227054,
  },
  {
    town: 'Chýnice',
    townCode: 513431,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25217,
    lat: 49.995792,
    long: 14.264385,
  },
  {
    town: 'Chýnov',
    townCode: 552496,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39155,
    lat: 49.406872,
    long: 14.811319,
  },
  {
    town: 'Chýstovice',
    townCode: 561339,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.585781,
    long: 15.079667,
  },
  {
    town: 'Chyše',
    townCode: 555207,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36453,
    lat: 50.104736,
    long: 13.249179,
  },
  {
    town: 'Chyšky',
    townCode: 549452,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39853,
    lat: 49.52356,
    long: 14.427673,
  },
  {
    town: 'Chyšná',
    townCode: 561321,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.586467,
    long: 15.10003,
  },
  {
    town: 'Chýšť',
    townCode: 575097,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.128259,
    long: 15.541389,
  },
  {
    town: 'Ivaň',
    townCode: 584517,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69123,
    lat: 48.929811,
    long: 16.575843,
  },
  {
    town: 'Ivaň',
    townCode: 589578,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79823,
    lat: 49.424694,
    long: 17.251454,
  },
  {
    town: 'Ivančice',
    townCode: 583120,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.101545,
    long: 16.377622,
  },
  {
    town: 'Ivanovice na Hané',
    townCode: 593117,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68323,
    lat: 49.305518,
    long: 17.093537,
  },
  {
    town: 'Jabkenice',
    townCode: 535966,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29445,
    lat: 50.324168,
    long: 15.01488,
  },
  {
    town: 'Jabloňany',
    townCode: 581666,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67901,
    lat: 49.465713,
    long: 16.6061,
  },
  {
    town: 'Jablonec nad Jizerou',
    townCode: 577162,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51243,
    lat: 50.703569,
    long: 15.429698,
  },
  {
    town: 'Jablonec nad Nisou',
    townCode: 563510,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46601,
    lat: 50.722153,
    long: 15.170414,
  },
  {
    town: 'Jablonná',
    townCode: 540374,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26263,
    lat: 49.661146,
    long: 14.138547,
  },
  {
    town: 'Jablonné nad Orlicí',
    townCode: 580376,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56164,
    lat: 50.029734,
    long: 16.600698,
  },
  {
    town: 'Jablonné v Podještědí',
    townCode: 561631,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47125,
    lat: 50.765382,
    long: 14.760633,
  },
  {
    town: 'Jabloňov',
    townCode: 595730,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.324114,
    long: 16.089764,
  },
  {
    town: 'Jablůnka',
    townCode: 542865,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75623,
    lat: 49.383651,
    long: 17.950317,
  },
  {
    town: 'Jablunkov',
    townCode: 598259,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73991,
    lat: 49.576815,
    long: 18.764694,
  },
  {
    town: 'Jahodov',
    townCode: 548782,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51601,
    lat: 50.150364,
    long: 16.333536,
  },
  {
    town: 'Jáchymov',
    townCode: 555215,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36251,
    lat: 50.358573,
    long: 12.934767,
  },
  {
    town: 'Jakartovice',
    townCode: 507377,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74753,
    lat: 49.915196,
    long: 17.684108,
  },
  {
    town: 'Jakubčovice nad Odrou',
    townCode: 554065,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74236,
    lat: 49.695138,
    long: 17.787781,
  },
  {
    town: 'Jakubov u Moravských Budějovic',
    townCode: 590746,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67544,
    lat: 49.081114,
    long: 15.761519,
  },
  {
    town: 'Jakubovice',
    townCode: 553344,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78991,
    lat: 49.994405,
    long: 16.828875,
  },
  {
    town: 'Jalubí',
    townCode: 592226,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68705,
    lat: 49.116359,
    long: 17.427985,
  },
  {
    town: 'Jamné',
    townCode: 587249,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.431232,
    long: 15.723948,
  },
  {
    town: 'Jamné nad Orlicí',
    townCode: 580392,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56165,
    lat: 50.039685,
    long: 16.633004,
  },
  {
    town: 'Jamolice',
    townCode: 594181,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.072435,
    long: 16.253784,
  },
  {
    town: 'Jámy',
    townCode: 595756,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59232,
    lat: 49.530363,
    long: 16.005752,
  },
  {
    town: 'Jankov',
    townCode: 544612,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.966544,
    long: 14.297986,
  },
  {
    town: 'Jankov',
    townCode: 561461,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.415196,
    long: 15.38632,
  },
  {
    town: 'Jankov',
    townCode: 529842,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25703,
    lat: 49.653039,
    long: 14.730847,
  },
  {
    town: 'Jankovice',
    townCode: 575101,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.007735,
    long: 15.529259,
  },
  {
    town: 'Jankovice',
    townCode: 588555,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.35638,
    long: 17.618744,
  },
  {
    town: 'Jankovice',
    townCode: 592234,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68704,
    lat: 49.154219,
    long: 17.388585,
  },
  {
    town: 'Janoušov',
    townCode: 553212,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78991,
    lat: 50.01321,
    long: 16.845209,
  },
  {
    town: 'Janov',
    townCode: 576328,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.332407,
    long: 16.25188,
  },
  {
    town: 'Janov',
    townCode: 597431,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79384,
    lat: 50.244949,
    long: 17.481294,
  },
  {
    town: 'Janov',
    townCode: 578134,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56955,
    lat: 49.840871,
    long: 16.385333,
  },
  {
    town: 'Janov',
    townCode: 565270,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27006,
    lat: 50.210508,
    long: 13.639913,
  },
  {
    town: 'Janov',
    townCode: 544680,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.860304,
    long: 14.265378,
  },
  {
    town: 'Janov nad Nisou',
    townCode: 563595,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46811,
    lat: 50.772141,
    long: 15.169244,
  },
  {
    town: 'Janová',
    townCode: 570346,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75501,
    lat: 49.312144,
    long: 18.020158,
  },
  {
    town: 'Janovice',
    townCode: 507423,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73911,
    lat: 49.621505,
    long: 18.406126,
  },
  {
    town: 'Janovice nad Úhlavou',
    townCode: 556394,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.345257,
    long: 13.218239,
  },
  {
    town: 'Janovice v Podještědí',
    townCode: 561657,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46353,
    lat: 50.762974,
    long: 14.824344,
  },
  {
    town: 'Janská',
    townCode: 530395,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.80461,
    long: 14.363559,
  },
  {
    town: 'Janské Lázně',
    townCode: 579351,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54225,
    lat: 50.631188,
    long: 15.781916,
  },
  {
    town: 'Janův Důl',
    townCode: 546658,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46352,
    lat: 50.704656,
    long: 14.940408,
  },
  {
    town: 'Janůvky',
    townCode: 578142,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.671651,
    long: 16.592171,
  },
  {
    town: 'Jarcová',
    townCode: 542903,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75701,
    lat: 49.444628,
    long: 17.965972,
  },
  {
    town: 'Jarohněvice',
    townCode: 588563,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76801,
    lat: 49.267176,
    long: 17.377672,
  },
  {
    town: 'Jaroměř',
    townCode: 574121,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.356904,
    long: 15.924238,
  },
  {
    town: 'Jaroměřice',
    townCode: 578151,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56944,
    lat: 49.625661,
    long: 16.751955,
  },
  {
    town: 'Jaroměřice nad Rokytnou',
    townCode: 590754,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67551,
    lat: 49.094184,
    long: 15.893408,
  },
  {
    town: 'Jaroslav',
    townCode: 575119,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.012339,
    long: 16.077983,
  },
  {
    town: 'Jaroslavice',
    townCode: 594199,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67128,
    lat: 48.756671,
    long: 16.233615,
  },
  {
    town: 'Jarošov',
    townCode: 578169,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56966,
    lat: 49.824915,
    long: 16.16347,
  },
  {
    town: 'Jarošov nad Nežárkou',
    townCode: 546500,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37841,
    lat: 49.189995,
    long: 15.06744,
  },
  {
    town: 'Jarov',
    townCode: 578541,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.521192,
    long: 13.507696,
  },
  {
    town: 'Jarov',
    townCode: 558982,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.872569,
    long: 13.474387,
  },
  {
    town: 'Jarpice',
    townCode: 532401,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27372,
    lat: 50.321709,
    long: 14.08533,
  },
  {
    town: 'Jasenice',
    townCode: 590762,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.25824,
    long: 16.163698,
  },
  {
    town: 'Jasenná',
    townCode: 574139,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55222,
    lat: 50.318379,
    long: 15.99108,
  },
  {
    town: 'Jasenná',
    townCode: 585301,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76313,
    lat: 49.253493,
    long: 17.894297,
  },
  {
    town: 'Javor',
    townCode: 541869,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.325542,
    long: 13.247541,
  },
  {
    town: 'Javorek',
    townCode: 595748,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.65028,
    long: 16.17387,
  },
  {
    town: 'Javornice',
    townCode: 576336,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51711,
    lat: 50.171465,
    long: 16.349372,
  },
  {
    town: 'Javorník',
    townCode: 586218,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69674,
    lat: 48.862174,
    long: 17.533503,
  },
  {
    town: 'Javorník',
    townCode: 536148,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79070,
    lat: 50.390868,
    long: 17.002821,
  },
  {
    town: 'Javorník',
    townCode: 572713,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.782812,
    long: 16.427483,
  },
  {
    town: 'Javorník',
    townCode: 580406,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.889566,
    long: 16.156118,
  },
  {
    town: 'Javorník',
    townCode: 529851,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25763,
    lat: 49.686598,
    long: 15.026636,
  },
  {
    town: 'Javůrek',
    townCode: 583154,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.255628,
    long: 16.362283,
  },
  {
    town: 'Jedlá',
    townCode: 568783,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.73822,
    long: 15.234446,
  },
  {
    town: 'Jedlany',
    townCode: 562963,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39137,
    lat: 49.494676,
    long: 14.71654,
  },
  {
    town: 'Jedlí',
    townCode: 536288,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.931312,
    long: 16.794838,
  },
  {
    town: 'Jedlová',
    townCode: 578185,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56991,
    lat: 49.661104,
    long: 16.306186,
  },
  {
    town: 'Jedomělice',
    townCode: 532410,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27378,
    lat: 50.233057,
    long: 13.972409,
  },
  {
    town: 'Jedousov',
    townCode: 575127,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.995451,
    long: 15.610295,
  },
  {
    town: 'Jedovnice',
    townCode: 581682,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67906,
    lat: 49.344631,
    long: 16.756055,
  },
  {
    town: 'Jehnědí',
    townCode: 580414,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 49.971109,
    long: 16.310007,
  },
  {
    town: 'Jemnice',
    townCode: 590789,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 49.019086,
    long: 15.570038,
  },
  {
    town: 'Jemníky',
    townCode: 532428,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27401,
    lat: 50.207644,
    long: 14.119076,
  },
  {
    town: 'Jenčice',
    townCode: 505528,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.483044,
    long: 14.004486,
  },
  {
    town: 'Jeneč',
    townCode: 539317,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25261,
    lat: 50.087404,
    long: 14.214924,
  },
  {
    town: 'Jeníkov',
    townCode: 547816,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.74259,
    long: 15.957449,
  },
  {
    town: 'Jeníkov',
    townCode: 567582,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41724,
    lat: 50.628702,
    long: 13.749019,
  },
  {
    town: 'Jeníkovice',
    townCode: 570133,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50346,
    lat: 50.22828,
    long: 16.002737,
  },
  {
    town: 'Jeníkovice',
    townCode: 575135,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.981594,
    long: 15.660618,
  },
  {
    town: 'Jenišov',
    townCode: 537926,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.226649,
    long: 12.800046,
  },
  {
    town: 'Jenišovice',
    townCode: 563609,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46833,
    lat: 50.627796,
    long: 15.136637,
  },
  {
    town: 'Jenišovice',
    townCode: 571563,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53864,
    lat: 49.929644,
    long: 16.03112,
  },
  {
    town: 'Jenštejn',
    townCode: 538264,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25073,
    lat: 50.152759,
    long: 14.611909,
  },
  {
    town: 'Jersín',
    townCode: 587265,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58825,
    lat: 49.421358,
    long: 15.830768,
  },
  {
    town: 'Jeřice',
    townCode: 572993,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.344654,
    long: 15.680876,
  },
  {
    town: 'Jeřišno',
    townCode: 568805,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58274,
    lat: 49.792454,
    long: 15.641764,
  },
  {
    town: 'Jeřmanice',
    townCode: 530484,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46312,
    lat: 50.699666,
    long: 15.09393,
  },
  {
    town: 'Jesenec',
    townCode: 589586,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79853,
    lat: 49.608512,
    long: 16.862184,
  },
  {
    town: 'Jesenice',
    townCode: 539325,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25242,
    lat: 49.968246,
    long: 14.513602,
  },
  {
    town: 'Jesenice',
    townCode: 540391,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.607849,
    long: 14.47823,
  },
  {
    town: 'Jesenice',
    townCode: 541834,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27033,
    lat: 50.097137,
    long: 13.469595,
  },
  {
    town: 'Jeseník',
    townCode: 536385,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79001,
    lat: 50.224725,
    long: 17.198147,
  },
  {
    town: 'Jeseník nad Odrou',
    townCode: 599468,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74233,
    lat: 49.61204,
    long: 17.905365,
  },
  {
    town: 'Jesenný',
    townCode: 577171,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51212,
    lat: 50.660595,
    long: 15.338516,
  },
  {
    town: 'Jestřabí',
    townCode: 585319,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76333,
    lat: 49.068135,
    long: 17.955981,
  },
  {
    town: 'Jestřabí Lhota',
    townCode: 533360,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.089936,
    long: 15.261812,
  },
  {
    town: 'Jestřabí v Krkonoších',
    townCode: 577189,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51401,
    lat: 50.680618,
    long: 15.491835,
  },
  {
    town: 'Jestřebí',
    townCode: 574147,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.362184,
    long: 16.182163,
  },
  {
    town: 'Jestřebí',
    townCode: 561665,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47161,
    lat: 50.608694,
    long: 14.584657,
  },
  {
    town: 'Jestřebí',
    townCode: 536393,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.852199,
    long: 16.868736,
  },
  {
    town: 'Ješetice',
    townCode: 532134,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25789,
    lat: 49.581263,
    long: 14.610228,
  },
  {
    town: 'Jetětice',
    townCode: 549479,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39848,
    lat: 49.386055,
    long: 14.29271,
  },
  {
    town: 'Jetřichov',
    townCode: 574155,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54983,
    lat: 50.615071,
    long: 16.266763,
  },
  {
    town: 'Jetřichovice',
    townCode: 562556,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40716,
    lat: 50.852494,
    long: 14.394022,
  },
  {
    town: 'Jevany',
    townCode: 533378,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28166,
    lat: 49.970671,
    long: 14.810582,
  },
  {
    town: 'Jevíčko',
    townCode: 578193,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.632295,
    long: 16.71136,
  },
  {
    town: 'Jeviněves',
    townCode: 531871,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27705,
    lat: 50.345214,
    long: 14.33821,
  },
  {
    town: 'Jevišovice',
    townCode: 594202,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.987465,
    long: 15.990027,
  },
  {
    town: 'Jevišovka',
    townCode: 584525,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69183,
    lat: 48.82869,
    long: 16.46626,
  },
  {
    town: 'Jezbořice',
    townCode: 575143,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.980674,
    long: 15.694777,
  },
  {
    town: 'Jezdkovice',
    townCode: 547191,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74755,
    lat: 49.923129,
    long: 17.774912,
  },
  {
    town: 'Jezdovice',
    townCode: 587273,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58901,
    lat: 49.323203,
    long: 15.484258,
  },
  {
    town: 'Jezernice',
    townCode: 556998,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.547873,
    long: 17.625008,
  },
  {
    town: 'Jezeřany-Maršovice',
    townCode: 594211,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67175,
    lat: 49.028912,
    long: 16.437429,
  },
  {
    town: 'Ježená',
    townCode: 587281,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58841,
    lat: 49.416395,
    long: 15.465658,
  },
  {
    town: 'Ježkovice',
    townCode: 593125,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68304,
    lat: 49.298073,
    long: 16.892634,
  },
  {
    town: 'Ježov',
    townCode: 586226,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69648,
    lat: 49.027077,
    long: 17.210115,
  },
  {
    town: 'Ježov',
    townCode: 548073,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.613127,
    long: 15.23382,
  },
  {
    town: 'Ježovy',
    townCode: 541753,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.491162,
    long: 13.228504,
  },
  {
    town: 'Jickovice',
    townCode: 562084,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.450736,
    long: 14.215979,
  },
  {
    town: 'Jičín',
    townCode: 572659,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.435433,
    long: 15.361144,
  },
  {
    town: 'Jičíněves',
    townCode: 573001,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50731,
    lat: 50.373176,
    long: 15.337392,
  },
  {
    town: 'Jihlava',
    townCode: 586846,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58601,
    lat: 49.41586,
    long: 15.595469,
  },
  {
    town: 'Jihlávka',
    townCode: 587290,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.261225,
    long: 15.292576,
  },
  {
    town: 'Jíkev',
    townCode: 537250,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28932,
    lat: 50.264465,
    long: 15.060123,
  },
  {
    town: 'Jilem',
    townCode: 562769,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.17677,
    long: 15.268924,
  },
  {
    town: 'Jilem',
    townCode: 548413,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.713475,
    long: 15.58347,
  },
  {
    town: 'Jilemnice',
    townCode: 577197,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51401,
    lat: 50.608996,
    long: 15.506637,
  },
  {
    town: 'Jílové',
    townCode: 562564,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40701,
    lat: 50.760925,
    long: 14.103948,
  },
  {
    town: 'Jílové u Držkova',
    townCode: 563617,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.670963,
    long: 15.295375,
  },
  {
    town: 'Jílové u Prahy',
    townCode: 539333,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25401,
    lat: 49.895549,
    long: 14.493434,
  },
  {
    town: 'Jílovice',
    townCode: 544639,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37332,
    lat: 48.889587,
    long: 14.726899,
  },
  {
    town: 'Jílovice',
    townCode: 576352,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51772,
    lat: 50.250722,
    long: 16.012785,
  },
  {
    town: 'Jíloviště',
    townCode: 539341,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25202,
    lat: 49.927626,
    long: 14.342843,
  },
  {
    town: 'Jimlín',
    townCode: 546011,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.320403,
    long: 13.747256,
  },
  {
    town: 'Jimramov',
    townCode: 595772,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59242,
    lat: 49.637288,
    long: 16.226424,
  },
  {
    town: 'Jinačovice',
    townCode: 583171,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66434,
    lat: 49.267903,
    long: 16.529591,
  },
  {
    town: 'Jince',
    townCode: 540404,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.786343,
    long: 13.978781,
  },
  {
    town: 'Jindřichov',
    townCode: 597449,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79383,
    lat: 50.251932,
    long: 17.519131,
  },
  {
    town: 'Jindřichov',
    townCode: 513873,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.644693,
    long: 17.748345,
  },
  {
    town: 'Jindřichov',
    townCode: 536521,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78823,
    lat: 50.095891,
    long: 16.985006,
  },
  {
    town: 'Jindřichovice',
    townCode: 560413,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35801,
    lat: 50.28276,
    long: 12.602422,
  },
  {
    town: 'Jindřichovice',
    townCode: 587303,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67526,
    lat: 49.137705,
    long: 15.638697,
  },
  {
    town: 'Jindřichovice pod Smrkem',
    townCode: 564133,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46365,
    lat: 50.960916,
    long: 15.249643,
  },
  {
    town: 'Jindřichův Hradec',
    townCode: 545881,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.144582,
    long: 15.006239,
  },
  {
    town: 'Jinín',
    townCode: 551163,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.227879,
    long: 13.982656,
  },
  {
    town: 'Jinočany',
    townCode: 539350,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25225,
    lat: 50.032857,
    long: 14.268789,
  },
  {
    town: 'Jinolice',
    townCode: 549151,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.478592,
    long: 15.32977,
  },
  {
    town: 'Jinošov',
    townCode: 590797,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.231477,
    long: 16.193554,
  },
  {
    town: 'Jiratice',
    townCode: 550591,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.983174,
    long: 15.612866,
  },
  {
    town: 'Jirkov',
    townCode: 563099,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43111,
    lat: 50.500627,
    long: 13.448885,
  },
  {
    town: 'Jirny',
    townCode: 538272,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25090,
    lat: 50.115879,
    long: 14.699337,
  },
  {
    town: 'Jiřetín pod Bukovou',
    townCode: 546585,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46843,
    lat: 50.755788,
    long: 15.26303,
  },
  {
    town: 'Jiřetín pod Jedlovou',
    townCode: 562572,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40756,
    lat: 50.874552,
    long: 14.57519,
  },
  {
    town: 'Jiřice',
    townCode: 548081,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.55332,
    long: 15.31844,
  },
  {
    town: 'Jiřice',
    townCode: 599581,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28922,
    lat: 50.252532,
    long: 14.836959,
  },
  {
    town: 'Jiřice u Miroslavi',
    townCode: 594229,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.920914,
    long: 16.39205,
  },
  {
    town: 'Jiřice u Moravských Budějovic',
    townCode: 550841,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67154,
    lat: 48.993974,
    long: 15.925489,
  },
  {
    town: 'Jiříkov',
    townCode: 597457,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79351,
    lat: 49.854028,
    long: 17.277651,
  },
  {
    town: 'Jiříkov',
    townCode: 562581,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40753,
    lat: 50.993471,
    long: 14.568449,
  },
  {
    town: 'Jiříkovice',
    townCode: 583189,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66451,
    lat: 49.166816,
    long: 16.758096,
  },
  {
    town: 'Jistebnice',
    townCode: 552534,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39133,
    lat: 49.485634,
    long: 14.527704,
  },
  {
    town: 'Jistebník',
    townCode: 599506,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74282,
    lat: 49.754094,
    long: 18.130739,
  },
  {
    town: 'Jitkov',
    townCode: 546216,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.662324,
    long: 15.7274,
  },
  {
    town: 'Jivina',
    townCode: 531308,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26762,
    lat: 49.794246,
    long: 13.836497,
  },
  {
    town: 'Jivina',
    townCode: 535974,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29414,
    lat: 50.554218,
    long: 14.947263,
  },
  {
    town: 'Jívka',
    townCode: 579378,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54213,
    lat: 50.535096,
    long: 16.109111,
  },
  {
    town: 'Jivno',
    townCode: 535761,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 48.99562,
    long: 14.569321,
  },
  {
    town: 'Jívová',
    townCode: 503142,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78316,
    lat: 49.70927,
    long: 17.394675,
  },
  {
    town: 'Jívoví',
    townCode: 595802,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.40547,
    long: 16.090844,
  },
  {
    town: 'Jizbice',
    townCode: 537268,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.257782,
    long: 14.993959,
  },
  {
    town: 'Jizerní Vtelno',
    townCode: 566039,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29431,
    lat: 50.369496,
    long: 14.853294,
  },
  {
    town: 'Josefov',
    townCode: 586234,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69621,
    lat: 48.839579,
    long: 17.010146,
  },
  {
    town: 'Josefov',
    townCode: 511587,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35709,
    lat: 50.211627,
    long: 12.579546,
  },
  {
    town: 'Josefův Důl',
    townCode: 563633,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46844,
    lat: 50.782016,
    long: 15.231574,
  },
  {
    town: 'Josefův Důl',
    townCode: 529613,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29307,
    lat: 50.453507,
    long: 14.893781,
  },
  {
    town: 'Kacákova Lhota',
    townCode: 549312,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.409627,
    long: 15.419326,
  },
  {
    town: 'Kacanovy',
    townCode: 577201,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.550769,
    long: 15.14538,
  },
  {
    town: 'Kaceřov',
    townCode: 560421,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35751,
    lat: 50.14885,
    long: 12.504505,
  },
  {
    town: 'Kaceřov',
    townCode: 558991,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.870714,
    long: 13.512774,
  },
  {
    town: 'Kácov',
    townCode: 534129,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28509,
    lat: 49.777968,
    long: 15.027994,
  },
  {
    town: 'Kačice',
    townCode: 532444,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27304,
    lat: 50.162716,
    long: 13.98826,
  },
  {
    town: 'Kačlehy',
    townCode: 562491,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.108963,
    long: 15.077166,
  },
  {
    town: 'Kadaň',
    townCode: 563102,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43201,
    lat: 50.376092,
    long: 13.271422,
  },
  {
    town: 'Kadlín',
    townCode: 531774,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27735,
    lat: 50.399568,
    long: 14.699845,
  },
  {
    town: 'Kadolec',
    townCode: 595811,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.374803,
    long: 16.141838,
  },
  {
    town: 'Kadov',
    townCode: 551180,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38733,
    lat: 49.402831,
    long: 13.774881,
  },
  {
    town: 'Kadov',
    townCode: 594237,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 48.982858,
    long: 16.287457,
  },
  {
    town: 'Kadov',
    townCode: 595829,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.632666,
    long: 16.079322,
  },
  {
    town: 'Kájov',
    townCode: 545554,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38221,
    lat: 48.810921,
    long: 14.258692,
  },
  {
    town: 'Kakejcov',
    townCode: 579017,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.667036,
    long: 13.624286,
  },
  {
    town: 'Kalek',
    townCode: 563111,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43132,
    lat: 50.577837,
    long: 13.322071,
  },
  {
    town: 'Kalenice',
    townCode: 536946,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.271655,
    long: 13.7168,
  },
  {
    town: 'Kalhov',
    townCode: 587320,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58842,
    lat: 49.481127,
    long: 15.44153,
  },
  {
    town: 'Kaliště',
    townCode: 587338,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.241354,
    long: 15.301432,
  },
  {
    town: 'Kaliště',
    townCode: 548090,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39451,
    lat: 49.5927,
    long: 15.304162,
  },
  {
    town: 'Kaliště',
    townCode: 538281,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25165,
    lat: 49.882761,
    long: 14.774613,
  },
  {
    town: 'Kalivody',
    townCode: 565440,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.208527,
    long: 13.841968,
  },
  {
    town: 'Kaly',
    townCode: 595837,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.379422,
    long: 16.351706,
  },
  {
    town: 'Kamberk',
    townCode: 531031,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25706,
    lat: 49.597236,
    long: 14.840416,
  },
  {
    town: 'Kámen',
    townCode: 568821,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58242,
    lat: 49.711957,
    long: 15.519989,
  },
  {
    town: 'Kámen',
    townCode: 548103,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39413,
    lat: 49.423391,
    long: 15.015964,
  },
  {
    town: 'Kámen',
    townCode: 546453,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40713,
    lat: 50.810319,
    long: 14.268547,
  },
  {
    town: 'Kamenec',
    townCode: 566811,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33828,
    lat: 49.881166,
    long: 13.596339,
  },
  {
    town: 'Kamenec u Poličky',
    townCode: 578207,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.707979,
    long: 16.233812,
  },
  {
    town: 'Kamenice',
    townCode: 587346,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58823,
    lat: 49.366688,
    long: 15.780333,
  },
  {
    town: 'Kamenice',
    townCode: 538299,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25168,
    lat: 49.901617,
    long: 14.582527,
  },
  {
    town: 'Kamenice nad Lipou',
    townCode: 548111,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39470,
    lat: 49.303136,
    long: 15.075292,
  },
  {
    town: 'Kamenický Šenov',
    townCode: 561681,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47114,
    lat: 50.773693,
    long: 14.472979,
  },
  {
    town: 'Kameničky',
    townCode: 571571,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53941,
    lat: 49.736024,
    long: 15.975128,
  },
  {
    town: 'Kameničná',
    townCode: 580422,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.120278,
    long: 16.435011,
  },
  {
    town: 'Kamenná',
    townCode: 535982,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.779882,
    long: 14.671182,
  },
  {
    town: 'Kamenná',
    townCode: 587362,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.51005,
    long: 15.652675,
  },
  {
    town: 'Kamenná',
    townCode: 590801,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.272529,
    long: 16.060488,
  },
  {
    town: 'Kamenná',
    townCode: 536571,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78974,
    lat: 49.859436,
    long: 17.031142,
  },
  {
    town: 'Kamenná Horka',
    townCode: 578215,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.738007,
    long: 16.52403,
  },
  {
    town: 'Kamenná Lhota',
    townCode: 568848,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58292,
    lat: 49.643905,
    long: 15.275344,
  },
  {
    town: 'Kamenné Zboží',
    townCode: 537276,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.193015,
    long: 14.99953,
  },
  {
    town: 'Kamenné Žehrovice',
    townCode: 532452,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27301,
    lat: 50.127079,
    long: 14.0182,
  },
  {
    town: 'Kamenný Malíkov',
    townCode: 598631,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.211998,
    long: 15.122369,
  },
  {
    town: 'Kamenný Most',
    townCode: 513032,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27326,
    lat: 50.241505,
    long: 14.205845,
  },
  {
    town: 'Kamenný Přívoz',
    townCode: 539368,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25282,
    lat: 49.863096,
    long: 14.503494,
  },
  {
    town: 'Kamenný Újezd',
    townCode: 544663,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37381,
    lat: 48.897635,
    long: 14.446481,
  },
  {
    town: 'Kamenný Újezd',
    townCode: 541150,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.723772,
    long: 13.618864,
  },
  {
    town: 'Kamýk',
    townCode: 546771,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.558481,
    long: 14.07749,
  },
  {
    town: 'Kamýk nad Vltavou',
    townCode: 540439,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26263,
    lat: 49.639124,
    long: 14.253549,
  },
  {
    town: 'Kanice',
    townCode: 583197,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66401,
    lat: 49.263805,
    long: 16.714624,
  },
  {
    town: 'Kanice',
    townCode: 566144,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.475118,
    long: 13.072809,
  },
  {
    town: 'Kaničky',
    townCode: 553778,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.474432,
    long: 13.145358,
  },
  {
    town: 'Kanina',
    townCode: 531651,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27735,
    lat: 50.424809,
    long: 14.600046,
  },
  {
    town: 'Kaňovice',
    townCode: 598275,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73936,
    lat: 49.744405,
    long: 18.39622,
  },
  {
    town: 'Kaňovice',
    townCode: 585327,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76341,
    lat: 49.109153,
    long: 17.698856,
  },
  {
    town: 'Kaplice',
    townCode: 545562,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38241,
    lat: 48.738589,
    long: 14.496373,
  },
  {
    town: 'Káranice',
    townCode: 570150,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50366,
    lat: 50.153056,
    long: 15.557599,
  },
  {
    town: 'Káraný',
    townCode: 564974,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25075,
    lat: 50.174869,
    long: 14.7371,
  },
  {
    town: 'Kardašova Řečice',
    townCode: 546542,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.184882,
    long: 14.853256,
  },
  {
    town: 'Karle',
    townCode: 572748,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.766089,
    long: 16.364833,
  },
  {
    town: 'Karlík',
    townCode: 599727,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25229,
    lat: 49.935506,
    long: 14.259616,
  },
  {
    town: 'Karlín',
    townCode: 586242,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69614,
    lat: 48.975875,
    long: 16.977406,
  },
  {
    town: 'Karlov',
    townCode: 595845,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.647105,
    long: 15.914538,
  },
  {
    town: 'Karlova Studánka',
    townCode: 597473,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79324,
    lat: 50.073193,
    long: 17.30696,
  },
  {
    town: 'Karlova Ves',
    townCode: 565288,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 49.987386,
    long: 13.862509,
  },
  {
    town: 'Karlovice',
    townCode: 577219,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.561843,
    long: 15.20728,
  },
  {
    town: 'Karlovice',
    townCode: 597481,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79326,
    lat: 50.105736,
    long: 17.445738,
  },
  {
    town: 'Karlovice',
    townCode: 587052,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76302,
    lat: 49.176512,
    long: 17.585926,
  },
  {
    town: 'Karlovy Vary',
    townCode: 554961,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.231952,
    long: 12.872062,
  },
  {
    town: 'Karlštejn',
    townCode: 531316,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 49.939604,
    long: 14.188146,
  },
  {
    town: 'Karolín',
    townCode: 587354,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.230694,
    long: 17.43461,
  },
  {
    town: 'Karolinka',
    townCode: 542911,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75605,
    lat: 49.351376,
    long: 18.240174,
  },
  {
    town: 'KARVINÁ',
    townCode: 598917,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73301,
    lat: 49.856752,
    long: 18.543319,
  },
  {
    town: 'Kařez',
    townCode: 559903,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.824356,
    long: 13.781719,
  },
  {
    town: 'Kařízek',
    townCode: 530361,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.813466,
    long: 13.799741,
  },
  {
    town: 'Kasalice',
    townCode: 575151,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.118105,
    long: 15.609768,
  },
  {
    town: 'Kasejovice',
    townCode: 557862,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33544,
    lat: 49.462805,
    long: 13.740706,
  },
  {
    town: 'Kašava',
    townCode: 585343,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76319,
    lat: 49.295509,
    long: 17.785771,
  },
  {
    town: 'Kašnice',
    townCode: 550256,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69172,
    lat: 48.996536,
    long: 16.882945,
  },
  {
    town: 'Kašperské Hory',
    townCode: 556432,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34192,
    lat: 49.143,
    long: 13.556264,
  },
  {
    town: 'Kateřinice',
    townCode: 568643,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74258,
    lat: 49.669288,
    long: 18.188284,
  },
  {
    town: 'Kateřinice',
    townCode: 542946,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75621,
    lat: 49.382193,
    long: 17.885865,
  },
  {
    town: 'Katov',
    townCode: 530042,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.281817,
    long: 14.828622,
  },
  {
    town: 'Katov',
    townCode: 587907,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.332793,
    long: 16.278861,
  },
  {
    town: 'Katovice',
    townCode: 551201,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38711,
    lat: 49.273591,
    long: 13.830458,
  },
  {
    town: 'Katusice',
    townCode: 536008,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29425,
    lat: 50.445203,
    long: 14.777464,
  },
  {
    town: 'Kaznějov',
    townCode: 559008,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.893239,
    long: 13.383058,
  },
  {
    town: 'Kbel',
    townCode: 557871,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.493815,
    long: 13.365703,
  },
  {
    town: 'Kbel',
    townCode: 513415,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.988323,
    long: 15.143645,
  },
  {
    town: 'Kbelany',
    townCode: 538183,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.732444,
    long: 13.126409,
  },
  {
    town: 'Kbelnice',
    townCode: 549169,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.454929,
    long: 15.350713,
  },
  {
    town: 'Kdousov',
    townCode: 590819,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.986074,
    long: 15.647401,
  },
  {
    town: 'Kdyně',
    townCode: 553786,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.390348,
    long: 13.040638,
  },
  {
    town: 'Keblice',
    townCode: 565016,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.480149,
    long: 14.101914,
  },
  {
    town: 'Keblov',
    townCode: 529907,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.677749,
    long: 15.071992,
  },
  {
    town: 'Kejnice',
    townCode: 541826,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.266995,
    long: 13.694293,
  },
  {
    town: 'Kejžlice',
    townCode: 548120,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39452,
    lat: 49.590575,
    long: 15.392728,
  },
  {
    town: 'Kelč',
    townCode: 542989,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75643,
    lat: 49.478541,
    long: 17.815441,
  },
  {
    town: 'Kelčany',
    townCode: 586251,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69649,
    lat: 49.005319,
    long: 17.173901,
  },
  {
    town: 'Kelníky',
    townCode: 592251,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76307,
    lat: 49.110985,
    long: 17.644771,
  },
  {
    town: 'Kestřany',
    townCode: 549487,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39821,
    lat: 49.269153,
    long: 14.072641,
  },
  {
    town: 'Ketkovice',
    townCode: 583201,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.159216,
    long: 16.26264,
  },
  {
    town: 'Klabava',
    townCode: 559911,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33841,
    lat: 49.753546,
    long: 13.539382,
  },
  {
    town: 'Kladeruby',
    townCode: 542997,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75643,
    lat: 49.492821,
    long: 17.865253,
  },
  {
    town: 'Kladeruby nad Oslavou',
    townCode: 590827,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67575,
    lat: 49.144911,
    long: 16.17187,
  },
  {
    town: 'Kladky',
    townCode: 589594,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79854,
    lat: 49.650182,
    long: 16.841358,
  },
  {
    town: 'Kladníky',
    townCode: 569283,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.483773,
    long: 17.603034,
  },
  {
    town: 'Kladno',
    townCode: 571580,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.772574,
    long: 15.982386,
  },
  {
    town: 'Kladno',
    townCode: 532053,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27201,
    lat: 50.141799,
    long: 14.106846,
  },
  {
    town: 'Kladruby',
    townCode: 560405,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.268814,
    long: 13.763561,
  },
  {
    town: 'Kladruby',
    townCode: 559920,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.912977,
    long: 13.631799,
  },
  {
    town: 'Kladruby',
    townCode: 560928,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34961,
    lat: 49.715408,
    long: 12.980021,
  },
  {
    town: 'Kladruby',
    townCode: 533084,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.723269,
    long: 14.950154,
  },
  {
    town: 'Kladruby',
    townCode: 567604,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.615093,
    long: 13.826385,
  },
  {
    town: 'Kladruby nad Labem',
    townCode: 575178,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53314,
    lat: 50.057816,
    long: 15.487192,
  },
  {
    town: 'Klamoš',
    townCode: 570168,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.125681,
    long: 15.501358,
  },
  {
    town: 'Klapý',
    townCode: 565024,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41116,
    lat: 50.43154,
    long: 14.006583,
  },
  {
    town: 'Klášter',
    townCode: 557897,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.50201,
    long: 13.576777,
  },
  {
    town: 'Klášter Hradiště nad Jizerou',
    townCode: 536024,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29415,
    lat: 50.523509,
    long: 14.944829,
  },
  {
    town: 'Klášterec nad Ohří',
    townCode: 563129,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43151,
    lat: 50.384561,
    long: 13.171393,
  },
  {
    town: 'Klášterec nad Orlicí',
    townCode: 580431,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56182,
    lat: 50.111702,
    long: 16.554593,
  },
  {
    town: 'Klášterní Skalice',
    townCode: 571687,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 50.023624,
    long: 14.98539,
  },
  {
    town: 'Klášterská Lhota',
    townCode: 579386,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54371,
    lat: 50.559794,
    long: 15.663687,
  },
  {
    town: 'Klatovec',
    townCode: 587371,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.222518,
    long: 15.294793,
  },
  {
    town: 'Klatovy',
    townCode: 555771,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.395655,
    long: 13.295194,
  },
  {
    town: 'Klec',
    townCode: 562688,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.099391,
    long: 14.748496,
  },
  {
    town: 'Klecany',
    townCode: 538311,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25067,
    lat: 50.176091,
    long: 14.411589,
  },
  {
    town: 'Klenčí pod Čerchovem',
    townCode: 553794,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34534,
    lat: 49.434948,
    long: 12.814835,
  },
  {
    town: 'Kleneč',
    townCode: 565032,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.392685,
    long: 14.248831,
  },
  {
    town: 'Klenová',
    townCode: 541851,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.333543,
    long: 13.233291,
  },
  {
    town: 'Klenovice',
    townCode: 563986,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.278877,
    long: 14.715759,
  },
  {
    town: 'Klenovice na Hané',
    townCode: 589608,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79823,
    lat: 49.403017,
    long: 17.211237,
  },
  {
    town: 'Klentnice',
    townCode: 584541,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69201,
    lat: 48.844725,
    long: 16.644789,
  },
  {
    town: 'Klešice',
    townCode: 573787,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.963712,
    long: 15.681376,
  },
  {
    town: 'Klíčany',
    townCode: 538329,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25069,
    lat: 50.202124,
    long: 14.434551,
  },
  {
    town: 'Klimkovice',
    townCode: 599549,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74283,
    lat: 49.788191,
    long: 18.125961,
  },
  {
    town: 'Klínec',
    townCode: 571211,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.900957,
    long: 14.343355,
  },
  {
    town: 'Klíny',
    townCode: 567191,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43601,
    lat: 50.638349,
    long: 13.548232,
  },
  {
    town: 'Klobouky u Brna',
    townCode: 584550,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69172,
    lat: 48.995112,
    long: 16.859619,
  },
  {
    town: 'Klobuky',
    townCode: 532461,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27374,
    lat: 50.294113,
    long: 13.987593,
  },
  {
    town: 'Klokočí',
    townCode: 577227,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.599761,
    long: 15.221716,
  },
  {
    town: 'Klokočí',
    townCode: 514047,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75361,
    lat: 49.560292,
    long: 17.682377,
  },
  {
    town: 'Klokočná',
    townCode: 513628,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25164,
    lat: 49.958513,
    long: 14.718623,
  },
  {
    town: 'Klokočov',
    townCode: 568856,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.801828,
    long: 15.674289,
  },
  {
    town: 'Klopina',
    townCode: 536687,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78973,
    lat: 49.818661,
    long: 17.019494,
  },
  {
    town: 'Klopotovice',
    townCode: 589616,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79821,
    lat: 49.446217,
    long: 17.250871,
  },
  {
    town: 'Klučenice',
    townCode: 540447,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26256,
    lat: 49.553233,
    long: 14.212131,
  },
  {
    town: 'Klučov',
    townCode: 590835,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.167093,
    long: 15.935181,
  },
  {
    town: 'Klučov',
    townCode: 533386,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.095114,
    long: 14.910171,
  },
  {
    town: 'Kluky',
    townCode: 549495,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39819,
    lat: 49.316885,
    long: 14.245388,
  },
  {
    town: 'Kluky',
    townCode: 534137,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28545,
    lat: 49.907559,
    long: 15.325361,
  },
  {
    town: 'Kluky',
    townCode: 571075,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29426,
    lat: 50.440316,
    long: 14.725295,
  },
  {
    town: 'Kly',
    townCode: 534897,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27741,
    lat: 50.308894,
    long: 14.501593,
  },
  {
    town: 'Kmetiněves',
    townCode: 532479,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27322,
    lat: 50.309285,
    long: 14.157106,
  },
  {
    town: 'Kněždub',
    townCode: 586269,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69664,
    lat: 48.886761,
    long: 17.395572,
  },
  {
    town: 'Kněževes',
    townCode: 581721,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.587125,
    long: 16.423892,
  },
  {
    town: 'Kněževes',
    townCode: 595853,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.456579,
    long: 15.980924,
  },
  {
    town: 'Kněževes',
    townCode: 539384,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25268,
    lat: 50.121321,
    long: 14.259214,
  },
  {
    town: 'Kněževes',
    townCode: 541877,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27001,
    lat: 50.146689,
    long: 13.637213,
  },
  {
    town: 'Kněžice',
    townCode: 590843,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67529,
    lat: 49.27088,
    long: 15.672268,
  },
  {
    town: 'Kněžice',
    townCode: 574007,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53843,
    lat: 49.861905,
    long: 15.527475,
  },
  {
    town: 'Kněžice',
    townCode: 537292,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28902,
    lat: 50.257311,
    long: 15.335464,
  },
  {
    town: 'Kněžičky',
    townCode: 551481,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28908,
    lat: 50.173997,
    long: 15.344934,
  },
  {
    town: 'Kněžmost',
    townCode: 536041,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29402,
    lat: 50.489274,
    long: 15.038396,
  },
  {
    town: 'Kněžnice',
    townCode: 573043,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.493286,
    long: 15.322548,
  },
  {
    town: 'Kněžpole',
    townCode: 592269,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.098647,
    long: 17.516817,
  },
  {
    town: 'Knínice',
    townCode: 587389,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.094109,
    long: 15.604156,
  },
  {
    town: 'Knínice u Boskovic',
    townCode: 581739,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67934,
    lat: 49.539688,
    long: 16.69513,
  },
  {
    town: 'Kňovice',
    townCode: 598461,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.688403,
    long: 14.400412,
  },
  {
    town: 'Knovíz',
    townCode: 532487,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27401,
    lat: 50.212665,
    long: 14.137056,
  },
  {
    town: 'Knyk',
    townCode: 548286,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.647038,
    long: 15.578739,
  },
  {
    town: 'Koberovice',
    townCode: 548146,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.587669,
    long: 15.262965,
  },
  {
    town: 'Koberovy',
    townCode: 563641,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.62476,
    long: 15.228332,
  },
  {
    town: 'Kobeřice',
    townCode: 507504,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74727,
    lat: 49.98558,
    long: 18.052227,
  },
  {
    town: 'Kobeřice u Brna',
    townCode: 593141,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.092284,
    long: 16.885919,
  },
  {
    town: 'Kobylá nad Vidnavkou',
    townCode: 557218,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79065,
    lat: 50.342045,
    long: 17.123713,
  },
  {
    town: 'Kobylí',
    townCode: 584568,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69110,
    lat: 48.932959,
    long: 16.891691,
  },
  {
    town: 'Kobylice',
    townCode: 573710,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.245928,
    long: 15.587203,
  },
  {
    town: 'Kobylnice',
    townCode: 583219,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66451,
    lat: 49.138134,
    long: 16.73193,
  },
  {
    town: 'Kobylnice',
    townCode: 531405,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 50.006398,
    long: 15.375802,
  },
  {
    town: 'Kobylnice',
    townCode: 571172,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29446,
    lat: 50.371738,
    long: 15.053963,
  },
  {
    town: 'Kobyly',
    townCode: 564141,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46345,
    lat: 50.610271,
    long: 15.004443,
  },
  {
    town: 'Kocbeře',
    townCode: 579394,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54464,
    lat: 50.453757,
    long: 15.858823,
  },
  {
    town: 'Kocelovice',
    townCode: 536601,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38742,
    lat: 49.465172,
    long: 13.827677,
  },
  {
    town: 'Koclířov',
    townCode: 578231,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56911,
    lat: 49.766393,
    long: 16.539938,
  },
  {
    town: 'Kočí',
    townCode: 571610,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53861,
    lat: 49.947276,
    long: 15.855614,
  },
  {
    town: 'Kočín',
    townCode: 578771,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.930488,
    long: 13.476248,
  },
  {
    town: 'Kočov',
    townCode: 541559,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34815,
    lat: 49.808767,
    long: 12.736709,
  },
  {
    town: 'Kohoutov',
    townCode: 579408,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.451411,
    long: 15.904893,
  },
  {
    town: 'Kochánky',
    townCode: 536067,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29474,
    lat: 50.277131,
    long: 14.780339,
  },
  {
    town: 'Kochánov',
    townCode: 548529,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58253,
    lat: 49.534276,
    long: 15.540336,
  },
  {
    town: 'Kojatice',
    townCode: 590851,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.998947,
    long: 15.703223,
  },
  {
    town: 'Kojatín',
    townCode: 510645,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.242707,
    long: 16.010276,
  },
  {
    town: 'Kojátky',
    townCode: 593150,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.171903,
    long: 17.026237,
  },
  {
    town: 'Kojčice',
    townCode: 598712,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39409,
    lat: 49.476052,
    long: 15.255999,
  },
  {
    town: 'Kojetice',
    townCode: 590860,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67523,
    lat: 49.157925,
    long: 15.818142,
  },
  {
    town: 'Kojetice',
    townCode: 538345,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25072,
    lat: 50.238202,
    long: 14.508588,
  },
  {
    town: 'Kojetín',
    townCode: 568881,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.657213,
    long: 15.658186,
  },
  {
    town: 'Kojetín',
    townCode: 514055,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75201,
    lat: 49.352911,
    long: 17.30366,
  },
  {
    town: 'Kojice',
    townCode: 575194,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53312,
    lat: 50.043079,
    long: 15.386682,
  },
  {
    town: 'Kokašice',
    townCode: 541494,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34952,
    lat: 49.878396,
    long: 12.947328,
  },
  {
    town: 'Kokory',
    townCode: 514152,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75105,
    lat: 49.494915,
    long: 17.375546,
  },
  {
    town: 'Kokořín',
    townCode: 534901,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27723,
    lat: 50.429981,
    long: 14.567322,
  },
  {
    town: 'Kolaje',
    townCode: 537306,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28904,
    lat: 50.155469,
    long: 15.238544,
  },
  {
    town: 'Koldín',
    townCode: 580465,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.03692,
    long: 16.251721,
  },
  {
    town: 'Koleč',
    townCode: 532495,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27329,
    lat: 50.198872,
    long: 14.22351,
  },
  {
    town: 'Kolešov',
    townCode: 565199,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27004,
    lat: 50.157254,
    long: 13.510143,
  },
  {
    town: 'Kolešovice',
    townCode: 541893,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27002,
    lat: 50.139748,
    long: 13.610387,
  },
  {
    town: 'Kolín',
    townCode: 533165,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.027429,
    long: 15.202828,
  },
  {
    town: 'Kolinec',
    townCode: 556467,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34142,
    lat: 49.299057,
    long: 13.439106,
  },
  {
    town: 'Kolomuty',
    townCode: 570974,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.402199,
    long: 14.979095,
  },
  {
    town: 'Kolová',
    townCode: 555258,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.187545,
    long: 12.903449,
  },
  {
    town: 'Koloveč',
    townCode: 553816,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.486895,
    long: 13.108876,
  },
  {
    town: 'Kolšov',
    townCode: 536733,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78821,
    lat: 49.903176,
    long: 16.947532,
  },
  {
    town: 'Komárno',
    townCode: 588598,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76871,
    lat: 49.434675,
    long: 17.780479,
  },
  {
    town: 'Komárov',
    townCode: 599280,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.250167,
    long: 14.594124,
  },
  {
    town: 'Komárov',
    townCode: 547123,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.764167,
    long: 17.241052,
  },
  {
    town: 'Komárov',
    townCode: 531324,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26762,
    lat: 49.806602,
    long: 13.856467,
  },
  {
    town: 'Komárov',
    townCode: 549436,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76361,
    lat: 49.150786,
    long: 17.568861,
  },
  {
    town: 'Komárovice',
    townCode: 590878,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67526,
    lat: 49.070089,
    long: 15.701107,
  },
  {
    town: 'Komařice',
    townCode: 535877,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37314,
    lat: 48.878549,
    long: 14.545763,
  },
  {
    town: 'Komňa',
    townCode: 592277,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68771,
    lat: 48.99393,
    long: 17.800925,
  },
  {
    town: 'Komorní Lhotka',
    townCode: 507237,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73953,
    lat: 49.658204,
    long: 18.527882,
  },
  {
    town: 'Komorovice',
    townCode: 548162,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.508793,
    long: 15.345625,
  },
  {
    town: 'Komořany',
    townCode: 593168,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.216446,
    long: 16.906888,
  },
  {
    town: 'Konárovice',
    townCode: 533394,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28125,
    lat: 50.041558,
    long: 15.284322,
  },
  {
    town: 'Kondrac',
    townCode: 529931,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.667248,
    long: 14.884609,
  },
  {
    town: 'Konecchlumí',
    townCode: 573051,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50705,
    lat: 50.402345,
    long: 15.480335,
  },
  {
    town: 'Koněprusy',
    townCode: 531332,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 49.920996,
    long: 14.065859,
  },
  {
    town: 'Koněšín',
    townCode: 590886,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67502,
    lat: 49.190593,
    long: 16.041305,
  },
  {
    town: 'Konětopy',
    townCode: 531553,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.276506,
    long: 14.653932,
  },
  {
    town: 'Konice',
    townCode: 589624,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79852,
    lat: 49.590395,
    long: 16.889217,
  },
  {
    town: 'Konojedy',
    townCode: 564761,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.948677,
    long: 14.851354,
  },
  {
    town: 'Konstantinovy Lázně',
    townCode: 560952,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34952,
    lat: 49.881263,
    long: 12.977983,
  },
  {
    town: 'Kopidlno',
    townCode: 573060,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50732,
    lat: 50.330951,
    long: 15.2704,
  },
  {
    town: 'Kopidlo',
    townCode: 559024,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.943303,
    long: 13.464495,
  },
  {
    town: 'Kopřivná',
    townCode: 553247,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78833,
    lat: 50.046475,
    long: 16.946863,
  },
  {
    town: 'Kopřivnice',
    townCode: 599565,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74221,
    lat: 49.59957,
    long: 18.14491,
  },
  {
    town: 'Korkyně',
    townCode: 599204,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26206,
    lat: 49.780542,
    long: 14.351437,
  },
  {
    town: 'Kornatice',
    townCode: 579033,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.659042,
    long: 13.592325,
  },
  {
    town: 'Korno',
    townCode: 533793,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26727,
    lat: 49.920584,
    long: 14.136968,
  },
  {
    town: 'Korolupy',
    townCode: 594253,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.930251,
    long: 15.646296,
  },
  {
    town: 'Korouhev',
    townCode: 578258,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56993,
    lat: 49.67142,
    long: 16.245888,
  },
  {
    town: 'Koroužné',
    townCode: 595861,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.527574,
    long: 16.347737,
  },
  {
    town: 'Korozluky',
    townCode: 567221,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.478686,
    long: 13.723088,
  },
  {
    town: 'Koruna',
    townCode: 578266,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.846904,
    long: 16.714969,
  },
  {
    town: 'Koryčany',
    townCode: 588601,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76805,
    lat: 49.10649,
    long: 17.164435,
  },
  {
    town: 'Koryta',
    townCode: 559032,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.900611,
    long: 13.474862,
  },
  {
    town: 'Koryta',
    townCode: 599557,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29411,
    lat: 50.572055,
    long: 15.011824,
  },
  {
    town: 'Korytná',
    townCode: 592285,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68752,
    lat: 48.94107,
    long: 17.665308,
  },
  {
    town: 'Kořenec',
    townCode: 581755,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.530418,
    long: 16.754045,
  },
  {
    town: 'Kořenice',
    townCode: 533408,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.977216,
    long: 15.140969,
  },
  {
    town: 'Kořenov',
    townCode: 563668,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46849,
    lat: 50.759359,
    long: 15.365424,
  },
  {
    town: 'Kosice',
    townCode: 570176,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.179841,
    long: 15.534913,
  },
  {
    town: 'Kosičky',
    townCode: 570184,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50365,
    lat: 50.178703,
    long: 15.555822,
  },
  {
    town: 'Kosmonosy',
    townCode: 570826,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29306,
    lat: 50.438608,
    long: 14.929915,
  },
  {
    town: 'Kosoř',
    townCode: 539392,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25226,
    lat: 49.98758,
    long: 14.326682,
  },
  {
    town: 'Kosořice',
    townCode: 536121,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29441,
    lat: 50.33348,
    long: 14.96974,
  },
  {
    town: 'Kosořín',
    townCode: 574449,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 49.979239,
    long: 16.233825,
  },
  {
    town: 'Kosov',
    townCode: 536814,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.883233,
    long: 16.79882,
  },
  {
    town: 'Kosova Hora',
    townCode: 540498,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26291,
    lat: 49.654247,
    long: 14.471834,
  },
  {
    town: 'Kostelany',
    townCode: 588521,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.203174,
    long: 17.382954,
  },
  {
    town: 'Kostelany nad Moravou',
    townCode: 592293,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68601,
    lat: 49.045476,
    long: 17.407042,
  },
  {
    town: 'Kostelec',
    townCode: 586277,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69651,
    lat: 49.02693,
    long: 17.153306,
  },
  {
    town: 'Kostelec',
    townCode: 587401,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58861,
    lat: 49.3614,
    long: 15.490771,
  },
  {
    town: 'Kostelec',
    townCode: 548928,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.381344,
    long: 15.327377,
  },
  {
    town: 'Kostelec',
    townCode: 503916,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.674415,
    long: 13.026491,
  },
  {
    town: 'Kostelec na Hané',
    townCode: 589632,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79841,
    lat: 49.514078,
    long: 17.058346,
  },
  {
    town: 'Kostelec nad Černými Lesy',
    townCode: 533416,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.994137,
    long: 14.859324,
  },
  {
    town: 'Kostelec nad Labem',
    townCode: 534935,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27713,
    lat: 50.226634,
    long: 14.585628,
  },
  {
    town: 'Kostelec nad Orlicí',
    townCode: 576361,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.122511,
    long: 16.215084,
  },
  {
    town: 'Kostelec nad Vltavou',
    townCode: 549509,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39858,
    lat: 49.49999,
    long: 14.211859,
  },
  {
    town: 'Kostelec u Heřmanova Městce',
    townCode: 571628,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.923421,
    long: 15.651641,
  },
  {
    town: 'Kostelec u Holešova',
    townCode: 588610,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76843,
    lat: 49.374174,
    long: 17.511445,
  },
  {
    town: 'Kostelec u Křížků',
    townCode: 538370,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25168,
    lat: 49.907123,
    long: 14.557334,
  },
  {
    town: 'Kostelecké Horky',
    townCode: 576387,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.051755,
    long: 16.206964,
  },
  {
    town: 'Kostelní Hlavno',
    townCode: 536130,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29476,
    lat: 50.257529,
    long: 14.699086,
  },
  {
    town: 'Kostelní Lhota',
    townCode: 537314,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28912,
    lat: 50.129367,
    long: 15.024308,
  },
  {
    town: 'Kostelní Myslová',
    townCode: 587419,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.147908,
    long: 15.42899,
  },
  {
    town: 'Kostelní Radouň',
    townCode: 509108,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.225517,
    long: 15.008829,
  },
  {
    town: 'Kostelní Vydří',
    townCode: 508357,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.106163,
    long: 15.421758,
  },
  {
    town: 'Kostěnice',
    townCode: 575232,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.009667,
    long: 15.903791,
  },
  {
    town: 'Kostice',
    townCode: 584576,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69152,
    lat: 48.74695,
    long: 16.978794,
  },
  {
    town: 'Kostníky',
    townCode: 590894,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.974807,
    long: 15.639908,
  },
  {
    town: 'Kostomlátky',
    townCode: 529630,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28921,
    lat: 50.171133,
    long: 14.984131,
  },
  {
    town: 'Kostomlaty nad Labem',
    townCode: 537331,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28921,
    lat: 50.184587,
    long: 14.954085,
  },
  {
    town: 'Kostomlaty pod Milešovkou',
    townCode: 567612,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41754,
    lat: 50.560217,
    long: 13.873166,
  },
  {
    town: 'Kostomlaty pod Řípem',
    townCode: 565059,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.383135,
    long: 14.333177,
  },
  {
    town: 'Košařiska',
    townCode: 507458,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73981,
    lat: 49.589496,
    long: 18.69578,
  },
  {
    town: 'Košátky',
    townCode: 566047,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29479,
    lat: 50.315276,
    long: 14.667096,
  },
  {
    town: 'Košetice',
    townCode: 548171,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39422,
    lat: 49.558467,
    long: 15.116371,
  },
  {
    town: 'Košice',
    townCode: 552585,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39117,
    lat: 49.325429,
    long: 14.751505,
  },
  {
    town: 'Košice',
    townCode: 551465,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.895897,
    long: 15.150945,
  },
  {
    town: 'Košík',
    townCode: 537349,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28935,
    lat: 50.318352,
    long: 15.134157,
  },
  {
    town: 'Košíky',
    townCode: 592307,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68704,
    lat: 49.157681,
    long: 17.416297,
  },
  {
    town: 'Košín',
    townCode: 562955,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39137,
    lat: 49.456508,
    long: 14.658548,
  },
  {
    town: 'Košťálov',
    townCode: 577235,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51202,
    lat: 50.571751,
    long: 15.404135,
  },
  {
    town: 'Košťany',
    townCode: 567621,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41723,
    lat: 50.655181,
    long: 13.755656,
  },
  {
    town: 'Koštice',
    townCode: 566284,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43921,
    lat: 50.403319,
    long: 13.944037,
  },
  {
    town: 'Kotenčice',
    townCode: 513555,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.736397,
    long: 14.093917,
  },
  {
    town: 'Kotlasy',
    townCode: 595870,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.492812,
    long: 15.946201,
  },
  {
    town: 'Kotopeky',
    townCode: 534072,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26801,
    lat: 49.856839,
    long: 13.925264,
  },
  {
    town: 'Kotovice',
    townCode: 540633,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.672114,
    long: 13.154585,
  },
  {
    town: 'Kotvrdovice',
    townCode: 581763,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67907,
    lat: 49.355206,
    long: 16.784459,
  },
  {
    town: 'Kounice',
    townCode: 537357,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28915,
    lat: 50.10777,
    long: 14.856029,
  },
  {
    town: 'Kounov',
    townCode: 576395,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51792,
    lat: 50.298871,
    long: 16.258155,
  },
  {
    town: 'Kounov',
    townCode: 541907,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27006,
    lat: 50.212979,
    long: 13.675205,
  },
  {
    town: 'Koupě',
    townCode: 529681,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.514885,
    long: 13.918493,
  },
  {
    town: 'Kouřim',
    townCode: 533424,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28161,
    lat: 50.003158,
    long: 14.977137,
  },
  {
    town: 'Kout na Šumavě',
    townCode: 553824,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34502,
    lat: 49.402659,
    long: 13.002193,
  },
  {
    town: 'Kouty',
    townCode: 548189,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.648891,
    long: 15.293094,
  },
  {
    town: 'Kouty',
    townCode: 590908,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67508,
    lat: 49.314835,
    long: 15.792795,
  },
  {
    town: 'Kouty',
    townCode: 534943,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.193218,
    long: 15.148855,
  },
  {
    town: 'Kovač',
    townCode: 548944,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.39615,
    long: 15.470916,
  },
  {
    town: 'Kovalovice',
    townCode: 583227,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66406,
    lat: 49.204721,
    long: 16.81914,
  },
  {
    town: 'Koválovice-Osíčany',
    townCode: 589641,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79829,
    lat: 49.284523,
    long: 17.171314,
  },
  {
    town: 'Kováň',
    townCode: 571971,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29425,
    lat: 50.423409,
    long: 14.777875,
  },
  {
    town: 'Kovanec',
    townCode: 572012,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29426,
    lat: 50.417808,
    long: 14.77674,
  },
  {
    town: 'Kovanice',
    townCode: 537373,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.169567,
    long: 15.070901,
  },
  {
    town: 'Kovářov',
    townCode: 549517,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39855,
    lat: 49.517705,
    long: 14.278199,
  },
  {
    town: 'Kovářská',
    townCode: 563137,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43186,
    lat: 50.438324,
    long: 13.053997,
  },
  {
    town: 'Kovčín',
    townCode: 578177,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.415936,
    long: 13.606717,
  },
  {
    town: 'Kozárov',
    townCode: 581771,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.443935,
    long: 16.458762,
  },
  {
    town: 'Kozárovice',
    townCode: 540536,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26284,
    lat: 49.555628,
    long: 14.106587,
  },
  {
    town: 'Kozlany',
    townCode: 550108,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68341,
    lat: 49.20417,
    long: 17.035316,
  },
  {
    town: 'Kozlany',
    townCode: 590916,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67502,
    lat: 49.179832,
    long: 16.061293,
  },
  {
    town: 'Kozlov',
    townCode: 568899,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.734658,
    long: 15.293073,
  },
  {
    town: 'Kozlov',
    townCode: 587427,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58821,
    lat: 49.413143,
    long: 15.700567,
  },
  {
    town: 'Kozlov',
    townCode: 500135,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77200,
    lat: 49.603626,
    long: 17.535662,
  },
  {
    town: 'Kozlov',
    townCode: 595888,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.379245,
    long: 16.078773,
  },
  {
    town: 'Kozlovice',
    townCode: 598321,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73947,
    lat: 49.590494,
    long: 18.256672,
  },
  {
    town: 'Kozlovice',
    townCode: 540200,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.465098,
    long: 13.582934,
  },
  {
    town: 'Kozly',
    townCode: 546232,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47001,
    lat: 50.655449,
    long: 14.45693,
  },
  {
    town: 'Kozly',
    townCode: 530557,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.45686,
    long: 13.784625,
  },
  {
    town: 'Kozmice',
    townCode: 547182,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74711,
    lat: 49.9129,
    long: 18.15595,
  },
  {
    town: 'Kozmice',
    townCode: 529940,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.824883,
    long: 14.796183,
  },
  {
    town: 'Kozojedy',
    townCode: 572136,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50703,
    lat: 50.316531,
    long: 15.374882,
  },
  {
    town: 'Kozojedy',
    townCode: 559041,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.931343,
    long: 13.542516,
  },
  {
    town: 'Kozojedy',
    townCode: 533432,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.996652,
    long: 14.814366,
  },
  {
    town: 'Kozojedy',
    townCode: 565385,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.255389,
    long: 13.815687,
  },
  {
    town: 'Kozojídky',
    townCode: 586285,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69663,
    lat: 48.918744,
    long: 17.399733,
  },
  {
    town: 'Kozolupy',
    townCode: 559059,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33032,
    lat: 49.763902,
    long: 13.252214,
  },
  {
    town: 'Kozomín',
    townCode: 571792,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27745,
    lat: 50.236919,
    long: 14.371215,
  },
  {
    town: 'Kožichovice',
    townCode: 545309,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67401,
    lat: 49.199963,
    long: 15.922024,
  },
  {
    town: 'Kožlany',
    townCode: 559067,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33144,
    lat: 49.993998,
    long: 13.541176,
  },
  {
    town: 'Kožlí',
    townCode: 561550,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.515875,
    long: 14.146759,
  },
  {
    town: 'Kožlí',
    townCode: 568902,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58293,
    lat: 49.670414,
    long: 15.253313,
  },
  {
    town: 'Kožušany-Tážaly',
    townCode: 503304,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78375,
    lat: 49.537792,
    long: 17.253626,
  },
  {
    town: 'Kožušice',
    townCode: 593184,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.15519,
    long: 17.18489,
  },
  {
    town: 'Krabčice',
    townCode: 565067,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41187,
    lat: 50.405474,
    long: 14.301425,
  },
  {
    town: 'Kraborovice',
    townCode: 548618,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.800604,
    long: 15.571977,
  },
  {
    town: 'Krahulčí',
    townCode: 587435,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.181877,
    long: 15.414923,
  },
  {
    town: 'Krahulov',
    townCode: 550710,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.223007,
    long: 15.808241,
  },
  {
    town: 'Krajková',
    townCode: 560456,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35709,
    lat: 50.216079,
    long: 12.534192,
  },
  {
    town: 'Krajníčko',
    townCode: 536342,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.147647,
    long: 14.028846,
  },
  {
    town: 'Krakov',
    townCode: 565351,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.037468,
    long: 13.647573,
  },
  {
    town: 'Krakovany',
    townCode: 533441,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28127,
    lat: 50.066166,
    long: 15.36897,
  },
  {
    town: 'Krakovec',
    townCode: 565369,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.018944,
    long: 13.638347,
  },
  {
    town: 'Kralice na Hané',
    townCode: 589659,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79812,
    lat: 49.463062,
    long: 17.180583,
  },
  {
    town: 'Kralice nad Oslavou',
    townCode: 590941,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67573,
    lat: 49.199373,
    long: 16.201664,
  },
  {
    town: 'Králíky',
    townCode: 570192,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.259542,
    long: 15.53668,
  },
  {
    town: 'Králíky',
    townCode: 580481,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56169,
    lat: 50.083939,
    long: 16.760646,
  },
  {
    town: 'Králova Lhota',
    townCode: 549525,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.495809,
    long: 14.110652,
  },
  {
    town: 'Králova Lhota',
    townCode: 576409,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.294662,
    long: 15.998922,
  },
  {
    town: 'Královec',
    townCode: 530808,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54203,
    lat: 50.676859,
    long: 15.97381,
  },
  {
    town: 'Kralovice',
    townCode: 559075,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.982024,
    long: 13.487584,
  },
  {
    town: 'Královice',
    townCode: 535109,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27401,
    lat: 50.263129,
    long: 14.055907,
  },
  {
    town: 'Královské Poříčí',
    townCode: 560464,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.19412,
    long: 12.67954,
  },
  {
    town: 'Kralupy nad Vltavou',
    townCode: 534951,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27801,
    lat: 50.241745,
    long: 14.310745,
  },
  {
    town: 'Králův Dvůr',
    townCode: 533203,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26701,
    lat: 49.949911,
    long: 14.034561,
  },
  {
    town: 'Kramolín',
    townCode: 590959,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67577,
    lat: 49.134304,
    long: 16.132027,
  },
  {
    town: 'Kramolín',
    townCode: 557943,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.446183,
    long: 13.577065,
  },
  {
    town: 'Kramolna',
    townCode: 574546,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54701,
    lat: 50.420798,
    long: 16.13492,
  },
  {
    town: 'Kraselov',
    townCode: 551261,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.227936,
    long: 13.804051,
  },
  {
    town: 'Krásensko',
    townCode: 593192,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68304,
    lat: 49.364634,
    long: 16.829977,
  },
  {
    town: 'Krasíkov',
    townCode: 580490,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.855681,
    long: 16.695801,
  },
  {
    town: 'Krasíkovice',
    townCode: 561371,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.461735,
    long: 15.228765,
  },
  {
    town: 'Kraslice',
    townCode: 560472,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35801,
    lat: 50.323835,
    long: 12.517588,
  },
  {
    town: 'Krásná',
    townCode: 538795,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35201,
    lat: 50.234889,
    long: 12.168117,
  },
  {
    town: 'Krásná',
    townCode: 549673,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73904,
    lat: 49.582088,
    long: 18.481485,
  },
  {
    town: 'Krásná Hora',
    townCode: 568929,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58234,
    lat: 49.602787,
    long: 15.470441,
  },
  {
    town: 'Krásná Hora nad Vltavou',
    townCode: 540552,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26256,
    lat: 49.604711,
    long: 14.277524,
  },
  {
    town: 'Krásná Lípa',
    townCode: 562611,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40746,
    lat: 50.913136,
    long: 14.510101,
  },
  {
    town: 'Krásná Ves',
    townCode: 536164,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29425,
    lat: 50.42478,
    long: 14.792241,
  },
  {
    town: 'Krásné',
    townCode: 595896,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.677952,
    long: 16.145108,
  },
  {
    town: 'Krásné',
    townCode: 571652,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53825,
    lat: 49.821656,
    long: 15.745623,
  },
  {
    town: 'Krásné Údolí',
    townCode: 555304,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36401,
    lat: 50.072448,
    long: 12.921351,
  },
  {
    town: 'Krásněves',
    townCode: 595900,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.44451,
    long: 15.981262,
  },
  {
    town: 'Krásno',
    townCode: 538337,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35731,
    lat: 50.109287,
    long: 12.786342,
  },
  {
    town: 'Krásný Dvůr',
    townCode: 566306,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43972,
    lat: 50.254271,
    long: 13.367878,
  },
  {
    town: 'Krásný Les',
    townCode: 578045,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36301,
    lat: 50.344955,
    long: 13.002857,
  },
  {
    town: 'Krásný Les',
    townCode: 564168,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.940324,
    long: 15.127667,
  },
  {
    town: 'Krasonice',
    townCode: 587443,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58864,
    lat: 49.11513,
    long: 15.616146,
  },
  {
    town: 'Krasov',
    townCode: 597511,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79401,
    lat: 50.091869,
    long: 17.546206,
  },
  {
    town: 'Krasová',
    townCode: 581780,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67906,
    lat: 49.361476,
    long: 16.768035,
  },
  {
    town: 'Krašlovice',
    townCode: 536806,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.166695,
    long: 14.132576,
  },
  {
    town: 'Krašovice',
    townCode: 559083,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33013,
    lat: 49.872448,
    long: 13.30535,
  },
  {
    town: 'Krátká Ves',
    townCode: 568937,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.625837,
    long: 15.684616,
  },
  {
    town: 'Kratochvilka',
    townCode: 583235,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.156753,
    long: 16.376457,
  },
  {
    town: 'Kratonohy',
    townCode: 570206,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50324,
    lat: 50.169243,
    long: 15.607018,
  },
  {
    town: 'Krátošice',
    townCode: 560634,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.325991,
    long: 14.786807,
  },
  {
    town: 'Kratušín',
    townCode: 537136,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.020356,
    long: 13.928608,
  },
  {
    town: 'Kravaře',
    townCode: 561720,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47103,
    lat: 50.632503,
    long: 14.392521,
  },
  {
    town: 'Kravaře',
    townCode: 507580,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74721,
    lat: 49.93213,
    long: 18.004827,
  },
  {
    town: 'Kravsko',
    townCode: 594261,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67151,
    lat: 48.921596,
    long: 15.986425,
  },
  {
    town: 'Krčmaň',
    townCode: 552437,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.520843,
    long: 17.344253,
  },
  {
    town: 'Krejnice',
    townCode: 536954,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.233828,
    long: 13.718584,
  },
  {
    town: 'Krhanice',
    townCode: 529958,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25742,
    lat: 49.856112,
    long: 14.557463,
  },
  {
    town: 'Krhov',
    townCode: 581798,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67901,
    lat: 49.46036,
    long: 16.583923,
  },
  {
    town: 'Krhov',
    townCode: 590967,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.100437,
    long: 16.019513,
  },
  {
    town: 'Krhová',
    townCode: 500062,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75701,
    lat: 49.465249,
    long: 17.97427,
  },
  {
    town: 'Krhovice',
    townCode: 594270,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67128,
    lat: 48.815911,
    long: 16.173693,
  },
  {
    town: 'Krchleby',
    townCode: 548685,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.079206,
    long: 16.234632,
  },
  {
    town: 'Krchleby',
    townCode: 569372,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.820815,
    long: 16.833722,
  },
  {
    town: 'Krchleby',
    townCode: 534153,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.888996,
    long: 15.350407,
  },
  {
    town: 'Krchleby',
    townCode: 537390,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.239265,
    long: 15.022812,
  },
  {
    town: 'Krmelín',
    townCode: 598348,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73924,
    lat: 49.729234,
    long: 18.235519,
  },
  {
    town: 'Krňany',
    townCode: 529974,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25744,
    lat: 49.844913,
    long: 14.477553,
  },
  {
    town: 'Krnov',
    townCode: 597520,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79401,
    lat: 50.090683,
    long: 17.703168,
  },
  {
    town: 'Krnsko',
    townCode: 536172,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29431,
    lat: 50.372511,
    long: 14.863152,
  },
  {
    town: 'Krokočín',
    townCode: 590975,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.244186,
    long: 16.23308,
  },
  {
    town: 'Kroměříž',
    townCode: 588296,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.291758,
    long: 17.39948,
  },
  {
    town: 'Krompach',
    townCode: 561738,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47157,
    lat: 50.828174,
    long: 14.701621,
  },
  {
    town: 'Kropáčova Vrutice',
    townCode: 536181,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29479,
    lat: 50.330635,
    long: 14.717485,
  },
  {
    town: 'Kroučová',
    townCode: 541940,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.206875,
    long: 13.784056,
  },
  {
    town: 'Krouna',
    townCode: 571661,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53943,
    lat: 49.772498,
    long: 16.026846,
  },
  {
    town: 'Krsy',
    townCode: 559091,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33038,
    lat: 49.926348,
    long: 13.055063,
  },
  {
    town: 'Krtov',
    townCode: 563030,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.348553,
    long: 14.832583,
  },
  {
    town: 'Krty',
    townCode: 598500,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27033,
    lat: 50.091708,
    long: 13.432026,
  },
  {
    town: 'Krty-Hradec',
    townCode: 536555,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.291408,
    long: 13.848107,
  },
  {
    town: 'Krucemburk',
    townCode: 568945,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58266,
    lat: 49.688511,
    long: 15.852171,
  },
  {
    town: 'Kruh',
    townCode: 577243,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51401,
    lat: 50.565638,
    long: 15.480245,
  },
  {
    town: 'Krumsín',
    townCode: 589667,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79803,
    lat: 49.446019,
    long: 17.001558,
  },
  {
    town: 'Krumvíř',
    townCode: 584584,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69173,
    lat: 48.989106,
    long: 16.910379,
  },
  {
    town: 'Krupá',
    townCode: 533459,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 50.017461,
    long: 14.871405,
  },
  {
    town: 'Krupá',
    townCode: 541966,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27009,
    lat: 50.174955,
    long: 13.731687,
  },
  {
    town: 'Krupka',
    townCode: 567639,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41741,
    lat: 50.684596,
    long: 13.858264,
  },
  {
    town: 'Krušovice',
    townCode: 541974,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27053,
    lat: 50.172357,
    long: 13.775232,
  },
  {
    town: 'Kružberk',
    townCode: 568180,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74786,
    lat: 49.831881,
    long: 17.683296,
  },
  {
    town: 'Krychnov',
    townCode: 599484,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.006062,
    long: 15.057761,
  },
  {
    town: 'Kryry',
    townCode: 566314,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43981,
    lat: 50.174477,
    long: 13.426708,
  },
  {
    town: 'Kryštofovo Údolí',
    townCode: 564176,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46001,
    lat: 50.774549,
    long: 14.933501,
  },
  {
    town: 'Kryštofovy Hamry',
    townCode: 563315,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43191,
    lat: 50.499571,
    long: 13.136207,
  },
  {
    town: 'Křeč',
    townCode: 548201,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39495,
    lat: 49.389356,
    long: 14.917101,
  },
  {
    town: 'Křečhoř',
    townCode: 533467,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.025621,
    long: 15.127128,
  },
  {
    town: 'Křečkov',
    townCode: 537403,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.180061,
    long: 15.114377,
  },
  {
    town: 'Křečovice',
    townCode: 529991,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25756,
    lat: 49.721417,
    long: 14.475637,
  },
  {
    town: 'Křekov',
    townCode: 586960,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76601,
    lat: 49.129596,
    long: 17.967873,
  },
  {
    town: 'Křelov-Břuchotín',
    townCode: 554901,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78336,
    lat: 49.614533,
    long: 17.195665,
  },
  {
    town: 'Křelovice',
    townCode: 548219,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39445,
    lat: 49.536955,
    long: 15.168678,
  },
  {
    town: 'Křelovice',
    townCode: 559105,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33036,
    lat: 49.874423,
    long: 13.075914,
  },
  {
    town: 'Křemže',
    townCode: 545571,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38203,
    lat: 48.90507,
    long: 14.305777,
  },
  {
    town: 'Křenek',
    townCode: 534960,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.229642,
    long: 14.629558,
  },
  {
    town: 'Křenice',
    townCode: 556505,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.502807,
    long: 13.200398,
  },
  {
    town: 'Křenice',
    townCode: 564991,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25084,
    lat: 50.031104,
    long: 14.668617,
  },
  {
    town: 'Křenov',
    townCode: 578274,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56922,
    lat: 49.679791,
    long: 16.628932,
  },
  {
    town: 'Křenovice',
    townCode: 562181,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.367396,
    long: 14.342995,
  },
  {
    town: 'Křenovice',
    townCode: 593214,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68352,
    lat: 49.142261,
    long: 16.829426,
  },
  {
    town: 'Křenovice',
    townCode: 569143,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75201,
    lat: 49.330514,
    long: 17.272737,
  },
  {
    town: 'Křenovy',
    townCode: 553832,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.53926,
    long: 13.021618,
  },
  {
    town: 'Křepenice',
    townCode: 540579,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.702999,
    long: 14.347666,
  },
  {
    town: 'Křepice',
    townCode: 584592,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69165,
    lat: 48.999961,
    long: 16.719993,
  },
  {
    town: 'Křepice',
    townCode: 594288,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67140,
    lat: 48.98749,
    long: 16.097506,
  },
  {
    town: 'Křesetice',
    townCode: 534161,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28547,
    lat: 49.907238,
    long: 15.262953,
  },
  {
    town: 'Křesín',
    townCode: 565075,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.394622,
    long: 13.980842,
  },
  {
    town: 'Křešice',
    townCode: 565083,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41148,
    lat: 50.522692,
    long: 14.21461,
  },
  {
    town: 'Křešín',
    townCode: 548227,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39424,
    lat: 49.581824,
    long: 15.043819,
  },
  {
    town: 'Křešín',
    townCode: 540587,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.799554,
    long: 13.948174,
  },
  {
    town: 'Křetín',
    townCode: 581801,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.563204,
    long: 16.504506,
  },
  {
    town: 'Křičeň',
    townCode: 572861,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.109618,
    long: 15.65169,
  },
  {
    town: 'Křídla',
    townCode: 587842,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59231,
    lat: 49.52733,
    long: 16.122451,
  },
  {
    town: 'Křídlůvky',
    townCode: 550086,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67128,
    lat: 48.781811,
    long: 16.239054,
  },
  {
    town: 'Křimov',
    townCode: 563161,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.486132,
    long: 13.301587,
  },
  {
    town: 'Křinec',
    townCode: 537411,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28933,
    lat: 50.264587,
    long: 15.137929,
  },
  {
    town: 'Křinice',
    townCode: 574171,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55001,
    lat: 50.571797,
    long: 16.306073,
  },
  {
    town: 'Křišťanov',
    townCode: 561673,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 48.909239,
    long: 14.020131,
  },
  {
    town: 'Křišťanovice',
    townCode: 597538,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79368,
    lat: 49.850911,
    long: 17.51114,
  },
  {
    town: 'Křivoklát',
    townCode: 541982,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.037956,
    long: 13.870474,
  },
  {
    town: 'Křivsoudov',
    townCode: 530000,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25766,
    lat: 49.633077,
    long: 15.087465,
  },
  {
    town: 'Křižánky',
    townCode: 595918,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59202,
    lat: 49.687674,
    long: 16.0644,
  },
  {
    town: 'Křižanov',
    townCode: 509752,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.39884,
    long: 14.378237,
  },
  {
    town: 'Křižanov',
    townCode: 595926,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.388682,
    long: 16.109707,
  },
  {
    town: 'Křižanovice',
    townCode: 593222,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.142428,
    long: 16.939154,
  },
  {
    town: 'Křižanovice',
    townCode: 547824,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53821,
    lat: 49.859518,
    long: 15.761796,
  },
  {
    town: 'Křižanovice u Vyškova',
    townCode: 593231,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.287758,
    long: 17.040305,
  },
  {
    town: 'Křižany',
    townCode: 564184,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46353,
    lat: 50.73858,
    long: 14.901417,
  },
  {
    town: 'Křižínkov',
    townCode: 595934,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59453,
    lat: 49.32587,
    long: 16.270362,
  },
  {
    town: 'Křížkový Újezdec',
    townCode: 538418,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25168,
    lat: 49.930882,
    long: 14.585468,
  },
  {
    town: 'Křižovatka',
    townCode: 554596,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35134,
    lat: 50.194269,
    long: 12.393172,
  },
  {
    town: 'Křoví',
    townCode: 595951,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59454,
    lat: 49.306061,
    long: 16.26435,
  },
  {
    town: 'Křtěnov',
    townCode: 581810,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.545085,
    long: 16.419371,
  },
  {
    town: 'Křtiny',
    townCode: 581828,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67905,
    lat: 49.297155,
    long: 16.744194,
  },
  {
    town: 'Křtomil',
    townCode: 552780,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.409188,
    long: 17.626333,
  },
  {
    town: 'Kšely',
    townCode: 571717,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.04352,
    long: 14.902034,
  },
  {
    town: 'Kšice',
    townCode: 560979,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.80252,
    long: 12.997365,
  },
  {
    town: 'Ktiš',
    townCode: 550329,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38403,
    lat: 48.917082,
    long: 14.132752,
  },
  {
    town: 'Ktová',
    townCode: 547484,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51263,
    lat: 50.519937,
    long: 15.246847,
  },
  {
    town: 'Kublov',
    townCode: 531375,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26741,
    lat: 49.943803,
    long: 13.876779,
  },
  {
    town: 'Kubova Huť',
    townCode: 563978,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38501,
    lat: 48.983333,
    long: 13.771924,
  },
  {
    town: 'Kubšice',
    townCode: 594296,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67176,
    lat: 49.000765,
    long: 16.413164,
  },
  {
    town: 'Kučerov',
    townCode: 593249,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.218686,
    long: 17.005432,
  },
  {
    town: 'Kučeř',
    townCode: 549541,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39834,
    lat: 49.434342,
    long: 14.245724,
  },
  {
    town: 'Kudlovice',
    townCode: 592323,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68703,
    lat: 49.131767,
    long: 17.457274,
  },
  {
    town: 'Kuchařovice',
    townCode: 594300,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.876057,
    long: 16.077071,
  },
  {
    town: 'Kujavy',
    townCode: 555312,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74245,
    lat: 49.703412,
    long: 17.972636,
  },
  {
    town: 'Kukle',
    townCode: 572594,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.793206,
    long: 16.425709,
  },
  {
    town: 'Kuklík',
    townCode: 595969,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.630022,
    long: 16.113247,
  },
  {
    town: 'Kuks',
    townCode: 579416,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54443,
    lat: 50.401587,
    long: 15.888322,
  },
  {
    town: 'Kulířov',
    townCode: 581836,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67906,
    lat: 49.379422,
    long: 16.846914,
  },
  {
    town: 'Kunčice',
    townCode: 570214,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.217617,
    long: 15.636021,
  },
  {
    town: 'Kunčice nad Labem',
    townCode: 579424,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54361,
    lat: 50.581962,
    long: 15.619536,
  },
  {
    town: 'Kunčice pod Ondřejníkem',
    townCode: 598356,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73913,
    lat: 49.550798,
    long: 18.261235,
  },
  {
    town: 'Kunčina',
    townCode: 578282,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56924,
    lat: 49.794652,
    long: 16.627737,
  },
  {
    town: 'Kunčina Ves',
    townCode: 581844,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.44708,
    long: 16.475366,
  },
  {
    town: 'Kundratice',
    townCode: 595977,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.402684,
    long: 16.134262,
  },
  {
    town: 'Kunějovice',
    townCode: 559121,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33035,
    lat: 49.862066,
    long: 13.237025,
  },
  {
    town: 'Kunemil',
    townCode: 548570,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.707561,
    long: 15.431616,
  },
  {
    town: 'Kunětice',
    townCode: 573515,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53304,
    lat: 50.070734,
    long: 15.827021,
  },
  {
    town: 'Kunice',
    townCode: 581852,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.478926,
    long: 16.490834,
  },
  {
    town: 'Kunice',
    townCode: 538426,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25163,
    lat: 49.936652,
    long: 14.671607,
  },
  {
    town: 'Kuničky',
    townCode: 581861,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67902,
    lat: 49.435026,
    long: 16.681468,
  },
  {
    town: 'Kunín',
    townCode: 568546,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74253,
    lat: 49.63387,
    long: 17.989756,
  },
  {
    town: 'Kunkovice',
    townCode: 588628,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76813,
    lat: 49.182821,
    long: 17.174357,
  },
  {
    town: 'Kunovice',
    townCode: 550744,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68604,
    lat: 49.045088,
    long: 17.470215,
  },
  {
    town: 'Kunovice',
    townCode: 543021,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75644,
    lat: 49.444343,
    long: 17.809991,
  },
  {
    town: 'Kuňovice',
    townCode: 530026,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.658386,
    long: 14.999521,
  },
  {
    town: 'Kunratice',
    townCode: 530433,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.921515,
    long: 15.026152,
  },
  {
    town: 'Kunratice',
    townCode: 546330,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.818924,
    long: 14.41998,
  },
  {
    town: 'Kunratice u Cvikova',
    townCode: 561746,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47155,
    lat: 50.768777,
    long: 14.678722,
  },
  {
    town: 'Kunštát',
    townCode: 581879,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67972,
    lat: 49.506551,
    long: 16.517324,
  },
  {
    town: 'Kunvald',
    townCode: 580503,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56181,
    lat: 50.129372,
    long: 16.50007,
  },
  {
    town: 'Kunžak',
    townCode: 546615,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37862,
    lat: 49.12129,
    long: 15.190385,
  },
  {
    town: 'Kupařovice',
    townCode: 583243,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.043314,
    long: 16.490816,
  },
  {
    town: 'Kurdějov',
    townCode: 555282,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69301,
    lat: 48.957874,
    long: 16.763556,
  },
  {
    town: 'Kuroslepy',
    townCode: 550302,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67575,
    lat: 49.154432,
    long: 16.210217,
  },
  {
    town: 'Kurovice',
    townCode: 588636,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76852,
    lat: 49.289235,
    long: 17.515668,
  },
  {
    town: 'Kuřim',
    townCode: 583251,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66434,
    lat: 49.298618,
    long: 16.531546,
  },
  {
    town: 'Kuřimany',
    townCode: 560391,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.204002,
    long: 13.968229,
  },
  {
    town: 'Kuřimská Nová Ves',
    townCode: 595985,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.345656,
    long: 16.297158,
  },
  {
    town: 'Kuřimské Jestřabí',
    townCode: 595993,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.346676,
    long: 16.314032,
  },
  {
    town: 'Kutná Hora',
    townCode: 533955,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.952531,
    long: 15.268754,
  },
  {
    town: 'Kutrovice',
    townCode: 571512,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27375,
    lat: 50.261654,
    long: 14.018974,
  },
  {
    town: 'Kuželov',
    townCode: 586293,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69673,
    lat: 48.859737,
    long: 17.488933,
  },
  {
    town: 'Kvasice',
    townCode: 588644,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.242324,
    long: 17.469853,
  },
  {
    town: 'Kvasiny',
    townCode: 576425,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51702,
    lat: 50.212594,
    long: 16.263334,
  },
  {
    town: 'Kváskovice',
    townCode: 536750,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.188506,
    long: 14.003793,
  },
  {
    town: 'Kvášňovice',
    townCode: 541931,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.413124,
    long: 13.642076,
  },
  {
    town: 'Květinov',
    townCode: 568953,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.564751,
    long: 15.50741,
  },
  {
    town: 'Květná',
    townCode: 578291,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.736321,
    long: 16.34626,
  },
  {
    town: 'Květnice',
    townCode: 564982,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25084,
    lat: 50.057363,
    long: 14.684222,
  },
  {
    town: 'Květov',
    townCode: 598801,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.425542,
    long: 14.275882,
  },
  {
    town: 'Kvíčovice',
    townCode: 553841,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.590322,
    long: 13.073059,
  },
  {
    town: 'Kvilda',
    townCode: 550337,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38493,
    lat: 49.019358,
    long: 13.57968,
  },
  {
    town: 'Kvílice',
    townCode: 532517,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27375,
    lat: 50.258155,
    long: 14.002429,
  },
  {
    town: 'Kvítkov',
    townCode: 546259,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47001,
    lat: 50.655024,
    long: 14.486766,
  },
  {
    town: 'Kvítkovice',
    townCode: 529729,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.957506,
    long: 14.33126,
  },
  {
    town: 'Kyje',
    townCode: 572047,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50713,
    lat: 50.494389,
    long: 15.37809,
  },
  {
    town: 'Kyjov',
    townCode: 586307,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69701,
    lat: 49.009967,
    long: 17.12261,
  },
  {
    town: 'Kyjov',
    townCode: 548308,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.629564,
    long: 15.623325,
  },
  {
    town: 'Kyjov',
    townCode: 596001,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.443544,
    long: 15.881657,
  },
  {
    town: 'Kyjovice',
    townCode: 594318,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.913818,
    long: 16.166617,
  },
  {
    town: 'Kyjovice',
    townCode: 512907,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74768,
    lat: 49.832445,
    long: 18.042227,
  },
  {
    town: 'Kynice',
    townCode: 568970,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.739281,
    long: 15.360244,
  },
  {
    town: 'Kynšperk nad Ohří',
    townCode: 560499,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35751,
    lat: 50.119038,
    long: 12.530388,
  },
  {
    town: 'Kyselka',
    townCode: 555347,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36272,
    lat: 50.262803,
    long: 13.000007,
  },
  {
    town: 'Kyselovice',
    townCode: 588652,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76811,
    lat: 49.377252,
    long: 17.402164,
  },
  {
    town: 'Kyšice',
    townCode: 559130,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33001,
    lat: 49.753353,
    long: 13.486312,
  },
  {
    town: 'Kyšice',
    townCode: 532525,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.091291,
    long: 14.106343,
  },
  {
    town: 'Kyškovice',
    townCode: 565091,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.448307,
    long: 14.285987,
  },
  {
    town: 'Kytín',
    townCode: 571261,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.850721,
    long: 14.219156,
  },
  {
    town: 'Kytlice',
    townCode: 562645,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40745,
    lat: 50.812746,
    long: 14.53547,
  },
  {
    town: 'Labská Stráň',
    townCode: 544701,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.848754,
    long: 14.231709,
  },
  {
    town: 'Labské Chrčice',
    townCode: 575259,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 28126,
    lat: 50.051519,
    long: 15.410279,
  },
  {
    town: 'Labuty',
    townCode: 586315,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69648,
    lat: 49.046739,
    long: 17.214588,
  },
  {
    town: 'Lačnov',
    townCode: 543098,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75612,
    lat: 49.178879,
    long: 18.016608,
  },
  {
    town: 'Ladná',
    townCode: 558443,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69146,
    lat: 48.805496,
    long: 16.872412,
  },
  {
    town: 'Lahošť',
    townCode: 567647,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41725,
    lat: 50.618346,
    long: 13.765404,
  },
  {
    town: 'Lampertice',
    townCode: 548804,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54101,
    lat: 50.664684,
    long: 15.951068,
  },
  {
    town: 'Lančov',
    townCode: 594326,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67106,
    lat: 48.907159,
    long: 15.767901,
  },
  {
    town: 'Lánov',
    townCode: 579432,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54341,
    lat: 50.620172,
    long: 15.65585,
  },
  {
    town: 'Lanškroun',
    townCode: 580511,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.912141,
    long: 16.612597,
  },
  {
    town: 'Lány',
    townCode: 548481,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.759535,
    long: 15.712996,
  },
  {
    town: 'Lány',
    townCode: 504807,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.94646,
    long: 15.727244,
  },
  {
    town: 'Lány',
    townCode: 541991,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27061,
    lat: 50.124811,
    long: 13.950519,
  },
  {
    town: 'Lány u Dašic',
    townCode: 572845,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.043622,
    long: 15.889187,
  },
  {
    town: 'Lanžhot',
    townCode: 584622,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69151,
    lat: 48.724531,
    long: 16.967053,
  },
  {
    town: 'Lanžov',
    townCode: 579441,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.386918,
    long: 15.760854,
  },
  {
    town: 'Lásenice',
    townCode: 546623,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37801,
    lat: 49.074391,
    long: 14.970283,
  },
  {
    town: 'Laškov',
    townCode: 589675,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79857,
    lat: 49.584113,
    long: 17.002235,
  },
  {
    town: 'Lašovice',
    townCode: 542008,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27021,
    lat: 50.05506,
    long: 13.78231,
  },
  {
    town: 'Lavičky',
    townCode: 596019,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.380597,
    long: 15.968444,
  },
  {
    town: 'Lavičné',
    townCode: 578304,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.643678,
    long: 16.462574,
  },
  {
    town: 'Láz',
    townCode: 510556,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67541,
    lat: 49.012392,
    long: 15.785165,
  },
  {
    town: 'Láz',
    townCode: 540625,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26241,
    lat: 49.652138,
    long: 13.916712,
  },
  {
    town: 'Lazinov',
    townCode: 581887,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.563913,
    long: 16.523495,
  },
  {
    town: 'Lázně Bělohrad',
    townCode: 573094,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50781,
    lat: 50.428843,
    long: 15.582797,
  },
  {
    town: 'Lázně Bohdaneč',
    townCode: 574767,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.075702,
    long: 15.67989,
  },
  {
    town: 'Lázně Kynžvart',
    townCode: 554600,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35491,
    lat: 50.010693,
    long: 12.624853,
  },
  {
    town: 'Lázně Libverda',
    townCode: 564206,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46362,
    lat: 50.890241,
    long: 15.190471,
  },
  {
    town: 'Lázně Toušeň',
    townCode: 538914,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25089,
    lat: 50.16937,
    long: 14.716112,
  },
  {
    town: 'Lazníčky',
    townCode: 514446,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75125,
    lat: 49.545565,
    long: 17.460189,
  },
  {
    town: 'Lazníky',
    townCode: 514471,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75125,
    lat: 49.524536,
    long: 17.462787,
  },
  {
    town: 'Lazsko',
    townCode: 564346,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.623599,
    long: 14.003954,
  },
  {
    town: 'Lažánky',
    townCode: 598950,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.391505,
    long: 13.836837,
  },
  {
    town: 'Lažánky',
    townCode: 583260,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66471,
    lat: 49.279046,
    long: 16.388167,
  },
  {
    town: 'Lažany',
    townCode: 560197,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.36295,
    long: 13.883237,
  },
  {
    town: 'Lažany',
    townCode: 581909,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.354468,
    long: 16.550117,
  },
  {
    town: 'Lažany',
    townCode: 545937,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46345,
    lat: 50.601,
    long: 15.109852,
  },
  {
    town: 'Lažiště',
    townCode: 550345,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38432,
    lat: 49.03766,
    long: 13.92781,
  },
  {
    town: 'Lážovice',
    townCode: 533939,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.85831,
    long: 14.071383,
  },
  {
    town: 'Lčovice',
    townCode: 561649,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38481,
    lat: 49.114639,
    long: 13.850712,
  },
  {
    town: 'Ledce',
    townCode: 583278,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66462,
    lat: 49.051603,
    long: 16.55712,
  },
  {
    town: 'Ledce',
    townCode: 576433,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.223913,
    long: 16.04283,
  },
  {
    town: 'Ledce',
    townCode: 559148,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33014,
    lat: 49.821738,
    long: 13.328535,
  },
  {
    town: 'Ledce',
    townCode: 532533,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27305,
    lat: 50.196529,
    long: 14.005095,
  },
  {
    town: 'Ledce',
    townCode: 536202,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29447,
    lat: 50.353466,
    long: 15.084579,
  },
  {
    town: 'Ledčice',
    townCode: 534978,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27708,
    lat: 50.341051,
    long: 14.294576,
  },
  {
    town: 'Ledeč nad Sázavou',
    townCode: 568988,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.695269,
    long: 15.277827,
  },
  {
    town: 'Ledečko',
    townCode: 534170,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.84992,
    long: 14.94898,
  },
  {
    town: 'Ledenice',
    townCode: 544736,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37311,
    lat: 48.932311,
    long: 14.618133,
  },
  {
    town: 'Lednice',
    townCode: 584631,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69144,
    lat: 48.800018,
    long: 16.803498,
  },
  {
    town: 'Ledvice',
    townCode: 567655,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41772,
    lat: 50.585119,
    long: 13.772139,
  },
  {
    town: 'Lechotice',
    townCode: 588661,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76852,
    lat: 49.273774,
    long: 17.588001,
  },
  {
    town: 'Lechovice',
    townCode: 594334,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67163,
    lat: 48.872953,
    long: 16.221921,
  },
  {
    town: 'Lejšovka',
    townCode: 570222,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.297761,
    long: 15.942389,
  },
  {
    town: 'Lelekovice',
    townCode: 583286,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66431,
    lat: 49.291537,
    long: 16.578848,
  },
  {
    town: 'Lenešice',
    townCode: 566322,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43923,
    lat: 50.375267,
    long: 13.766007,
  },
  {
    town: 'Lenora',
    townCode: 550353,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38442,
    lat: 48.922415,
    long: 13.79337,
  },
  {
    town: 'Leskovec',
    townCode: 544264,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75611,
    lat: 49.284384,
    long: 17.998777,
  },
  {
    town: 'Leskovec nad Moravicí',
    townCode: 597546,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79368,
    lat: 49.905954,
    long: 17.574652,
  },
  {
    town: 'Leskovice',
    townCode: 548235,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39414,
    lat: 49.43,
    long: 15.08121,
  },
  {
    town: 'Lesná',
    townCode: 594342,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.907277,
    long: 15.868824,
  },
  {
    town: 'Lesná',
    townCode: 562041,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.518016,
    long: 15.057662,
  },
  {
    town: 'Lesná',
    townCode: 590983,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67526,
    lat: 49.171418,
    long: 15.679494,
  },
  {
    town: 'Lesná',
    townCode: 561002,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.754286,
    long: 12.537785,
  },
  {
    town: 'Lesní Hluboké',
    townCode: 583294,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.268807,
    long: 16.306928,
  },
  {
    town: 'Lesní Jakubov',
    townCode: 590991,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67573,
    lat: 49.205878,
    long: 16.243465,
  },
  {
    town: 'Lesnice',
    townCode: 537284,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.88386,
    long: 16.941325,
  },
  {
    town: 'Lesonice',
    townCode: 594351,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.003355,
    long: 16.310735,
  },
  {
    town: 'Lesonice',
    townCode: 591009,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67544,
    lat: 49.107958,
    long: 15.755986,
  },
  {
    town: 'Lestkov',
    townCode: 561011,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34953,
    lat: 49.883163,
    long: 12.871116,
  },
  {
    town: 'Lesůňky',
    townCode: 573485,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67551,
    lat: 49.107167,
    long: 15.84245,
  },
  {
    town: 'Lešany',
    townCode: 589683,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79842,
    lat: 49.499779,
    long: 17.024171,
  },
  {
    town: 'Lešany',
    townCode: 530051,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25744,
    lat: 49.844269,
    long: 14.525051,
  },
  {
    town: 'Lešetice',
    townCode: 513521,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.647301,
    long: 14.02119,
  },
  {
    town: 'Leškovice',
    townCode: 568996,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.762995,
    long: 15.537109,
  },
  {
    town: 'Lešná',
    townCode: 544302,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75641,
    lat: 49.520653,
    long: 17.930151,
  },
  {
    town: 'Leština',
    townCode: 537713,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78971,
    lat: 49.868883,
    long: 16.927588,
  },
  {
    town: 'Leština',
    townCode: 571695,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53944,
    lat: 49.867762,
    long: 16.117895,
  },
  {
    town: 'Leština u Světlé',
    townCode: 569011,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58286,
    lat: 49.761453,
    long: 15.39771,
  },
  {
    town: 'Leštinka',
    townCode: 571709,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53973,
    lat: 49.845309,
    long: 15.958993,
  },
  {
    town: 'Letiny',
    townCode: 557951,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.540003,
    long: 13.455391,
  },
  {
    town: 'Letkov',
    townCode: 540561,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 32600,
    lat: 49.730543,
    long: 13.465091,
  },
  {
    town: 'Letohrad',
    townCode: 580538,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56151,
    lat: 50.036122,
    long: 16.500231,
  },
  {
    town: 'Letonice',
    townCode: 593257,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68335,
    lat: 49.17736,
    long: 16.959237,
  },
  {
    town: 'Letovice',
    townCode: 581917,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.547189,
    long: 16.573678,
  },
  {
    town: 'Lety',
    townCode: 549568,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.517034,
    long: 14.087866,
  },
  {
    town: 'Lety',
    townCode: 539406,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25229,
    lat: 49.9211,
    long: 14.255311,
  },
  {
    town: 'Levín',
    townCode: 565105,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41145,
    lat: 50.613935,
    long: 14.284017,
  },
  {
    town: 'Levínská Olešnice',
    townCode: 577375,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51401,
    lat: 50.528307,
    long: 15.540814,
  },
  {
    town: 'Lhánice',
    townCode: 591025,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67575,
    lat: 49.109192,
    long: 16.223507,
  },
  {
    town: 'Lhenice',
    townCode: 550361,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38402,
    lat: 48.994897,
    long: 14.149903,
  },
  {
    town: 'Lhota',
    townCode: 514497,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.497745,
    long: 17.614881,
  },
  {
    town: 'Lhota',
    townCode: 513041,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27301,
    lat: 50.088744,
    long: 14.011917,
  },
  {
    town: 'Lhota',
    townCode: 534986,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.243309,
    long: 14.65652,
  },
  {
    town: 'Lhota',
    townCode: 573434,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76302,
    lat: 49.169435,
    long: 17.602533,
  },
  {
    town: 'Lhota pod Hořičkami',
    townCode: 574180,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55205,
    lat: 50.422788,
    long: 16.003204,
  },
  {
    town: 'Lhota pod Libčany',
    townCode: 570231,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.172522,
    long: 15.696345,
  },
  {
    town: 'Lhota pod Radčem',
    townCode: 567001,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.827464,
    long: 13.710816,
  },
  {
    town: 'Lhota Rapotina',
    townCode: 581925,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67901,
    lat: 49.466146,
    long: 16.624954,
  },
  {
    town: 'Lhota u Lysic',
    townCode: 581933,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.469778,
    long: 16.496885,
  },
  {
    town: 'Lhota u Olešnice',
    townCode: 581941,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.544909,
    long: 16.390829,
  },
  {
    town: 'Lhota u Příbramě',
    townCode: 598411,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.714255,
    long: 13.980642,
  },
  {
    town: 'Lhota u Vsetína',
    townCode: 556866,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75501,
    lat: 49.304675,
    long: 17.958094,
  },
  {
    town: 'Lhota-Vlasenice',
    townCode: 561282,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39470,
    lat: 49.302785,
    long: 15.12482,
  },
  {
    town: 'Lhotice',
    townCode: 544876,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 49.019369,
    long: 15.60716,
  },
  {
    town: 'Lhotka',
    townCode: 587451,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.209194,
    long: 15.385751,
  },
  {
    town: 'Lhotka',
    townCode: 596035,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.582281,
    long: 16.002978,
  },
  {
    town: 'Lhotka',
    townCode: 598364,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73947,
    lat: 49.597285,
    long: 18.298465,
  },
  {
    town: 'Lhotka',
    townCode: 514527,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75124,
    lat: 49.499836,
    long: 17.410166,
  },
  {
    town: 'Lhotka',
    townCode: 533335,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26723,
    lat: 49.83232,
    long: 13.996335,
  },
  {
    town: 'Lhotka',
    townCode: 531898,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27731,
    lat: 50.371468,
    long: 14.548888,
  },
  {
    town: 'Lhotka nad Labem',
    townCode: 565113,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.525685,
    long: 14.047429,
  },
  {
    town: 'Lhotka u Litultovic',
    townCode: 553115,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74755,
    lat: 49.872905,
    long: 17.730857,
  },
  {
    town: 'Lhotka u Radnic',
    townCode: 559946,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.89004,
    long: 13.581715,
  },
  {
    town: 'Lhotky',
    townCode: 536211,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29406,
    lat: 50.396401,
    long: 15.052956,
  },
  {
    town: 'Lhotsko',
    townCode: 549550,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76312,
    lat: 49.212296,
    long: 17.883478,
  },
  {
    town: 'Lhoty u Potštejna',
    townCode: 576441,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.055957,
    long: 16.268803,
  },
  {
    town: 'Lhůta',
    townCode: 578606,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33201,
    lat: 49.70137,
    long: 13.52891,
  },
  {
    town: 'Libá',
    townCode: 554618,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35131,
    lat: 50.128275,
    long: 12.230943,
  },
  {
    town: 'Libáň',
    townCode: 573108,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.375516,
    long: 15.21695,
  },
  {
    town: 'Libavá (vojenský újezd)',
    townCode: 503941,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.723088,
    long: 17.523528,
  },
  {
    town: 'Libavské Údolí',
    townCode: 560502,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35751,
    lat: 50.128978,
    long: 12.552602,
  },
  {
    town: 'Libčany',
    townCode: 570249,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50322,
    lat: 50.191851,
    long: 15.695007,
  },
  {
    town: 'Libčeves',
    townCode: 566349,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43926,
    lat: 50.452574,
    long: 13.838289,
  },
  {
    town: 'Libčice nad Vltavou',
    townCode: 539414,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25266,
    lat: 50.199129,
    long: 14.362784,
  },
  {
    town: 'Libecina',
    townCode: 580562,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.882981,
    long: 16.118331,
  },
  {
    town: 'Libědice',
    townCode: 563188,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.315996,
    long: 13.385678,
  },
  {
    town: 'Liběchov',
    townCode: 535001,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.407939,
    long: 14.446855,
  },
  {
    town: 'Libějice',
    townCode: 563544,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39002,
    lat: 49.376947,
    long: 14.623952,
  },
  {
    town: 'Libějovice',
    townCode: 551333,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38772,
    lat: 49.114439,
    long: 14.193459,
  },
  {
    town: 'Libel',
    townCode: 548651,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.15517,
    long: 16.202418,
  },
  {
    town: 'Libenice',
    townCode: 533475,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.984575,
    long: 15.258007,
  },
  {
    town: 'Liberec',
    townCode: 563889,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46001,
    lat: 50.76638,
    long: 15.054439,
  },
  {
    town: 'Liberk',
    townCode: 576450,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51712,
    lat: 50.199288,
    long: 16.343029,
  },
  {
    town: 'Libeř',
    townCode: 539422,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25241,
    lat: 49.924257,
    long: 14.480724,
  },
  {
    town: 'Liběšice',
    townCode: 565121,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41146,
    lat: 50.568962,
    long: 14.289175,
  },
  {
    town: 'Liběšice',
    townCode: 566357,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43963,
    lat: 50.293667,
    long: 13.621573,
  },
  {
    town: 'Libětice',
    townCode: 536831,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.219149,
    long: 13.862757,
  },
  {
    town: 'Líbeznice',
    townCode: 538442,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25065,
    lat: 50.192079,
    long: 14.493682,
  },
  {
    town: 'Libež',
    townCode: 530069,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.757522,
    long: 14.916873,
  },
  {
    town: 'Libhošť',
    townCode: 500046,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74257,
    lat: 49.626557,
    long: 18.077075,
  },
  {
    town: 'Libchavy',
    townCode: 580147,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56116,
    lat: 50.005575,
    long: 16.38914,
  },
  {
    town: 'Libchyně',
    townCode: 547701,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.356657,
    long: 16.190034,
  },
  {
    town: 'Libice nad Cidlinou',
    townCode: 537438,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28907,
    lat: 50.126874,
    long: 15.178306,
  },
  {
    town: 'Libice nad Doubravou',
    townCode: 569020,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58277,
    lat: 49.745023,
    long: 15.704338,
  },
  {
    town: 'Libín',
    townCode: 544744,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37373,
    lat: 48.969727,
    long: 14.683706,
  },
  {
    town: 'Libina',
    townCode: 539961,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78805,
    lat: 49.876529,
    long: 17.08282,
  },
  {
    town: 'Libiš',
    townCode: 571784,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27711,
    lat: 50.274275,
    long: 14.50251,
  },
  {
    town: 'Libišany',
    townCode: 575305,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.153387,
    long: 15.756738,
  },
  {
    town: 'Libkov',
    townCode: 571725,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53825,
    lat: 49.841833,
    long: 15.75641,
  },
  {
    town: 'Libkov',
    townCode: 553859,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.366295,
    long: 13.13447,
  },
  {
    town: 'Libkova Voda',
    townCode: 598721,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39462,
    lat: 49.376595,
    long: 15.191112,
  },
  {
    town: 'Libkovice pod Řípem',
    townCode: 565148,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.392532,
    long: 14.342424,
  },
  {
    town: 'Liblice',
    townCode: 531502,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27732,
    lat: 50.31343,
    long: 14.590516,
  },
  {
    town: 'Liblín',
    townCode: 559954,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.916919,
    long: 13.544351,
  },
  {
    town: 'Libňatov',
    townCode: 579475,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54236,
    lat: 50.481436,
    long: 16.002299,
  },
  {
    town: 'Libníč',
    townCode: 535800,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 49.019769,
    long: 14.543731,
  },
  {
    town: 'Libníkovice',
    townCode: 570257,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50346,
    lat: 50.244268,
    long: 15.996241,
  },
  {
    town: 'Libočany',
    townCode: 530590,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43975,
    lat: 50.33349,
    long: 13.513599,
  },
  {
    town: 'Libodřice',
    townCode: 533483,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.004416,
    long: 15.088387,
  },
  {
    town: 'Libochovany',
    townCode: 565156,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41103,
    lat: 50.566669,
    long: 14.039146,
  },
  {
    town: 'Libochovice',
    townCode: 565164,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41117,
    lat: 50.406368,
    long: 14.044498,
  },
  {
    town: 'Libochovičky',
    townCode: 564150,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27342,
    lat: 50.172676,
    long: 14.239708,
  },
  {
    town: 'Liboměřice',
    townCode: 571733,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53821,
    lat: 49.87195,
    long: 15.741396,
  },
  {
    town: 'Libomyšl',
    townCode: 531448,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26723,
    lat: 49.872637,
    long: 13.998731,
  },
  {
    town: 'Libořice',
    townCode: 566381,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.254811,
    long: 13.515189,
  },
  {
    town: 'Liboš',
    townCode: 569003,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78313,
    lat: 49.691682,
    long: 17.225136,
  },
  {
    town: 'Libošovice',
    townCode: 573116,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50744,
    lat: 50.490669,
    long: 15.162912,
  },
  {
    town: 'Libotenice',
    townCode: 565172,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.477022,
    long: 14.229354,
  },
  {
    town: 'Libotov',
    townCode: 579483,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.399472,
    long: 15.811963,
  },
  {
    town: 'Libouchec',
    townCode: 568058,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40335,
    lat: 50.75865,
    long: 14.040826,
  },
  {
    town: 'Libovice',
    townCode: 571601,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27379,
    lat: 50.235701,
    long: 14.016452,
  },
  {
    town: 'Librantice',
    townCode: 570265,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50346,
    lat: 50.242363,
    long: 15.95985,
  },
  {
    town: 'Libřice',
    townCode: 570273,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50344,
    lat: 50.287938,
    long: 15.963989,
  },
  {
    town: 'Libštát',
    townCode: 577294,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51203,
    lat: 50.559503,
    long: 15.416037,
  },
  {
    town: 'Libuň',
    townCode: 573124,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50715,
    lat: 50.498255,
    long: 15.298603,
  },
  {
    town: 'Libušín',
    townCode: 532576,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27306,
    lat: 50.168293,
    long: 14.05469,
  },
  {
    town: 'Licibořice',
    townCode: 547832,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53823,
    lat: 49.877003,
    long: 15.760021,
  },
  {
    town: 'Lično',
    townCode: 576468,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51735,
    lat: 50.177967,
    long: 16.172124,
  },
  {
    town: 'Lidečko',
    townCode: 544370,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75612,
    lat: 49.20313,
    long: 18.051411,
  },
  {
    town: 'Lidice',
    townCode: 532584,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27354,
    lat: 50.143626,
    long: 14.190234,
  },
  {
    town: 'Lidmaň',
    townCode: 561100,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.381938,
    long: 15.036826,
  },
  {
    town: 'Lichkov',
    townCode: 580571,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56168,
    lat: 50.097876,
    long: 16.666117,
  },
  {
    town: 'Lichnov',
    townCode: 597554,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79315,
    lat: 50.007958,
    long: 17.62651,
  },
  {
    town: 'Lichnov',
    townCode: 599603,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74275,
    lat: 49.563651,
    long: 18.170051,
  },
  {
    town: 'Lichoceves',
    townCode: 571326,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25264,
    lat: 50.152863,
    long: 14.284353,
  },
  {
    town: 'Líně',
    townCode: 559164,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33021,
    lat: 49.694828,
    long: 13.257039,
  },
  {
    town: 'Linhartice',
    townCode: 578339,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.757429,
    long: 16.695338,
  },
  {
    town: 'Lípa',
    townCode: 569038,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58257,
    lat: 49.554584,
    long: 15.542919,
  },
  {
    town: 'Lípa',
    townCode: 549622,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76311,
    lat: 49.215383,
    long: 17.768842,
  },
  {
    town: 'Lípa nad Orlicí',
    townCode: 576476,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51721,
    lat: 50.135714,
    long: 16.098112,
  },
  {
    town: 'Lipec',
    townCode: 513270,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28126,
    lat: 50.085084,
    long: 15.364668,
  },
  {
    town: 'Lipí',
    townCode: 544761,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.949581,
    long: 14.352239,
  },
  {
    town: 'Lipina',
    townCode: 552305,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.741758,
    long: 17.323633,
  },
  {
    town: 'Lipinka',
    townCode: 540005,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78383,
    lat: 49.837875,
    long: 17.050055,
  },
  {
    town: 'Lipnice nad Sázavou',
    townCode: 569046,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58232,
    lat: 49.613125,
    long: 15.413664,
  },
  {
    town: 'Lipník',
    townCode: 591041,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.144357,
    long: 15.950723,
  },
  {
    town: 'Lipník',
    townCode: 565563,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29443,
    lat: 50.272647,
    long: 14.912532,
  },
  {
    town: 'Lipník nad Bečvou',
    townCode: 514705,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.526832,
    long: 17.586743,
  },
  {
    town: 'Lipno',
    townCode: 566403,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.300702,
    long: 13.680972,
  },
  {
    town: 'Lipno nad Vltavou',
    townCode: 545597,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38278,
    lat: 48.639427,
    long: 14.22942,
  },
  {
    town: 'Lipoltice',
    townCode: 575313,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53364,
    lat: 49.98787,
    long: 15.568989,
  },
  {
    town: 'Lipov',
    townCode: 586323,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69672,
    lat: 48.905046,
    long: 17.46182,
  },
  {
    town: 'Lipová',
    townCode: 554626,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.036398,
    long: 12.448928,
  },
  {
    town: 'Lipová',
    townCode: 589691,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79845,
    lat: 49.526065,
    long: 16.861891,
  },
  {
    town: 'Lipová',
    townCode: 514772,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.409927,
    long: 17.614169,
  },
  {
    town: 'Lipová',
    townCode: 562661,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40781,
    lat: 51.011146,
    long: 14.360332,
  },
  {
    town: 'Lipová',
    townCode: 586871,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.121999,
    long: 17.879725,
  },
  {
    town: 'Lipová-lázně',
    townCode: 540030,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79061,
    lat: 50.227866,
    long: 17.14055,
  },
  {
    town: 'Lipovec',
    townCode: 581950,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67915,
    lat: 49.38404,
    long: 16.805938,
  },
  {
    town: 'Lipovec',
    townCode: 547875,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53843,
    lat: 49.916436,
    long: 15.545079,
  },
  {
    town: 'Lipovice',
    townCode: 537071,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.100635,
    long: 13.993981,
  },
  {
    town: 'Liptál',
    townCode: 544396,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75501,
    lat: 49.290608,
    long: 17.921879,
  },
  {
    town: 'Liptaň',
    townCode: 597571,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.222367,
    long: 17.605521,
  },
  {
    town: 'Lipůvka',
    townCode: 581968,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.340382,
    long: 16.553004,
  },
  {
    town: 'Lísek',
    townCode: 596051,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.586936,
    long: 16.201244,
  },
  {
    town: 'Lískovice',
    townCode: 573086,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.336986,
    long: 15.554989,
  },
  {
    town: 'Líský',
    townCode: 571555,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27376,
    lat: 50.250661,
    long: 13.929036,
  },
  {
    town: 'Lisov',
    townCode: 540064,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.638638,
    long: 13.100966,
  },
  {
    town: 'Lišany',
    townCode: 542016,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27052,
    lat: 50.147452,
    long: 13.742038,
  },
  {
    town: 'Lišany',
    townCode: 566411,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.344465,
    long: 13.642025,
  },
  {
    town: 'Lišice',
    townCode: 570290,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.181052,
    long: 15.408168,
  },
  {
    town: 'Líšina',
    townCode: 540617,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.603604,
    long: 13.164824,
  },
  {
    town: 'Líšná',
    townCode: 596060,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.640272,
    long: 16.151155,
  },
  {
    town: 'Líšná',
    townCode: 514802,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75115,
    lat: 49.411684,
    long: 17.547451,
  },
  {
    town: 'Líšná',
    townCode: 559962,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.885111,
    long: 13.806522,
  },
  {
    town: 'Lišnice',
    townCode: 567248,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.454552,
    long: 13.63312,
  },
  {
    town: 'Líšnice',
    townCode: 540161,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78985,
    lat: 49.75594,
    long: 16.876089,
  },
  {
    town: 'Líšnice',
    townCode: 580589,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56184,
    lat: 50.079921,
    long: 16.508318,
  },
  {
    town: 'Líšnice',
    townCode: 539457,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.888884,
    long: 14.319068,
  },
  {
    town: 'Líšný',
    townCode: 563676,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.64567,
    long: 15.212313,
  },
  {
    town: 'Lišov',
    townCode: 544779,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37372,
    lat: 49.016073,
    long: 14.608479,
  },
  {
    town: 'Líšťany',
    townCode: 559172,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33035,
    lat: 49.831183,
    long: 13.181206,
  },
  {
    town: 'Líšťany',
    townCode: 546879,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.312594,
    long: 13.800031,
  },
  {
    town: 'Líté',
    townCode: 566420,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.913753,
    long: 13.26085,
  },
  {
    town: 'Liteň',
    townCode: 531456,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26727,
    lat: 49.903811,
    long: 14.149092,
  },
  {
    town: 'Litenčice',
    townCode: 588695,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76813,
    lat: 49.202303,
    long: 17.208524,
  },
  {
    town: 'Litíč',
    townCode: 546470,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.375254,
    long: 15.84848,
  },
  {
    town: 'Litichovice',
    townCode: 532258,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.783034,
    long: 14.850678,
  },
  {
    town: 'Litoboř',
    townCode: 573388,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55205,
    lat: 50.449962,
    long: 16.015368,
  },
  {
    town: 'Litobratřice',
    townCode: 594369,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.887149,
    long: 16.402604,
  },
  {
    town: 'Litohlavy',
    townCode: 553611,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.766543,
    long: 13.56469,
  },
  {
    town: 'Litohoř',
    townCode: 550507,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67544,
    lat: 49.066937,
    long: 15.768521,
  },
  {
    town: 'Litohošť',
    townCode: 561266,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.449741,
    long: 15.091095,
  },
  {
    town: 'Litochovice',
    townCode: 551341,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.159413,
    long: 13.94153,
  },
  {
    town: 'Litoměřice',
    townCode: 564567,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.53852,
    long: 14.130646,
  },
  {
    town: 'Litomyšl',
    townCode: 578347,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.870623,
    long: 16.311162,
  },
  {
    town: 'Litostrov',
    townCode: 583308,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.225246,
    long: 16.330795,
  },
  {
    town: 'Litošice',
    townCode: 575330,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.984932,
    long: 15.514334,
  },
  {
    town: 'Litovany',
    townCode: 591068,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67557,
    lat: 49.055056,
    long: 16.044024,
  },
  {
    town: 'Litovel',
    townCode: 503444,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78401,
    lat: 49.701309,
    long: 17.076255,
  },
  {
    town: 'Litultovice',
    townCode: 507920,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74755,
    lat: 49.90397,
    long: 17.751529,
  },
  {
    town: 'Litvínov',
    townCode: 567256,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43601,
    lat: 50.598526,
    long: 13.610342,
  },
  {
    town: 'Litvínovice',
    townCode: 544795,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.962172,
    long: 14.451559,
  },
  {
    town: 'Lkáň',
    townCode: 546691,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.443126,
    long: 13.969778,
  },
  {
    town: 'Lnáře',
    townCode: 551350,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38742,
    lat: 49.458006,
    long: 13.784168,
  },
  {
    town: 'Lobeč',
    townCode: 531677,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27736,
    lat: 50.460567,
    long: 14.666882,
  },
  {
    town: 'Lobendava',
    townCode: 545708,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40784,
    lat: 51.019574,
    long: 14.314344,
  },
  {
    town: 'Lobodice',
    townCode: 515191,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75101,
    lat: 49.395559,
    long: 17.292031,
  },
  {
    town: 'Ločenice',
    townCode: 544809,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37322,
    lat: 48.824304,
    long: 14.527609,
  },
  {
    town: 'Loděnice',
    townCode: 594377,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67175,
    lat: 49.011698,
    long: 16.463176,
  },
  {
    town: 'Loděnice',
    townCode: 531464,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26712,
    lat: 49.994962,
    long: 14.157959,
  },
  {
    town: 'Lodhéřov',
    townCode: 546666,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37826,
    lat: 49.215189,
    long: 14.960045,
  },
  {
    town: 'Lodín',
    townCode: 570303,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.270952,
    long: 15.610553,
  },
  {
    town: 'Lochenice',
    townCode: 570311,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50302,
    lat: 50.272221,
    long: 15.820017,
  },
  {
    town: 'Lochousice',
    townCode: 566462,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.675204,
    long: 13.090555,
  },
  {
    town: 'Lochovice',
    townCode: 531472,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26723,
    lat: 49.853286,
    long: 13.981372,
  },
  {
    town: 'Loket',
    townCode: 560537,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35733,
    lat: 50.186112,
    long: 12.754163,
  },
  {
    town: 'Loket',
    townCode: 530093,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.655592,
    long: 15.116995,
  },
  {
    town: 'Lom',
    townCode: 536822,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.410552,
    long: 13.989092,
  },
  {
    town: 'Lom',
    townCode: 563587,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39002,
    lat: 49.362958,
    long: 14.62841,
  },
  {
    town: 'Lom',
    townCode: 567264,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43511,
    lat: 50.593384,
    long: 13.657403,
  },
  {
    town: 'Lom u Tachova',
    townCode: 541702,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.818772,
    long: 12.692703,
  },
  {
    town: 'Lomec',
    townCode: 578070,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.371502,
    long: 13.267633,
  },
  {
    town: 'Lomnice',
    townCode: 581976,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.404719,
    long: 16.413696,
  },
  {
    town: 'Lomnice',
    townCode: 560545,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.211851,
    long: 12.632789,
  },
  {
    town: 'Lomnice',
    townCode: 597589,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79302,
    lat: 49.871099,
    long: 17.415174,
  },
  {
    town: 'Lomnice nad Lužnicí',
    townCode: 546674,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37816,
    lat: 49.084786,
    long: 14.717374,
  },
  {
    town: 'Lomnice nad Popelkou',
    townCode: 577308,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51251,
    lat: 50.530724,
    long: 15.373517,
  },
  {
    town: 'Lomnička',
    townCode: 583316,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.367091,
    long: 16.431352,
  },
  {
    town: 'Lomy',
    townCode: 587605,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 49.065617,
    long: 15.601184,
  },
  {
    town: 'Lopeník',
    townCode: 592340,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68767,
    lat: 48.942882,
    long: 17.781225,
  },
  {
    town: 'Losiná',
    townCode: 558001,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.6693,
    long: 13.448442,
  },
  {
    town: 'Lošany',
    townCode: 533505,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.99764,
    long: 15.126048,
  },
  {
    town: 'Loštice',
    townCode: 540196,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78983,
    lat: 49.744796,
    long: 16.929028,
  },
  {
    town: 'Loucká',
    townCode: 535095,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27324,
    lat: 50.327578,
    long: 14.239126,
  },
  {
    town: 'Loučany',
    townCode: 552232,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78344,
    lat: 49.601996,
    long: 17.082765,
  },
  {
    town: 'Loučeň',
    townCode: 537446,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28937,
    lat: 50.285812,
    long: 15.02016,
  },
  {
    town: 'Loučim',
    townCode: 553867,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.367168,
    long: 13.112222,
  },
  {
    town: 'Loučka',
    townCode: 552038,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78322,
    lat: 49.656944,
    long: 17.011221,
  },
  {
    town: 'Loučka',
    townCode: 544418,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75644,
    lat: 49.438791,
    long: 17.832764,
  },
  {
    town: 'Loučka',
    townCode: 585432,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76325,
    lat: 49.170133,
    long: 17.876186,
  },
  {
    town: 'Loučky',
    townCode: 573400,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.617659,
    long: 15.218593,
  },
  {
    town: 'Loučná nad Desnou',
    townCode: 540226,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78811,
    lat: 50.07166,
    long: 17.091064,
  },
  {
    town: 'Loučná pod Klínovcem',
    townCode: 546518,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43191,
    lat: 50.420711,
    long: 12.986674,
  },
  {
    town: 'Loučovice',
    townCode: 545601,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38276,
    lat: 48.620292,
    long: 14.257565,
  },
  {
    town: 'Louka',
    townCode: 553875,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.529269,
    long: 16.43115,
  },
  {
    town: 'Louka',
    townCode: 586331,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69676,
    lat: 48.915266,
    long: 17.489382,
  },
  {
    town: 'Louka u Litvínova',
    townCode: 567272,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43533,
    lat: 50.587967,
    long: 13.636592,
  },
  {
    town: 'Loukov',
    townCode: 570770,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29411,
    lat: 50.561381,
    long: 15.035739,
  },
  {
    town: 'Loukov',
    townCode: 588709,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76875,
    lat: 49.421886,
    long: 17.721131,
  },
  {
    town: 'Loukovec',
    townCode: 536261,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29411,
    lat: 50.562014,
    long: 15.015815,
  },
  {
    town: 'Loukovice',
    townCode: 591092,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.137327,
    long: 15.793465,
  },
  {
    town: 'Louňová',
    townCode: 558010,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.562286,
    long: 13.608016,
  },
  {
    town: 'Louňovice',
    townCode: 538451,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25162,
    lat: 49.982366,
    long: 14.761849,
  },
  {
    town: 'Louňovice pod Blaníkem',
    townCode: 530107,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25706,
    lat: 49.637336,
    long: 14.846795,
  },
  {
    town: 'Louny',
    townCode: 565971,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.354081,
    long: 13.803455,
  },
  {
    town: 'Loužnice',
    townCode: 563684,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.679747,
    long: 15.2678,
  },
  {
    town: 'Lovčice',
    townCode: 586340,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69639,
    lat: 49.063682,
    long: 17.05439,
  },
  {
    town: 'Lovčice',
    townCode: 570320,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50361,
    lat: 50.165301,
    long: 15.38474,
  },
  {
    town: 'Lovčičky',
    townCode: 593265,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68354,
    lat: 49.068009,
    long: 16.850309,
  },
  {
    town: 'Lovčovice',
    townCode: 544957,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 48.981577,
    long: 15.53442,
  },
  {
    town: 'Lovečkovice',
    townCode: 565211,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41145,
    lat: 50.621676,
    long: 14.263257,
  },
  {
    town: 'Lovosice',
    townCode: 565229,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.515143,
    long: 14.051142,
  },
  {
    town: 'Loza',
    townCode: 566446,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.893909,
    long: 13.290472,
  },
  {
    town: 'Lozice',
    townCode: 571750,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53854,
    lat: 49.916576,
    long: 16.023891,
  },
  {
    town: 'Lštění',
    townCode: 532193,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25722,
    lat: 49.864385,
    long: 14.71437,
  },
  {
    town: 'Lubě',
    townCode: 581992,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67921,
    lat: 49.396274,
    long: 16.526068,
  },
  {
    town: 'Lubenec',
    townCode: 566438,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43983,
    lat: 50.132182,
    long: 13.313301,
  },
  {
    town: 'Luběnice',
    townCode: 552216,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78346,
    lat: 49.576275,
    long: 17.120578,
  },
  {
    town: 'Lubná',
    townCode: 578355,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56963,
    lat: 49.774189,
    long: 16.223798,
  },
  {
    town: 'Lubná',
    townCode: 542032,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27036,
    lat: 50.07703,
    long: 13.700847,
  },
  {
    town: 'Lubná',
    townCode: 588717,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.220846,
    long: 17.398055,
  },
  {
    town: 'Lubné',
    townCode: 596078,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59451,
    lat: 49.354268,
    long: 16.275314,
  },
  {
    town: 'Lubnice',
    townCode: 594385,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.939563,
    long: 15.613963,
  },
  {
    town: 'Lubník',
    townCode: 580619,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.888599,
    long: 16.661647,
  },
  {
    town: 'Luboměř',
    townCode: 599646,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74235,
    lat: 49.688754,
    long: 17.706584,
  },
  {
    town: 'Luboměř pod Strážnou',
    townCode: 500151,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75362,
    lat: 49.689117,
    long: 17.663752,
  },
  {
    town: 'Luby',
    townCode: 554634,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35137,
    lat: 50.252592,
    long: 12.406065,
  },
  {
    town: 'Lučany nad Nisou',
    townCode: 563692,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46871,
    lat: 50.741456,
    long: 15.220572,
  },
  {
    town: 'Lučice',
    townCode: 569062,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58235,
    lat: 49.662406,
    long: 15.496764,
  },
  {
    town: 'Lučina',
    townCode: 598399,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73939,
    lat: 49.716011,
    long: 18.449769,
  },
  {
    town: 'Ludgeřovice',
    townCode: 507971,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74714,
    lat: 49.89052,
    long: 18.24019,
  },
  {
    town: 'Ludíkov',
    townCode: 531006,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.455493,
    long: 16.731887,
  },
  {
    town: 'Ludkovice',
    townCode: 585441,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76341,
    lat: 49.114836,
    long: 17.72672,
  },
  {
    town: 'Ludmírov',
    townCode: 589705,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79855,
    lat: 49.641418,
    long: 16.87332,
  },
  {
    town: 'Ludslavice',
    townCode: 588725,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76852,
    lat: 49.299616,
    long: 17.540777,
  },
  {
    town: 'Ludvíkov',
    townCode: 551996,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79326,
    lat: 50.107531,
    long: 17.342351,
  },
  {
    town: 'Ludvíkovice',
    townCode: 546496,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40713,
    lat: 50.794169,
    long: 14.256524,
  },
  {
    town: 'Luhačovice',
    townCode: 585459,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76326,
    lat: 49.099922,
    long: 17.757583,
  },
  {
    town: 'Luka',
    townCode: 514161,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.51251,
    long: 14.664183,
  },
  {
    town: 'Luká',
    townCode: 503622,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78324,
    lat: 49.649243,
    long: 16.947383,
  },
  {
    town: 'Luka nad Jihlavou',
    townCode: 587478,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58822,
    lat: 49.374132,
    long: 15.702039,
  },
  {
    town: 'Lukavec',
    townCode: 548332,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39426,
    lat: 49.565511,
    long: 14.990517,
  },
  {
    town: 'Lukavec',
    townCode: 565237,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.501745,
    long: 14.085804,
  },
  {
    town: 'Lukavec u Hořic',
    townCode: 573141,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.395819,
    long: 15.616987,
  },
  {
    town: 'Lukavice',
    townCode: 576492,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51603,
    lat: 50.200324,
    long: 16.293747,
  },
  {
    town: 'Lukavice',
    townCode: 540234,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.823003,
    long: 16.920503,
  },
  {
    town: 'Lukavice',
    townCode: 571768,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53821,
    lat: 49.888935,
    long: 15.839045,
  },
  {
    town: 'Lukavice',
    townCode: 580627,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56151,
    lat: 50.060386,
    long: 16.482177,
  },
  {
    town: 'Lukov',
    townCode: 594393,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.861685,
    long: 15.910794,
  },
  {
    town: 'Lukov',
    townCode: 550566,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67602,
    lat: 49.073601,
    long: 15.824336,
  },
  {
    town: 'Lukov',
    townCode: 546909,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41804,
    lat: 50.528228,
    long: 13.885519,
  },
  {
    town: 'Lukov',
    townCode: 585467,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76317,
    lat: 49.290372,
    long: 17.729695,
  },
  {
    town: 'Luková',
    townCode: 580635,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56123,
    lat: 49.875582,
    long: 16.606774,
  },
  {
    town: 'Lukovany',
    townCode: 583324,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.162573,
    long: 16.297954,
  },
  {
    town: 'Lukoveček',
    townCode: 557145,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76316,
    lat: 49.30359,
    long: 17.668809,
  },
  {
    town: 'Luleč',
    townCode: 593273,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68303,
    lat: 49.253592,
    long: 16.928755,
  },
  {
    town: 'Lupenice',
    townCode: 576506,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.132992,
    long: 16.273884,
  },
  {
    town: 'Luštěnice',
    townCode: 536270,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29442,
    lat: 50.323059,
    long: 14.93678,
  },
  {
    town: 'Lutín',
    townCode: 503657,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78349,
    lat: 49.558552,
    long: 17.135827,
  },
  {
    town: 'Lutonina',
    townCode: 585483,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76312,
    lat: 49.238638,
    long: 17.882915,
  },
  {
    town: 'Lutopecny',
    townCode: 588733,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.301479,
    long: 17.344491,
  },
  {
    town: 'Lužany',
    townCode: 570354,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50305,
    lat: 50.33965,
    long: 15.819476,
  },
  {
    town: 'Lužany',
    townCode: 573159,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50706,
    lat: 50.431154,
    long: 15.470396,
  },
  {
    town: 'Lužany',
    townCode: 558028,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33454,
    lat: 49.546752,
    long: 13.315847,
  },
  {
    town: 'Lužce',
    townCode: 534404,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 49.98422,
    long: 14.196827,
  },
  {
    town: 'Luže',
    townCode: 571776,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53854,
    lat: 49.893513,
    long: 16.028604,
  },
  {
    town: 'Lužec nad Cidlinou',
    townCode: 570362,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50362,
    lat: 50.213644,
    long: 15.411967,
  },
  {
    town: 'Lužec nad Vltavou',
    townCode: 535028,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27706,
    lat: 50.321488,
    long: 14.400326,
  },
  {
    town: 'Luženičky',
    townCode: 553891,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.458913,
    long: 12.897685,
  },
  {
    town: 'Lužice',
    townCode: 537322,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.031398,
    long: 14.205036,
  },
  {
    town: 'Lužice',
    townCode: 586358,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69618,
    lat: 48.841077,
    long: 17.071145,
  },
  {
    town: 'Lužice',
    townCode: 569844,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.715844,
    long: 17.259668,
  },
  {
    town: 'Lužice',
    townCode: 567281,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43524,
    lat: 50.491802,
    long: 13.75425,
  },
  {
    town: 'Lužná',
    townCode: 542041,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27051,
    lat: 50.123876,
    long: 13.770152,
  },
  {
    town: 'Lužná',
    townCode: 544434,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75611,
    lat: 49.239886,
    long: 18.019755,
  },
  {
    town: 'Lužnice',
    townCode: 508501,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.063083,
    long: 14.756284,
  },
  {
    town: 'Lysá nad Labem',
    townCode: 537454,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28922,
    lat: 50.201532,
    long: 14.832919,
  },
  {
    town: 'Lysice',
    townCode: 582018,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.451697,
    long: 16.537263,
  },
  {
    town: 'Lysovice',
    townCode: 593281,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.21801,
    long: 16.970637,
  },
  {
    town: 'Mackovice',
    townCode: 594407,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.883712,
    long: 16.309445,
  },
  {
    town: 'Mačkov',
    townCode: 536466,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.40436,
    long: 13.886196,
  },
  {
    town: 'Mahouš',
    townCode: 537381,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.047948,
    long: 14.256061,
  },
  {
    town: 'Machov',
    townCode: 574210,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54963,
    lat: 50.499363,
    long: 16.277008,
  },
  {
    town: 'Machová',
    townCode: 585491,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76301,
    lat: 49.254401,
    long: 17.545053,
  },
  {
    town: 'Majdalena',
    townCode: 546712,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37803,
    lat: 48.960809,
    long: 14.86141,
  },
  {
    town: 'Majetín',
    townCode: 503738,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75103,
    lat: 49.498174,
    long: 17.333246,
  },
  {
    town: 'Makotřasy',
    townCode: 532622,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27354,
    lat: 50.144584,
    long: 14.214806,
  },
  {
    town: 'Makov',
    townCode: 582026,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67972,
    lat: 49.519247,
    long: 16.483791,
  },
  {
    town: 'Makov',
    townCode: 578363,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.855103,
    long: 16.191233,
  },
  {
    town: 'Malá Bystřice',
    townCode: 544469,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75627,
    lat: 49.409504,
    long: 18.04863,
  },
  {
    town: 'Malá Hraštice',
    townCode: 540714,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26203,
    lat: 49.807609,
    long: 14.279979,
  },
  {
    town: 'Malá Lhota',
    townCode: 582034,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67921,
    lat: 49.39199,
    long: 16.549636,
  },
  {
    town: 'Malá Losenice',
    townCode: 596086,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59211,
    lat: 49.600028,
    long: 15.796704,
  },
  {
    town: 'Malá Morava',
    townCode: 540331,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78833,
    lat: 50.096366,
    long: 16.826768,
  },
  {
    town: 'Malá Morávka',
    townCode: 597601,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79336,
    lat: 50.021157,
    long: 17.311666,
  },
  {
    town: 'Malá Roudka',
    townCode: 582042,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67963,
    lat: 49.60178,
    long: 16.644574,
  },
  {
    town: 'Malá Skála',
    townCode: 563706,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.646408,
    long: 15.195534,
  },
  {
    town: 'Malá Štáhle',
    townCode: 551902,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79501,
    lat: 49.9515,
    long: 17.341559,
  },
  {
    town: 'Malá Úpa',
    townCode: 579505,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54227,
    lat: 50.744947,
    long: 15.820639,
  },
  {
    town: 'Malá Veleň',
    townCode: 562700,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.741627,
    long: 14.270704,
  },
  {
    town: 'Malá Víska',
    townCode: 533319,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26762,
    lat: 49.776121,
    long: 13.875624,
  },
  {
    town: 'Malá Vrbka',
    townCode: 586366,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69673,
    lat: 48.869505,
    long: 17.459307,
  },
  {
    town: 'Malčín',
    townCode: 569071,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.688715,
    long: 15.465269,
  },
  {
    town: 'Malé Březno',
    townCode: 567299,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.462594,
    long: 13.560308,
  },
  {
    town: 'Malé Březno',
    townCode: 568091,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.672709,
    long: 14.172366,
  },
  {
    town: 'Malé Hradisko',
    townCode: 589713,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79849,
    lat: 49.493414,
    long: 16.87669,
  },
  {
    town: 'Malé Kyšice',
    townCode: 532631,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.061193,
    long: 14.09042,
  },
  {
    town: 'Malé Přítočno',
    townCode: 513113,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.107798,
    long: 14.135713,
  },
  {
    town: 'Malé Svatoňovice',
    townCode: 579513,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54234,
    lat: 50.534044,
    long: 16.049886,
  },
  {
    town: 'Malé Výkleky',
    townCode: 572802,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.119436,
    long: 15.538618,
  },
  {
    town: 'Malé Žernoseky',
    townCode: 565245,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.534078,
    long: 14.05484,
  },
  {
    town: 'Maleč',
    townCode: 569089,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58276,
    lat: 49.772128,
    long: 15.676917,
  },
  {
    town: 'Malečov',
    townCode: 568104,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40327,
    lat: 50.632028,
    long: 14.119558,
  },
  {
    town: 'Malenice',
    townCode: 551384,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38706,
    lat: 49.126512,
    long: 13.882929,
  },
  {
    town: 'Malenovice',
    townCode: 552593,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73911,
    lat: 49.579287,
    long: 18.398071,
  },
  {
    town: 'Malešov',
    townCode: 534188,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28541,
    lat: 49.911117,
    long: 15.224443,
  },
  {
    town: 'Malešovice',
    townCode: 583332,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66465,
    lat: 49.023694,
    long: 16.501392,
  },
  {
    town: 'Maletín',
    townCode: 540366,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.799359,
    long: 16.78743,
  },
  {
    town: 'Malhostovice',
    townCode: 583341,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66603,
    lat: 49.333699,
    long: 16.502322,
  },
  {
    town: 'Malhotice',
    townCode: 515329,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.490108,
    long: 17.764264,
  },
  {
    town: 'Malíč',
    townCode: 542491,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.543636,
    long: 14.082115,
  },
  {
    town: 'Malíkov',
    townCode: 578371,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.731136,
    long: 16.69618,
  },
  {
    town: 'Malíkovice',
    townCode: 532657,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27377,
    lat: 50.211503,
    long: 13.982657,
  },
  {
    town: 'Malínky',
    townCode: 593290,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.159408,
    long: 17.160321,
  },
  {
    town: 'Malinová',
    townCode: 565377,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.047922,
    long: 13.667032,
  },
  {
    town: 'Málkov',
    townCode: 534218,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26701,
    lat: 49.888313,
    long: 14.023652,
  },
  {
    town: 'Málkov',
    townCode: 563200,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.446278,
    long: 13.333493,
  },
  {
    town: 'Malonty',
    townCode: 545619,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38291,
    lat: 48.686212,
    long: 14.576875,
  },
  {
    town: 'Malotice',
    townCode: 533513,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.965299,
    long: 14.977728,
  },
  {
    town: 'Malovice',
    townCode: 550418,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.091285,
    long: 14.225863,
  },
  {
    town: 'Malšice',
    townCode: 552666,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39175,
    lat: 49.364014,
    long: 14.578788,
  },
  {
    town: 'Malšín',
    townCode: 536296,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38273,
    lat: 48.678126,
    long: 14.287135,
  },
  {
    town: 'Malšovice',
    townCode: 562718,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.735259,
    long: 14.169817,
  },
  {
    town: 'Malý Beranov',
    townCode: 587486,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58603,
    lat: 49.396595,
    long: 15.637796,
  },
  {
    town: 'Malý Bor',
    townCode: 556629,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.330621,
    long: 13.652357,
  },
  {
    town: 'Malý Újezd',
    townCode: 535036,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27731,
    lat: 50.33257,
    long: 14.529687,
  },
  {
    town: 'Manětín',
    townCode: 559202,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33162,
    lat: 49.991884,
    long: 13.233304,
  },
  {
    town: 'Mankovice',
    townCode: 568589,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74235,
    lat: 49.637559,
    long: 17.880249,
  },
  {
    town: 'Maňovice',
    townCode: 578410,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.393065,
    long: 13.653942,
  },
  {
    town: 'Mariánské Lázně',
    townCode: 554642,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.964699,
    long: 12.701298,
  },
  {
    town: 'Mariánské Radčice',
    townCode: 567302,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43532,
    lat: 50.574142,
    long: 13.665101,
  },
  {
    town: 'Markvartice',
    townCode: 587494,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.178289,
    long: 15.617202,
  },
  {
    town: 'Markvartice',
    townCode: 591114,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.200958,
    long: 15.767422,
  },
  {
    town: 'Markvartice',
    townCode: 573167,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50742,
    lat: 50.430868,
    long: 15.196175,
  },
  {
    town: 'Markvartice',
    townCode: 545678,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40742,
    lat: 50.775633,
    long: 14.355383,
  },
  {
    town: 'Markvartovice',
    townCode: 508128,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74714,
    lat: 49.906049,
    long: 18.23613,
  },
  {
    town: 'Maršov',
    townCode: 583359,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66471,
    lat: 49.28378,
    long: 16.359854,
  },
  {
    town: 'Maršov u Úpice',
    townCode: 579530,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54232,
    lat: 50.484721,
    long: 15.976044,
  },
  {
    town: 'Maršovice',
    townCode: 563714,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46801,
    lat: 50.696455,
    long: 15.198577,
  },
  {
    town: 'Maršovice',
    townCode: 530115,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25755,
    lat: 49.71367,
    long: 14.564615,
  },
  {
    town: 'Martiněves',
    townCode: 565253,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41119,
    lat: 50.372805,
    long: 14.152928,
  },
  {
    town: 'Martinice',
    townCode: 596094,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.371786,
    long: 16.038309,
  },
  {
    town: 'Martinice',
    townCode: 588741,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.310408,
    long: 17.601188,
  },
  {
    town: 'Martinice u Onšova',
    townCode: 561347,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.579951,
    long: 15.115482,
  },
  {
    town: 'Martinice v Krkonoších',
    townCode: 573418,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51232,
    lat: 50.580946,
    long: 15.533412,
  },
  {
    town: 'Martínkov',
    townCode: 550388,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67544,
    lat: 49.096759,
    long: 15.711505,
  },
  {
    town: 'Martínkovice',
    townCode: 574228,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54973,
    lat: 50.547626,
    long: 16.342079,
  },
  {
    town: 'Mařenice',
    townCode: 561827,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47156,
    lat: 50.807507,
    long: 14.678659,
  },
  {
    town: 'Máslojedy',
    townCode: 573779,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.297029,
    long: 15.75893,
  },
  {
    town: 'Máslovice',
    townCode: 538469,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25069,
    lat: 50.208722,
    long: 14.37903,
  },
  {
    town: 'Masojedy',
    townCode: 564702,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.026078,
    long: 14.777985,
  },
  {
    town: 'Mastník',
    townCode: 591122,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.180293,
    long: 15.827933,
  },
  {
    town: 'Mašovice',
    townCode: 594415,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.857475,
    long: 15.973646,
  },
  {
    town: 'Mašťov',
    townCode: 563218,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43156,
    lat: 50.262382,
    long: 13.280572,
  },
  {
    town: 'Matějov',
    townCode: 596108,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.528697,
    long: 15.863108,
  },
  {
    town: 'Mazelov',
    townCode: 535940,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37363,
    lat: 49.103053,
    long: 14.617886,
  },
  {
    town: 'Mažice',
    townCode: 562866,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.213602,
    long: 14.612918,
  },
  {
    town: 'Mcely',
    townCode: 537462,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28936,
    lat: 50.294356,
    long: 15.075984,
  },
  {
    town: 'Meclov',
    townCode: 553913,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34521,
    lat: 49.505676,
    long: 12.880927,
  },
  {
    town: 'Mečeříž',
    townCode: 565644,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29477,
    lat: 50.29048,
    long: 14.7369,
  },
  {
    town: 'Mečichov',
    townCode: 551392,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38736,
    lat: 49.347873,
    long: 13.812134,
  },
  {
    town: 'Měčín',
    townCode: 556637,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.480195,
    long: 13.402993,
  },
  {
    town: 'Měděnec',
    townCode: 563226,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43184,
    lat: 50.421723,
    long: 13.115541,
  },
  {
    town: 'Medlice',
    townCode: 594423,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67140,
    lat: 49.003081,
    long: 16.121404,
  },
  {
    town: 'Medlov',
    townCode: 583367,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66466,
    lat: 49.03519,
    long: 16.522482,
  },
  {
    town: 'Medlov',
    townCode: 552372,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78391,
    lat: 49.787639,
    long: 17.062716,
  },
  {
    town: 'Medlovice',
    townCode: 550141,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.27451,
    long: 17.093049,
  },
  {
    town: 'Medlovice',
    townCode: 592366,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68741,
    lat: 49.049125,
    long: 17.27186,
  },
  {
    town: 'Medonosy',
    townCode: 529575,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.494256,
    long: 14.487049,
  },
  {
    town: 'Medový Újezd',
    townCode: 579009,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.773949,
    long: 13.719185,
  },
  {
    town: 'Měchenice',
    townCode: 539490,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25206,
    lat: 49.908274,
    long: 14.389375,
  },
  {
    town: 'Měcholupy',
    townCode: 539716,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33551,
    lat: 49.519592,
    long: 13.532756,
  },
  {
    town: 'Měcholupy',
    townCode: 566454,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43931,
    lat: 50.26677,
    long: 13.537482,
  },
  {
    town: 'Měkynec',
    townCode: 536415,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.15838,
    long: 14.029485,
  },
  {
    town: 'Melč',
    townCode: 508144,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74784,
    lat: 49.850024,
    long: 17.757906,
  },
  {
    town: 'Mělčany',
    townCode: 583375,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.076242,
    long: 16.4923,
  },
  {
    town: 'Mělnické Vtelno',
    townCode: 535044,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27738,
    lat: 50.352413,
    long: 14.695218,
  },
  {
    town: 'Mělník',
    townCode: 534676,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27601,
    lat: 50.354002,
    long: 14.481881,
  },
  {
    town: 'Měňany',
    townCode: 531529,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26727,
    lat: 49.910104,
    long: 14.117791,
  },
  {
    town: 'Menhartice',
    townCode: 545031,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 48.990055,
    long: 15.552611,
  },
  {
    town: 'Měník',
    townCode: 570397,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50364,
    lat: 50.215505,
    long: 15.528273,
  },
  {
    town: 'Měnín',
    townCode: 583383,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66457,
    lat: 49.082495,
    long: 16.694343,
  },
  {
    town: 'Merboltice',
    townCode: 545791,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.684307,
    long: 14.339205,
  },
  {
    town: 'Merklín',
    townCode: 555363,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36234,
    lat: 50.32819,
    long: 12.863613,
  },
  {
    town: 'Merklín',
    townCode: 558044,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33452,
    lat: 49.560538,
    long: 13.198008,
  },
  {
    town: 'Měrotín',
    townCode: 568911,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78324,
    lat: 49.692571,
    long: 17.001818,
  },
  {
    town: 'Měrovice nad Hanou',
    townCode: 552909,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75201,
    lat: 49.34167,
    long: 17.245955,
  },
  {
    town: 'Měrunice',
    townCode: 567698,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41804,
    lat: 50.480523,
    long: 13.818088,
  },
  {
    town: 'Měřín',
    townCode: 596116,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59442,
    lat: 49.393312,
    long: 15.883916,
  },
  {
    town: 'Městec Králové',
    townCode: 537489,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28903,
    lat: 50.207281,
    long: 15.297687,
  },
  {
    town: 'Městečko',
    townCode: 542067,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.050739,
    long: 13.86367,
  },
  {
    town: 'Městečko Trnávka',
    townCode: 578380,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56941,
    lat: 49.709363,
    long: 16.727541,
  },
  {
    town: 'Město Albrechtice',
    townCode: 597635,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79395,
    lat: 50.163036,
    long: 17.574913,
  },
  {
    town: 'Město Libavá',
    townCode: 500160,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78307,
    lat: 49.721619,
    long: 17.520135,
  },
  {
    town: 'Město Touškov',
    townCode: 559211,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33033,
    lat: 49.77598,
    long: 13.251189,
  },
  {
    town: 'Měšice',
    townCode: 538477,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25064,
    lat: 50.198097,
    long: 14.520024,
  },
  {
    town: 'Měšín',
    townCode: 587508,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58601,
    lat: 49.437406,
    long: 15.657133,
  },
  {
    town: 'Mešno',
    townCode: 579084,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.655921,
    long: 13.622053,
  },
  {
    town: 'Metylovice',
    townCode: 512184,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73949,
    lat: 49.606756,
    long: 18.339222,
  },
  {
    town: 'Mezholezy',
    townCode: 553921,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.411826,
    long: 13.103952,
  },
  {
    town: 'Mezholezy',
    townCode: 553930,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.624867,
    long: 12.905124,
  },
  {
    town: 'Meziboří',
    townCode: 567311,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43513,
    lat: 50.62126,
    long: 13.598813,
  },
  {
    town: 'Mezihoří',
    townCode: 578461,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.488506,
    long: 13.254671,
  },
  {
    town: 'Mezilečí',
    townCode: 574236,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55205,
    lat: 50.453464,
    long: 15.983292,
  },
  {
    town: 'Mezilesí',
    townCode: 548367,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.541028,
    long: 14.949183,
  },
  {
    town: 'Mezilesí',
    townCode: 574244,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54923,
    lat: 50.356207,
    long: 16.217095,
  },
  {
    town: 'Meziměstí',
    townCode: 574252,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54981,
    lat: 50.624705,
    long: 16.242178,
  },
  {
    town: 'Mezina',
    townCode: 551724,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.958602,
    long: 17.477161,
  },
  {
    town: 'Meziříčí',
    townCode: 563234,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.436646,
    long: 14.575126,
  },
  {
    town: 'Meziříčko',
    townCode: 591149,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67526,
    lat: 49.109422,
    long: 15.660333,
  },
  {
    town: 'Meziříčko',
    townCode: 587516,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.405486,
    long: 15.844614,
  },
  {
    town: 'Mezná',
    townCode: 599255,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.258242,
    long: 14.800827,
  },
  {
    town: 'Mezná',
    townCode: 529834,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.34713,
    long: 15.211484,
  },
  {
    town: 'Mezno',
    townCode: 530158,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25786,
    lat: 49.534622,
    long: 14.64504,
  },
  {
    town: 'Mezouň',
    townCode: 531537,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 50.004378,
    long: 14.214277,
  },
  {
    town: 'Mičovice',
    townCode: 550426,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 48.983641,
    long: 14.125165,
  },
  {
    town: 'Míčov-Sušice',
    townCode: 571822,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.905062,
    long: 15.605872,
  },
  {
    town: 'Michalovice',
    townCode: 548316,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.577036,
    long: 15.524426,
  },
  {
    town: 'Michalovice',
    townCode: 542521,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.536682,
    long: 14.082042,
  },
  {
    town: 'Míchov',
    townCode: 582069,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.524132,
    long: 16.615857,
  },
  {
    town: 'Mikolajice',
    townCode: 568279,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74784,
    lat: 49.877258,
    long: 17.793425,
  },
  {
    town: 'Mikulášovice',
    townCode: 562751,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40779,
    lat: 50.965179,
    long: 14.363794,
  },
  {
    town: 'Mikulčice',
    townCode: 586374,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69619,
    lat: 48.816526,
    long: 17.051171,
  },
  {
    town: 'Mikuleč',
    townCode: 578398,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.805919,
    long: 16.422601,
  },
  {
    town: 'Mikulov',
    townCode: 584649,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69201,
    lat: 48.805383,
    long: 16.637788,
  },
  {
    town: 'Mikulov',
    townCode: 567701,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41901,
    lat: 50.687713,
    long: 13.721712,
  },
  {
    town: 'Mikulovice',
    townCode: 594431,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67133,
    lat: 48.956878,
    long: 16.09478,
  },
  {
    town: 'Mikulovice',
    townCode: 591157,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.161765,
    long: 15.846693,
  },
  {
    town: 'Mikulovice',
    townCode: 540382,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79084,
    lat: 50.298634,
    long: 17.321655,
  },
  {
    town: 'Mikulovice',
    townCode: 575372,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.989526,
    long: 15.775487,
  },
  {
    town: 'Mikulůvka',
    townCode: 544507,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75624,
    lat: 49.413614,
    long: 17.925167,
  },
  {
    town: 'Milasín',
    townCode: 549835,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.466338,
    long: 16.228909,
  },
  {
    town: 'Milavče',
    townCode: 553948,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.467066,
    long: 12.980829,
  },
  {
    town: 'Milčice',
    townCode: 537497,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28911,
    lat: 50.10547,
    long: 14.991803,
  },
  {
    town: 'Mileč',
    townCode: 558052,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.469232,
    long: 13.605014,
  },
  {
    town: 'Milejovice',
    townCode: 536539,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.188193,
    long: 13.930185,
  },
  {
    town: 'Milenov',
    townCode: 515418,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75361,
    lat: 49.562684,
    long: 17.66712,
  },
  {
    town: 'Milešín',
    townCode: 587770,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.368503,
    long: 16.201661,
  },
  {
    town: 'Milešov',
    townCode: 540749,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26256,
    lat: 49.589338,
    long: 14.22151,
  },
  {
    town: 'Milešovice',
    townCode: 593320,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68354,
    lat: 49.082845,
    long: 16.854355,
  },
  {
    town: 'Miletín',
    townCode: 573175,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50771,
    lat: 50.403916,
    long: 15.682367,
  },
  {
    town: 'Milevsko',
    townCode: 549576,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.450998,
    long: 14.360109,
  },
  {
    town: 'Milhostov',
    townCode: 554651,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.156155,
    long: 12.453308,
  },
  {
    town: 'Miličín',
    townCode: 530166,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25786,
    lat: 49.570793,
    long: 14.66151,
  },
  {
    town: 'Milíčov',
    townCode: 587524,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.395568,
    long: 15.393119,
  },
  {
    town: 'Milíčovice',
    townCode: 594440,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.891673,
    long: 15.932448,
  },
  {
    town: 'Milíkov',
    townCode: 538906,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.055886,
    long: 12.547716,
  },
  {
    town: 'Milíkov',
    townCode: 507547,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73981,
    lat: 49.585749,
    long: 18.719541,
  },
  {
    town: 'Milín',
    townCode: 540757,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.632028,
    long: 14.046103,
  },
  {
    town: 'Milínov',
    townCode: 530140,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.643171,
    long: 13.566047,
  },
  {
    town: 'Milíře',
    townCode: 541532,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.796407,
    long: 12.5507783,
  },
  {
    town: 'Milonice',
    townCode: 582077,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.366571,
    long: 16.568459,
  },
  {
    town: 'Milonice',
    townCode: 593338,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.15947,
    long: 17.071226,
  },
  {
    town: 'Miloňovice',
    townCode: 551414,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.22067,
    long: 13.958469,
  },
  {
    town: 'Milostín',
    townCode: 542075,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27004,
    lat: 50.193824,
    long: 13.669209,
  },
  {
    town: 'Milotice',
    townCode: 586382,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69605,
    lat: 48.955858,
    long: 17.141387,
  },
  {
    town: 'Milotice nad Bečvou',
    townCode: 515477,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75367,
    lat: 49.536608,
    long: 17.839864,
  },
  {
    town: 'Milotice nad Opavou',
    townCode: 569526,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.995792,
    long: 17.542152,
  },
  {
    town: 'Milovice',
    townCode: 584657,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69188,
    lat: 48.852588,
    long: 16.698247,
  },
  {
    town: 'Milovice',
    townCode: 537501,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28924,
    lat: 50.226061,
    long: 14.888739,
  },
  {
    town: 'Milovice u Hořic',
    townCode: 548863,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.329866,
    long: 15.63112,
  },
  {
    town: 'Milý',
    townCode: 565466,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.232771,
    long: 13.867148,
  },
  {
    town: 'Mimoň',
    townCode: 561835,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47124,
    lat: 50.655768,
    long: 14.724956,
  },
  {
    town: 'Minice',
    townCode: 562149,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.489944,
    long: 14.01224,
  },
  {
    town: 'Mirkovice',
    townCode: 545627,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.811076,
    long: 14.391352,
  },
  {
    town: 'Miroslav',
    townCode: 594458,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67172,
    lat: 48.94777,
    long: 16.312624,
  },
  {
    town: 'Miroslavské Knínice',
    townCode: 594466,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67172,
    lat: 48.977901,
    long: 16.32241,
  },
  {
    town: 'Mirošov',
    townCode: 587532,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.389533,
    long: 15.463549,
  },
  {
    town: 'Mirošov',
    townCode: 596132,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.465697,
    long: 16.155648,
  },
  {
    town: 'Mirošov',
    townCode: 559997,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.68793,
    long: 13.658174,
  },
  {
    town: 'Mirošovice',
    townCode: 538485,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25166,
    lat: 49.909949,
    long: 14.711306,
  },
  {
    town: 'Mirotice',
    townCode: 549584,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39801,
    lat: 49.429185,
    long: 14.037078,
  },
  {
    town: 'Mírov',
    townCode: 569381,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.798197,
    long: 16.84759,
  },
  {
    town: 'Mírová',
    townCode: 537934,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35735,
    lat: 50.237288,
    long: 12.770109,
  },
  {
    town: 'Mírová pod Kozákovem',
    townCode: 577316,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.591643,
    long: 15.19435,
  },
  {
    town: 'Mirovice',
    townCode: 549592,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39806,
    lat: 49.515657,
    long: 14.035924,
  },
  {
    town: 'Miřejovice',
    townCode: 530506,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.553345,
    long: 14.109038,
  },
  {
    town: 'Miřetice',
    townCode: 571831,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53955,
    lat: 49.841358,
    long: 15.884829,
  },
  {
    town: 'Miřetice',
    townCode: 530174,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.659049,
    long: 14.976635,
  },
  {
    town: 'Mířkov',
    townCode: 553956,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.589255,
    long: 12.881612,
  },
  {
    town: 'Miskovice',
    townCode: 534200,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28501,
    lat: 49.946226,
    long: 15.204823,
  },
  {
    town: 'Místo',
    townCode: 563242,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43158,
    lat: 50.447156,
    long: 13.26742,
  },
  {
    town: 'Mistrovice',
    townCode: 580643,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56164,
    lat: 50.02377,
    long: 16.571618,
  },
  {
    town: 'Mistřice',
    townCode: 592382,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.086778,
    long: 17.536075,
  },
  {
    town: 'Míškovice',
    townCode: 588750,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76852,
    lat: 49.276669,
    long: 17.549103,
  },
  {
    town: 'Míšov',
    townCode: 546399,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33563,
    lat: 49.622664,
    long: 13.725854,
  },
  {
    town: 'Mišovice',
    townCode: 549606,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.495358,
    long: 14.005039,
  },
  {
    town: 'Mladá Boleslav',
    townCode: 535419,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.413525,
    long: 14.908538,
  },
  {
    town: 'Mladá Vožice',
    townCode: 552704,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.53323,
    long: 14.808669,
  },
  {
    town: 'Mladé Bříště',
    townCode: 548383,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39443,
    lat: 49.491565,
    long: 15.335272,
  },
  {
    town: 'Mladé Buky',
    townCode: 579548,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54223,
    lat: 50.606524,
    long: 15.833588,
  },
  {
    town: 'Mladecko',
    townCode: 553042,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74754,
    lat: 49.898335,
    long: 17.708278,
  },
  {
    town: 'Mladeč',
    townCode: 504246,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78321,
    lat: 49.705924,
    long: 17.01963,
  },
  {
    town: 'Mladějov',
    townCode: 573205,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50745,
    lat: 50.482181,
    long: 15.232724,
  },
  {
    town: 'Mladějov na Moravě',
    townCode: 578401,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56935,
    lat: 49.822707,
    long: 16.591176,
  },
  {
    town: 'Mladějovice',
    townCode: 552348,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.752475,
    long: 17.23154,
  },
  {
    town: 'Mladkov',
    townCode: 580651,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56167,
    lat: 50.096953,
    long: 16.627025,
  },
  {
    town: 'Mladoňovice',
    townCode: 591165,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 49.010221,
    long: 15.64373,
  },
  {
    town: 'Mladoňovice',
    townCode: 571857,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53821,
    lat: 49.887468,
    long: 15.724015,
  },
  {
    town: 'Mladošovice',
    townCode: 544817,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 48.940569,
    long: 14.69925,
  },
  {
    town: 'Mladotice',
    townCode: 559237,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.985347,
    long: 13.364505,
  },
  {
    town: 'Mladý Smolivec',
    townCode: 558061,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.506411,
    long: 13.735393,
  },
  {
    town: 'Mlázovice',
    townCode: 573213,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50758,
    lat: 50.411963,
    long: 15.521712,
  },
  {
    town: 'Mlečice',
    townCode: 560006,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.920399,
    long: 13.696075,
  },
  {
    town: 'Mlékojedy',
    townCode: 565296,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.526999,
    long: 14.11933,
  },
  {
    town: 'Mlékosrby',
    townCode: 570401,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.191824,
    long: 15.501571,
  },
  {
    town: 'Mlýnské Struhadlo',
    townCode: 542059,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.432149,
    long: 13.469571,
  },
  {
    town: 'Mlýny',
    townCode: 552712,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.336335,
    long: 14.877147,
  },
  {
    town: 'Mnetěš',
    townCode: 565300,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.36565,
    long: 14.281839,
  },
  {
    town: 'Mnich',
    townCode: 548391,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39492,
    lat: 49.298466,
    long: 14.965835,
  },
  {
    town: 'Mnichov',
    townCode: 536563,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.302187,
    long: 13.830176,
  },
  {
    town: 'Mnichov',
    townCode: 554677,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 50.03698,
    long: 12.787043,
  },
  {
    town: 'Mnichov',
    townCode: 566292,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.49683,
    long: 12.764531,
  },
  {
    town: 'Mnichovice',
    townCode: 530191,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.668707,
    long: 15.039688,
  },
  {
    town: 'Mnichovice',
    townCode: 538493,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25164,
    lat: 49.936117,
    long: 14.709175,
  },
  {
    town: 'Mnichovo Hradiště',
    townCode: 536326,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.527029,
    long: 14.972104,
  },
  {
    town: 'Mníšek',
    townCode: 564231,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46331,
    lat: 50.831733,
    long: 15.056405,
  },
  {
    town: 'Mníšek pod Brdy',
    townCode: 540765,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.866601,
    long: 14.261865,
  },
  {
    town: 'Močerady',
    townCode: 599174,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.518078,
    long: 13.073554,
  },
  {
    town: 'Močovice',
    townCode: 530999,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.906414,
    long: 15.348298,
  },
  {
    town: 'Modlany',
    townCode: 567710,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41713,
    lat: 50.650606,
    long: 13.895449,
  },
  {
    town: 'Modletice',
    townCode: 598267,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.97026,
    long: 14.591186,
  },
  {
    town: 'Modlíkov',
    townCode: 569127,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.608287,
    long: 15.770401,
  },
  {
    town: 'Modrá',
    townCode: 592391,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68706,
    lat: 49.112121,
    long: 17.403508,
  },
  {
    town: 'Modrá Hůrka',
    townCode: 598615,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.180142,
    long: 14.525766,
  },
  {
    town: 'Modrava',
    townCode: 542148,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34192,
    lat: 49.024173,
    long: 13.499417,
  },
  {
    town: 'Modřice',
    townCode: 583391,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66442,
    lat: 49.12799,
    long: 16.614517,
  },
  {
    town: 'Modřišice',
    townCode: 577324,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.574176,
    long: 15.119437,
  },
  {
    town: 'Modřovice',
    townCode: 599751,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.617462,
    long: 13.956485,
  },
  {
    town: 'Mohelnice',
    townCode: 540471,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78985,
    lat: 49.777082,
    long: 16.919567,
  },
  {
    town: 'Mohelnice',
    townCode: 558079,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.48089,
    long: 13.641798,
  },
  {
    town: 'Mohelnice nad Jizerou',
    townCode: 565822,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29413,
    lat: 50.559891,
    long: 14.977625,
  },
  {
    town: 'Mohelno',
    townCode: 591173,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67575,
    lat: 49.114222,
    long: 16.190323,
  },
  {
    town: 'Mochov',
    townCode: 538507,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25087,
    lat: 50.141925,
    long: 14.795066,
  },
  {
    town: 'Mochtín',
    townCode: 556718,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.360477,
    long: 13.357005,
  },
  {
    town: 'Mojné',
    townCode: 598623,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.834818,
    long: 14.407373,
  },
  {
    town: 'Mokošín',
    townCode: 575381,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.014912,
    long: 15.572047,
  },
  {
    town: 'Mokrá-Horákov',
    townCode: 583405,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66404,
    lat: 49.22287,
    long: 16.751677,
  },
  {
    town: 'Mokré',
    townCode: 576522,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.259297,
    long: 16.066529,
  },
  {
    town: 'Mokré Lazce',
    townCode: 508373,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74762,
    lat: 49.904714,
    long: 18.029644,
  },
  {
    town: 'Mokrosuky',
    townCode: 556726,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.275464,
    long: 13.454904,
  },
  {
    town: 'Mokrouše',
    townCode: 540641,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33201,
    lat: 49.715159,
    long: 13.524657,
  },
  {
    town: 'Mokrovousy',
    townCode: 570419,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.27513,
    long: 15.68594,
  },
  {
    town: 'Mokrovraty',
    townCode: 540781,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26203,
    lat: 49.795772,
    long: 14.25023,
  },
  {
    town: 'Mokrý Lom',
    townCode: 535842,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.844884,
    long: 14.514153,
  },
  {
    town: 'Moldava',
    townCode: 567728,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41781,
    lat: 50.720738,
    long: 13.657342,
  },
  {
    town: 'Morašice',
    townCode: 594474,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67171,
    lat: 48.957631,
    long: 16.209004,
  },
  {
    town: 'Morašice',
    townCode: 571873,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53802,
    lat: 49.934791,
    long: 15.709072,
  },
  {
    town: 'Morašice',
    townCode: 573035,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.001981,
    long: 15.486111,
  },
  {
    town: 'Morašice',
    townCode: 578428,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56951,
    lat: 49.867799,
    long: 16.233701,
  },
  {
    town: 'Moravany',
    townCode: 583413,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66448,
    lat: 49.14566,
    long: 16.576269,
  },
  {
    town: 'Moravany',
    townCode: 586391,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69650,
    lat: 49.040216,
    long: 17.169127,
  },
  {
    town: 'Moravany',
    townCode: 575399,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53372,
    lat: 50.00105,
    long: 15.940811,
  },
  {
    town: 'Moravec',
    townCode: 596141,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59254,
    lat: 49.440204,
    long: 16.143415,
  },
  {
    town: 'Moravecké Pavlovice',
    townCode: 596159,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59262,
    lat: 49.425534,
    long: 16.256425,
  },
  {
    town: 'Moraveč',
    townCode: 548405,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.409182,
    long: 15.076977,
  },
  {
    town: 'Moravice',
    townCode: 569097,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74784,
    lat: 49.857852,
    long: 17.720204,
  },
  {
    town: 'Moravičany',
    townCode: 540480,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78982,
    lat: 49.757034,
    long: 16.960527,
  },
  {
    town: 'Morávka',
    townCode: 598445,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73904,
    lat: 49.596169,
    long: 18.524824,
  },
  {
    town: 'Moravská Nová Ves',
    townCode: 584665,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69155,
    lat: 48.803142,
    long: 17.013814,
  },
  {
    town: 'Moravská Třebová',
    townCode: 578444,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.757697,
    long: 16.663631,
  },
  {
    town: 'Moravské Bránice',
    townCode: 583421,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.083374,
    long: 16.436388,
  },
  {
    town: 'Moravské Budějovice',
    townCode: 591181,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67602,
    lat: 49.05219,
    long: 15.808746,
  },
  {
    town: 'Moravské Knínice',
    townCode: 583430,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66434,
    lat: 49.293382,
    long: 16.50184,
  },
  {
    town: 'Moravské Málkovice',
    townCode: 593346,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.257021,
    long: 17.090766,
  },
  {
    town: 'Moravskoslezský Kočov',
    townCode: 551732,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.960503,
    long: 17.441174,
  },
  {
    town: 'Moravský Beroun',
    townCode: 597678,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79305,
    lat: 49.79384,
    long: 17.442222,
  },
  {
    town: 'Moravský Krumlov',
    townCode: 594482,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.049031,
    long: 16.311798,
  },
  {
    town: 'Moravský Písek',
    townCode: 586404,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69685,
    lat: 48.990264,
    long: 17.332795,
  },
  {
    town: 'Moravský Žižkov',
    townCode: 584673,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69101,
    lat: 48.832952,
    long: 16.931502,
  },
  {
    town: 'Morkovice-Slížany',
    townCode: 588768,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76833,
    lat: 49.249941,
    long: 17.209733,
  },
  {
    town: 'Morkůvky',
    townCode: 584681,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69172,
    lat: 48.966228,
    long: 16.862319,
  },
  {
    town: 'Mořice',
    townCode: 589721,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79828,
    lat: 49.330574,
    long: 17.196995,
  },
  {
    town: 'Mořina',
    townCode: 531545,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26717,
    lat: 49.95294,
    long: 14.20874,
  },
  {
    town: 'Mořinka',
    townCode: 533912,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 49.939081,
    long: 14.237277,
  },
  {
    town: 'Mořkov',
    townCode: 599689,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74272,
    lat: 49.536937,
    long: 18.059792,
  },
  {
    town: 'Most',
    townCode: 567027,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.501655,
    long: 13.633012,
  },
  {
    town: 'Mostek',
    townCode: 579556,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54475,
    lat: 50.486326,
    long: 15.696323,
  },
  {
    town: 'Mostek',
    townCode: 580660,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.009486,
    long: 16.265146,
  },
  {
    town: 'Mostkovice',
    townCode: 589730,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79802,
    lat: 49.472246,
    long: 17.052223,
  },
  {
    town: 'Mosty u Jablunkova',
    townCode: 598453,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73998,
    lat: 49.527472,
    long: 18.754281,
  },
  {
    town: 'Mošnov',
    townCode: 568686,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74251,
    lat: 49.689142,
    long: 18.132574,
  },
  {
    town: 'Mouchnice',
    townCode: 593354,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.111822,
    long: 17.135627,
  },
  {
    town: 'Mouřínov',
    townCode: 557048,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.121563,
    long: 16.978594,
  },
  {
    town: 'Moutnice',
    townCode: 583448,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66455,
    lat: 49.049337,
    long: 16.73752,
  },
  {
    town: 'Mrač',
    townCode: 530204,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25721,
    lat: 49.829754,
    long: 14.690616,
  },
  {
    town: 'Mrákotín',
    townCode: 587541,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58854,
    lat: 49.189556,
    long: 15.376196,
  },
  {
    town: 'Mrákotín',
    townCode: 554847,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.814666,
    long: 15.95683,
  },
  {
    town: 'Mrákov',
    townCode: 553981,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34501,
    lat: 49.403252,
    long: 12.951311,
  },
  {
    town: 'Mratín',
    townCode: 538515,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.203151,
    long: 14.551084,
  },
  {
    town: 'Mrlínek',
    townCode: 553905,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.428534,
    long: 17.678364,
  },
  {
    town: 'Mrsklesy',
    townCode: 554944,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78365,
    lat: 49.602712,
    long: 17.401657,
  },
  {
    town: 'Mrtník',
    townCode: 559245,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.895538,
    long: 13.312306,
  },
  {
    town: 'Mrzky',
    townCode: 513288,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.044722,
    long: 14.810127,
  },
  {
    town: 'Mříčná',
    townCode: 577332,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51204,
    lat: 50.600813,
    long: 15.468897,
  },
  {
    town: 'Mšec',
    townCode: 542105,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27064,
    lat: 50.205291,
    long: 13.898432,
  },
  {
    town: 'Mšecké Žehrovice',
    townCode: 542113,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27064,
    lat: 50.179113,
    long: 13.923232,
  },
  {
    town: 'Mšené-lázně',
    townCode: 565318,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41119,
    lat: 50.362321,
    long: 14.127166,
  },
  {
    town: 'Mšeno',
    townCode: 535052,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27735,
    lat: 50.438194,
    long: 14.632611,
  },
  {
    town: 'Mukařov',
    townCode: 571865,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.56925,
    long: 14.925793,
  },
  {
    town: 'Mukařov',
    townCode: 538523,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25162,
    lat: 49.991254,
    long: 14.741654,
  },
  {
    town: 'Mutějovice',
    townCode: 542121,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27007,
    lat: 50.194353,
    long: 13.709619,
  },
  {
    town: 'Mutěnice',
    townCode: 560278,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.23981,
    long: 13.89664,
  },
  {
    town: 'Mutěnice',
    townCode: 586412,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69611,
    lat: 48.904228,
    long: 17.02928,
  },
  {
    town: 'Mutěnín',
    townCode: 553999,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34525,
    lat: 49.544857,
    long: 12.74467,
  },
  {
    town: 'Mutkov',
    townCode: 547093,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79351,
    lat: 49.801996,
    long: 17.284841,
  },
  {
    town: 'Mydlovary',
    townCode: 535281,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37349,
    lat: 49.091233,
    long: 14.35445,
  },
  {
    town: 'Myslejovice',
    townCode: 589748,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79805,
    lat: 49.406547,
    long: 17.027659,
  },
  {
    town: 'Mysletice',
    townCode: 587559,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.142671,
    long: 15.389524,
  },
  {
    town: 'Mysletín',
    townCode: 561819,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.476693,
    long: 15.368309,
  },
  {
    town: 'Mysliboř',
    townCode: 587567,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58862,
    lat: 49.209518,
    long: 15.484514,
  },
  {
    town: 'Myslibořice',
    townCode: 591190,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67560,
    lat: 49.102992,
    long: 15.98466,
  },
  {
    town: 'Myslín',
    townCode: 549614,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.532189,
    long: 14.02744,
  },
  {
    town: 'Myslinka',
    townCode: 566543,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.748125,
    long: 13.219142,
  },
  {
    town: 'Myslív',
    townCode: 556734,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.414314,
    long: 13.572532,
  },
  {
    town: 'Myslkovice',
    townCode: 552721,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39116,
    lat: 49.299224,
    long: 14.7457,
  },
  {
    town: 'Mysločovice',
    townCode: 585505,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76301,
    lat: 49.256096,
    long: 17.566252,
  },
  {
    town: 'Myslovice',
    townCode: 541745,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.406902,
    long: 13.387145,
  },
  {
    town: 'Myštěves',
    townCode: 570427,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.297719,
    long: 15.557476,
  },
  {
    town: 'Myštice',
    townCode: 551473,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.453257,
    long: 13.97019,
  },
  {
    town: 'Mýto',
    townCode: 560014,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33805,
    lat: 49.789152,
    long: 13.734722,
  },
  {
    town: 'Mžany',
    townCode: 570435,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.296508,
    long: 15.675954,
  },
  {
    town: 'Nabočany',
    townCode: 571890,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.94387,
    long: 15.886976,
  },
  {
    town: 'Načeradec',
    townCode: 530212,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25708,
    lat: 49.610286,
    long: 14.906434,
  },
  {
    town: 'Načešice',
    townCode: 571903,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.941391,
    long: 15.628949,
  },
  {
    town: 'Nadějkov',
    townCode: 549631,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39852,
    lat: 49.502815,
    long: 14.479339,
  },
  {
    town: 'Nadějov',
    townCode: 587575,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.422331,
    long: 15.773162,
  },
  {
    town: 'Nadryby',
    townCode: 559253,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.820798,
    long: 13.524572,
  },
  {
    town: 'Nahořany',
    townCode: 574261,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54907,
    lat: 50.351812,
    long: 16.082511,
  },
  {
    town: 'Nahošovice',
    townCode: 552810,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.437824,
    long: 17.57822,
  },
  {
    town: 'Náchod',
    townCode: 573868,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54701,
    lat: 50.414672,
    long: 16.165735,
  },
  {
    town: 'Náklo',
    townCode: 504441,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78332,
    lat: 49.654721,
    long: 17.129794,
  },
  {
    town: 'Nákří',
    townCode: 535371,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37348,
    lat: 49.118968,
    long: 14.329443,
  },
  {
    town: 'Naloučany',
    townCode: 550779,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.233146,
    long: 16.135313,
  },
  {
    town: 'Nalžovice',
    townCode: 540790,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26293,
    lat: 49.69869,
    long: 14.370852,
  },
  {
    town: 'Nalžovské Hory',
    townCode: 556751,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.331486,
    long: 13.546557,
  },
  {
    town: 'Náměšť na Hané',
    townCode: 504505,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78344,
    lat: 49.602226,
    long: 17.065499,
  },
  {
    town: 'Náměšť nad Oslavou',
    townCode: 591211,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.205556,
    long: 16.155845,
  },
  {
    town: 'Napajedla',
    townCode: 585513,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76361,
    lat: 49.171658,
    long: 17.512053,
  },
  {
    town: 'Nárameč',
    townCode: 591220,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.264513,
    long: 15.974825,
  },
  {
    town: 'Narysov',
    townCode: 564478,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.640955,
    long: 13.970987,
  },
  {
    town: 'Nasavrky',
    townCode: 559016,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.452054,
    long: 14.640664,
  },
  {
    town: 'Nasavrky',
    townCode: 571911,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53825,
    lat: 49.844597,
    long: 15.804712,
  },
  {
    town: 'Nasavrky',
    townCode: 580678,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.025583,
    long: 16.259185,
  },
  {
    town: 'Násedlovice',
    townCode: 586421,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69636,
    lat: 49.012277,
    long: 16.960303,
  },
  {
    town: 'Našiměřice',
    townCode: 594512,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67176,
    lat: 48.968632,
    long: 16.372859,
  },
  {
    town: 'Návojná',
    townCode: 585521,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76332,
    lat: 49.108405,
    long: 18.053057,
  },
  {
    town: 'Návsí',
    townCode: 554014,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73992,
    lat: 49.5873,
    long: 18.759182,
  },
  {
    town: 'Nebahovy',
    townCode: 550434,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38401,
    lat: 49.005858,
    long: 14.052436,
  },
  {
    town: 'Nebanice',
    townCode: 554693,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.115352,
    long: 12.472085,
  },
  {
    town: 'Nebílovy',
    townCode: 540340,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.630199,
    long: 13.429246,
  },
  {
    town: 'Nebovidy',
    townCode: 583456,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66448,
    lat: 49.141432,
    long: 16.551476,
  },
  {
    town: 'Nebovidy',
    townCode: 533521,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.991627,
    long: 15.219584,
  },
  {
    town: 'Nebřehovice',
    townCode: 536644,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.238537,
    long: 13.962118,
  },
  {
    town: 'Nebužely',
    townCode: 535061,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27734,
    lat: 50.390406,
    long: 14.5909,
  },
  {
    town: 'Nečín',
    townCode: 540811,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26213,
    lat: 49.698546,
    long: 14.23414,
  },
  {
    town: 'Nečtiny',
    townCode: 559261,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33162,
    lat: 49.974944,
    long: 13.164739,
  },
  {
    town: 'Nedabyle',
    townCode: 544825,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37006,
    lat: 48.928509,
    long: 14.515037,
  },
  {
    town: 'Nedachlebice',
    townCode: 592404,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.099385,
    long: 17.589225,
  },
  {
    town: 'Nedakonice',
    townCode: 592412,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68738,
    lat: 49.031694,
    long: 17.38152,
  },
  {
    town: 'Nedašov',
    townCode: 585530,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76332,
    lat: 49.107884,
    long: 18.070468,
  },
  {
    town: 'Nedašova Lhota',
    townCode: 585548,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76332,
    lat: 49.121404,
    long: 18.079714,
  },
  {
    town: 'Neděliště',
    townCode: 570443,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50312,
    lat: 50.27676,
    long: 15.78561,
  },
  {
    town: 'Nedomice',
    townCode: 531863,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.259765,
    long: 14.616064,
  },
  {
    town: 'Nedrahovice',
    townCode: 540820,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.609069,
    long: 14.455837,
  },
  {
    town: 'Nedvědice',
    townCode: 596175,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59262,
    lat: 49.457116,
    long: 16.334163,
  },
  {
    town: 'Nedvězí',
    townCode: 578452,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56992,
    lat: 49.630695,
    long: 16.301003,
  },
  {
    town: 'Nehodiv',
    townCode: 578223,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.410858,
    long: 13.556463,
  },
  {
    town: 'Nehvizdy',
    townCode: 538540,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25081,
    lat: 50.130663,
    long: 14.730041,
  },
  {
    town: 'Nechanice',
    townCode: 570451,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.237468,
    long: 15.632865,
  },
  {
    town: 'Nechvalice',
    townCode: 540846,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.576649,
    long: 14.396667,
  },
  {
    town: 'Nechvalín',
    townCode: 586439,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69631,
    lat: 49.054642,
    long: 17.080689,
  },
  {
    town: 'Nejdek',
    townCode: 555380,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36221,
    lat: 50.322529,
    long: 12.729474,
  },
  {
    town: 'Nejepín',
    townCode: 548197,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.744607,
    long: 15.600679,
  },
  {
    town: 'Nekmíř',
    townCode: 559270,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33152,
    lat: 49.858193,
    long: 13.263246,
  },
  {
    town: 'Nekoř',
    townCode: 580686,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56163,
    lat: 50.055817,
    long: 16.551297,
  },
  {
    town: 'Nekvasovy',
    townCode: 558095,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33547,
    lat: 49.434661,
    long: 13.62585,
  },
  {
    town: 'Nelahozeves',
    townCode: 535079,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27751,
    lat: 50.261583,
    long: 14.298919,
  },
  {
    town: 'Nelepeč-Žernůvka',
    townCode: 583464,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.334089,
    long: 16.386382,
  },
  {
    town: 'Nelešovice',
    townCode: 515787,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75103,
    lat: 49.510794,
    long: 17.388256,
  },
  {
    town: 'Nemanice',
    townCode: 554006,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.436663,
    long: 12.720642,
  },
  {
    town: 'Němčany',
    townCode: 593371,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.164452,
    long: 16.919514,
  },
  {
    town: 'Němčice',
    townCode: 550396,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.031903,
    long: 14.271361,
  },
  {
    town: 'Němčice',
    townCode: 536474,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.192799,
    long: 13.800188,
  },
  {
    town: 'Němčice',
    townCode: 582085,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67951,
    lat: 49.450065,
    long: 16.718057,
  },
  {
    town: 'Němčice',
    townCode: 572870,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53352,
    lat: 50.093029,
    long: 15.805868,
  },
  {
    town: 'Němčice',
    townCode: 580694,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56118,
    lat: 49.890679,
    long: 16.343315,
  },
  {
    town: 'Němčice',
    townCode: 599166,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.425183,
    long: 13.077609,
  },
  {
    town: 'Němčice',
    townCode: 571636,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.084482,
    long: 15.294147,
  },
  {
    town: 'Němčice',
    townCode: 536334,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29442,
    lat: 50.346866,
    long: 14.926664,
  },
  {
    town: 'Němčice',
    townCode: 588784,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76843,
    lat: 49.364766,
    long: 17.497843,
  },
  {
    town: 'Němčice nad Hanou',
    townCode: 589756,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79827,
    lat: 49.341914,
    long: 17.206072,
  },
  {
    town: 'Němčičky',
    townCode: 583472,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66466,
    lat: 49.050477,
    long: 16.5007,
  },
  {
    town: 'Němčičky',
    townCode: 584703,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69107,
    lat: 48.93569,
    long: 16.824364,
  },
  {
    town: 'Němčičky',
    townCode: 594521,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.942345,
    long: 16.088509,
  },
  {
    town: 'Němčovice',
    townCode: 566837,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.877038,
    long: 13.574993,
  },
  {
    town: 'Němětice',
    townCode: 536725,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.194724,
    long: 13.879078,
  },
  {
    town: 'Nemile',
    townCode: 553476,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.874866,
    long: 16.847553,
  },
  {
    town: 'Nemochovice',
    townCode: 593389,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.18054,
    long: 17.135056,
  },
  {
    town: 'Nemojany',
    townCode: 593397,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68303,
    lat: 49.246812,
    long: 16.913617,
  },
  {
    town: 'Nemojov',
    townCode: 579564,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54461,
    lat: 50.467018,
    long: 15.753975,
  },
  {
    town: 'Nemotice',
    townCode: 593401,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.129699,
    long: 17.124981,
  },
  {
    town: 'Nemyčeves',
    townCode: 573230,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.384534,
    long: 15.370126,
  },
  {
    town: 'Nemyslovice',
    townCode: 571156,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29429,
    lat: 50.358549,
    long: 14.76393,
  },
  {
    town: 'Nemyšl',
    townCode: 552747,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.513482,
    long: 14.693011,
  },
  {
    town: 'Nenačovice',
    townCode: 533602,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 50.019222,
    long: 14.139071,
  },
  {
    town: 'Nenkovice',
    townCode: 586447,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69637,
    lat: 49.003151,
    long: 17.01104,
  },
  {
    town: 'Neplachov',
    townCode: 535435,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37365,
    lat: 49.130401,
    long: 14.601091,
  },
  {
    town: 'Neplachovice',
    townCode: 553158,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74774,
    lat: 49.992379,
    long: 17.809969,
  },
  {
    town: 'Nepolisy',
    townCode: 570478,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50363,
    lat: 50.192306,
    long: 15.463452,
  },
  {
    town: 'Nepoměřice',
    townCode: 534226,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28511,
    lat: 49.880863,
    long: 15.148908,
  },
  {
    town: 'Nepomuk',
    townCode: 558109,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.48627,
    long: 13.582361,
  },
  {
    town: 'Nepomuk',
    townCode: 564524,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.642895,
    long: 13.837368,
  },
  {
    town: 'Nepomyšl',
    townCode: 566501,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43971,
    lat: 50.218181,
    long: 13.313325,
  },
  {
    town: 'Neprobylice',
    townCode: 571521,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27375,
    lat: 50.264054,
    long: 14.027719,
  },
  {
    town: 'Nepřevázka',
    townCode: 536351,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.378415,
    long: 14.916429,
  },
  {
    town: 'Neratov',
    townCode: 573078,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.079868,
    long: 15.647275,
  },
  {
    town: 'Neratovice',
    townCode: 535087,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27711,
    lat: 50.259361,
    long: 14.517703,
  },
  {
    town: 'Nerestce',
    townCode: 562157,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.50082,
    long: 14.063758,
  },
  {
    town: 'Neslovice',
    townCode: 583481,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.142313,
    long: 16.387883,
  },
  {
    town: 'Nesovice',
    townCode: 593419,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.151205,
    long: 17.081054,
  },
  {
    town: 'Nespeky',
    townCode: 530263,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25722,
    lat: 49.859411,
    long: 14.659464,
  },
  {
    town: 'Nestrašovice',
    townCode: 564222,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.560455,
    long: 14.026157,
  },
  {
    town: 'Nesuchyně',
    townCode: 542130,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27007,
    lat: 50.179666,
    long: 13.688009,
  },
  {
    town: 'Nesvačilka',
    townCode: 583499,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66454,
    lat: 49.064124,
    long: 16.754104,
  },
  {
    town: 'Nesvačily',
    townCode: 534269,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26727,
    lat: 49.881363,
    long: 14.124461,
  },
  {
    town: 'Netín',
    townCode: 596183,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.413112,
    long: 15.950806,
  },
  {
    town: 'Netolice',
    townCode: 550442,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.049406,
    long: 14.197098,
  },
  {
    town: 'Netřebice',
    townCode: 545643,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.790887,
    long: 14.455665,
  },
  {
    town: 'Netřebice',
    townCode: 534919,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.213205,
    long: 15.142899,
  },
  {
    town: 'Netunice',
    townCode: 558117,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.616473,
    long: 13.430689,
  },
  {
    town: 'Netvořice',
    townCode: 530298,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25744,
    lat: 49.815795,
    long: 14.518381,
  },
  {
    town: 'Neubuz',
    townCode: 585556,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 49.260516,
    long: 17.825454,
  },
  {
    town: 'Neuměř',
    townCode: 554022,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.597691,
    long: 13.064248,
  },
  {
    town: 'Neuměřice',
    townCode: 532665,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27326,
    lat: 50.241781,
    long: 14.220097,
  },
  {
    town: 'Neumětely',
    townCode: 531588,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.852562,
    long: 14.036716,
  },
  {
    town: 'Neurazy',
    townCode: 558125,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33555,
    lat: 49.441098,
    long: 13.515683,
  },
  {
    town: 'Neustupov',
    townCode: 530301,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25786,
    lat: 49.615106,
    long: 14.698704,
  },
  {
    town: 'Nevcehle',
    townCode: 587583,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58862,
    lat: 49.225836,
    long: 15.534527,
  },
  {
    town: 'Neveklov',
    townCode: 530310,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25756,
    lat: 49.753835,
    long: 14.533011,
  },
  {
    town: 'Neveklovice',
    townCode: 571997,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29413,
    lat: 50.570239,
    long: 14.948481,
  },
  {
    town: 'Nevězice',
    townCode: 549657,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.477833,
    long: 14.153463,
  },
  {
    town: 'Nevid',
    townCode: 541192,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.685555,
    long: 13.605743,
  },
  {
    town: 'Nevojice',
    townCode: 593427,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.135416,
    long: 17.049752,
  },
  {
    town: 'Nevolice',
    townCode: 554031,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.420508,
    long: 12.933341,
  },
  {
    town: 'Nevratice',
    townCode: 549207,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.347043,
    long: 15.493052,
  },
  {
    town: 'Nevřeň',
    townCode: 559288,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.822935,
    long: 13.274982,
  },
  {
    town: 'Nezabudice',
    townCode: 598585,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.013274,
    long: 13.822228,
  },
  {
    town: 'Nezabylice',
    townCode: 546160,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.424293,
    long: 13.478643,
  },
  {
    town: 'Nezamyslice',
    townCode: 589764,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79826,
    lat: 49.325526,
    long: 17.173366,
  },
  {
    town: 'Nezamyslice',
    townCode: 578533,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.262507,
    long: 13.675029,
  },
  {
    town: 'Nezbavětice',
    townCode: 553590,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.655024,
    long: 13.477167,
  },
  {
    town: 'Nezdenice',
    townCode: 592421,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68732,
    lat: 49.016782,
    long: 17.752313,
  },
  {
    town: 'Nezdice',
    townCode: 542296,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.531654,
    long: 13.316677,
  },
  {
    town: 'Nezdice na Šumavě',
    townCode: 556815,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.172674,
    long: 13.612383,
  },
  {
    town: 'Nezdřev',
    townCode: 540102,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33544,
    lat: 49.426677,
    long: 13.728163,
  },
  {
    town: 'Nezvěstice',
    townCode: 558141,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.640535,
    long: 13.519727,
  },
  {
    town: 'Nicov',
    townCode: 529893,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38473,
    lat: 49.125538,
    long: 13.620561,
  },
  {
    town: 'Nihošovice',
    townCode: 551520,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.188367,
    long: 13.861812,
  },
  {
    town: 'Níhov',
    townCode: 596191,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.341792,
    long: 16.257645,
  },
  {
    town: 'Nikolčice',
    townCode: 584711,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69171,
    lat: 48.993283,
    long: 16.754291,
  },
  {
    town: 'Niměřice',
    townCode: 571121,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29430,
    lat: 50.39588,
    long: 14.808547,
  },
  {
    town: 'Nimpšov',
    townCode: 591238,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67541,
    lat: 49.022725,
    long: 15.747338,
  },
  {
    town: 'Nišovice',
    townCode: 536962,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.15533,
    long: 13.897452,
  },
  {
    town: 'Nítkovice',
    townCode: 588806,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76813,
    lat: 49.203726,
    long: 17.166004,
  },
  {
    town: 'Niva',
    townCode: 589772,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79861,
    lat: 49.445315,
    long: 16.851911,
  },
  {
    town: 'Nivnice',
    townCode: 592439,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68751,
    lat: 48.974744,
    long: 17.647683,
  },
  {
    town: 'Nižbor',
    townCode: 531596,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26705,
    lat: 49.999065,
    long: 14.001056,
  },
  {
    town: 'Nížkov',
    townCode: 596205,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.532665,
    long: 15.805946,
  },
  {
    town: 'Nížkovice',
    townCode: 593435,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.109637,
    long: 16.901793,
  },
  {
    town: 'Nižní Lhoty',
    townCode: 552526,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.648584,
    long: 18.433859,
  },
  {
    town: 'Norberčany',
    townCode: 597686,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79305,
    lat: 49.754048,
    long: 17.506344,
  },
  {
    town: 'Nosálov',
    townCode: 531707,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27735,
    lat: 50.473589,
    long: 14.670766,
  },
  {
    town: 'Nosislav',
    townCode: 584720,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69164,
    lat: 49.013902,
    long: 16.654416,
  },
  {
    town: 'Nošovice',
    townCode: 552518,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.660825,
    long: 18.426436,
  },
  {
    town: 'Nová Buková',
    townCode: 561177,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.346075,
    long: 15.297103,
  },
  {
    town: 'Nová Bystřice',
    townCode: 546798,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37833,
    lat: 49.019361,
    long: 15.103258,
  },
  {
    town: 'Nová Cerekev',
    townCode: 548456,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39415,
    lat: 49.417337,
    long: 15.116849,
  },
  {
    town: 'Nová Dědina',
    townCode: 588814,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.210212,
    long: 17.453821,
  },
  {
    town: 'Nová Hradečná',
    townCode: 552381,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78383,
    lat: 49.834478,
    long: 17.077461,
  },
  {
    town: 'Nová Lhota',
    townCode: 586455,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69674,
    lat: 48.861047,
    long: 17.593418,
  },
  {
    town: 'Nová Olešná',
    townCode: 562734,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.175714,
    long: 15.161053,
  },
  {
    town: 'Nová Paka',
    townCode: 573248,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50901,
    lat: 50.494593,
    long: 15.515138,
  },
  {
    town: 'Nová Pec',
    townCode: 550451,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38462,
    lat: 48.778263,
    long: 13.930124,
  },
  {
    town: 'Nová Pláň',
    townCode: 546950,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.922008,
    long: 17.475201,
  },
  {
    town: 'Nová Role',
    townCode: 555398,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36225,
    lat: 50.271028,
    long: 12.784334,
  },
  {
    town: 'Nová Říše',
    townCode: 587591,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58865,
    lat: 49.13951,
    long: 15.563696,
  },
  {
    town: 'Nová Sídla',
    townCode: 572608,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.884023,
    long: 16.237288,
  },
  {
    town: 'Nová Telib',
    townCode: 536377,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29406,
    lat: 50.39127,
    long: 15.032963,
  },
  {
    town: 'Nová Včelnice',
    townCode: 546801,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.239453,
    long: 15.072705,
  },
  {
    town: 'Nová Ves',
    townCode: 535648,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37315,
    lat: 48.920709,
    long: 14.52874,
  },
  {
    town: 'Nová Ves',
    townCode: 513661,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38203,
    lat: 48.948418,
    long: 14.24726,
  },
  {
    town: 'Nová Ves',
    townCode: 560201,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.187495,
    long: 13.733768,
  },
  {
    town: 'Nová Ves',
    townCode: 583502,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66491,
    lat: 49.108212,
    long: 16.310943,
  },
  {
    town: 'Nová Ves',
    townCode: 560561,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36464,
    lat: 50.084201,
    long: 12.775287,
  },
  {
    town: 'Nová Ves',
    townCode: 591246,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.248618,
    long: 15.803952,
  },
  {
    town: 'Nová Ves',
    townCode: 596213,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.391108,
    long: 16.196383,
  },
  {
    town: 'Nová Ves',
    townCode: 576549,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51721,
    lat: 50.13079,
    long: 16.050209,
  },
  {
    town: 'Nová Ves',
    townCode: 546593,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46331,
    lat: 50.831607,
    long: 15.001175,
  },
  {
    town: 'Nová Ves',
    townCode: 599131,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.366549,
    long: 13.038868,
  },
  {
    town: 'Nová Ves',
    townCode: 540269,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33441,
    lat: 49.686066,
    long: 13.292789,
  },
  {
    town: 'Nová Ves',
    townCode: 535117,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27752,
    lat: 50.312898,
    long: 14.308286,
  },
  {
    town: 'Nová Ves',
    townCode: 538558,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.219324,
    long: 14.535739,
  },
  {
    town: 'Nová Ves',
    townCode: 542636,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.285958,
    long: 13.842789,
  },
  {
    town: 'Nová Ves I',
    townCode: 533530,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.052246,
    long: 15.144556,
  },
  {
    town: 'Nová Ves nad Lužnicí',
    townCode: 562360,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37809,
    lat: 48.810739,
    long: 14.925675,
  },
  {
    town: 'Nová Ves nad Nisou',
    townCode: 563731,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46827,
    lat: 50.72524,
    long: 15.214758,
  },
  {
    town: 'Nová Ves nad Popelkou',
    townCode: 577341,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51271,
    lat: 50.52041,
    long: 15.411952,
  },
  {
    town: 'Nová Ves pod Pleší',
    townCode: 540889,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26204,
    lat: 49.831865,
    long: 14.275336,
  },
  {
    town: 'Nová Ves u Bakova',
    townCode: 571806,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29401,
    lat: 50.490776,
    long: 14.926496,
  },
  {
    town: 'Nová Ves u Chotěboře',
    townCode: 569160,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58273,
    lat: 49.756205,
    long: 15.648091,
  },
  {
    town: 'Nová Ves u Chýnova',
    townCode: 552763,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39155,
    lat: 49.392801,
    long: 14.783071,
  },
  {
    town: 'Nová Ves u Jarošova',
    townCode: 572438,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.837637,
    long: 16.160009,
  },
  {
    town: 'Nová Ves u Leštiny',
    townCode: 569151,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.785954,
    long: 15.404017,
  },
  {
    town: 'Nová Ves u Mladé Vožice',
    townCode: 563455,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.543134,
    long: 14.748066,
  },
  {
    town: 'Nová Ves u Nového Města na Moravě',
    townCode: 596221,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59231,
    lat: 49.540029,
    long: 16.084205,
  },
  {
    town: 'Nová Ves u Světlé',
    townCode: 555266,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.648874,
    long: 15.437793,
  },
  {
    town: 'Nová Ves v Horách',
    townCode: 567329,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43545,
    lat: 50.594847,
    long: 13.482558,
  },
  {
    town: 'Nové Bránice',
    townCode: 583511,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.071249,
    long: 16.441855,
  },
  {
    town: 'Nové Dvory',
    townCode: 587974,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.564483,
    long: 15.808971,
  },
  {
    town: 'Nové Dvory',
    townCode: 534242,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28531,
    lat: 49.970682,
    long: 15.324978,
  },
  {
    town: 'Nové Dvory',
    townCode: 540897,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26203,
    lat: 49.803328,
    long: 14.357021,
  },
  {
    town: 'Nové Dvory',
    townCode: 565342,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.447702,
    long: 14.179516,
  },
  {
    town: 'Nové Hamry',
    townCode: 506494,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36221,
    lat: 50.360145,
    long: 12.719531,
  },
  {
    town: 'Nové Heřminovy',
    townCode: 569551,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 50.023575,
    long: 17.5283,
  },
  {
    town: 'Nové Hrady',
    townCode: 544868,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37333,
    lat: 48.789733,
    long: 14.778483,
  },
  {
    town: 'Nové Hrady',
    townCode: 571920,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53945,
    lat: 49.851778,
    long: 16.143909,
  },
  {
    town: 'Nové Hutě',
    townCode: 561568,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38501,
    lat: 49.038803,
    long: 13.645759,
  },
  {
    town: 'Nové Lublice',
    townCode: 512893,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74901,
    lat: 49.862875,
    long: 17.678131,
  },
  {
    town: 'Nové Město',
    townCode: 570494,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.147769,
    long: 15.495214,
  },
  {
    town: 'Nové Město na Moravě',
    townCode: 596230,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59231,
    lat: 49.561543,
    long: 16.074288,
  },
  {
    town: 'Nové Město nad Metují',
    townCode: 574279,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.344662,
    long: 16.151571,
  },
  {
    town: 'Nové Město pod Smrkem',
    townCode: 564265,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46365,
    lat: 50.925011,
    long: 15.229539,
  },
  {
    town: 'Nové Mitrovice',
    townCode: 558176,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33563,
    lat: 49.579685,
    long: 13.683735,
  },
  {
    town: 'Nové Sady',
    townCode: 593443,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68308,
    lat: 49.408906,
    long: 16.902045,
  },
  {
    town: 'Nové Sady',
    townCode: 596248,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59501,
    lat: 49.293788,
    long: 16.193421,
  },
  {
    town: 'Nové Sedlice',
    townCode: 555274,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74706,
    lat: 49.902222,
    long: 18.001326,
  },
  {
    town: 'Nové Sedlo',
    townCode: 560570,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35734,
    lat: 50.206578,
    long: 12.738121,
  },
  {
    town: 'Nové Sedlo',
    townCode: 566519,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.339745,
    long: 13.474941,
  },
  {
    town: 'Nové Strašecí',
    townCode: 542164,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27101,
    lat: 50.152823,
    long: 13.900538,
  },
  {
    town: 'Nové Syrovice',
    townCode: 591254,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67541,
    lat: 49.01773,
    long: 15.773555,
  },
  {
    town: 'Nové Veselí',
    townCode: 596256,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.519866,
    long: 15.90863,
  },
  {
    town: 'Noviny pod Ralskem',
    townCode: 561851,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47124,
    lat: 50.692151,
    long: 14.746964,
  },
  {
    town: 'Novosedlice',
    townCode: 567752,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41731,
    lat: 50.656439,
    long: 13.823154,
  },
  {
    town: 'Novosedly',
    townCode: 551554,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.26277,
    long: 13.797628,
  },
  {
    town: 'Novosedly',
    townCode: 584746,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69182,
    lat: 48.83714,
    long: 16.492837,
  },
  {
    town: 'Novosedly nad Nežárkou',
    townCode: 546844,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37817,
    lat: 49.081103,
    long: 14.82226,
  },
  {
    town: 'Nový Bor',
    townCode: 561860,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47301,
    lat: 50.757714,
    long: 14.555664,
  },
  {
    town: 'Nový Bydžov',
    townCode: 570508,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.241602,
    long: 15.490926,
  },
  {
    town: 'Nový Dům',
    townCode: 542181,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26901,
    lat: 50.08824,
    long: 13.831001,
  },
  {
    town: 'Nový Dvůr',
    townCode: 599654,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28932,
    lat: 50.238112,
    long: 15.022165,
  },
  {
    town: 'Nový Hrádek',
    townCode: 574287,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54922,
    lat: 50.357375,
    long: 16.244478,
  },
  {
    town: 'Nový Hrozenkov',
    townCode: 544566,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75604,
    lat: 49.337068,
    long: 18.198046,
  },
  {
    town: 'Nový Jáchymov',
    townCode: 531600,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26703,
    lat: 49.980867,
    long: 13.943296,
  },
  {
    town: 'Nový Jičín',
    townCode: 599191,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74101,
    lat: 49.594425,
    long: 18.013636,
  },
  {
    town: 'Nový Jimramov',
    townCode: 596264,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59242,
    lat: 49.634722,
    long: 16.187315,
  },
  {
    town: 'Nový Knín',
    townCode: 540901,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26203,
    lat: 49.788108,
    long: 14.293661,
  },
  {
    town: 'Nový Kostel',
    townCode: 554707,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35134,
    lat: 50.217131,
    long: 12.445362,
  },
  {
    town: 'Nový Kramolín',
    townCode: 554057,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.477383,
    long: 12.805087,
  },
  {
    town: 'Nový Malín',
    townCode: 540501,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78803,
    lat: 49.942722,
    long: 17.03201,
  },
  {
    town: 'Nový Oldřichov',
    townCode: 561878,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47113,
    lat: 50.765514,
    long: 14.442254,
  },
  {
    town: 'Nový Ples',
    townCode: 574295,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.321268,
    long: 15.94929,
  },
  {
    town: 'Nový Poddvorov',
    townCode: 586463,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69616,
    lat: 48.868447,
    long: 16.961126,
  },
  {
    town: 'Nový Přerov',
    townCode: 584754,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69181,
    lat: 48.809718,
    long: 16.493828,
  },
  {
    town: 'Nový Rychnov',
    townCode: 548464,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39404,
    lat: 49.383617,
    long: 15.36629,
  },
  {
    town: 'Nový Šaldorf-Sedlešovice',
    townCode: 587729,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67181,
    lat: 48.830248,
    long: 16.060675,
  },
  {
    town: 'Nový Telečkov',
    townCode: 591262,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.32127,
    long: 15.938454,
  },
  {
    town: 'Nový Vestec',
    townCode: 538566,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25075,
    lat: 50.183861,
    long: 14.720401,
  },
  {
    town: 'Nučice',
    townCode: 533548,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.955626,
    long: 14.8845,
  },
  {
    town: 'Nučice',
    townCode: 531618,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25216,
    lat: 50.018581,
    long: 14.230078,
  },
  {
    town: 'Nupaky',
    townCode: 564907,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.994052,
    long: 14.602336,
  },
  {
    town: 'Nýdek',
    townCode: 507091,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73995,
    lat: 49.656185,
    long: 18.756984,
  },
  {
    town: 'Nyklovice',
    townCode: 596272,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.603976,
    long: 16.345044,
  },
  {
    town: 'Nymburk',
    townCode: 537004,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.185682,
    long: 15.04376,
  },
  {
    town: 'Nýrov',
    townCode: 582107,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67972,
    lat: 49.528083,
    long: 16.539265,
  },
  {
    town: 'Nýrsko',
    townCode: 556831,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34022,
    lat: 49.293979,
    long: 13.143639,
  },
  {
    town: 'Nýřany',
    townCode: 559300,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.712816,
    long: 13.204705,
  },
  {
    town: 'Občov',
    townCode: 513571,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.713206,
    long: 14.066994,
  },
  {
    town: 'Obecnice',
    townCode: 540935,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26221,
    lat: 49.716261,
    long: 13.947414,
  },
  {
    town: 'Obědkovice',
    townCode: 589799,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79823,
    lat: 49.394852,
    long: 17.227643,
  },
  {
    town: 'Obědovice',
    townCode: 548065,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.161163,
    long: 15.582212,
  },
  {
    town: 'Obora',
    townCode: 582115,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67901,
    lat: 49.452311,
    long: 16.605726,
  },
  {
    town: 'Obora',
    townCode: 559318,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.889575,
    long: 13.413718,
  },
  {
    town: 'Obora',
    townCode: 541443,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.814715,
    long: 12.5378,
  },
  {
    town: 'Obora',
    townCode: 542580,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.373356,
    long: 13.863081,
  },
  {
    town: 'Oborná',
    townCode: 569577,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 50.003161,
    long: 17.497004,
  },
  {
    town: 'Obory',
    townCode: 540943,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.680504,
    long: 14.216474,
  },
  {
    town: 'Obořiště',
    townCode: 540951,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26212,
    lat: 49.742352,
    long: 14.151959,
  },
  {
    town: 'Obrataň',
    townCode: 548472,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39412,
    lat: 49.425159,
    long: 14.943589,
  },
  {
    town: 'Obrnice',
    townCode: 567337,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43521,
    lat: 50.505083,
    long: 13.695511,
  },
  {
    town: 'Obrubce',
    townCode: 570893,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.447959,
    long: 15.06372,
  },
  {
    town: 'Obruby',
    townCode: 536407,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29403,
    lat: 50.460227,
    long: 15.082414,
  },
  {
    town: 'Obříství',
    townCode: 535133,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27742,
    lat: 50.295983,
    long: 14.478492,
  },
  {
    town: 'Obyčtov',
    townCode: 596281,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.499959,
    long: 16.001685,
  },
  {
    town: 'Obytce',
    townCode: 541915,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.390514,
    long: 13.378436,
  },
  {
    town: 'Ocmanice',
    townCode: 510980,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.233244,
    long: 16.125399,
  },
  {
    town: 'Očelice',
    townCode: 576557,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.239986,
    long: 16.067392,
  },
  {
    town: 'Očihov',
    townCode: 566527,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43987,
    lat: 50.19866,
    long: 13.460534,
  },
  {
    town: 'Odolena Voda',
    townCode: 538574,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25070,
    lat: 50.233515,
    long: 14.410889,
  },
  {
    town: 'Odrava',
    townCode: 539554,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.103171,
    long: 12.48425,
  },
  {
    town: 'Odrovice',
    townCode: 583529,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.010907,
    long: 16.509119,
  },
  {
    town: 'Odry',
    townCode: 599701,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74235,
    lat: 49.662648,
    long: 17.83095,
  },
  {
    town: 'Odřepsy',
    townCode: 537551,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28907,
    lat: 50.14424,
    long: 15.188842,
  },
  {
    town: 'Odunec',
    townCode: 591289,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.120315,
    long: 16.014372,
  },
  {
    town: 'Ohaře',
    townCode: 533556,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28130,
    lat: 50.097882,
    long: 15.29512,
  },
  {
    town: 'Ohařice',
    townCode: 549185,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.454396,
    long: 15.258528,
  },
  {
    town: 'Ohaveč',
    townCode: 548910,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.4497,
    long: 15.30877,
  },
  {
    town: 'Ohníč',
    townCode: 567761,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41765,
    lat: 50.587135,
    long: 13.844786,
  },
  {
    town: 'Ohnišov',
    townCode: 576565,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51784,
    lat: 50.322692,
    long: 16.213912,
  },
  {
    town: 'Ohnišťany',
    townCode: 570516,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50354,
    lat: 50.32963,
    long: 15.511087,
  },
  {
    town: 'Ohrazenice',
    townCode: 577359,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.597745,
    long: 15.126071,
  },
  {
    town: 'Ohrazenice',
    townCode: 540960,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26223,
    lat: 49.78714,
    long: 13.959817,
  },
  {
    town: 'Ohrobec',
    townCode: 539503,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25245,
    lat: 49.941829,
    long: 14.432139,
  },
  {
    town: 'Ohrozim',
    townCode: 589802,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79803,
    lat: 49.48656,
    long: 17.02073,
  },
  {
    town: 'Ochoz',
    townCode: 589811,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79852,
    lat: 49.600231,
    long: 16.915109,
  },
  {
    town: 'Ochoz u Brna',
    townCode: 583537,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66402,
    lat: 49.254302,
    long: 16.737338,
  },
  {
    town: 'Ochoz u Tišnova',
    townCode: 582123,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.425693,
    long: 16.394338,
  },
  {
    town: 'Okarec',
    townCode: 591297,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67502,
    lat: 49.206057,
    long: 16.088033,
  },
  {
    town: 'Okna',
    townCode: 561886,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47162,
    lat: 50.527594,
    long: 14.671066,
  },
  {
    town: 'Okoř',
    townCode: 571334,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25264,
    lat: 50.162011,
    long: 14.258724,
  },
  {
    town: 'Okounov',
    townCode: 563269,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43151,
    lat: 50.362327,
    long: 13.106679,
  },
  {
    town: 'Okrouhlá',
    townCode: 529877,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.413732,
    long: 14.364412,
  },
  {
    town: 'Okrouhlá',
    townCode: 582131,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.507604,
    long: 16.732103,
  },
  {
    town: 'Okrouhlá',
    townCode: 538922,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.062566,
    long: 12.487772,
  },
  {
    town: 'Okrouhlá',
    townCode: 561894,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47301,
    lat: 50.766932,
    long: 14.527685,
  },
  {
    town: 'Okrouhlá Radouň',
    townCode: 562475,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.239826,
    long: 15.017172,
  },
  {
    town: 'Okrouhlice',
    townCode: 569186,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58231,
    lat: 49.630014,
    long: 15.490933,
  },
  {
    town: 'Okrouhlička',
    townCode: 548588,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58253,
    lat: 49.534541,
    long: 15.556975,
  },
  {
    town: 'Okrouhlo',
    townCode: 539511,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25401,
    lat: 49.918924,
    long: 14.447417,
  },
  {
    town: 'Okřesaneč',
    townCode: 534251,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.852528,
    long: 15.475842,
  },
  {
    town: 'Okřešice',
    townCode: 546933,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67401,
    lat: 49.25948,
    long: 15.852076,
  },
  {
    town: 'Okřínek',
    townCode: 537560,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.164391,
    long: 15.192429,
  },
  {
    town: 'Okříšky',
    townCode: 591301,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.245493,
    long: 15.769689,
  },
  {
    town: 'Olbramice',
    townCode: 554049,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74283,
    lat: 49.78965,
    long: 18.089056,
  },
  {
    town: 'Olbramice',
    townCode: 552259,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78322,
    lat: 49.613591,
    long: 17.001576,
  },
  {
    town: 'Olbramkostel',
    townCode: 594555,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67151,
    lat: 48.921815,
    long: 15.949704,
  },
  {
    town: 'Olbramov',
    townCode: 566888,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.843499,
    long: 12.866878,
  },
  {
    town: 'Olbramovice',
    townCode: 594563,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67176,
    lat: 48.984904,
    long: 16.402498,
  },
  {
    town: 'Olbramovice',
    townCode: 530344,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25901,
    lat: 49.67328,
    long: 14.640953,
  },
  {
    town: 'Oldřichov',
    townCode: 552798,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.558828,
    long: 14.754364,
  },
  {
    town: 'Oldřichov',
    townCode: 515825,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75111,
    lat: 49.49756,
    long: 17.539328,
  },
  {
    town: 'Oldřichov v Hájích',
    townCode: 564281,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46331,
    lat: 50.849733,
    long: 15.083777,
  },
  {
    town: 'Oldřichovice',
    townCode: 549444,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76361,
    lat: 49.181867,
    long: 17.561448,
  },
  {
    town: 'Oldřiš',
    townCode: 578479,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56982,
    lat: 49.727227,
    long: 16.19381,
  },
  {
    town: 'Oldřišov',
    townCode: 509574,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74733,
    lat: 49.991395,
    long: 17.960845,
  },
  {
    town: 'Oleksovice',
    townCode: 594571,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67162,
    lat: 48.902158,
    long: 16.248504,
  },
  {
    town: 'Olešenka',
    townCode: 569208,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.549005,
    long: 15.765938,
  },
  {
    town: 'Oleška',
    townCode: 533564,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28162,
    lat: 49.971695,
    long: 14.916786,
  },
  {
    town: 'Oleško',
    townCode: 542440,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.480652,
    long: 14.196615,
  },
  {
    town: 'Olešná',
    townCode: 562190,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.346255,
    long: 14.310591,
  },
  {
    town: 'Olešná',
    townCode: 569216,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.68167,
    long: 15.547785,
  },
  {
    town: 'Olešná',
    townCode: 561967,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.445848,
    long: 15.263754,
  },
  {
    town: 'Olešná',
    townCode: 531626,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26764,
    lat: 49.780462,
    long: 13.810119,
  },
  {
    town: 'Olešná',
    townCode: 542199,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26901,
    lat: 50.128597,
    long: 13.695961,
  },
  {
    town: 'Olešnice',
    townCode: 544884,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37331,
    lat: 48.84133,
    long: 14.704931,
  },
  {
    town: 'Olešnice',
    townCode: 582158,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.557654,
    long: 16.421795,
  },
  {
    town: 'Olešnice',
    townCode: 570524,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.142363,
    long: 15.445092,
  },
  {
    town: 'Olešnice',
    townCode: 576581,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51736,
    lat: 50.14431,
    long: 16.148606,
  },
  {
    town: 'Olešnice',
    townCode: 577367,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.545045,
    long: 15.119305,
  },
  {
    town: 'Olešnice v Orlických horách',
    townCode: 576573,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51783,
    lat: 50.37326,
    long: 16.30998,
  },
  {
    town: 'Olešník',
    townCode: 544892,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37350,
    lat: 49.107235,
    long: 14.363919,
  },
  {
    town: 'Olomouc',
    townCode: 500496,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.593878,
    long: 17.250979,
  },
  {
    town: 'Olomučany',
    townCode: 582166,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67903,
    lat: 49.33097,
    long: 16.671791,
  },
  {
    town: 'Oloví',
    townCode: 560588,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35707,
    lat: 50.251243,
    long: 12.558884,
  },
  {
    town: 'Olovnice',
    townCode: 532673,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27326,
    lat: 50.234699,
    long: 14.240487,
  },
  {
    town: 'Olšany',
    townCode: 550132,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.248136,
    long: 16.86616,
  },
  {
    town: 'Olšany',
    townCode: 587613,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.186221,
    long: 15.566091,
  },
  {
    town: 'Olšany',
    townCode: 540510,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78962,
    lat: 49.965186,
    long: 16.859046,
  },
  {
    town: 'Olšany',
    townCode: 541958,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.400933,
    long: 13.627031,
  },
  {
    town: 'Olšany u Prostějova',
    townCode: 589829,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79814,
    lat: 49.53655,
    long: 17.16467,
  },
  {
    town: 'Olší',
    townCode: 596302,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59261,
    lat: 49.421365,
    long: 16.290327,
  },
  {
    town: 'Olší',
    townCode: 587214,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.155548,
    long: 15.373333,
  },
  {
    town: 'Olšovec',
    townCode: 552844,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.590212,
    long: 17.717277,
  },
  {
    town: 'Olšovice',
    townCode: 537365,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38411,
    lat: 49.056923,
    long: 14.235971,
  },
  {
    town: 'Omice',
    townCode: 583545,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66441,
    lat: 49.170033,
    long: 16.451834,
  },
  {
    town: 'Omlenice',
    townCode: 545660,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38241,
    lat: 48.725918,
    long: 14.443732,
  },
  {
    town: 'Ondratice',
    townCode: 589837,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79807,
    lat: 49.363049,
    long: 17.063785,
  },
  {
    town: 'Ondřejov',
    townCode: 537691,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.393042,
    long: 15.178062,
  },
  {
    town: 'Ondřejov',
    townCode: 538582,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25165,
    lat: 49.904717,
    long: 14.78431,
  },
  {
    town: 'Onomyšl',
    townCode: 534277,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.89933,
    long: 15.12436,
  },
  {
    town: 'Onšov',
    townCode: 594580,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.905385,
    long: 15.834328,
  },
  {
    town: 'Onšov',
    townCode: 548502,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.578327,
    long: 15.136477,
  },
  {
    town: 'Opařany',
    townCode: 552801,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39161,
    lat: 49.396884,
    long: 14.481477,
  },
  {
    town: 'Opatov',
    townCode: 587621,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58805,
    lat: 49.431128,
    long: 15.394379,
  },
  {
    town: 'Opatov',
    townCode: 591319,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67528,
    lat: 49.224435,
    long: 15.661768,
  },
  {
    town: 'Opatov',
    townCode: 578487,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56912,
    lat: 49.825097,
    long: 16.504684,
  },
  {
    town: 'Opatovec',
    townCode: 572721,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.805398,
    long: 16.480232,
  },
  {
    town: 'Opatovice',
    townCode: 583553,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66461,
    lat: 49.075131,
    long: 16.641079,
  },
  {
    town: 'Opatovice',
    townCode: 516201,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75356,
    lat: 49.49929,
    long: 17.739289,
  },
  {
    town: 'Opatovice I',
    townCode: 530956,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.85525,
    long: 15.248583,
  },
  {
    town: 'Opatovice nad Labem',
    townCode: 575429,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.145512,
    long: 15.790553,
  },
  {
    town: 'Opava',
    townCode: 505927,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74601,
    lat: 49.94076,
    long: 17.894899,
  },
  {
    town: 'Oplany',
    townCode: 571679,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.924267,
    long: 14.867406,
  },
  {
    town: 'Oplocany',
    townCode: 553000,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75101,
    lat: 49.409663,
    long: 17.260311,
  },
  {
    town: 'Oplot',
    townCode: 539783,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.579961,
    long: 13.274335,
  },
  {
    town: 'Opočnice',
    townCode: 537578,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28904,
    lat: 50.172581,
    long: 15.257777,
  },
  {
    town: 'Opočno',
    townCode: 576590,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51773,
    lat: 50.267515,
    long: 16.114902,
  },
  {
    town: 'Opočno',
    townCode: 542555,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.311585,
    long: 13.735342,
  },
  {
    town: 'Opolany',
    townCode: 537586,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28907,
    lat: 50.130814,
    long: 15.217103,
  },
  {
    town: 'Oponešice',
    townCode: 591327,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 49.037839,
    long: 15.652148,
  },
  {
    town: 'Oprostovice',
    townCode: 516350,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.469951,
    long: 17.620402,
  },
  {
    town: 'Oráčov',
    townCode: 542202,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27032,
    lat: 50.111647,
    long: 13.549003,
  },
  {
    town: 'Orel',
    townCode: 571962,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53821,
    lat: 49.919409,
    long: 15.839135,
  },
  {
    town: 'Orlické Podhůří',
    townCode: 580716,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 50.00342,
    long: 16.35071,
  },
  {
    town: 'Orlické Záhoří',
    townCode: 576603,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51764,
    lat: 50.278761,
    long: 16.475033,
  },
  {
    town: 'Orličky',
    townCode: 580724,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56155,
    lat: 50.031626,
    long: 16.681575,
  },
  {
    town: 'Orlík nad Vltavou',
    townCode: 549681,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39807,
    lat: 49.509979,
    long: 14.165613,
  },
  {
    town: 'Orlová',
    townCode: 599069,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73511,
    lat: 49.870238,
    long: 18.425108,
  },
  {
    town: 'Orlovice',
    townCode: 593460,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.239184,
    long: 17.093701,
  },
  {
    town: 'Ořech',
    townCode: 539520,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25225,
    lat: 50.020209,
    long: 14.296653,
  },
  {
    town: 'Ořechov',
    townCode: 583561,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66444,
    lat: 49.11128,
    long: 16.523392,
  },
  {
    town: 'Ořechov',
    townCode: 587630,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58862,
    lat: 49.200027,
    long: 15.532067,
  },
  {
    town: 'Ořechov',
    townCode: 596329,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59452,
    lat: 49.350482,
    long: 16.139044,
  },
  {
    town: 'Ořechov',
    townCode: 592447,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68737,
    lat: 49.030686,
    long: 17.300934,
  },
  {
    town: 'Osečany',
    townCode: 598470,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.697825,
    long: 14.437729,
  },
  {
    town: 'Oseček',
    townCode: 599662,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28941,
    lat: 50.10165,
    long: 15.148691,
  },
  {
    town: 'Osečná',
    townCode: 564290,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46352,
    lat: 50.69499,
    long: 14.921485,
  },
  {
    town: 'Osečnice',
    townCode: 576611,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51703,
    lat: 50.257266,
    long: 16.307,
  },
  {
    town: 'Osek',
    townCode: 598828,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.443367,
    long: 14.299945,
  },
  {
    town: 'Osek',
    townCode: 551562,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.318408,
    long: 13.963291,
  },
  {
    town: 'Osek',
    townCode: 573264,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50743,
    lat: 50.463947,
    long: 15.159618,
  },
  {
    town: 'Osek',
    townCode: 560057,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33821,
    lat: 49.778115,
    long: 13.59104,
  },
  {
    town: 'Osek',
    townCode: 531634,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26762,
    lat: 49.819743,
    long: 13.858627,
  },
  {
    town: 'Osek',
    townCode: 567779,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41705,
    lat: 50.622637,
    long: 13.691488,
  },
  {
    town: 'Osek nad Bečvou',
    townCode: 516619,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75122,
    lat: 49.511313,
    long: 17.528401,
  },
  {
    town: 'Oselce',
    townCode: 558184,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33546,
    lat: 49.437309,
    long: 13.672931,
  },
  {
    town: 'Osice',
    townCode: 570532,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50326,
    lat: 50.142888,
    long: 15.686098,
  },
  {
    town: 'Osíčko',
    townCode: 588822,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.431087,
    long: 17.751607,
  },
  {
    town: 'Osičky',
    townCode: 570541,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.143649,
    long: 15.676288,
  },
  {
    town: 'Osík',
    townCode: 578509,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56967,
    lat: 49.843645,
    long: 16.28477,
  },
  {
    town: 'Osiky',
    townCode: 582174,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.456294,
    long: 16.421688,
  },
  {
    town: 'Oskava',
    townCode: 540544,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78801,
    lat: 49.895329,
    long: 17.132249,
  },
  {
    town: 'Oskořínek',
    townCode: 537616,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28932,
    lat: 50.240157,
    long: 15.084104,
  },
  {
    town: 'Oslavany',
    townCode: 583588,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66412,
    lat: 49.123447,
    long: 16.336633,
  },
  {
    town: 'Oslavice',
    townCode: 596337,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.340872,
    long: 15.990807,
  },
  {
    town: 'Oslavička',
    townCode: 511412,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.315507,
    long: 15.966948,
  },
  {
    town: 'Oslnovice',
    townCode: 594598,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.932188,
    long: 15.6875,
  },
  {
    town: 'Oslov',
    townCode: 549703,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39835,
    lat: 49.399365,
    long: 14.212059,
  },
  {
    town: 'Osoblaha',
    townCode: 597716,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.275267,
    long: 17.715337,
  },
  {
    town: 'Osov',
    townCode: 531642,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26725,
    lat: 49.844478,
    long: 14.08402,
  },
  {
    town: 'Osová Bítýška',
    townCode: 596345,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59453,
    lat: 49.325143,
    long: 16.168556,
  },
  {
    town: 'Osové',
    townCode: 596353,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.325323,
    long: 16.015528,
  },
  {
    town: 'Ostašov',
    townCode: 591335,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.155648,
    long: 15.918092,
  },
  {
    town: 'Ostopovice',
    townCode: 583596,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66449,
    lat: 49.161102,
    long: 16.54559,
  },
  {
    town: 'Ostrá',
    townCode: 537624,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28922,
    lat: 50.180537,
    long: 14.893003,
  },
  {
    town: 'Ostrata',
    townCode: 557170,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76311,
    lat: 49.271025,
    long: 17.76694,
  },
  {
    town: 'Ostrava',
    townCode: 554821,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 70200,
    lat: 49.821023,
    long: 18.262624,
  },
  {
    town: 'Ostravice',
    townCode: 598542,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73914,
    lat: 49.535196,
    long: 18.391751,
  },
  {
    town: 'Ostrolovský Újezd',
    townCode: 535231,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.880718,
    long: 14.600707,
  },
  {
    town: 'Ostroměř',
    townCode: 573272,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50752,
    lat: 50.372556,
    long: 15.549593,
  },
  {
    town: 'Ostrov',
    townCode: 555428,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36301,
    lat: 50.306035,
    long: 12.939183,
  },
  {
    town: 'Ostrov',
    townCode: 548359,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.693104,
    long: 15.301494,
  },
  {
    town: 'Ostrov',
    townCode: 574104,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53863,
    lat: 49.972703,
    long: 16.030432,
  },
  {
    town: 'Ostrov',
    townCode: 580732,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56122,
    lat: 49.930345,
    long: 16.540637,
  },
  {
    town: 'Ostrov',
    townCode: 599395,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25706,
    lat: 49.665402,
    long: 14.851197,
  },
  {
    town: 'Ostrov',
    townCode: 598372,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.611219,
    long: 14.014609,
  },
  {
    town: 'Ostrov nad Oslavou',
    townCode: 596361,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59445,
    lat: 49.486919,
    long: 15.990033,
  },
  {
    town: 'Ostrov u Bezdružic',
    townCode: 559326,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33038,
    lat: 49.900238,
    long: 13.042079,
  },
  {
    town: 'Ostrov u Macochy',
    townCode: 582182,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67914,
    lat: 49.382462,
    long: 16.762786,
  },
  {
    town: 'Ostrovačice',
    townCode: 583600,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66481,
    lat: 49.210924,
    long: 16.409562,
  },
  {
    town: 'Ostrovánky',
    townCode: 586471,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69631,
    lat: 49.042793,
    long: 17.080434,
  },
  {
    town: 'Ostrovec',
    townCode: 549711,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39833,
    lat: 49.421243,
    long: 14.115581,
  },
  {
    town: 'Ostrovec-Lhotka',
    townCode: 566993,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.907578,
    long: 13.728204,
  },
  {
    town: 'Ostrožská Lhota',
    townCode: 592455,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68723,
    lat: 48.975689,
    long: 17.467622,
  },
  {
    town: 'Ostrožská Nová Ves',
    townCode: 592463,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68722,
    lat: 49.004438,
    long: 17.436427,
  },
  {
    town: 'Ostružná',
    townCode: 569330,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78825,
    lat: 50.185253,
    long: 17.051691,
  },
  {
    town: 'Ostružno',
    townCode: 573281,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.443397,
    long: 15.289734,
  },
  {
    town: 'Ostředek',
    townCode: 530352,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25724,
    lat: 49.834893,
    long: 14.8324,
  },
  {
    town: 'Ostřešany',
    townCode: 575437,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.993525,
    long: 15.805408,
  },
  {
    town: 'Ostřetice',
    townCode: 578061,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.422439,
    long: 13.347004,
  },
  {
    town: 'Ostřetín',
    townCode: 575445,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.044716,
    long: 16.030478,
  },
  {
    town: 'Osvětimany',
    townCode: 592471,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68742,
    lat: 49.055871,
    long: 17.249789,
  },
  {
    town: 'Osvračín',
    townCode: 554073,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.513274,
    long: 13.047035,
  },
  {
    town: 'Ošelín',
    townCode: 541681,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.772115,
    long: 12.856261,
  },
  {
    town: 'Otaslavice',
    townCode: 589845,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79806,
    lat: 49.388426,
    long: 17.071186,
  },
  {
    town: 'Otěšice',
    townCode: 540293,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.544137,
    long: 13.220352,
  },
  {
    town: 'Otice',
    townCode: 509612,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74781,
    lat: 49.916939,
    long: 17.869927,
  },
  {
    town: 'Otín',
    townCode: 587648,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58833,
    lat: 49.2666,
    long: 15.569796,
  },
  {
    town: 'Otín',
    townCode: 596370,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.362965,
    long: 15.906706,
  },
  {
    town: 'Otinoves',
    townCode: 589853,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79861,
    lat: 49.421275,
    long: 16.871783,
  },
  {
    town: 'Otmarov',
    townCode: 506699,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66457,
    lat: 49.100613,
    long: 16.672783,
  },
  {
    town: 'Otmíče',
    townCode: 534111,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.869145,
    long: 13.947252,
  },
  {
    town: 'Otnice',
    townCode: 593478,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68354,
    lat: 49.086517,
    long: 16.814533,
  },
  {
    town: 'Otov',
    townCode: 566209,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.486597,
    long: 12.842602,
  },
  {
    town: 'Otovice',
    townCode: 537969,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.25545,
    long: 12.871721,
  },
  {
    town: 'Otovice',
    townCode: 574317,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54972,
    lat: 50.557245,
    long: 16.387685,
  },
  {
    town: 'Otradov',
    townCode: 554952,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53943,
    lat: 49.793442,
    long: 16.043608,
  },
  {
    town: 'Otročín',
    townCode: 555444,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36401,
    lat: 50.032393,
    long: 12.892407,
  },
  {
    town: 'Otročiněves',
    townCode: 531669,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26703,
    lat: 49.980598,
    long: 13.978869,
  },
  {
    town: 'Otrokovice',
    townCode: 585599,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76502,
    lat: 49.210016,
    long: 17.530876,
  },
  {
    town: 'Otvice',
    townCode: 563277,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43111,
    lat: 50.480923,
    long: 13.45081,
  },
  {
    town: 'Otvovice',
    townCode: 532681,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27327,
    lat: 50.211664,
    long: 14.27303,
  },
  {
    town: 'Ouběnice',
    townCode: 541010,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.717747,
    long: 14.159939,
  },
  {
    town: 'Oucmanice',
    townCode: 580741,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 49.989464,
    long: 16.281865,
  },
  {
    town: 'Oudoleň',
    townCode: 569224,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58224,
    lat: 49.659429,
    long: 15.755752,
  },
  {
    town: 'Ovčáry',
    townCode: 533572,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.062882,
    long: 15.239607,
  },
  {
    town: 'Ovčáry',
    townCode: 535141,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27714,
    lat: 50.253151,
    long: 14.613962,
  },
  {
    town: 'Ovesná Lhota',
    townCode: 569232,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.722657,
    long: 15.38416,
  },
  {
    town: 'Ovesné Kladruby',
    townCode: 539473,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.953112,
    long: 12.779206,
  },
  {
    town: 'Oznice',
    townCode: 544574,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75624,
    lat: 49.432567,
    long: 17.917399,
  },
  {
    town: 'Paběnice',
    townCode: 531278,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28543,
    lat: 49.84174,
    long: 15.302429,
  },
  {
    town: 'Paceřice',
    townCode: 545953,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46344,
    lat: 50.619335,
    long: 15.113636,
  },
  {
    town: 'Pacetluky',
    townCode: 588831,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76843,
    lat: 49.379562,
    long: 17.56585,
  },
  {
    town: 'Pacov',
    townCode: 548511,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.470865,
    long: 15.001783,
  },
  {
    town: 'Pačejov',
    townCode: 556912,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.373007,
    long: 13.632835,
  },
  {
    town: 'Pačlavice',
    townCode: 588849,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76834,
    lat: 49.25977,
    long: 17.169012,
  },
  {
    town: 'Páleč',
    townCode: 564192,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27371,
    lat: 50.312029,
    long: 14.049685,
  },
  {
    town: 'Palkovice',
    townCode: 598551,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73941,
    lat: 49.63477,
    long: 18.315185,
  },
  {
    town: 'Palonín',
    townCode: 540595,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78983,
    lat: 49.729051,
    long: 16.952733,
  },
  {
    town: 'Pálovice',
    townCode: 550469,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 49.00562,
    long: 15.537655,
  },
  {
    town: 'Pamětice',
    townCode: 582191,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.549563,
    long: 16.644594,
  },
  {
    town: 'Panenská Rozsíčka',
    townCode: 587656,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58901,
    lat: 49.252661,
    long: 15.515001,
  },
  {
    town: 'Panenské Břežany',
    townCode: 538604,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25070,
    lat: 50.213867,
    long: 14.44021,
  },
  {
    town: 'Panenský Týnec',
    townCode: 566535,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43905,
    lat: 50.295028,
    long: 13.917056,
  },
  {
    town: 'Panoší Újezd',
    townCode: 542211,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27021,
    lat: 50.036103,
    long: 13.716918,
  },
  {
    town: 'Panské Dubenky',
    townCode: 587672,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 37853,
    lat: 49.219628,
    long: 15.265918,
  },
  {
    town: 'Paračov',
    townCode: 551571,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.201136,
    long: 13.994739,
  },
  {
    town: 'Pardubice',
    townCode: 555134,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.034409,
    long: 15.781299,
  },
  {
    town: 'Paršovice',
    townCode: 516635,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75355,
    lat: 49.50123,
    long: 17.708077,
  },
  {
    town: 'Partutovice',
    townCode: 516686,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.631419,
    long: 17.708201,
  },
  {
    town: 'Pařezov',
    townCode: 599182,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.470477,
    long: 12.83793,
  },
  {
    town: 'Pasečnice',
    townCode: 554081,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.395458,
    long: 12.893516,
  },
  {
    town: 'Paseka',
    townCode: 504785,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78397,
    lat: 49.796542,
    long: 17.222863,
  },
  {
    town: 'Paseky',
    townCode: 562254,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39811,
    lat: 49.25174,
    long: 14.254921,
  },
  {
    town: 'Paseky nad Jizerou',
    townCode: 547476,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51247,
    lat: 50.724065,
    long: 15.400555,
  },
  {
    town: 'Paskov',
    townCode: 598569,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73921,
    lat: 49.731885,
    long: 18.290478,
  },
  {
    town: 'Pasohlávky',
    townCode: 584762,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69122,
    lat: 48.90306,
    long: 16.543748,
  },
  {
    town: 'Pastuchovice',
    townCode: 566781,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33165,
    lat: 50.069086,
    long: 13.382322,
  },
  {
    town: 'Pastviny',
    townCode: 580759,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.094975,
    long: 16.566309,
  },
  {
    town: 'Pašinka',
    townCode: 513423,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.996452,
    long: 15.186297,
  },
  {
    town: 'Pašovice',
    townCode: 592480,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68756,
    lat: 49.07963,
    long: 17.644446,
  },
  {
    town: 'Pátek',
    townCode: 537632,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.165617,
    long: 15.158562,
  },
  {
    town: 'Patokryje',
    townCode: 567345,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.499915,
    long: 13.705297,
  },
  {
    town: 'Pavlice',
    townCode: 594601,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67156,
    lat: 48.971577,
    long: 15.899056,
  },
  {
    town: 'Pavlíkov',
    townCode: 544248,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27021,
    lat: 50.056094,
    long: 13.73647,
  },
  {
    town: 'Pavlínov',
    townCode: 596388,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.348216,
    long: 15.878564,
  },
  {
    town: 'Pavlov',
    townCode: 584771,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69201,
    lat: 48.874256,
    long: 16.672359,
  },
  {
    town: 'Pavlov',
    townCode: 569241,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.699317,
    long: 15.332621,
  },
  {
    town: 'Pavlov',
    townCode: 587681,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58833,
    lat: 49.242892,
    long: 15.55721,
  },
  {
    town: 'Pavlov',
    townCode: 561916,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.398772,
    long: 15.244081,
  },
  {
    town: 'Pavlov',
    townCode: 596396,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.450847,
    long: 15.913945,
  },
  {
    town: 'Pavlov',
    townCode: 540609,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78985,
    lat: 49.74289,
    long: 16.879352,
  },
  {
    town: 'Pavlov',
    townCode: 532711,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.096481,
    long: 14.167154,
  },
  {
    town: 'Pavlovice',
    townCode: 533076,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.715216,
    long: 14.933216,
  },
  {
    town: 'Pavlovice u Kojetína',
    townCode: 557196,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79830,
    lat: 49.302054,
    long: 17.212617,
  },
  {
    town: 'Pavlovice u Přerova',
    townCode: 516694,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75111,
    lat: 49.46952,
    long: 17.547853,
  },
  {
    town: 'Pazderna',
    townCode: 552500,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.704374,
    long: 18.434339,
  },
  {
    town: 'Pec',
    townCode: 554090,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.398684,
    long: 12.831288,
  },
  {
    town: 'Pec pod Sněžkou',
    townCode: 579581,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54221,
    lat: 50.693981,
    long: 15.733267,
  },
  {
    town: 'Pecka',
    townCode: 573299,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50782,
    lat: 50.480435,
    long: 15.608329,
  },
  {
    town: 'Peč',
    townCode: 507717,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.057931,
    long: 15.392475,
  },
  {
    town: 'Pečice',
    townCode: 541028,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26232,
    lat: 49.600518,
    long: 14.105591,
  },
  {
    town: 'Pěčice',
    townCode: 571032,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29446,
    lat: 50.35125,
    long: 15.004099,
  },
  {
    town: 'Pěčín',
    townCode: 576620,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51757,
    lat: 50.153878,
    long: 16.424789,
  },
  {
    town: 'Pečky',
    townCode: 537641,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28911,
    lat: 50.090527,
    long: 15.030275,
  },
  {
    town: 'Pěčnov',
    townCode: 537543,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.053207,
    long: 13.942131,
  },
  {
    town: 'Pelechy',
    townCode: 566373,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.389227,
    long: 12.914379,
  },
  {
    town: 'Pelhřimov',
    townCode: 547492,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.430721,
    long: 15.223083,
  },
  {
    town: 'Pěnčín',
    townCode: 563749,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46821,
    lat: 50.687791,
    long: 15.236038,
  },
  {
    town: 'Pěnčín',
    townCode: 564303,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46345,
    lat: 50.594968,
    long: 15.076196,
  },
  {
    town: 'Pěnčín',
    townCode: 589870,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79857,
    lat: 49.567294,
    long: 17.013234,
  },
  {
    town: 'Perálec',
    townCode: 572004,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53944,
    lat: 49.826885,
    long: 16.079952,
  },
  {
    town: 'Perná',
    townCode: 584789,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69186,
    lat: 48.85232,
    long: 16.624527,
  },
  {
    town: 'Pernarec',
    townCode: 559334,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33036,
    lat: 49.840507,
    long: 13.102822,
  },
  {
    town: 'Pernink',
    townCode: 555452,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36236,
    lat: 50.365797,
    long: 12.783825,
  },
  {
    town: 'Pernštejnské Jestřabí',
    townCode: 596400,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59261,
    lat: 49.406417,
    long: 16.32571,
  },
  {
    town: 'Perštejn',
    townCode: 563285,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43163,
    lat: 50.381769,
    long: 13.110315,
  },
  {
    town: 'Pertoltice',
    townCode: 564311,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46373,
    lat: 50.979084,
    long: 15.076532,
  },
  {
    town: 'Pertoltice',
    townCode: 534307,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.75491,
    long: 15.181716,
  },
  {
    town: 'Pertoltice pod Ralskem',
    townCode: 514276,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47124,
    lat: 50.680046,
    long: 14.719254,
  },
  {
    town: 'Peruc',
    townCode: 566551,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43907,
    lat: 50.342609,
    long: 13.959969,
  },
  {
    town: 'Peřimov',
    townCode: 577391,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51204,
    lat: 50.619384,
    long: 15.44404,
  },
  {
    town: 'Pesvice',
    townCode: 546062,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43111,
    lat: 50.463315,
    long: 13.484983,
  },
  {
    town: 'Pětihosty',
    townCode: 529656,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25167,
    lat: 49.886462,
    long: 14.705522,
  },
  {
    town: 'Pětikozly',
    townCode: 598241,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29430,
    lat: 50.411512,
    long: 14.811952,
  },
  {
    town: 'Pětipsy',
    townCode: 563293,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43153,
    lat: 50.321219,
    long: 13.349824,
  },
  {
    town: 'Petkovy',
    townCode: 536431,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.413286,
    long: 15.076925,
  },
  {
    town: 'Petráveč',
    townCode: 596418,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.327579,
    long: 16.041249,
  },
  {
    town: 'Petrohrad',
    townCode: 566560,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43985,
    lat: 50.127625,
    long: 13.446526,
  },
  {
    town: 'Petroupim',
    townCode: 530409,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.808356,
    long: 14.752698,
  },
  {
    town: 'Petrov',
    townCode: 582204,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.533771,
    long: 16.489694,
  },
  {
    town: 'Petrov',
    townCode: 586480,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69665,
    lat: 48.882055,
    long: 17.278203,
  },
  {
    town: 'Petrov',
    townCode: 539546,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25281,
    lat: 49.886498,
    long: 14.433839,
  },
  {
    town: 'Petrov nad Desnou',
    townCode: 500020,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78816,
    lat: 50.005536,
    long: 17.04438,
  },
  {
    town: 'Petrovice',
    townCode: 582212,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67902,
    lat: 49.411964,
    long: 16.69985,
  },
  {
    town: 'Petrovice',
    townCode: 594610,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.006837,
    long: 16.292563,
  },
  {
    town: 'Petrovice',
    townCode: 591360,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.241283,
    long: 15.78769,
  },
  {
    town: 'Petrovice',
    townCode: 570567,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50355,
    lat: 50.289854,
    long: 15.598601,
  },
  {
    town: 'Petrovice',
    townCode: 551848,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79384,
    lat: 50.239024,
    long: 17.448488,
  },
  {
    town: 'Petrovice',
    townCode: 580767,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.988215,
    long: 16.541627,
  },
  {
    town: 'Petrovice',
    townCode: 541044,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26255,
    lat: 49.554366,
    long: 14.337472,
  },
  {
    town: 'Petrovice',
    townCode: 542229,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.067363,
    long: 13.63928,
  },
  {
    town: 'Petrovice',
    townCode: 568147,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40337,
    lat: 50.789131,
    long: 13.976255,
  },
  {
    town: 'Petrovice I',
    townCode: 534315,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.811063,
    long: 15.297295,
  },
  {
    town: 'Petrovice II',
    townCode: 534323,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.81004,
    long: 15.063514,
  },
  {
    town: 'Petrovice u Karviné',
    townCode: 599077,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73572,
    lat: 49.895965,
    long: 18.547898,
  },
  {
    town: 'Petrovice u Sušice',
    townCode: 556921,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.218758,
    long: 13.440898,
  },
  {
    town: 'Petrovičky',
    townCode: 548871,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.299084,
    long: 15.607452,
  },
  {
    town: 'Petrůvka',
    townCode: 556874,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.105005,
    long: 17.810083,
  },
  {
    town: 'Petrůvky',
    townCode: 591378,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.159311,
    long: 15.902416,
  },
  {
    town: 'Petříkov',
    townCode: 535699,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.847072,
    long: 14.754708,
  },
  {
    town: 'Petříkov',
    townCode: 538612,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25169,
    lat: 49.925301,
    long: 14.617066,
  },
  {
    town: 'Petřvald',
    townCode: 599085,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73541,
    lat: 49.831096,
    long: 18.389513,
  },
  {
    town: 'Petřvald',
    townCode: 599743,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74260,
    lat: 49.707197,
    long: 18.15153,
  },
  {
    town: 'Pchery',
    townCode: 532720,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27308,
    lat: 50.193882,
    long: 14.117927,
  },
  {
    town: 'Pičín',
    townCode: 541052,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26225,
    lat: 49.745546,
    long: 14.057909,
  },
  {
    town: 'Pikárec',
    townCode: 549916,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59253,
    lat: 49.432505,
    long: 16.122491,
  },
  {
    town: 'Pila',
    townCode: 556947,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.179793,
    long: 12.925973,
  },
  {
    town: 'Pilníkov',
    townCode: 579599,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54242,
    lat: 50.532571,
    long: 15.820303,
  },
  {
    town: 'Písařov',
    townCode: 540650,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78991,
    lat: 50.005065,
    long: 16.801608,
  },
  {
    town: 'Písečná',
    townCode: 557226,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73991,
    lat: 49.57477,
    long: 18.787469,
  },
  {
    town: 'Písečná',
    townCode: 540684,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79082,
    lat: 50.273123,
    long: 17.253835,
  },
  {
    town: 'Písečná',
    townCode: 580775,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56170,
    lat: 50.045242,
    long: 16.448156,
  },
  {
    town: 'Písečné',
    townCode: 546917,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37872,
    lat: 48.965043,
    long: 15.462488,
  },
  {
    town: 'Písečné',
    townCode: 596434,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.568007,
    long: 16.23676,
  },
  {
    town: 'Písek',
    townCode: 549240,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.303554,
    long: 14.158129,
  },
  {
    town: 'Písek',
    townCode: 570575,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.15553,
    long: 15.501834,
  },
  {
    town: 'Písek',
    townCode: 512028,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73984,
    lat: 49.55934,
    long: 18.80242,
  },
  {
    town: 'Písková Lhota',
    townCode: 536440,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29431,
    lat: 50.367841,
    long: 14.874736,
  },
  {
    town: 'Písková Lhota',
    townCode: 537659,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.131421,
    long: 15.065865,
  },
  {
    town: 'Pístina',
    townCode: 561070,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37802,
    lat: 49.049781,
    long: 14.901411,
  },
  {
    town: 'Písty',
    townCode: 537667,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28913,
    lat: 50.164646,
    long: 15.001364,
  },
  {
    town: 'Píšť',
    townCode: 548545,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.601839,
    long: 15.203524,
  },
  {
    town: 'Píšť',
    townCode: 509647,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74718,
    lat: 49.978666,
    long: 18.193601,
  },
  {
    town: 'Píšťany',
    townCode: 542539,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41101,
    lat: 50.519327,
    long: 14.069206,
  },
  {
    town: 'Pištín',
    townCode: 535991,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37346,
    lat: 49.045975,
    long: 14.335259,
  },
  {
    town: 'Pitín',
    townCode: 592498,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68771,
    lat: 49.038403,
    long: 17.850785,
  },
  {
    town: 'Pivín',
    townCode: 589888,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79824,
    lat: 49.384785,
    long: 17.184933,
  },
  {
    town: 'Pivkovice',
    townCode: 598887,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.177594,
    long: 14.069728,
  },
  {
    town: 'Planá',
    townCode: 535176,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.943775,
    long: 14.452868,
  },
  {
    town: 'Planá',
    townCode: 561134,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34815,
    lat: 49.868267,
    long: 12.743897,
  },
  {
    town: 'Planá nad Lužnicí',
    townCode: 552828,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39111,
    lat: 49.354541,
    long: 14.701577,
  },
  {
    town: 'Plaňany',
    townCode: 533581,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28104,
    lat: 50.050204,
    long: 15.029546,
  },
  {
    town: 'Plandry',
    townCode: 587702,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58841,
    lat: 49.42009,
    long: 15.53837,
  },
  {
    town: 'Pláně',
    townCode: 530336,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33101,
    lat: 49.9338,
    long: 13.389711,
  },
  {
    town: 'Plánice',
    townCode: 556955,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34034,
    lat: 49.390036,
    long: 13.471166,
  },
  {
    town: 'Plasy',
    townCode: 559351,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33101,
    lat: 49.934598,
    long: 13.390465,
  },
  {
    town: 'Plav',
    townCode: 535346,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37007,
    lat: 48.901535,
    long: 14.487974,
  },
  {
    town: 'Plaveč',
    townCode: 594628,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67132,
    lat: 48.928863,
    long: 16.080106,
  },
  {
    town: 'Plavsko',
    townCode: 509078,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37802,
    lat: 49.084695,
    long: 14.904124,
  },
  {
    town: 'Plavy',
    townCode: 563757,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46846,
    lat: 50.703338,
    long: 15.317471,
  },
  {
    town: 'Plazy',
    townCode: 536458,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.414136,
    long: 14.975134,
  },
  {
    town: 'Plenkovice',
    townCode: 550051,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67151,
    lat: 48.919012,
    long: 16.002555,
  },
  {
    town: 'Plesná',
    townCode: 554740,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35135,
    lat: 50.220815,
    long: 12.34681,
  },
  {
    town: 'Pleše',
    townCode: 507628,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.195629,
    long: 14.821465,
  },
  {
    town: 'Plešnice',
    townCode: 559369,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33033,
    lat: 49.774084,
    long: 13.17685,
  },
  {
    town: 'Pletený Újezd',
    townCode: 532738,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.109433,
    long: 14.116178,
  },
  {
    town: 'Plch',
    townCode: 572942,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.12887,
    long: 15.70284,
  },
  {
    town: 'Plchov',
    townCode: 564125,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27375,
    lat: 50.255276,
    long: 13.986724,
  },
  {
    town: 'Plchovice',
    townCode: 580783,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.045181,
    long: 16.181298,
  },
  {
    town: 'Plískov',
    townCode: 566861,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.842744,
    long: 13.739921,
  },
  {
    town: 'Ploskovice',
    townCode: 565393,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41142,
    lat: 50.56034,
    long: 14.198588,
  },
  {
    town: 'Pluhův Žďár',
    townCode: 546968,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.223995,
    long: 14.892803,
  },
  {
    town: 'Plumlov',
    townCode: 589896,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79803,
    lat: 49.466236,
    long: 17.015122,
  },
  {
    town: 'Plužná',
    townCode: 565580,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29423,
    lat: 50.473807,
    long: 14.804269,
  },
  {
    town: 'PLZEŇ',
    townCode: 554791,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 30100,
    lat: 49.738531,
    long: 13.373737,
  },
  {
    town: 'Pnětluky',
    townCode: 566578,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.250358,
    long: 13.703895,
  },
  {
    town: 'Pňovany',
    townCode: 559377,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33033,
    lat: 49.778992,
    long: 13.121864,
  },
  {
    town: 'Pňovice',
    townCode: 552160,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78401,
    lat: 49.721386,
    long: 17.161923,
  },
  {
    town: 'Pňov-Předhradí',
    townCode: 537675,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28941,
    lat: 50.086521,
    long: 15.147597,
  },
  {
    town: 'Poběžovice',
    townCode: 554111,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.510406,
    long: 12.802721,
  },
  {
    town: 'Poběžovice u Holic',
    townCode: 575461,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.097655,
    long: 16.000768,
  },
  {
    town: 'Poběžovice u Přelouče',
    townCode: 575470,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.991102,
    long: 15.581991,
  },
  {
    town: 'Pocinovice',
    townCode: 554120,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34509,
    lat: 49.343523,
    long: 13.133597,
  },
  {
    town: 'Počaply',
    townCode: 564214,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.538772,
    long: 13.983561,
  },
  {
    town: 'Počátky',
    townCode: 548561,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39464,
    lat: 49.260301,
    long: 15.240324,
  },
  {
    town: 'Počedělice',
    townCode: 566586,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.371926,
    long: 13.887909,
  },
  {
    town: 'Počenice-Tetětice',
    townCode: 588865,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76833,
    lat: 49.271262,
    long: 17.228235,
  },
  {
    town: 'Počepice',
    townCode: 541087,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26255,
    lat: 49.596115,
    long: 14.380945,
  },
  {
    town: 'Počítky',
    townCode: 596442,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.588779,
    long: 15.971975,
  },
  {
    town: 'Podbořanský Rohozec',
    townCode: 566608,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44101,
    lat: 50.216536,
    long: 13.262884,
  },
  {
    town: 'Podbořany',
    townCode: 566616,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44101,
    lat: 50.229475,
    long: 13.41203,
  },
  {
    town: 'Podbrdy',
    townCode: 534285,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26727,
    lat: 49.863079,
    long: 14.126698,
  },
  {
    town: 'Podbřezí',
    townCode: 576654,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51803,
    lat: 50.259989,
    long: 16.214851,
  },
  {
    town: 'Podbřežice',
    townCode: 550795,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.212563,
    long: 16.928192,
  },
  {
    town: 'Poděbrady',
    townCode: 537683,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.142525,
    long: 15.118988,
  },
  {
    town: 'Poděšín',
    townCode: 596451,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.507768,
    long: 15.800993,
  },
  {
    town: 'Poděvousy',
    townCode: 566365,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.527617,
    long: 13.131214,
  },
  {
    town: 'Podhorní Újezd a Vojice',
    townCode: 573311,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50754,
    lat: 50.390156,
    long: 15.514528,
  },
  {
    town: 'Podhořany u Ronova',
    townCode: 572039,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53841,
    lat: 49.936237,
    long: 15.536819,
  },
  {
    town: 'Podhradí',
    townCode: 538817,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35201,
    lat: 50.255461,
    long: 12.201857,
  },
  {
    town: 'Podhradí',
    townCode: 573329,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.418572,
    long: 15.310632,
  },
  {
    town: 'Podhradí',
    townCode: 534811,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76326,
    lat: 49.140048,
    long: 17.77407,
  },
  {
    town: 'Podhradí nad Dyjí',
    townCode: 594636,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67106,
    lat: 48.900345,
    long: 15.686517,
  },
  {
    town: 'Podhradní Lhota',
    townCode: 588873,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76871,
    lat: 49.420849,
    long: 17.79516,
  },
  {
    town: 'Podivice',
    townCode: 593486,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68321,
    lat: 49.365845,
    long: 17.010822,
  },
  {
    town: 'Podivín',
    townCode: 584797,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69145,
    lat: 48.82564,
    long: 16.848324,
  },
  {
    town: 'Podkopná Lhota',
    townCode: 585611,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76318,
    lat: 49.305859,
    long: 17.831511,
  },
  {
    town: 'Podlesí',
    townCode: 580805,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 50.020296,
    long: 16.281063,
  },
  {
    town: 'Podlesí',
    townCode: 564486,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.690395,
    long: 13.981947,
  },
  {
    town: 'Podlešín',
    townCode: 532754,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27325,
    lat: 50.221126,
    long: 14.160368,
  },
  {
    town: 'Podluhy',
    townCode: 531685,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26801,
    lat: 49.815724,
    long: 13.91363,
  },
  {
    town: 'Podmoklany',
    townCode: 548634,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58264,
    lat: 49.721628,
    long: 15.767847,
  },
  {
    town: 'Podmokly',
    townCode: 551686,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.230189,
    long: 13.578261,
  },
  {
    town: 'Podmokly',
    townCode: 560081,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.943339,
    long: 13.704478,
  },
  {
    town: 'Podmoky',
    townCode: 548251,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.830381,
    long: 15.439055,
  },
  {
    town: 'Podmoky',
    townCode: 599590,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28904,
    lat: 50.191564,
    long: 15.232291,
  },
  {
    town: 'Podmolí',
    townCode: 594644,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.850738,
    long: 15.940168,
  },
  {
    town: 'Podmyče',
    townCode: 594652,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67106,
    lat: 48.887701,
    long: 15.782341,
  },
  {
    town: 'Podolanka',
    townCode: 538621,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25073,
    lat: 50.159219,
    long: 14.601033,
  },
  {
    town: 'Podolí',
    townCode: 583634,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66403,
    lat: 49.190524,
    long: 16.72095,
  },
  {
    town: 'Podolí',
    townCode: 596469,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.48436,
    long: 16.080553,
  },
  {
    town: 'Podolí',
    townCode: 516864,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75116,
    lat: 49.445465,
    long: 17.530335,
  },
  {
    town: 'Podolí',
    townCode: 592501,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68604,
    lat: 49.0409,
    long: 17.529564,
  },
  {
    town: 'Podolí',
    townCode: 569496,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75644,
    lat: 49.430358,
    long: 17.857251,
  },
  {
    town: 'Podolí I',
    townCode: 549754,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.361265,
    long: 14.312023,
  },
  {
    town: 'Podomí',
    townCode: 550175,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68304,
    lat: 49.344818,
    long: 16.833319,
  },
  {
    town: 'Podsedice',
    townCode: 565415,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.472089,
    long: 13.948396,
  },
  {
    town: 'Podůlšany',
    townCode: 572951,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.128935,
    long: 15.738311,
  },
  {
    town: 'Podůlší',
    townCode: 573345,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.469069,
    long: 15.340577,
  },
  {
    town: 'Podveky',
    townCode: 528196,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.825146,
    long: 14.994103,
  },
  {
    town: 'Pohled',
    townCode: 569291,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58221,
    lat: 49.606211,
    long: 15.648156,
  },
  {
    town: 'Pohleď',
    townCode: 573591,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.603572,
    long: 15.648294,
  },
  {
    town: 'Pohledy',
    townCode: 578550,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.695006,
    long: 16.560608,
  },
  {
    town: 'Pohnánec',
    townCode: 560553,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.473682,
    long: 14.802766,
  },
  {
    town: 'Pohnání',
    townCode: 552852,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.477597,
    long: 14.811241,
  },
  {
    town: 'Pohorovice',
    townCode: 536911,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.188696,
    long: 14.135183,
  },
  {
    town: 'Pohorská Ves',
    townCode: 545694,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38283,
    lat: 48.670025,
    long: 14.647748,
  },
  {
    town: 'Pohořelice',
    townCode: 584801,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69123,
    lat: 48.981287,
    long: 16.524557,
  },
  {
    town: 'Pohořelice',
    townCode: 549461,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76361,
    lat: 49.176665,
    long: 17.537954,
  },
  {
    town: 'Pohoří',
    townCode: 576662,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.292257,
    long: 16.09906,
  },
  {
    town: 'Pohoří',
    townCode: 539562,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25401,
    lat: 49.900021,
    long: 14.525125,
  },
  {
    town: 'Pochvalov',
    townCode: 542237,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27055,
    lat: 50.227542,
    long: 13.794371,
  },
  {
    town: 'Pojbuky',
    townCode: 552861,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.495907,
    long: 14.896833,
  },
  {
    town: 'Pokojov',
    townCode: 596477,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.481732,
    long: 15.906642,
  },
  {
    town: 'Pokojovice',
    townCode: 550370,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.219742,
    long: 15.742458,
  },
  {
    town: 'Pokřikov',
    townCode: 572063,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.79687,
    long: 15.988264,
  },
  {
    town: 'Polánka',
    townCode: 553565,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.435798,
    long: 13.555643,
  },
  {
    town: 'Poleň',
    townCode: 541788,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.425079,
    long: 13.176854,
  },
  {
    town: 'Polepy',
    townCode: 533599,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.004771,
    long: 15.206086,
  },
  {
    town: 'Polepy',
    townCode: 565431,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41147,
    lat: 50.50573,
    long: 14.264579,
  },
  {
    town: 'Polerady',
    townCode: 538639,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.200671,
    long: 14.593492,
  },
  {
    town: 'Polerady',
    townCode: 567353,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.444544,
    long: 13.652795,
  },
  {
    town: 'Polesí',
    townCode: 561436,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39468,
    lat: 49.293206,
    long: 15.246599,
  },
  {
    town: 'Polešovice',
    townCode: 592510,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68737,
    lat: 49.033999,
    long: 17.340746,
  },
  {
    town: 'Polevsko',
    townCode: 561959,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47116,
    lat: 50.786771,
    long: 14.533028,
  },
  {
    town: 'Police',
    townCode: 591394,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67534,
    lat: 49.21454,
    long: 15.883581,
  },
  {
    town: 'Police',
    townCode: 540731,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78973,
    lat: 49.814846,
    long: 16.996381,
  },
  {
    town: 'Police',
    townCode: 544621,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75644,
    lat: 49.45682,
    long: 17.867653,
  },
  {
    town: 'Police nad Metují',
    townCode: 574341,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54954,
    lat: 50.536968,
    long: 16.23361,
  },
  {
    town: 'Polička',
    townCode: 578576,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.715034,
    long: 16.265977,
  },
  {
    town: 'Poličná',
    townCode: 500071,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75701,
    lat: 49.467058,
    long: 17.943924,
  },
  {
    town: 'Polkovice',
    townCode: 516899,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75144,
    lat: 49.39183,
    long: 17.259275,
  },
  {
    town: 'Polná',
    townCode: 587711,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.487099,
    long: 15.718914,
  },
  {
    town: 'Polná na Šumavě',
    townCode: 500194,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38226,
    lat: 48.805608,
    long: 14.131502,
  },
  {
    town: 'Polní Chrčice',
    townCode: 513237,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.110106,
    long: 15.296802,
  },
  {
    town: 'Polní Voděrady',
    townCode: 513148,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 49.992409,
    long: 15.095338,
  },
  {
    town: 'Polnička',
    townCode: 596485,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59102,
    lat: 49.607595,
    long: 15.916439,
  },
  {
    town: 'Polom',
    townCode: 548723,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.059088,
    long: 16.305976,
  },
  {
    town: 'Polom',
    townCode: 516911,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75364,
    lat: 49.577179,
    long: 17.841791,
  },
  {
    town: 'Polomí',
    townCode: 549983,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79855,
    lat: 49.631541,
    long: 16.949496,
  },
  {
    town: 'Polště',
    townCode: 562459,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.106486,
    long: 14.927954,
  },
  {
    town: 'Pomezí',
    townCode: 578584,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56971,
    lat: 49.710361,
    long: 16.317396,
  },
  {
    town: 'Pomezí nad Ohří',
    townCode: 538868,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.086208,
    long: 12.279652,
  },
  {
    town: 'Ponědraž',
    townCode: 562670,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.116075,
    long: 14.702066,
  },
  {
    town: 'Ponědrážka',
    townCode: 562653,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.136634,
    long: 14.703419,
  },
  {
    town: 'Ponětovice',
    townCode: 549738,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66451,
    lat: 49.152257,
    long: 16.742391,
  },
  {
    town: 'Poniklá',
    townCode: 577405,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51242,
    lat: 50.661618,
    long: 15.463395,
  },
  {
    town: 'Popelín',
    townCode: 546992,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37855,
    lat: 49.213683,
    long: 15.184019,
  },
  {
    town: 'Popice',
    townCode: 584819,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69127,
    lat: 48.927358,
    long: 16.66701,
  },
  {
    town: 'Popovice',
    townCode: 583651,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66461,
    lat: 49.107197,
    long: 16.616203,
  },
  {
    town: 'Popovice',
    townCode: 532649,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25701,
    lat: 49.695492,
    long: 14.75256,
  },
  {
    town: 'Popovice',
    townCode: 592528,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68604,
    lat: 49.052651,
    long: 17.527232,
  },
  {
    town: 'Popovičky',
    townCode: 599221,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.962644,
    long: 14.597904,
  },
  {
    town: 'Popůvky',
    townCode: 583669,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66441,
    lat: 49.177467,
    long: 16.487676,
  },
  {
    town: 'Popůvky',
    townCode: 591408,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67575,
    lat: 49.159171,
    long: 16.127493,
  },
  {
    town: 'Poříčany',
    townCode: 537705,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28914,
    lat: 50.108165,
    long: 14.918285,
  },
  {
    town: 'Poříčí nad Sázavou',
    townCode: 530441,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25721,
    lat: 49.839058,
    long: 14.674564,
  },
  {
    town: 'Poříčí u Litomyšle',
    townCode: 572373,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.798443,
    long: 16.193901,
  },
  {
    town: 'Postoloprty',
    townCode: 566624,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43942,
    lat: 50.359895,
    long: 13.70302,
  },
  {
    town: 'Postřekov',
    townCode: 554138,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34535,
    lat: 49.458386,
    long: 12.806891,
  },
  {
    town: 'Postřelmov',
    townCode: 540773,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78969,
    lat: 49.907661,
    long: 16.912368,
  },
  {
    town: 'Postřelmůvek',
    townCode: 553352,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.922722,
    long: 16.879208,
  },
  {
    town: 'Postřižín',
    townCode: 538647,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25070,
    lat: 50.233091,
    long: 14.386813,
  },
  {
    town: 'Postupice',
    townCode: 530450,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25701,
    lat: 49.728144,
    long: 14.777499,
  },
  {
    town: 'Pošná',
    townCode: 548600,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.458874,
    long: 15.042352,
  },
  {
    town: 'Poštovice',
    townCode: 564087,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27372,
    lat: 50.312793,
    long: 14.137949,
  },
  {
    town: 'Poteč',
    townCode: 549533,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76601,
    lat: 49.154482,
    long: 18.035541,
  },
  {
    town: 'Potěhy',
    townCode: 534331,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28563,
    lat: 49.86946,
    long: 15.4202,
  },
  {
    town: 'Potštát',
    townCode: 517101,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75362,
    lat: 49.637025,
    long: 17.651843,
  },
  {
    town: 'Potštejn',
    townCode: 576671,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51743,
    lat: 50.082189,
    long: 16.309021,
  },
  {
    town: 'Potůčky',
    townCode: 555479,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36235,
    lat: 50.428273,
    long: 12.736597,
  },
  {
    town: 'Potvorov',
    townCode: 530247,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 50.016105,
    long: 13.399461,
  },
  {
    town: 'Poustka',
    townCode: 577979,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.140272,
    long: 12.298291,
  },
  {
    town: 'Pouzdřany',
    townCode: 584835,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69126,
    lat: 48.934526,
    long: 16.624973,
  },
  {
    town: 'Povrly',
    townCode: 568155,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40332,
    lat: 50.672866,
    long: 14.160445,
  },
  {
    town: 'Pozďatín',
    townCode: 591416,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.235855,
    long: 16.037952,
  },
  {
    town: 'Pozděchov',
    townCode: 544655,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75611,
    lat: 49.233333,
    long: 17.955546,
  },
  {
    town: 'Pozdeň',
    townCode: 532762,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27376,
    lat: 50.242157,
    long: 13.943656,
  },
  {
    town: 'Pozlovice',
    townCode: 549401,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76326,
    lat: 49.129313,
    long: 17.769364,
  },
  {
    town: 'Pozořice',
    townCode: 583677,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66407,
    lat: 49.209864,
    long: 16.790847,
  },
  {
    town: 'Prace',
    townCode: 583685,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66458,
    lat: 49.141161,
    long: 16.765498,
  },
  {
    town: 'Pracejovice',
    townCode: 551619,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.257287,
    long: 13.849231,
  },
  {
    town: 'Prackovice nad Labem',
    townCode: 565458,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41133,
    lat: 50.569522,
    long: 14.032075,
  },
  {
    town: 'Práče',
    townCode: 594679,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.877137,
    long: 16.201279,
  },
  {
    town: 'Prádlo',
    townCode: 558231,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.503547,
    long: 13.541553,
  },
  {
    town: 'Praha',
    townCode: 554782,
    district: 'Praha',
    lau: 'CZ0100',
    region: 'Hlavní město Praha',
    nuts: 'CZ010',
    zip: 11000,
    lat: 50.075638,
    long: 14.4379,
  },
  {
    town: 'Prachatice',
    townCode: 550094,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.01101,
    long: 14.0001,
  },
  {
    town: 'Prachovice',
    townCode: 572071,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53804,
    lat: 49.893895,
    long: 15.628821,
  },
  {
    town: 'Prakšice',
    townCode: 592536,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68756,
    lat: 49.069003,
    long: 17.633144,
  },
  {
    town: 'Prameny',
    townCode: 539538,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 50.050184,
    long: 12.732909,
  },
  {
    town: 'Prasek',
    townCode: 570648,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.238775,
    long: 15.548695,
  },
  {
    town: 'Praskačka',
    townCode: 570656,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50333,
    lat: 50.17297,
    long: 15.742802,
  },
  {
    town: 'Prasklice',
    townCode: 587397,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76833,
    lat: 49.268795,
    long: 17.186821,
  },
  {
    town: 'Praskolesy',
    townCode: 531693,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26754,
    lat: 49.865986,
    long: 13.933537,
  },
  {
    town: 'Prášily',
    townCode: 556084,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.10524,
    long: 13.378047,
  },
  {
    town: 'Pravčice',
    townCode: 588890,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76824,
    lat: 49.324587,
    long: 17.495591,
  },
  {
    town: 'Pravice',
    townCode: 594687,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.843456,
    long: 16.361153,
  },
  {
    town: 'Pravlov',
    townCode: 583693,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.055779,
    long: 16.487786,
  },
  {
    town: 'Pravonín',
    townCode: 530476,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25709,
    lat: 49.635687,
    long: 14.943477,
  },
  {
    town: 'Pravy',
    townCode: 572853,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.131879,
    long: 15.624255,
  },
  {
    town: 'Pražmo',
    townCode: 568813,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73904,
    lat: 49.608863,
    long: 18.48628,
  },
  {
    town: 'Prlov',
    townCode: 544671,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75611,
    lat: 49.248001,
    long: 17.961456,
  },
  {
    town: 'Proboštov',
    townCode: 567787,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41712,
    lat: 50.667833,
    long: 13.836123,
  },
  {
    town: 'Probulov',
    townCode: 561509,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.492895,
    long: 14.145234,
  },
  {
    town: 'Prodašice',
    townCode: 570753,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.350064,
    long: 15.116768,
  },
  {
    town: 'Prokopov',
    townCode: 594695,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67154,
    lat: 48.998438,
    long: 15.896085,
  },
  {
    town: 'Proruby',
    townCode: 548758,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.070679,
    long: 16.295451,
  },
  {
    town: 'Proseč',
    townCode: 537829,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.600804,
    long: 15.329186,
  },
  {
    town: 'Proseč',
    townCode: 572080,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53944,
    lat: 49.805994,
    long: 16.11631,
  },
  {
    town: 'Proseč pod Ještědem',
    townCode: 544345,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46343,
    lat: 50.701762,
    long: 15.017139,
  },
  {
    town: 'Proseč pod Křemešníkem',
    townCode: 561941,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.415347,
    long: 15.295046,
  },
  {
    town: 'Prosečné',
    townCode: 579602,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54373,
    lat: 50.562125,
    long: 15.687438,
  },
  {
    town: 'Prosenice',
    townCode: 517151,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75121,
    lat: 49.488904,
    long: 17.484287,
  },
  {
    town: 'Prosenická Lhota',
    townCode: 541133,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.689735,
    long: 14.482797,
  },
  {
    town: 'Prosetín',
    townCode: 596493,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59264,
    lat: 49.526397,
    long: 16.394946,
  },
  {
    town: 'Prosetín',
    townCode: 572098,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53976,
    lat: 49.833121,
    long: 15.957751,
  },
  {
    town: 'Prosíčka',
    townCode: 569313,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.724592,
    long: 15.323639,
  },
  {
    town: 'Prosiměřice',
    townCode: 594709,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.902803,
    long: 16.192067,
  },
  {
    town: 'PROSTĚJOV',
    townCode: 589250,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79601,
    lat: 49.472549,
    long: 17.106851,
  },
  {
    town: 'Prostějovičky',
    townCode: 589918,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79803,
    lat: 49.427632,
    long: 16.997349,
  },
  {
    town: 'Prostiboř',
    townCode: 541486,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.652373,
    long: 12.89399,
  },
  {
    town: 'Prostřední Bečva',
    townCode: 544698,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75656,
    lat: 49.436192,
    long: 18.252106,
  },
  {
    town: 'Prostřední Poříčí',
    townCode: 582221,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.572106,
    long: 16.497452,
  },
  {
    town: 'Protivanov',
    townCode: 589926,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79848,
    lat: 49.483614,
    long: 16.836047,
  },
  {
    town: 'Protivín',
    townCode: 549771,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39811,
    lat: 49.199591,
    long: 14.217277,
  },
  {
    town: 'Provodín',
    townCode: 561983,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47167,
    lat: 50.617925,
    long: 14.601372,
  },
  {
    town: 'Provodov',
    townCode: 585661,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76345,
    lat: 49.160363,
    long: 17.736899,
  },
  {
    town: 'Provodovice',
    townCode: 517208,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.451055,
    long: 17.768349,
  },
  {
    town: 'Provodov-Šonov',
    townCode: 574350,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54908,
    lat: 50.382206,
    long: 16.114965,
  },
  {
    town: 'Prštice',
    townCode: 583707,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66446,
    lat: 49.115118,
    long: 16.470866,
  },
  {
    town: 'Průhonice',
    townCode: 539571,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25243,
    lat: 50.001815,
    long: 14.560406,
  },
  {
    town: 'Prusice',
    townCode: 564788,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.968457,
    long: 14.877965,
  },
  {
    town: 'Prusinovice',
    townCode: 588903,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76842,
    lat: 49.379083,
    long: 17.587212,
  },
  {
    town: 'Prusy-Boškůvky',
    townCode: 593494,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.258521,
    long: 17.063799,
  },
  {
    town: 'Prušánky',
    townCode: 586498,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69621,
    lat: 48.828498,
    long: 16.980787,
  },
  {
    town: 'Prysk',
    townCode: 561991,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47115,
    lat: 50.796139,
    long: 14.468026,
  },
  {
    town: 'Pržno',
    townCode: 507181,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73911,
    lat: 49.613573,
    long: 18.361716,
  },
  {
    town: 'Pržno',
    townCode: 544728,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75623,
    lat: 49.387569,
    long: 17.942957,
  },
  {
    town: 'Přáslavice',
    townCode: 552411,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78354,
    lat: 49.587462,
    long: 17.390548,
  },
  {
    town: 'Přeborov',
    townCode: 561517,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.479579,
    long: 14.357241,
  },
  {
    town: 'Přebuz',
    townCode: 560596,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35801,
    lat: 50.36589,
    long: 12.620158,
  },
  {
    town: 'Přeckov',
    townCode: 591424,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.275939,
    long: 15.9164,
  },
  {
    town: 'Předboj',
    townCode: 538655,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25072,
    lat: 50.225492,
    long: 14.476835,
  },
  {
    town: 'Předenice',
    townCode: 540412,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33209,
    lat: 49.624495,
    long: 13.396669,
  },
  {
    town: 'Předhradí',
    townCode: 572101,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53974,
    lat: 49.831724,
    long: 16.038455,
  },
  {
    town: 'Předín',
    townCode: 591432,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67527,
    lat: 49.198388,
    long: 15.673827,
  },
  {
    town: 'Předklášteří',
    townCode: 549746,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66602,
    lat: 49.35263,
    long: 16.402512,
  },
  {
    town: 'Předměřice nad Jizerou',
    townCode: 536491,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29474,
    lat: 50.25558,
    long: 14.781377,
  },
  {
    town: 'Předměřice nad Labem',
    townCode: 570672,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50302,
    lat: 50.256426,
    long: 15.815669,
  },
  {
    town: 'Předmíř',
    townCode: 551627,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38742,
    lat: 49.489369,
    long: 13.770472,
  },
  {
    town: 'Přední Výtoň',
    townCode: 545716,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38273,
    lat: 48.631244,
    long: 14.16459,
  },
  {
    town: 'Přední Zborovice',
    townCode: 536792,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.218622,
    long: 13.892282,
  },
  {
    town: 'Předotice',
    townCode: 509621,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.365038,
    long: 14.053525,
  },
  {
    town: 'Předslav',
    townCode: 557005,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.447575,
    long: 13.354485,
  },
  {
    town: 'Předslavice',
    townCode: 551635,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.132138,
    long: 13.935156,
  },
  {
    town: 'Přehořov',
    townCode: 552895,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.247699,
    long: 14.756334,
  },
  {
    town: 'Přehvozdí',
    townCode: 513369,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 50.027508,
    long: 14.840073,
  },
  {
    town: 'Přehýšov',
    townCode: 559393,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.702736,
    long: 13.126957,
  },
  {
    town: 'Přechovice',
    townCode: 536547,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.179643,
    long: 13.894871,
  },
  {
    town: 'Přelíc',
    townCode: 532771,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27305,
    lat: 50.20572,
    long: 14.045964,
  },
  {
    town: 'Přelouč',
    townCode: 575500,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.039948,
    long: 15.560413,
  },
  {
    town: 'Přelovice',
    townCode: 575518,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.072887,
    long: 15.614899,
  },
  {
    town: 'Přemyslovice',
    townCode: 589934,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79851,
    lat: 49.556472,
    long: 16.955914,
  },
  {
    town: 'Přepeře',
    townCode: 577413,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51261,
    lat: 50.583032,
    long: 15.112901,
  },
  {
    town: 'Přepeře',
    townCode: 570923,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.467724,
    long: 15.101992,
  },
  {
    town: 'Přepychy',
    townCode: 576689,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51732,
    lat: 50.235959,
    long: 16.106634,
  },
  {
    town: 'Přepychy',
    townCode: 575526,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.106455,
    long: 15.519991,
  },
  {
    town: 'PŘEROV',
    townCode: 511382,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75002,
    lat: 49.456579,
    long: 17.45033,
  },
  {
    town: 'Přerov nad Labem',
    townCode: 537721,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28916,
    lat: 50.16037,
    long: 14.825129,
  },
  {
    town: 'Přerubenice',
    townCode: 598577,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.217271,
    long: 13.841132,
  },
  {
    town: 'Přeskače',
    townCode: 550078,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67140,
    lat: 49.01253,
    long: 16.107001,
  },
  {
    town: 'Přestanov',
    townCode: 530620,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40317,
    lat: 50.686777,
    long: 13.920379,
  },
  {
    town: 'Přestavlky',
    townCode: 517224,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75002,
    lat: 49.390351,
    long: 17.481629,
  },
  {
    town: 'Přestavlky',
    townCode: 572110,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.938074,
    long: 15.92634,
  },
  {
    town: 'Přestavlky',
    townCode: 530131,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.59986,
    long: 13.244478,
  },
  {
    town: 'Přestavlky',
    townCode: 565474,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.403615,
    long: 14.193965,
  },
  {
    town: 'Přestavlky u Čerčan',
    townCode: 530492,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25723,
    lat: 49.8531,
    long: 14.74423,
  },
  {
    town: 'Přešovice',
    townCode: 591441,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67557,
    lat: 49.050205,
    long: 16.061445,
  },
  {
    town: 'Přeštěnice',
    townCode: 549797,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.479763,
    long: 14.42045,
  },
  {
    town: 'Přeštice',
    townCode: 558249,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.573091,
    long: 13.333607,
  },
  {
    town: 'Přešťovice',
    townCode: 551643,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.277278,
    long: 13.974442,
  },
  {
    town: 'Převýšov',
    townCode: 570681,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.151634,
    long: 15.410541,
  },
  {
    town: 'Přezletice',
    townCode: 538671,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25073,
    lat: 50.155303,
    long: 14.575506,
  },
  {
    town: 'Přibice',
    townCode: 584843,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69124,
    lat: 48.961724,
    long: 16.57344,
  },
  {
    town: 'Příbor',
    townCode: 599808,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74258,
    lat: 49.641036,
    long: 18.145096,
  },
  {
    town: 'Příbram',
    townCode: 539911,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.685532,
    long: 13.999045,
  },
  {
    town: 'Příbram na Moravě',
    townCode: 583715,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.195583,
    long: 16.299175,
  },
  {
    town: 'Příbraz',
    townCode: 561088,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37802,
    lat: 49.051469,
    long: 14.937708,
  },
  {
    town: 'Přibyslav',
    townCode: 569321,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.576939,
    long: 15.73865,
  },
  {
    town: 'Přibyslav',
    townCode: 574368,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.373743,
    long: 16.16869,
  },
  {
    town: 'Přibyslavice',
    townCode: 583723,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.278696,
    long: 16.266436,
  },
  {
    town: 'Přibyslavice',
    townCode: 591459,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.260738,
    long: 15.778435,
  },
  {
    town: 'Příčina',
    townCode: 542253,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.065833,
    long: 13.667379,
  },
  {
    town: 'Příčovy',
    townCode: 513547,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.672874,
    long: 14.389683,
  },
  {
    town: 'Přídolí',
    townCode: 545724,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38101,
    lat: 48.781912,
    long: 14.35229,
  },
  {
    town: 'Příchovice',
    townCode: 558257,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.562138,
    long: 13.33946,
  },
  {
    town: 'Příkazy',
    townCode: 505013,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78333,
    lat: 49.642471,
    long: 17.148305,
  },
  {
    town: 'Příkosice',
    townCode: 579131,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.668377,
    long: 13.663557,
  },
  {
    town: 'Příkrý',
    townCode: 577421,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.625029,
    long: 15.364623,
  },
  {
    town: 'Přílepy',
    townCode: 565261,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27001,
    lat: 50.123281,
    long: 13.632702,
  },
  {
    town: 'Přílepy',
    townCode: 549720,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.320079,
    long: 17.616021,
  },
  {
    town: 'Příluka',
    townCode: 578622,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53944,
    lat: 49.864971,
    long: 16.15664,
  },
  {
    town: 'Přimda',
    townCode: 561151,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34806,
    lat: 49.674989,
    long: 12.673772,
  },
  {
    town: 'Přísečná',
    townCode: 545732,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38101,
    lat: 48.833173,
    long: 14.345507,
  },
  {
    town: 'Příseka',
    townCode: 569348,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.670936,
    long: 15.425737,
  },
  {
    town: 'Přísnotice',
    townCode: 583731,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66463,
    lat: 49.00323,
    long: 16.61361,
  },
  {
    town: 'Přistoupim',
    townCode: 513393,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.054216,
    long: 14.878688,
  },
  {
    town: 'Přišimasy',
    townCode: 533611,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.049615,
    long: 14.764,
  },
  {
    town: 'Příšov',
    townCode: 567086,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.811806,
    long: 13.304241,
  },
  {
    town: 'Příšovice',
    townCode: 564354,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46346,
    lat: 50.578232,
    long: 15.084005,
  },
  {
    town: 'Příštpo',
    townCode: 544752,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67551,
    lat: 49.073941,
    long: 15.935004,
  },
  {
    town: 'Přítluky',
    townCode: 584851,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69104,
    lat: 48.855089,
    long: 16.774055,
  },
  {
    town: 'Přívětice',
    townCode: 560111,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33828,
    lat: 49.834798,
    long: 13.612239,
  },
  {
    town: 'Přívrat',
    townCode: 580821,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56002,
    lat: 49.924704,
    long: 16.39707,
  },
  {
    town: 'Psárov',
    townCode: 563374,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.319003,
    long: 14.905589,
  },
  {
    town: 'Psáry',
    townCode: 539597,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25244,
    lat: 49.93632,
    long: 14.512867,
  },
  {
    town: 'Psáře',
    townCode: 530514,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.755783,
    long: 14.96193,
  },
  {
    town: 'Pstruží',
    townCode: 552577,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73911,
    lat: 49.564927,
    long: 18.347648,
  },
  {
    town: 'Pšánky',
    townCode: 530671,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.294187,
    long: 15.620991,
  },
  {
    town: 'Pšov',
    townCode: 555525,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36452,
    lat: 50.051663,
    long: 13.170783,
  },
  {
    town: 'Pšovlky',
    townCode: 542270,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27031,
    lat: 50.107947,
    long: 13.594013,
  },
  {
    town: 'Ptení',
    townCode: 589942,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79843,
    lat: 49.511729,
    long: 16.961205,
  },
  {
    town: 'Ptenín',
    townCode: 558265,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33452,
    lat: 49.531607,
    long: 13.18506,
  },
  {
    town: 'Ptice',
    townCode: 532789,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25218,
    lat: 50.05287,
    long: 14.166076,
  },
  {
    town: 'Ptýrov',
    townCode: 571938,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.504933,
    long: 14.947236,
  },
  {
    town: 'Puclice',
    townCode: 554154,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.553725,
    long: 13.019504,
  },
  {
    town: 'Pucov',
    townCode: 591491,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.247148,
    long: 16.174175,
  },
  {
    town: 'Puchlovice',
    townCode: 573531,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.185916,
    long: 15.626417,
  },
  {
    town: 'Puklice',
    townCode: 587745,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58831,
    lat: 49.374959,
    long: 15.700414,
  },
  {
    town: 'Pulečný',
    townCode: 546577,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46802,
    lat: 50.675488,
    long: 15.167986,
  },
  {
    town: 'Pustá Kamenice',
    townCode: 578631,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56982,
    lat: 49.756215,
    long: 16.085881,
  },
  {
    town: 'Pustá Polom',
    townCode: 509736,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74769,
    lat: 49.849271,
    long: 17.998005,
  },
  {
    town: 'Pustá Rybná',
    townCode: 578649,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.714822,
    long: 16.1351,
  },
  {
    town: 'Pustějov',
    townCode: 568775,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74243,
    lat: 49.700606,
    long: 18.004007,
  },
  {
    town: 'Pustiměř',
    townCode: 593508,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68321,
    lat: 49.322614,
    long: 17.02803,
  },
  {
    town: 'Pustina',
    townCode: 580830,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.899577,
    long: 16.105003,
  },
  {
    town: 'Pustověty',
    townCode: 542288,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.055708,
    long: 13.814115,
  },
  {
    town: 'Putim',
    townCode: 549801,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.264627,
    long: 14.11913,
  },
  {
    town: 'Putimov',
    townCode: 598755,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.41393,
    long: 15.268871,
  },
  {
    town: 'Pyšel',
    townCode: 591505,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.250609,
    long: 16.066539,
  },
  {
    town: 'Pyšely',
    townCode: 538680,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25167,
    lat: 49.876884,
    long: 14.677239,
  },
  {
    town: 'Rabakov',
    townCode: 565652,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.38575,
    long: 15.101648,
  },
  {
    town: 'Rabí',
    townCode: 557013,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.280848,
    long: 13.617715,
  },
  {
    town: 'Rabštejnská Lhota',
    townCode: 556882,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.915662,
    long: 15.768153,
  },
  {
    town: 'Ráby',
    townCode: 575534,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53352,
    lat: 50.07288,
    long: 15.802625,
  },
  {
    town: 'Rabyně',
    townCode: 530522,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25208,
    lat: 49.81429,
    long: 14.436202,
  },
  {
    town: 'Racková',
    townCode: 585670,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76001,
    lat: 49.27717,
    long: 17.624991,
  },
  {
    town: 'Rácovice',
    townCode: 511307,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 49.02106,
    long: 15.687019,
  },
  {
    town: 'Račetice',
    townCode: 546071,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.30526,
    long: 13.364964,
  },
  {
    town: 'Račice',
    townCode: 591521,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.108129,
    long: 16.024703,
  },
  {
    town: 'Račice',
    townCode: 596507,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.497374,
    long: 16.139354,
  },
  {
    town: 'Račice',
    townCode: 599760,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27024,
    lat: 50.024833,
    long: 13.923039,
  },
  {
    town: 'Račice',
    townCode: 565482,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41108,
    lat: 50.461398,
    long: 14.351181,
  },
  {
    town: 'Račice nad Trotinou',
    townCode: 570702,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.315762,
    long: 15.796171,
  },
  {
    town: 'Račice-Pístovice',
    townCode: 593516,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68305,
    lat: 49.276006,
    long: 16.872942,
  },
  {
    town: 'Račín',
    townCode: 588059,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59211,
    lat: 49.617573,
    long: 15.866964,
  },
  {
    town: 'Račiněves',
    townCode: 565491,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.373201,
    long: 14.218727,
  },
  {
    town: 'Radčice',
    townCode: 563773,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.672861,
    long: 15.277749,
  },
  {
    town: 'Radějov',
    townCode: 586501,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69667,
    lat: 48.859476,
    long: 17.34472,
  },
  {
    town: 'Radějovice',
    townCode: 536423,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38773,
    lat: 49.186371,
    long: 14.026543,
  },
  {
    town: 'Radějovice',
    townCode: 538698,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25168,
    lat: 49.947328,
    long: 14.564877,
  },
  {
    town: 'Radenice',
    townCode: 596515,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.427318,
    long: 16.064675,
  },
  {
    town: 'Radenín',
    townCode: 552917,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39120,
    lat: 49.369486,
    long: 14.840783,
  },
  {
    town: 'Radešín',
    townCode: 596523,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59255,
    lat: 49.470362,
    long: 16.087846,
  },
  {
    town: 'Radešínská Svratka',
    townCode: 596531,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59233,
    lat: 49.508546,
    long: 16.085143,
  },
  {
    town: 'Radětice',
    townCode: 552925,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.31946,
    long: 14.441364,
  },
  {
    town: 'Radětice',
    townCode: 564389,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.639925,
    long: 14.078828,
  },
  {
    town: 'Radhostice',
    townCode: 550485,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38481,
    lat: 49.079455,
    long: 13.880611,
  },
  {
    town: 'Radhošť',
    townCode: 575542,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 49.987647,
    long: 16.076121,
  },
  {
    town: 'Radíč',
    townCode: 598488,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.714764,
    long: 14.417497,
  },
  {
    town: 'Radíkov',
    townCode: 517275,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.596189,
    long: 17.672293,
  },
  {
    town: 'Radíkovice',
    townCode: 570711,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.209432,
    long: 15.693658,
  },
  {
    town: 'Radim',
    townCode: 573370,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50712,
    lat: 50.458914,
    long: 15.428693,
  },
  {
    town: 'Radim',
    townCode: 533629,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28103,
    lat: 50.070165,
    long: 15.012548,
  },
  {
    town: 'Radiměř',
    townCode: 578657,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56907,
    lat: 49.699586,
    long: 16.431386,
  },
  {
    town: 'Radimovice',
    townCode: 544582,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46344,
    lat: 50.626455,
    long: 15.082181,
  },
  {
    town: 'Radimovice u Tábora',
    townCode: 563196,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.457417,
    long: 14.639125,
  },
  {
    town: 'Radimovice u Želče',
    townCode: 552933,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39002,
    lat: 49.377371,
    long: 14.647655,
  },
  {
    town: 'Radkov',
    townCode: 552941,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.465893,
    long: 14.611257,
  },
  {
    town: 'Radkov',
    townCode: 587761,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.145306,
    long: 15.475336,
  },
  {
    town: 'Radkov',
    townCode: 549924,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59253,
    lat: 49.423179,
    long: 16.158345,
  },
  {
    town: 'Radkov',
    townCode: 568317,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74784,
    lat: 49.825627,
    long: 17.770253,
  },
  {
    town: 'Radkov',
    townCode: 574333,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.734468,
    long: 16.741584,
  },
  {
    town: 'Radkova Lhota',
    townCode: 517321,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.44185,
    long: 17.620656,
  },
  {
    town: 'Radkovice',
    townCode: 540421,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.547925,
    long: 13.368061,
  },
  {
    town: 'Radkovice u Budče',
    townCode: 550493,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 38001,
    lat: 49.082593,
    long: 15.621844,
  },
  {
    town: 'Radkovice u Hrotovic',
    townCode: 591548,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67559,
    lat: 49.070537,
    long: 16.007196,
  },
  {
    town: 'Radkovy',
    townCode: 517437,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.436222,
    long: 17.614936,
  },
  {
    town: 'Rádlo',
    townCode: 563781,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46803,
    lat: 50.698552,
    long: 15.115859,
  },
  {
    town: 'Radnice',
    townCode: 560120,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33828,
    lat: 49.856879,
    long: 13.605812,
  },
  {
    town: 'Radňoves',
    townCode: 596540,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.388717,
    long: 16.214074,
  },
  {
    town: 'Radňovice',
    townCode: 596558,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59231,
    lat: 49.56411,
    long: 16.034964,
  },
  {
    town: 'Radomyšl',
    townCode: 551660,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38731,
    lat: 49.31645,
    long: 13.930344,
  },
  {
    town: 'Radonice',
    townCode: 538701,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25073,
    lat: 50.143163,
    long: 14.610368,
  },
  {
    town: 'Radonice',
    townCode: 563323,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43155,
    lat: 50.298139,
    long: 13.284757,
  },
  {
    town: 'Radonín',
    townCode: 591556,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.279799,
    long: 15.72424,
  },
  {
    town: 'Radostice',
    townCode: 583740,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66446,
    lat: 49.133707,
    long: 16.477112,
  },
  {
    town: 'Radostín',
    townCode: 569364,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.661841,
    long: 15.545004,
  },
  {
    town: 'Radostín',
    townCode: 596566,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.652815,
    long: 15.875868,
  },
  {
    town: 'Radostín nad Oslavou',
    townCode: 596574,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.46203,
    long: 15.965213,
  },
  {
    town: 'Radostná pod Kozákovem',
    townCode: 577430,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51263,
    lat: 50.577589,
    long: 15.245541,
  },
  {
    town: 'Radostov',
    townCode: 570729,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.20977,
    long: 15.663736,
  },
  {
    town: 'Radošov',
    townCode: 591564,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.335141,
    long: 15.786546,
  },
  {
    town: 'Radošovice',
    townCode: 544965,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.019699,
    long: 14.273026,
  },
  {
    town: 'Radošovice',
    townCode: 551678,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.233625,
    long: 13.898673,
  },
  {
    town: 'Radošovice',
    townCode: 530531,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.741095,
    long: 14.867658,
  },
  {
    town: 'Radotice',
    townCode: 545040,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 48.980111,
    long: 15.590214,
  },
  {
    town: 'Radotín',
    townCode: 517445,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.47973,
    long: 17.63283,
  },
  {
    town: 'Radovesice',
    townCode: 565521,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.41107,
    long: 14.068389,
  },
  {
    town: 'Radovesnice I',
    townCode: 533637,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.010493,
    long: 15.151007,
  },
  {
    town: 'Radovesnice II',
    townCode: 533645,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28128,
    lat: 50.104165,
    long: 15.367826,
  },
  {
    town: 'Radslavice',
    townCode: 593524,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68321,
    lat: 49.323013,
    long: 17.003932,
  },
  {
    town: 'Radslavice',
    townCode: 517534,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75111,
    lat: 49.478269,
    long: 17.516667,
  },
  {
    town: 'Raduň',
    townCode: 509841,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74761,
    lat: 49.89297,
    long: 17.943349,
  },
  {
    town: 'Radvanec',
    townCode: 530387,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47301,
    lat: 50.753003,
    long: 14.59215,
  },
  {
    town: 'Radvanice',
    townCode: 579629,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54212,
    lat: 50.567552,
    long: 16.061824,
  },
  {
    town: 'Radvanice',
    townCode: 517569,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75121,
    lat: 49.509905,
    long: 17.477349,
  },
  {
    town: 'Rájec',
    townCode: 540854,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.856577,
    long: 16.903068,
  },
  {
    town: 'Rájec-Jestřebí',
    townCode: 582239,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67902,
    lat: 49.410419,
    long: 16.640964,
  },
  {
    town: 'Ráječko',
    townCode: 582247,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67902,
    lat: 49.393418,
    long: 16.641436,
  },
  {
    town: 'Rajhrad',
    townCode: 583758,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66461,
    lat: 49.090311,
    long: 16.603982,
  },
  {
    town: 'Rajhradice',
    townCode: 583766,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66461,
    lat: 49.092135,
    long: 16.629436,
  },
  {
    town: 'Rajnochovice',
    townCode: 588920,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76871,
    lat: 49.413088,
    long: 17.813268,
  },
  {
    town: 'Rakousy',
    townCode: 577448,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.620425,
    long: 15.187647,
  },
  {
    town: 'Rakov',
    townCode: 517585,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.491801,
    long: 17.707876,
  },
  {
    town: 'Raková',
    townCode: 566942,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.70043,
    long: 13.582052,
  },
  {
    town: 'Raková u Konice',
    townCode: 589951,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79857,
    lat: 49.607347,
    long: 16.950931,
  },
  {
    town: 'Rakovice',
    townCode: 562068,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.471321,
    long: 14.05466,
  },
  {
    town: 'Rakovník',
    townCode: 541656,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26901,
    lat: 50.106223,
    long: 13.739762,
  },
  {
    town: 'Rakůvka',
    townCode: 589969,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79857,
    lat: 49.610112,
    long: 16.938064,
  },
  {
    town: 'Rakvice',
    townCode: 584860,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69103,
    lat: 48.858211,
    long: 16.813408,
  },
  {
    town: 'Ralsko',
    townCode: 562017,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47124,
    lat: 50.58629,
    long: 14.80363,
  },
  {
    town: 'Raná',
    townCode: 572152,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53972,
    lat: 49.796504,
    long: 15.96422,
  },
  {
    town: 'Raná',
    townCode: 566659,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43924,
    lat: 50.411665,
    long: 13.779373,
  },
  {
    town: 'Rančířov',
    townCode: 587176,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58601,
    lat: 49.362563,
    long: 15.588563,
  },
  {
    town: 'Rantířov',
    townCode: 587788,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58841,
    lat: 49.408348,
    long: 15.515264,
  },
  {
    town: 'Rapotice',
    townCode: 591581,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67573,
    lat: 49.192313,
    long: 16.25337,
  },
  {
    town: 'Rapotín',
    townCode: 540862,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78814,
    lat: 50.000846,
    long: 17.019059,
  },
  {
    town: 'Rapšach',
    townCode: 547069,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37807,
    lat: 48.879314,
    long: 14.933012,
  },
  {
    town: 'Rasošky',
    townCode: 574376,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55221,
    lat: 50.322012,
    long: 15.911774,
  },
  {
    town: 'Raspenava',
    townCode: 564371,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.904256,
    long: 15.114757,
  },
  {
    town: 'Rašín',
    townCode: 549274,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.333359,
    long: 15.678023,
  },
  {
    town: 'Raškovice',
    townCode: 549665,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73904,
    lat: 49.619845,
    long: 18.472974,
  },
  {
    town: 'Rašov',
    townCode: 582255,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.415645,
    long: 16.45383,
  },
  {
    town: 'Rašovice',
    townCode: 593532,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68501,
    lat: 49.121064,
    long: 16.948329,
  },
  {
    town: 'Rašovice',
    townCode: 534340,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.882642,
    long: 15.102485,
  },
  {
    town: 'Rataje',
    townCode: 552976,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.350249,
    long: 14.44584,
  },
  {
    town: 'Rataje',
    townCode: 530549,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.704164,
    long: 14.97055,
  },
  {
    town: 'Rataje',
    townCode: 588938,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76812,
    lat: 49.2714,
    long: 17.335656,
  },
  {
    town: 'Rataje nad Sázavou',
    townCode: 534358,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28507,
    lat: 49.841949,
    long: 14.956827,
  },
  {
    town: 'Ratboř',
    townCode: 533653,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28141,
    lat: 49.978185,
    long: 15.159345,
  },
  {
    town: 'Ratenice',
    townCode: 537748,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28911,
    lat: 50.09171,
    long: 15.059361,
  },
  {
    town: 'Ratiboř',
    townCode: 507784,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.143619,
    long: 14.915123,
  },
  {
    town: 'Ratiboř',
    townCode: 544787,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75621,
    lat: 49.367793,
    long: 17.915097,
  },
  {
    town: 'Ratibořské Hory',
    townCode: 552992,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39142,
    lat: 49.462778,
    long: 14.769911,
  },
  {
    town: 'Ratíškovice',
    townCode: 586510,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69602,
    lat: 48.920114,
    long: 17.165713,
  },
  {
    town: 'Ratměřice',
    townCode: 532550,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25703,
    lat: 49.643355,
    long: 14.756277,
  },
  {
    town: 'Razová',
    townCode: 597724,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.931401,
    long: 17.532102,
  },
  {
    town: 'Ražice',
    townCode: 549827,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39822,
    lat: 49.240999,
    long: 14.101842,
  },
  {
    town: 'Rebešovice',
    townCode: 583774,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66461,
    lat: 49.105224,
    long: 16.635332,
  },
  {
    town: 'Rejchartice',
    townCode: 553395,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78701,
    lat: 50.028348,
    long: 16.97802,
  },
  {
    town: 'Rejštejn',
    townCode: 557021,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34192,
    lat: 49.14064,
    long: 13.515272,
  },
  {
    town: 'Rešice',
    townCode: 594725,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67173,
    lat: 49.053466,
    long: 16.171572,
  },
  {
    town: 'Roblín',
    townCode: 571318,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25226,
    lat: 49.961936,
    long: 14.248667,
  },
  {
    town: 'Ročov',
    townCode: 566667,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43967,
    lat: 50.253498,
    long: 13.774466,
  },
  {
    town: 'Rodinov',
    townCode: 561789,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39470,
    lat: 49.282895,
    long: 15.103915,
  },
  {
    town: 'Rodkov',
    townCode: 587737,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.503956,
    long: 16.227678,
  },
  {
    town: 'Rodná',
    townCode: 560626,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.490264,
    long: 14.8426,
  },
  {
    town: 'Rodvínov',
    townCode: 547085,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.171096,
    long: 15.05709,
  },
  {
    town: 'Rohatec',
    townCode: 586528,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69601,
    lat: 48.880497,
    long: 17.183408,
  },
  {
    town: 'Rohatsko',
    townCode: 565636,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.440386,
    long: 15.104846,
  },
  {
    town: 'Rohenice',
    townCode: 548669,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.309374,
    long: 16.032244,
  },
  {
    town: 'Rohle',
    townCode: 540871,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78974,
    lat: 49.860823,
    long: 17.013786,
  },
  {
    town: 'Rohov',
    townCode: 568376,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74725,
    lat: 50.015707,
    long: 18.071507,
  },
  {
    town: 'Rohovládova Bělá',
    townCode: 575551,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53343,
    lat: 50.106311,
    long: 15.606265,
  },
  {
    town: 'Rohozec',
    townCode: 582263,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.390415,
    long: 16.482952,
  },
  {
    town: 'Rohozec',
    townCode: 526622,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.97612,
    long: 15.384746,
  },
  {
    town: 'Rohozná',
    townCode: 587796,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58844,
    lat: 49.350316,
    long: 15.399269,
  },
  {
    town: 'Rohozná',
    townCode: 578673,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56972,
    lat: 49.653741,
    long: 16.407989,
  },
  {
    town: 'Rohoznice',
    townCode: 573221,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50771,
    lat: 50.391682,
    long: 15.699658,
  },
  {
    town: 'Rohoznice',
    townCode: 575569,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.127321,
    long: 15.664377,
  },
  {
    town: 'Rohy',
    townCode: 591602,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.305639,
    long: 16.005703,
  },
  {
    town: 'Rochlov',
    townCode: 559423,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.730821,
    long: 13.146015,
  },
  {
    town: 'Rochov',
    townCode: 565547,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.45949,
    long: 14.117546,
  },
  {
    town: 'Rojetín',
    townCode: 596582,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59451,
    lat: 49.366746,
    long: 16.257478,
  },
  {
    town: 'Rokle',
    townCode: 563331,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43201,
    lat: 50.35328,
    long: 13.29881,
  },
  {
    town: 'Rokycany',
    townCode: 559717,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.738197,
    long: 13.592993,
  },
  {
    town: 'Rokytá',
    townCode: 529605,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29501,
    lat: 50.563767,
    long: 14.869309,
  },
  {
    town: 'Rokytňany',
    townCode: 548898,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.375876,
    long: 15.137489,
  },
  {
    town: 'Rokytnice',
    townCode: 517607,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75104,
    lat: 49.466023,
    long: 17.391308,
  },
  {
    town: 'Rokytnice',
    townCode: 556980,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.066239,
    long: 17.91147,
  },
  {
    town: 'Rokytnice nad Jizerou',
    townCode: 577456,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51244,
    lat: 50.729228,
    long: 15.448787,
  },
  {
    town: 'Rokytnice nad Rokytnou',
    townCode: 591611,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67525,
    lat: 49.184456,
    long: 15.77297,
  },
  {
    town: 'Rokytnice v Orlických horách',
    townCode: 576701,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51761,
    lat: 50.164831,
    long: 16.46578,
  },
  {
    town: 'Rokytno',
    townCode: 575577,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53304,
    lat: 50.104773,
    long: 15.889408,
  },
  {
    town: 'Rokytovec',
    townCode: 571148,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29430,
    lat: 50.406627,
    long: 14.830785,
  },
  {
    town: 'Ronov nad Doubravou',
    townCode: 572161,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53842,
    lat: 49.888353,
    long: 15.531541,
  },
  {
    town: 'Ropice',
    townCode: 556971,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73961,
    lat: 49.705458,
    long: 18.61356,
  },
  {
    town: 'Roprachtice',
    townCode: 577464,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.647554,
    long: 15.422263,
  },
  {
    town: 'Roseč',
    townCode: 508004,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37846,
    lat: 49.127862,
    long: 14.910845,
  },
  {
    town: 'Rosice',
    townCode: 583782,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66501,
    lat: 49.18242,
    long: 16.387975,
  },
  {
    town: 'Rosice',
    townCode: 572179,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53834,
    lat: 49.922359,
    long: 15.951376,
  },
  {
    town: 'Rosička',
    townCode: 560995,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.279706,
    long: 14.954045,
  },
  {
    town: 'Rosička',
    townCode: 549941,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.538671,
    long: 15.842695,
  },
  {
    town: 'Rosovice',
    townCode: 541206,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26211,
    lat: 49.756754,
    long: 14.109079,
  },
  {
    town: 'Rostěnice-Zvonovice',
    townCode: 554898,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.238368,
    long: 16.966061,
  },
  {
    town: 'Rostoklaty',
    townCode: 533661,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28171,
    lat: 50.074329,
    long: 14.801559,
  },
  {
    town: 'Roštění',
    townCode: 588946,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76843,
    lat: 49.367004,
    long: 17.538595,
  },
  {
    town: 'Roštín',
    townCode: 588954,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76803,
    lat: 49.188888,
    long: 17.286157,
  },
  {
    town: 'Rotava',
    townCode: 560600,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35701,
    lat: 50.29638,
    long: 12.573526,
  },
  {
    town: 'Roubanina',
    townCode: 513709,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.615509,
    long: 16.594167,
  },
  {
    town: 'Roudná',
    townCode: 553018,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.304487,
    long: 14.718671,
  },
  {
    town: 'Roudné',
    townCode: 544973,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37007,
    lat: 48.934985,
    long: 14.487539,
  },
  {
    town: 'Roudnice',
    townCode: 570745,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.176262,
    long: 15.651804,
  },
  {
    town: 'Roudnice nad Labem',
    townCode: 565555,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.425305,
    long: 14.260565,
  },
  {
    town: 'Roudno',
    townCode: 597741,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.896091,
    long: 17.513637,
  },
  {
    town: 'Rouchovany',
    townCode: 591629,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67557,
    lat: 49.070461,
    long: 16.107705,
  },
  {
    town: 'Roupov',
    townCode: 558290,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33453,
    lat: 49.538655,
    long: 13.249019,
  },
  {
    town: 'Rousínov',
    townCode: 593559,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.201381,
    long: 16.882252,
  },
  {
    town: 'Rouské',
    townCode: 517615,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.471832,
    long: 17.779252,
  },
  {
    town: 'Rousměrov',
    townCode: 596604,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.457769,
    long: 16.032622,
  },
  {
    town: 'Rovečné',
    townCode: 596612,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.577723,
    long: 16.362673,
  },
  {
    town: 'Rovensko',
    townCode: 540919,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.907785,
    long: 16.876347,
  },
  {
    town: 'Rovensko pod Troskami',
    townCode: 577472,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51263,
    lat: 50.535418,
    long: 15.259515,
  },
  {
    town: 'Rovná',
    townCode: 536865,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.286443,
    long: 13.954057,
  },
  {
    town: 'Rovná',
    townCode: 560618,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.104512,
    long: 12.668852,
  },
  {
    town: 'Rovná',
    townCode: 561274,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.510291,
    long: 15.129502,
  },
  {
    town: 'Rozdrojovice',
    townCode: 583791,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66434,
    lat: 49.254744,
    long: 16.510033,
  },
  {
    town: 'Rozhovice',
    townCode: 547808,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.967283,
    long: 15.713618,
  },
  {
    town: 'Rozhraní',
    townCode: 578681,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56903,
    lat: 49.601761,
    long: 16.533472,
  },
  {
    town: 'Rozkoš',
    townCode: 594733,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 49.028696,
    long: 15.977759,
  },
  {
    town: 'Rozseč',
    townCode: 587800,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58866,
    lat: 49.155992,
    long: 15.616703,
  },
  {
    town: 'Rozseč',
    townCode: 596639,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.360238,
    long: 16.219462,
  },
  {
    town: 'Rozseč nad Kunštátem',
    townCode: 582271,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67973,
    lat: 49.524499,
    long: 16.46313,
  },
  {
    town: 'Rozsíčka',
    townCode: 582280,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.552383,
    long: 16.46709,
  },
  {
    town: 'Rozsochatec',
    townCode: 569399,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58272,
    lat: 49.672641,
    long: 15.633903,
  },
  {
    town: 'Rozsochy',
    townCode: 596647,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59257,
    lat: 49.520317,
    long: 16.200201,
  },
  {
    town: 'Rozstání',
    townCode: 589977,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79862,
    lat: 49.397795,
    long: 16.840456,
  },
  {
    town: 'Rozstání',
    townCode: 578690,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.735067,
    long: 16.720164,
  },
  {
    town: 'Roztoky',
    townCode: 539627,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25263,
    lat: 50.158516,
    long: 14.397712,
  },
  {
    town: 'Roztoky',
    townCode: 598526,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.02682,
    long: 13.867976,
  },
  {
    town: 'Roztoky u Jilemnice',
    townCode: 577499,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51231,
    lat: 50.563887,
    long: 15.499852,
  },
  {
    town: 'Roztoky u Semil',
    townCode: 577481,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.65855,
    long: 15.371639,
  },
  {
    town: 'Rozvadov',
    townCode: 561169,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34806,
    lat: 49.668279,
    long: 12.551998,
  },
  {
    town: 'Rožďalovice',
    townCode: 537756,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28934,
    lat: 50.304864,
    long: 15.169724,
  },
  {
    town: 'Rožmberk nad Vltavou',
    townCode: 545767,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38218,
    lat: 48.654353,
    long: 14.365259,
  },
  {
    town: 'Rožmitál na Šumavě',
    townCode: 545775,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38292,
    lat: 48.701499,
    long: 14.388377,
  },
  {
    town: 'Rožmitál pod Třemšínem',
    townCode: 541231,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.601864,
    long: 13.865835,
  },
  {
    town: 'Rožná',
    townCode: 596655,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59252,
    lat: 49.477368,
    long: 16.23859,
  },
  {
    town: 'Rožnov',
    townCode: 574384,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.338147,
    long: 15.86139,
  },
  {
    town: 'Rožnov pod Radhoštěm',
    townCode: 544841,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75661,
    lat: 49.458626,
    long: 18.143131,
  },
  {
    town: 'Rpety',
    townCode: 531715,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26801,
    lat: 49.828376,
    long: 13.938596,
  },
  {
    town: 'Rtyně nad Bílinou',
    townCode: 567809,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41762,
    lat: 50.603629,
    long: 13.908818,
  },
  {
    town: 'Rtyně v Podkrkonoší',
    townCode: 579637,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54233,
    lat: 50.505329,
    long: 16.071973,
  },
  {
    town: 'Ruda',
    townCode: 596663,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.322584,
    long: 16.122796,
  },
  {
    town: 'Ruda',
    townCode: 542326,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27101,
    lat: 50.14089,
    long: 13.875801,
  },
  {
    town: 'Ruda nad Moravou',
    townCode: 540978,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78963,
    lat: 49.981095,
    long: 16.877925,
  },
  {
    town: 'Rudice',
    townCode: 582298,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67906,
    lat: 49.337274,
    long: 16.725919,
  },
  {
    town: 'Rudice',
    townCode: 592552,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68732,
    lat: 49.056153,
    long: 17.737584,
  },
  {
    town: 'Rudíkov',
    townCode: 591637,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.288117,
    long: 15.94605,
  },
  {
    town: 'Rudimov',
    townCode: 586919,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.079796,
    long: 17.828258,
  },
  {
    town: 'Rudka',
    townCode: 583804,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.242573,
    long: 16.331102,
  },
  {
    town: 'Rudlice',
    townCode: 594741,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.948588,
    long: 16.065799,
  },
  {
    town: 'Rudná',
    townCode: 578703,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.659222,
    long: 16.573374,
  },
  {
    town: 'Rudná',
    townCode: 531723,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25219,
    lat: 50.035128,
    long: 14.234454,
  },
  {
    town: 'Rudná pod Pradědem',
    townCode: 551945,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79331,
    lat: 50.020519,
    long: 17.377529,
  },
  {
    town: 'Rudník',
    townCode: 579645,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54372,
    lat: 50.578698,
    long: 15.736956,
  },
  {
    town: 'Rudolec',
    townCode: 596671,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59214,
    lat: 49.47692,
    long: 15.830304,
  },
  {
    town: 'Rudolfov',
    townCode: 544981,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37371,
    lat: 48.993496,
    long: 14.541889,
  },
  {
    town: 'Rudoltice',
    townCode: 580848,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56125,
    lat: 49.898427,
    long: 16.569965,
  },
  {
    town: 'Rumburk',
    townCode: 562777,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40801,
    lat: 50.953525,
    long: 14.555255,
  },
  {
    town: 'Ruprechtov',
    townCode: 593567,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68304,
    lat: 49.32875,
    long: 16.851494,
  },
  {
    town: 'Rusava',
    townCode: 588962,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76841,
    lat: 49.348527,
    long: 17.689193,
  },
  {
    town: 'Rusín',
    townCode: 597775,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79397,
    lat: 50.209884,
    long: 17.734323,
  },
  {
    town: 'Rušinov',
    townCode: 569402,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.791978,
    long: 15.683152,
  },
  {
    town: 'Růžďka',
    townCode: 544850,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75625,
    lat: 49.394052,
    long: 17.995701,
  },
  {
    town: 'Růžená',
    townCode: 587818,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58901,
    lat: 49.270494,
    long: 15.428507,
  },
  {
    town: 'Růžová',
    townCode: 566900,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.842265,
    long: 14.293898,
  },
  {
    town: 'Rybí',
    townCode: 568554,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74265,
    lat: 49.600825,
    long: 18.076024,
  },
  {
    town: 'Rybitví',
    townCode: 575593,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53354,
    lat: 50.060247,
    long: 15.704827,
  },
  {
    town: 'Rybná nad Zdobnicí',
    townCode: 576727,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51755,
    lat: 50.10864,
    long: 16.365963,
  },
  {
    town: 'Rybné',
    townCode: 587826,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.42295,
    long: 15.736398,
  },
  {
    town: 'Rybnice',
    townCode: 559431,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33151,
    lat: 49.908441,
    long: 13.373838,
  },
  {
    town: 'Rybníček',
    townCode: 553972,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.273976,
    long: 17.073903,
  },
  {
    town: 'Rybníček',
    townCode: 569411,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.76947,
    long: 15.509141,
  },
  {
    town: 'Rybník',
    townCode: 547905,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56002,
    lat: 49.888725,
    long: 16.474526,
  },
  {
    town: 'Rybník',
    townCode: 554189,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34525,
    lat: 49.512872,
    long: 12.676863,
  },
  {
    town: 'Rybníky',
    townCode: 594750,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67201,
    lat: 49.026365,
    long: 16.27947,
  },
  {
    town: 'Rybníky',
    townCode: 541257,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.752744,
    long: 14.206005,
  },
  {
    town: 'Rybniště',
    townCode: 562793,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40751,
    lat: 50.880068,
    long: 14.515148,
  },
  {
    town: 'Rychnov na Moravě',
    townCode: 578711,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56934,
    lat: 49.829244,
    long: 16.640214,
  },
  {
    town: 'Rychnov nad Kněžnou',
    townCode: 576069,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51601,
    lat: 50.166065,
    long: 16.277784,
  },
  {
    town: 'Rychnov u Jablonce nad Nisou',
    townCode: 563790,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46802,
    lat: 50.683891,
    long: 15.149898,
  },
  {
    town: 'Rychnovek',
    townCode: 574406,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55225,
    lat: 50.357467,
    long: 15.970419,
  },
  {
    town: 'Rychvald',
    townCode: 599107,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73532,
    lat: 49.86635,
    long: 18.376369,
  },
  {
    town: 'Ryjice',
    townCode: 546186,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40331,
    lat: 50.688055,
    long: 14.092111,
  },
  {
    town: 'Rýmařov',
    townCode: 597783,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79501,
    lat: 49.931927,
    long: 17.271873,
  },
  {
    town: 'Rymice',
    townCode: 588971,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.342008,
    long: 17.526316,
  },
  {
    town: 'Rynárec',
    townCode: 562009,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39401,
    lat: 49.389706,
    long: 15.234826,
  },
  {
    town: 'Rynholec',
    townCode: 542334,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27062,
    lat: 50.138031,
    long: 13.922328,
  },
  {
    town: 'Rynoltice',
    townCode: 564397,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46353,
    lat: 50.789106,
    long: 14.818942,
  },
  {
    town: 'Ryžoviště',
    townCode: 597791,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79356,
    lat: 49.875695,
    long: 17.358331,
  },
  {
    town: 'Řásná',
    townCode: 587834,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.221126,
    long: 15.391382,
  },
  {
    town: 'Řečany nad Labem',
    townCode: 575607,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53313,
    lat: 50.03599,
    long: 15.477455,
  },
  {
    town: 'Řečice',
    townCode: 548715,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.602983,
    long: 15.371725,
  },
  {
    town: 'Řečice',
    townCode: 596680,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59233,
    lat: 49.513093,
    long: 16.063959,
  },
  {
    town: 'Řehenice',
    townCode: 538710,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25167,
    lat: 49.869849,
    long: 14.650331,
  },
  {
    town: 'Řehlovice',
    townCode: 568201,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40313,
    lat: 50.607226,
    long: 13.954233,
  },
  {
    town: 'Řeka',
    townCode: 552640,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73955,
    lat: 49.641202,
    long: 18.571511,
  },
  {
    town: 'Řemíčov',
    townCode: 560511,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.515076,
    long: 14.775093,
  },
  {
    town: 'Řenče',
    townCode: 558303,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.579972,
    long: 13.4146,
  },
  {
    town: 'Řendějov',
    townCode: 534366,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.767946,
    long: 15.080471,
  },
  {
    town: 'Řepeč',
    townCode: 553034,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39161,
    lat: 49.403544,
    long: 14.51966,
  },
  {
    town: 'Řepice',
    townCode: 536849,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.280612,
    long: 13.933539,
  },
  {
    town: 'Řepín',
    townCode: 535168,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27733,
    lat: 50.366642,
    long: 14.634675,
  },
  {
    town: 'Řepiště',
    townCode: 568830,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73932,
    lat: 49.733473,
    long: 18.317179,
  },
  {
    town: 'Řepníky',
    townCode: 572209,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53865,
    lat: 49.901232,
    long: 16.079849,
  },
  {
    town: 'Řepov',
    townCode: 536580,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.402437,
    long: 14.957103,
  },
  {
    town: 'Řeřichy',
    townCode: 565504,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.079276,
    long: 13.585937,
  },
  {
    town: 'Řestoky',
    townCode: 572217,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53851,
    lat: 49.922503,
    long: 15.916661,
  },
  {
    town: 'Řetová',
    townCode: 580872,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56141,
    lat: 49.945893,
    long: 16.38133,
  },
  {
    town: 'Řetůvka',
    townCode: 580881,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56141,
    lat: 49.95587,
    long: 16.356124,
  },
  {
    town: 'Řevnice',
    townCode: 539643,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25230,
    lat: 49.914064,
    long: 14.235875,
  },
  {
    town: 'Řevničov',
    townCode: 542351,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.184992,
    long: 13.808344,
  },
  {
    town: 'Řícmanice',
    townCode: 583821,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66401,
    lat: 49.257564,
    long: 16.694045,
  },
  {
    town: 'Říčany',
    townCode: 583839,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66482,
    lat: 49.215075,
    long: 16.393723,
  },
  {
    town: 'Říčany',
    townCode: 538728,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.991778,
    long: 14.654376,
  },
  {
    town: 'Říčky',
    townCode: 549789,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66483,
    lat: 49.233025,
    long: 16.355945,
  },
  {
    town: 'Říčky v Orlických horách',
    townCode: 576735,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51761,
    lat: 50.211092,
    long: 16.45912,
  },
  {
    town: 'Řídeč',
    townCode: 554103,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.765829,
    long: 17.25688,
  },
  {
    town: 'Řídelov',
    townCode: 587851,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.234597,
    long: 15.406922,
  },
  {
    town: 'Řídký',
    townCode: 572233,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.894209,
    long: 16.243209,
  },
  {
    town: 'Řikonín',
    townCode: 596698,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59451,
    lat: 49.364487,
    long: 16.305808,
  },
  {
    town: 'Říkov',
    townCode: 530786,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55203,
    lat: 50.384385,
    long: 16.016933,
  },
  {
    town: 'Říkovice',
    townCode: 517666,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75118,
    lat: 49.381646,
    long: 17.451338,
  },
  {
    town: 'Římov',
    townCode: 545007,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37324,
    lat: 48.855719,
    long: 14.48694,
  },
  {
    town: 'Římov',
    townCode: 591645,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.170178,
    long: 15.757671,
  },
  {
    town: 'Řimovice',
    townCode: 532941,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.696448,
    long: 14.943106,
  },
  {
    town: 'Řípec',
    townCode: 599115,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.214291,
    long: 14.736808,
  },
  {
    town: 'Řisuty',
    townCode: 532797,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27378,
    lat: 50.216592,
    long: 14.005087,
  },
  {
    town: 'Řitka',
    townCode: 539651,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25203,
    lat: 49.894619,
    long: 14.299341,
  },
  {
    town: 'Řitonice',
    townCode: 565661,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.408309,
    long: 15.108053,
  },
  {
    town: 'Sádek',
    townCode: 578720,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.692663,
    long: 16.225728,
  },
  {
    town: 'Sádek',
    townCode: 541273,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.733317,
    long: 13.98323,
  },
  {
    town: 'Sadov',
    townCode: 555533,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.267226,
    long: 12.897194,
  },
  {
    town: 'Sadová',
    townCode: 573191,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.297512,
    long: 15.700009,
  },
  {
    town: 'Sadská',
    townCode: 537764,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28912,
    lat: 50.136066,
    long: 14.98644,
  },
  {
    town: 'Salačova Lhota',
    townCode: 548731,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.524136,
    long: 14.980329,
  },
  {
    town: 'Salaš',
    townCode: 592561,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68706,
    lat: 49.140618,
    long: 17.342876,
  },
  {
    town: 'Samopše',
    townCode: 534374,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.861533,
    long: 14.929498,
  },
  {
    town: 'Samotišky',
    townCode: 547077,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 77900,
    lat: 49.630522,
    long: 17.328172,
  },
  {
    town: 'Samšín',
    townCode: 548740,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.485662,
    long: 15.061812,
  },
  {
    town: 'Samšina',
    townCode: 573442,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.459432,
    long: 15.23502,
  },
  {
    town: 'Sány',
    townCode: 537772,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28906,
    lat: 50.124752,
    long: 15.247746,
  },
  {
    town: 'Sázava',
    townCode: 596701,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59211,
    lat: 49.565295,
    long: 15.928353,
  },
  {
    town: 'Sázava',
    townCode: 574392,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.908253,
    long: 16.641003,
  },
  {
    town: 'Sázava',
    townCode: 534382,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.871745,
    long: 14.896842,
  },
  {
    town: 'Sázavka',
    townCode: 569429,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58244,
    lat: 49.734505,
    long: 15.411535,
  },
  {
    town: 'Sazená',
    townCode: 532801,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27324,
    lat: 50.305277,
    long: 14.287363,
  },
  {
    town: 'Sazomín',
    townCode: 588237,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.508871,
    long: 15.981076,
  },
  {
    town: 'Sazovice',
    townCode: 585726,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76301,
    lat: 49.240997,
    long: 17.568782,
  },
  {
    town: 'Sběř',
    townCode: 573451,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50703,
    lat: 50.320225,
    long: 15.424479,
  },
  {
    town: 'Sebečice',
    townCode: 560146,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.869965,
    long: 13.692257,
  },
  {
    town: 'Sebranice',
    townCode: 582310,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67931,
    lat: 49.497022,
    long: 16.57464,
  },
  {
    town: 'Sebranice',
    townCode: 578738,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56962,
    lat: 49.771494,
    long: 16.249278,
  },
  {
    town: 'Seč',
    townCode: 572225,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53807,
    lat: 49.847037,
    long: 15.65653,
  },
  {
    town: 'Seč',
    townCode: 580902,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 50.025612,
    long: 16.294907,
  },
  {
    town: 'Seč',
    townCode: 558311,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.588075,
    long: 13.504999,
  },
  {
    town: 'Sedlatice',
    townCode: 587877,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.192397,
    long: 15.613497,
  },
  {
    town: 'Sedlčany',
    townCode: 541281,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.660677,
    long: 14.426744,
  },
  {
    town: 'Sedlec',
    townCode: 545015,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37347,
    lat: 49.072931,
    long: 14.286606,
  },
  {
    town: 'Sedlec',
    townCode: 584878,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69121,
    lat: 48.778993,
    long: 16.693989,
  },
  {
    town: 'Sedlec',
    townCode: 511081,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.167674,
    long: 16.134773,
  },
  {
    town: 'Sedlec',
    townCode: 530271,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 50.006379,
    long: 13.427287,
  },
  {
    town: 'Sedlec',
    townCode: 529591,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29471,
    lat: 50.300839,
    long: 14.79583,
  },
  {
    town: 'Sedlec',
    townCode: 598283,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25065,
    lat: 50.186836,
    long: 14.457979,
  },
  {
    town: 'Sedlec',
    townCode: 546721,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.450166,
    long: 14.016401,
  },
  {
    town: 'Sedlec-Prčice',
    townCode: 530573,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25791,
    lat: 49.573311,
    long: 14.533106,
  },
  {
    town: 'Sedlečko u Soběslavě',
    townCode: 599263,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.282784,
    long: 14.742959,
  },
  {
    town: 'Sedlejov',
    townCode: 587885,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58862,
    lat: 49.22761,
    long: 15.495752,
  },
  {
    town: 'Sedletín',
    townCode: 548421,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.708551,
    long: 15.564631,
  },
  {
    town: 'Sedlice',
    townCode: 551716,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38732,
    lat: 49.377258,
    long: 13.939059,
  },
  {
    town: 'Sedlice',
    townCode: 548766,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.515243,
    long: 15.256443,
  },
  {
    town: 'Sedlice',
    townCode: 564630,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.621869,
    long: 13.880889,
  },
  {
    town: 'Sedliště',
    townCode: 548961,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.394226,
    long: 15.219151,
  },
  {
    town: 'Sedliště',
    townCode: 598674,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73936,
    lat: 49.71846,
    long: 18.368797,
  },
  {
    town: 'Sedliště',
    townCode: 578746,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.893977,
    long: 16.274918,
  },
  {
    town: 'Sedliště',
    townCode: 540692,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.52758,
    long: 13.63234,
  },
  {
    town: 'Sedlnice',
    townCode: 599832,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74256,
    lat: 49.657799,
    long: 18.08701,
  },
  {
    town: 'Sedloňov',
    townCode: 576743,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51791,
    lat: 50.338401,
    long: 16.315588,
  },
  {
    town: 'Sehradice',
    townCode: 585734,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76323,
    lat: 49.144368,
    long: 17.824269,
  },
  {
    town: 'Sejřek',
    townCode: 596710,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59262,
    lat: 49.436195,
    long: 16.309362,
  },
  {
    town: 'Sekeřice',
    townCode: 572144,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50703,
    lat: 50.286507,
    long: 15.380794,
  },
  {
    town: 'Seletice',
    townCode: 534757,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28934,
    lat: 50.320442,
    long: 15.097101,
  },
  {
    town: 'Selmice',
    townCode: 575615,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.050233,
    long: 15.440919,
  },
  {
    town: 'Seloutky',
    townCode: 506770,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79804,
    lat: 49.441499,
    long: 17.063403,
  },
  {
    town: 'Semanín',
    townCode: 555240,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56002,
    lat: 49.869404,
    long: 16.453026,
  },
  {
    town: 'Semčice',
    townCode: 536610,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29446,
    lat: 50.368272,
    long: 15.007012,
  },
  {
    town: 'Semechnice',
    townCode: 576751,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.260342,
    long: 16.148495,
  },
  {
    town: 'Semice',
    townCode: 537781,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28917,
    lat: 50.164267,
    long: 14.871579,
  },
  {
    town: 'Semily',
    townCode: 576964,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.605258,
    long: 15.328241,
  },
  {
    town: 'Semín',
    townCode: 575623,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.053188,
    long: 15.519831,
  },
  {
    town: 'Semněvice',
    townCode: 554201,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.597859,
    long: 12.929307,
  },
  {
    town: 'Semtěš',
    townCode: 530859,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.960036,
    long: 15.514411,
  },
  {
    town: 'Sendraž',
    townCode: 547727,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.367711,
    long: 16.202186,
  },
  {
    town: 'Sendražice',
    townCode: 570796,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.289952,
    long: 15.796074,
  },
  {
    town: 'Senec',
    townCode: 542369,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27036,
    lat: 50.066842,
    long: 13.706979,
  },
  {
    town: 'Senetářov',
    townCode: 582328,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67906,
    lat: 49.354781,
    long: 16.80399,
  },
  {
    town: 'Senice',
    townCode: 537799,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.184332,
    long: 15.207677,
  },
  {
    town: 'Senice na Hané',
    townCode: 505081,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78345,
    lat: 49.62411,
    long: 17.085882,
  },
  {
    town: 'Senička',
    townCode: 552267,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78345,
    lat: 49.632317,
    long: 17.05639,
  },
  {
    town: 'Seninka',
    townCode: 544906,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75611,
    lat: 49.273311,
    long: 17.96516,
  },
  {
    town: 'Senohraby',
    townCode: 538752,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25166,
    lat: 49.895504,
    long: 14.718199,
  },
  {
    town: 'Senomaty',
    townCode: 542377,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27031,
    lat: 50.098281,
    long: 13.653828,
  },
  {
    town: 'Senorady',
    townCode: 591661,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67575,
    lat: 49.124447,
    long: 16.244551,
  },
  {
    town: 'Senožaty',
    townCode: 548774,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39456,
    lat: 49.569169,
    long: 15.198114,
  },
  {
    town: 'Sentice',
    townCode: 583847,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66603,
    lat: 49.310864,
    long: 16.446775,
  },
  {
    town: 'Sepekov',
    townCode: 549843,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39851,
    lat: 49.428755,
    long: 14.418256,
  },
  {
    town: 'Sezemice',
    townCode: 575640,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53304,
    lat: 50.066605,
    long: 15.852803,
  },
  {
    town: 'Sezemice',
    townCode: 599573,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29411,
    lat: 50.58565,
    long: 15.005199,
  },
  {
    town: 'Sezimovo Ústí',
    townCode: 553069,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39101,
    lat: 49.385291,
    long: 14.684908,
  },
  {
    town: 'Schořov',
    townCode: 531383,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.858229,
    long: 15.380002,
  },
  {
    town: 'Sibřina',
    townCode: 538761,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25084,
    lat: 50.056746,
    long: 14.669513,
  },
  {
    town: 'Silůvky',
    townCode: 583855,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66446,
    lat: 49.106075,
    long: 16.46804,
  },
  {
    town: 'Sirá',
    townCode: 546488,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.821542,
    long: 13.738545,
  },
  {
    town: 'Sirákov',
    townCode: 596728,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.504907,
    long: 15.818313,
  },
  {
    town: 'Siřejovice',
    townCode: 565598,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.478454,
    long: 14.071012,
  },
  {
    town: 'Sivice',
    townCode: 583863,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66407,
    lat: 49.203807,
    long: 16.782647,
  },
  {
    town: 'Skalice',
    townCode: 553077,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.303479,
    long: 14.695306,
  },
  {
    town: 'Skalice',
    townCode: 594768,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67171,
    lat: 48.964529,
    long: 16.224901,
  },
  {
    town: 'Skalice',
    townCode: 570800,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.27647,
    long: 15.872134,
  },
  {
    town: 'Skalice nad Svitavou',
    townCode: 582336,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67901,
    lat: 49.481246,
    long: 16.603686,
  },
  {
    town: 'Skalice u České Lípy',
    townCode: 562025,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47117,
    lat: 50.745217,
    long: 14.53067,
  },
  {
    town: 'Skalička',
    townCode: 545295,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66603,
    lat: 49.357972,
    long: 16.516283,
  },
  {
    town: 'Skalička',
    townCode: 517747,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75352,
    lat: 49.515497,
    long: 17.795975,
  },
  {
    town: 'Skalka',
    townCode: 586536,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69648,
    lat: 49.035877,
    long: 17.207332,
  },
  {
    town: 'Skalka',
    townCode: 589993,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79824,
    lat: 49.403186,
    long: 17.169915,
  },
  {
    town: 'Skalka u Doks',
    townCode: 513890,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.563681,
    long: 14.619672,
  },
  {
    town: 'Skalná',
    townCode: 554812,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35134,
    lat: 50.170411,
    long: 12.361561,
  },
  {
    town: 'Skalsko',
    townCode: 536636,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29426,
    lat: 50.427224,
    long: 14.759137,
  },
  {
    town: 'Skály',
    townCode: 549851,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39811,
    lat: 49.219961,
    long: 14.160276,
  },
  {
    town: 'Skály',
    townCode: 598909,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.183483,
    long: 13.99296,
  },
  {
    town: 'Skapce',
    townCode: 579467,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.657074,
    long: 12.990454,
  },
  {
    town: 'Skašov',
    townCode: 539937,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.510567,
    long: 13.431498,
  },
  {
    town: 'Skaštice',
    townCode: 588989,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.332412,
    long: 17.417495,
  },
  {
    town: 'Sklené',
    townCode: 596736,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.609496,
    long: 16.00697,
  },
  {
    town: 'Sklené',
    townCode: 578754,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.70686,
    long: 16.530602,
  },
  {
    town: 'Sklené nad Oslavou',
    townCode: 596744,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.438204,
    long: 16.057544,
  },
  {
    town: 'Skočice',
    townCode: 551741,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38775,
    lat: 49.186215,
    long: 14.104365,
  },
  {
    town: 'Skomelno',
    townCode: 566845,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33828,
    lat: 49.847471,
    long: 13.642262,
  },
  {
    town: 'Skopytce',
    townCode: 553085,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.331555,
    long: 14.798253,
  },
  {
    town: 'Skorkov',
    townCode: 548324,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58253,
    lat: 49.50855,
    long: 15.476213,
  },
  {
    town: 'Skorkov',
    townCode: 557030,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29474,
    lat: 50.231801,
    long: 14.749378,
  },
  {
    town: 'Skoronice',
    townCode: 586544,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69641,
    lat: 48.981428,
    long: 17.153534,
  },
  {
    town: 'Skorošice',
    townCode: 553484,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79065,
    lat: 50.308643,
    long: 17.080738,
  },
  {
    town: 'Skorotice',
    townCode: 596752,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59262,
    lat: 49.457421,
    long: 16.359248,
  },
  {
    town: 'Skořenice',
    townCode: 580929,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.031358,
    long: 16.222061,
  },
  {
    town: 'Skořice',
    townCode: 506664,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.677828,
    long: 13.705369,
  },
  {
    town: 'Skotnice',
    townCode: 568716,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74258,
    lat: 49.657664,
    long: 18.134051,
  },
  {
    town: 'Skrbeň',
    townCode: 552151,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78335,
    lat: 49.641248,
    long: 17.176605,
  },
  {
    town: 'Skrchov',
    townCode: 582344,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.57783,
    long: 16.549464,
  },
  {
    town: 'Skršín',
    townCode: 567361,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.465729,
    long: 13.754506,
  },
  {
    town: 'Skrýchov u Malšic',
    townCode: 560669,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39175,
    lat: 49.33027,
    long: 14.596666,
  },
  {
    town: 'Skryje',
    townCode: 549894,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.393663,
    long: 16.310789,
  },
  {
    town: 'Skryje',
    townCode: 569461,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.843818,
    long: 15.487779,
  },
  {
    town: 'Skryje',
    townCode: 542385,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27042,
    lat: 49.964953,
    long: 13.764601,
  },
  {
    town: 'Skřinářov',
    townCode: 596761,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59453,
    lat: 49.347147,
    long: 16.1721,
  },
  {
    town: 'Skřipel',
    townCode: 533963,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.842088,
    long: 14.067132,
  },
  {
    town: 'Skřipov',
    townCode: 510131,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74745,
    lat: 49.818845,
    long: 17.910595,
  },
  {
    town: 'Skřípov',
    townCode: 590002,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79852,
    lat: 49.583631,
    long: 16.82033,
  },
  {
    town: 'Skřivany',
    townCode: 570834,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50352,
    lat: 50.268616,
    long: 15.499348,
  },
  {
    town: 'Skuhrov',
    townCode: 569470,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58241,
    lat: 49.684765,
    long: 15.532234,
  },
  {
    town: 'Skuhrov',
    townCode: 563803,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.676103,
    long: 15.213411,
  },
  {
    town: 'Skuhrov',
    townCode: 531740,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26727,
    lat: 49.87342,
    long: 14.146829,
  },
  {
    town: 'Skuhrov nad Bělou',
    townCode: 576778,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51703,
    lat: 50.229557,
    long: 16.29241,
  },
  {
    town: 'Skuteč',
    townCode: 572241,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53973,
    lat: 49.843567,
    long: 15.996654,
  },
  {
    town: 'Skvrňov',
    townCode: 533696,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28144,
    lat: 49.897204,
    long: 15.001923,
  },
  {
    town: 'Slabce',
    townCode: 542415,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27041,
    lat: 50.000175,
    long: 13.714888,
  },
  {
    town: 'Slabčice',
    townCode: 549860,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39847,
    lat: 49.326635,
    long: 14.337975,
  },
  {
    town: 'Slaná',
    townCode: 577529,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51201,
    lat: 50.580911,
    long: 15.329787,
  },
  {
    town: 'Slaník',
    townCode: 536776,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.268386,
    long: 13.951671,
  },
  {
    town: 'Slaný',
    townCode: 532819,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27401,
    lat: 50.230562,
    long: 14.087044,
  },
  {
    town: 'Slapsko',
    townCode: 599026,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.575208,
    long: 14.762716,
  },
  {
    town: 'Slapy',
    townCode: 599042,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39176,
    lat: 49.38703,
    long: 14.616671,
  },
  {
    town: 'Slapy',
    townCode: 539660,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25208,
    lat: 49.815412,
    long: 14.396225,
  },
  {
    town: 'Slatina',
    townCode: 594776,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 49.019749,
    long: 16.018451,
  },
  {
    town: 'Slatina',
    townCode: 568406,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74293,
    lat: 49.790806,
    long: 17.979978,
  },
  {
    town: 'Slatina',
    townCode: 578762,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.629744,
    long: 16.607918,
  },
  {
    town: 'Slatina',
    townCode: 580945,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.978184,
    long: 16.163803,
  },
  {
    town: 'Slatina',
    townCode: 578436,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.38787,
    long: 13.744269,
  },
  {
    town: 'Slatina',
    townCode: 566748,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.984635,
    long: 13.634016,
  },
  {
    town: 'Slatina',
    townCode: 532827,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27326,
    lat: 50.224262,
    long: 14.220845,
  },
  {
    town: 'Slatina',
    townCode: 565601,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.430683,
    long: 14.038155,
  },
  {
    town: 'Slatina nad Úpou',
    townCode: 574422,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54947,
    lat: 50.454193,
    long: 16.036726,
  },
  {
    town: 'Slatina nad Zdobnicí',
    townCode: 576786,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51756,
    lat: 50.133907,
    long: 16.397982,
  },
  {
    town: 'Slatiňany',
    townCode: 572268,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53821,
    lat: 49.921196,
    long: 15.813873,
  },
  {
    town: 'Slatinice',
    townCode: 505111,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78342,
    lat: 49.561652,
    long: 17.100026,
  },
  {
    town: 'Slatinky',
    townCode: 590011,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78342,
    lat: 49.548787,
    long: 17.094088,
  },
  {
    town: 'Slatiny',
    townCode: 573469,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.366869,
    long: 15.381502,
  },
  {
    town: 'Slavče',
    townCode: 545023,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37321,
    lat: 48.797949,
    long: 14.615065,
  },
  {
    town: 'Slavětice',
    townCode: 591688,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.1037,
    long: 16.108814,
  },
  {
    town: 'Slavětín',
    townCode: 548553,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58263,
    lat: 49.668672,
    long: 15.772886,
  },
  {
    town: 'Slavětín',
    townCode: 552194,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78324,
    lat: 49.67466,
    long: 16.963636,
  },
  {
    town: 'Slavětín',
    townCode: 566713,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43909,
    lat: 50.350713,
    long: 13.907818,
  },
  {
    town: 'Slavětín nad Metují',
    townCode: 574431,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.329,
    long: 16.052982,
  },
  {
    town: 'Slavhostice',
    townCode: 572187,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50732,
    lat: 50.308911,
    long: 15.349485,
  },
  {
    town: 'Slavičín',
    townCode: 585751,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.088085,
    long: 17.873599,
  },
  {
    town: 'Slavičky',
    townCode: 591700,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67501,
    lat: 49.17486,
    long: 15.967999,
  },
  {
    town: 'Slavíkov',
    townCode: 569488,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58265,
    lat: 49.742924,
    long: 15.780817,
  },
  {
    town: 'Slavíkovice',
    townCode: 545180,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67531,
    lat: 49.004391,
    long: 15.624453,
  },
  {
    town: 'Slavkov',
    townCode: 510289,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74757,
    lat: 49.9219,
    long: 17.836519,
  },
  {
    town: 'Slavkov',
    townCode: 592579,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68764,
    lat: 48.946995,
    long: 17.611677,
  },
  {
    town: 'Slavkov pod Hostýnem',
    townCode: 588997,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.377245,
    long: 17.670437,
  },
  {
    town: 'Slavkov u Brna',
    townCode: 593583,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.153354,
    long: 16.876598,
  },
  {
    town: 'Slavníč',
    townCode: 548341,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58255,
    lat: 49.514827,
    long: 15.452365,
  },
  {
    town: 'Slavonice',
    townCode: 547166,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37881,
    lat: 48.997636,
    long: 15.351639,
  },
  {
    town: 'Slavoňov',
    townCode: 574457,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.343852,
    long: 16.204042,
  },
  {
    town: 'Slavošov',
    townCode: 534391,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.762279,
    long: 15.152072,
  },
  {
    town: 'Slepotice',
    townCode: 575658,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.992168,
    long: 15.96145,
  },
  {
    town: 'Slezské Pavlovice',
    townCode: 551881,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.309757,
    long: 17.700802,
  },
  {
    town: 'Slezské Rudoltice',
    townCode: 597813,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79397,
    lat: 50.207003,
    long: 17.681129,
  },
  {
    town: 'Slopné',
    townCode: 585769,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76323,
    lat: 49.157064,
    long: 17.847218,
  },
  {
    town: 'Sloup',
    townCode: 582352,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67913,
    lat: 49.414886,
    long: 16.739636,
  },
  {
    town: 'Sloup v Čechách',
    townCode: 562050,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47152,
    lat: 50.739037,
    long: 14.588922,
  },
  {
    town: 'Sloupnice',
    townCode: 580325,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56553,
    lat: 49.920923,
    long: 16.330377,
  },
  {
    town: 'Sloupno',
    townCode: 548499,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.73709,
    long: 15.749894,
  },
  {
    town: 'Sloupno',
    townCode: 570851,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50353,
    lat: 50.257418,
    long: 15.502075,
  },
  {
    town: 'Sloveč',
    townCode: 537802,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28903,
    lat: 50.229948,
    long: 15.326892,
  },
  {
    town: 'Slověnice',
    townCode: 532231,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.757388,
    long: 14.885194,
  },
  {
    town: 'Sluhy',
    townCode: 538779,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.192538,
    long: 14.557782,
  },
  {
    town: 'Slunečná',
    townCode: 546275,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47301,
    lat: 50.735875,
    long: 14.482593,
  },
  {
    town: 'Slup',
    townCode: 594784,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67128,
    lat: 48.781603,
    long: 16.199287,
  },
  {
    town: 'Slušovice',
    townCode: 585777,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 49.247918,
    long: 17.801607,
  },
  {
    town: 'Sluštice',
    townCode: 538787,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25084,
    lat: 50.039141,
    long: 14.685507,
  },
  {
    town: 'Služátky',
    townCode: 573604,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.684981,
    long: 15.431488,
  },
  {
    town: 'Služovice',
    townCode: 510297,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74728,
    lat: 49.988605,
    long: 17.994974,
  },
  {
    town: 'Smečno',
    townCode: 532835,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27305,
    lat: 50.188542,
    long: 14.040474,
  },
  {
    town: 'Smědčice',
    townCode: 540722,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.799216,
    long: 13.512935,
  },
  {
    town: 'Smetanova Lhota',
    townCode: 549878,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39804,
    lat: 49.447708,
    long: 14.087266,
  },
  {
    town: 'Smidary',
    townCode: 570869,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50353,
    lat: 50.291556,
    long: 15.477355,
  },
  {
    town: 'Smilkov',
    townCode: 530611,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25789,
    lat: 49.602598,
    long: 14.617508,
  },
  {
    town: 'Smilovice',
    townCode: 552658,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73955,
    lat: 49.660869,
    long: 18.571876,
  },
  {
    town: 'Smilovice',
    townCode: 536652,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29442,
    lat: 50.306626,
    long: 14.961154,
  },
  {
    town: 'Smilovice',
    townCode: 565407,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.247047,
    long: 13.807807,
  },
  {
    town: 'Smilovy Hory',
    townCode: 553123,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39152,
    lat: 49.536512,
    long: 14.875956,
  },
  {
    town: 'Smiřice',
    townCode: 570877,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.299879,
    long: 15.865181,
  },
  {
    town: 'Smolné Pece',
    townCode: 538027,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36225,
    lat: 50.291579,
    long: 12.765442,
  },
  {
    town: 'Smolnice',
    townCode: 566721,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43914,
    lat: 50.308774,
    long: 13.848572,
  },
  {
    town: 'Smolotely',
    townCode: 541311,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26263,
    lat: 49.620697,
    long: 14.135669,
  },
  {
    town: 'Smrček',
    townCode: 573817,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53851,
    lat: 49.868517,
    long: 15.893381,
  },
  {
    town: 'Smrčná',
    townCode: 550299,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58801,
    lat: 49.471478,
    long: 15.537956,
  },
  {
    town: 'Smrk',
    townCode: 591726,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67501,
    lat: 49.22568,
    long: 16.001974,
  },
  {
    town: 'Smržice',
    townCode: 590029,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79817,
    lat: 49.505793,
    long: 17.107084,
  },
  {
    town: 'Smržov',
    townCode: 561045,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.076158,
    long: 14.682477,
  },
  {
    town: 'Smržov',
    townCode: 570885,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.299846,
    long: 15.917943,
  },
  {
    town: 'Smržovka',
    townCode: 563811,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46851,
    lat: 50.738301,
    long: 15.246502,
  },
  {
    town: 'Snědovice',
    townCode: 565610,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41174,
    lat: 50.503633,
    long: 14.387857,
  },
  {
    town: 'Snět',
    townCode: 532436,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.626545,
    long: 15.226922,
  },
  {
    town: 'Sněžné',
    townCode: 596787,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.645617,
    long: 16.121753,
  },
  {
    town: 'Sněžné',
    townCode: 576794,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.340016,
    long: 16.277368,
  },
  {
    town: 'Snovídky',
    townCode: 593591,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.132902,
    long: 17.106415,
  },
  {
    town: 'Sobčice',
    townCode: 573477,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.372376,
    long: 15.514931,
  },
  {
    town: 'Soběhrdy',
    townCode: 530638,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.821122,
    long: 14.734312,
  },
  {
    town: 'Soběchleby',
    townCode: 517844,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.478963,
    long: 17.651641,
  },
  {
    town: 'Soběkury',
    townCode: 558346,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.576294,
    long: 13.239149,
  },
  {
    town: 'Soběnov',
    townCode: 545805,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38241,
    lat: 48.762808,
    long: 14.545827,
  },
  {
    town: 'Soběraz',
    townCode: 573361,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50713,
    lat: 50.463465,
    long: 15.402094,
  },
  {
    town: 'Soběslav',
    townCode: 553131,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.260039,
    long: 14.718717,
  },
  {
    town: 'Soběslavice',
    townCode: 564401,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46345,
    lat: 50.605,
    long: 15.034217,
  },
  {
    town: 'Soběsuky',
    townCode: 589004,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76802,
    lat: 49.233688,
    long: 17.359592,
  },
  {
    town: 'Soběšice',
    townCode: 557099,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.207905,
    long: 13.684205,
  },
  {
    town: 'Soběšín',
    townCode: 534293,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.791162,
    long: 14.955973,
  },
  {
    town: 'Soběšovice',
    townCode: 568791,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73938,
    lat: 49.724989,
    long: 18.4663,
  },
  {
    town: 'Sobětuchy',
    townCode: 572276,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.933341,
    long: 15.764066,
  },
  {
    town: 'Sobíňov',
    townCode: 569518,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58262,
    lat: 49.701095,
    long: 15.766977,
  },
  {
    town: 'Sobíšky',
    townCode: 517836,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75121,
    lat: 49.503857,
    long: 17.450876,
  },
  {
    town: 'Sobkovice',
    townCode: 547964,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56164,
    lat: 50.048008,
    long: 16.595086,
  },
  {
    town: 'Sobotín',
    townCode: 540986,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78816,
    lat: 50.011797,
    long: 17.090856,
  },
  {
    town: 'Sobotka',
    townCode: 573493,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50743,
    lat: 50.467515,
    long: 15.176299,
  },
  {
    town: 'Sobotovice',
    townCode: 583880,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66467,
    lat: 49.059999,
    long: 16.557396,
  },
  {
    town: 'Sobůlky',
    townCode: 586552,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69701,
    lat: 49.01974,
    long: 17.079041,
  },
  {
    town: 'Sojovice',
    townCode: 536661,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29475,
    lat: 50.222234,
    long: 14.762139,
  },
  {
    town: 'Sokoleč',
    townCode: 537811,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.098519,
    long: 15.107025,
  },
  {
    town: 'Sokolnice',
    townCode: 583898,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66452,
    lat: 49.11402,
    long: 16.721665,
  },
  {
    town: 'Sokolov',
    townCode: 560286,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.174629,
    long: 12.659992,
  },
  {
    town: 'Solenice',
    townCode: 541320,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26263,
    lat: 49.617671,
    long: 14.195881,
  },
  {
    town: 'Solnice',
    townCode: 576808,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51701,
    lat: 50.203755,
    long: 16.237723,
  },
  {
    town: 'Sopotnice',
    townCode: 580961,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56115,
    lat: 50.059141,
    long: 16.345368,
  },
  {
    town: 'Sopřeč',
    townCode: 575666,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.093704,
    long: 15.556821,
  },
  {
    town: 'Sosnová',
    townCode: 562076,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47001,
    lat: 50.655151,
    long: 14.532396,
  },
  {
    town: 'Sosnová',
    townCode: 597821,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79312,
    lat: 49.998741,
    long: 17.663121,
  },
  {
    town: 'Souňov',
    townCode: 531065,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.880122,
    long: 15.315664,
  },
  {
    town: 'Sousedovice',
    townCode: 551759,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.232155,
    long: 13.868628,
  },
  {
    town: 'Soutice',
    townCode: 599387,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25771,
    lat: 49.726208,
    long: 15.053023,
  },
  {
    town: 'Sovětice',
    townCode: 570907,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.307552,
    long: 15.705857,
  },
  {
    town: 'Sovínky',
    townCode: 565539,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29429,
    lat: 50.373175,
    long: 14.787182,
  },
  {
    town: 'Sovolusky',
    townCode: 573027,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.969347,
    long: 15.5373,
  },
  {
    town: 'Spálené Poříčí',
    townCode: 558362,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33561,
    lat: 49.613815,
    long: 13.605669,
  },
  {
    town: 'Spálov',
    townCode: 599867,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74237,
    lat: 49.704203,
    long: 17.722514,
  },
  {
    town: 'Spáňov',
    townCode: 554251,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.414624,
    long: 12.987415,
  },
  {
    town: 'Spělkov',
    townCode: 596795,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59203,
    lat: 49.674861,
    long: 16.161048,
  },
  {
    town: 'Spešov',
    townCode: 556963,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67902,
    lat: 49.394891,
    long: 16.629388,
  },
  {
    town: 'Spojil',
    townCode: 574198,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.042269,
    long: 15.822517,
  },
  {
    town: 'Spomyšl',
    townCode: 535192,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27705,
    lat: 50.33553,
    long: 14.360631,
  },
  {
    town: 'Spořice',
    townCode: 563340,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43101,
    lat: 50.44104,
    long: 13.391931,
  },
  {
    town: 'Spytihněv',
    townCode: 585793,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76364,
    lat: 49.141251,
    long: 17.498191,
  },
  {
    town: 'Srbce',
    townCode: 590045,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79827,
    lat: 49.30241,
    long: 17.229132,
  },
  {
    town: 'Srbeč',
    townCode: 542431,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27065,
    lat: 50.224713,
    long: 13.883458,
  },
  {
    town: 'Srbice',
    townCode: 554260,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.508409,
    long: 13.118703,
  },
  {
    town: 'Srbice',
    townCode: 567833,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.660759,
    long: 13.869399,
  },
  {
    town: 'Srbská Kamenice',
    townCode: 546348,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40715,
    lat: 50.820458,
    long: 14.352834,
  },
  {
    town: 'Srbsko',
    townCode: 531758,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26718,
    lat: 49.937271,
    long: 14.136025,
  },
  {
    town: 'Srby',
    townCode: 554278,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.536976,
    long: 12.868429,
  },
  {
    town: 'Srby',
    townCode: 540676,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.519054,
    long: 13.603397,
  },
  {
    town: 'Srch',
    townCode: 575682,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53352,
    lat: 50.084994,
    long: 15.763532,
  },
  {
    town: 'Srní',
    townCode: 557111,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34192,
    lat: 49.087292,
    long: 13.480548,
  },
  {
    town: 'Srnín',
    townCode: 536245,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38101,
    lat: 48.845115,
    long: 14.343803,
  },
  {
    town: 'Srnojedy',
    townCode: 553719,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.039211,
    long: 15.702721,
  },
  {
    town: 'Srubec',
    townCode: 545066,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37006,
    lat: 48.948161,
    long: 14.541407,
  },
  {
    town: 'Sruby',
    townCode: 580970,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56544,
    lat: 49.996975,
    long: 16.174354,
  },
  {
    town: 'Stádlec',
    townCode: 553140,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39162,
    lat: 49.3797,
    long: 14.495169,
  },
  {
    town: 'Stachy',
    townCode: 550515,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38473,
    lat: 49.1019,
    long: 13.666687,
  },
  {
    town: 'Stáj',
    townCode: 587915,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.458085,
    long: 15.803502,
  },
  {
    town: 'Stálky',
    townCode: 594792,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67106,
    lat: 48.870226,
    long: 15.684781,
  },
  {
    town: 'Staňkov',
    townCode: 562378,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37806,
    lat: 48.979627,
    long: 14.952798,
  },
  {
    town: 'Staňkov',
    townCode: 554294,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34561,
    lat: 49.553835,
    long: 13.06931,
  },
  {
    town: 'Staňkovice',
    townCode: 534412,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.875486,
    long: 15.015192,
  },
  {
    town: 'Staňkovice',
    townCode: 546828,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.589503,
    long: 14.167132,
  },
  {
    town: 'Staňkovice',
    townCode: 543128,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43949,
    lat: 50.349927,
    long: 13.571151,
  },
  {
    town: 'Stanovice',
    townCode: 555550,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36001,
    lat: 50.165217,
    long: 12.874064,
  },
  {
    town: 'Stanovice',
    townCode: 548812,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.400709,
    long: 15.871501,
  },
  {
    town: 'Stanoviště',
    townCode: 583901,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.239197,
    long: 16.253595,
  },
  {
    town: 'Stará Červená Voda',
    townCode: 541036,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79053,
    lat: 50.329431,
    long: 17.201256,
  },
  {
    town: 'Stará Huť',
    townCode: 541338,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26202,
    lat: 49.782357,
    long: 14.197461,
  },
  {
    town: 'Stará Lysá',
    townCode: 537837,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28926,
    lat: 50.224749,
    long: 14.799247,
  },
  {
    town: 'Stará Paka',
    townCode: 573507,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50791,
    lat: 50.510424,
    long: 15.49455,
  },
  {
    town: 'Stará Říše',
    townCode: 587923,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58867,
    lat: 49.179652,
    long: 15.594868,
  },
  {
    town: 'Stará Ves',
    townCode: 551911,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79501,
    lat: 49.958482,
    long: 17.236572,
  },
  {
    town: 'Stará Ves',
    townCode: 517887,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75002,
    lat: 49.378741,
    long: 17.488182,
  },
  {
    town: 'Stará Ves nad Ondřejnicí',
    townCode: 598739,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73923,
    lat: 49.727472,
    long: 18.193435,
  },
  {
    town: 'Stará Voda',
    townCode: 539112,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.991631,
    long: 12.59591,
  },
  {
    town: 'Stará Voda',
    townCode: 570915,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50351,
    lat: 50.150422,
    long: 15.530668,
  },
  {
    town: 'Staré Bříště',
    townCode: 561843,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.490839,
    long: 15.362636,
  },
  {
    town: 'Staré Buky',
    townCode: 579661,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54101,
    lat: 50.532161,
    long: 15.859366,
  },
  {
    town: 'Staré Hamry',
    townCode: 598747,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73915,
    lat: 49.472486,
    long: 18.44589,
  },
  {
    town: 'Staré Heřminovy',
    townCode: 551813,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79312,
    lat: 49.933251,
    long: 17.625765,
  },
  {
    town: 'Staré Hobzí',
    townCode: 547204,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37871,
    lat: 49.010499,
    long: 15.453308,
  },
  {
    town: 'Staré Hodějovice',
    townCode: 545074,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37008,
    lat: 48.945486,
    long: 14.521073,
  },
  {
    town: 'Staré Hradiště',
    townCode: 575704,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53352,
    lat: 50.065498,
    long: 15.778951,
  },
  {
    town: 'Staré Hrady',
    townCode: 530735,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.386111,
    long: 15.213064,
  },
  {
    town: 'Staré Hutě',
    townCode: 592587,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68601,
    lat: 49.129212,
    long: 17.277842,
  },
  {
    town: 'Staré Jesenčany',
    townCode: 575712,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.000581,
    long: 15.754182,
  },
  {
    town: 'Staré Křečany',
    townCode: 562823,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40761,
    lat: 50.950546,
    long: 14.496283,
  },
  {
    town: 'Staré Město',
    townCode: 551767,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 50.003657,
    long: 17.432173,
  },
  {
    town: 'Staré Město',
    townCode: 552551,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73801,
    lat: 49.670019,
    long: 18.363604,
  },
  {
    town: 'Staré Město',
    townCode: 541079,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78832,
    lat: 50.161832,
    long: 16.947446,
  },
  {
    town: 'Staré Město',
    townCode: 578789,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56932,
    lat: 49.794091,
    long: 16.675033,
  },
  {
    town: 'Staré Město',
    townCode: 550752,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68603,
    lat: 49.075248,
    long: 17.433488,
  },
  {
    town: 'Staré Město pod Landštejnem',
    townCode: 547212,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37882,
    lat: 49.00345,
    long: 15.254229,
  },
  {
    town: 'Staré Místo',
    townCode: 549096,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.40511,
    long: 15.342338,
  },
  {
    town: 'Staré Sedliště',
    townCode: 561185,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34801,
    lat: 49.744446,
    long: 12.694252,
  },
  {
    town: 'Staré Sedlo',
    townCode: 560642,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.181807,
    long: 12.719941,
  },
  {
    town: 'Staré Sedlo',
    townCode: 561193,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34802,
    lat: 49.666003,
    long: 12.863729,
  },
  {
    town: 'Staré Smrkovice',
    townCode: 573523,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.336688,
    long: 15.494647,
  },
  {
    town: 'Staré Těchanovice',
    townCode: 568198,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74901,
    lat: 49.81838,
    long: 17.692077,
  },
  {
    town: 'Staré Ždánice',
    townCode: 575721,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53344,
    lat: 50.124004,
    long: 15.720737,
  },
  {
    town: 'Starkoč',
    townCode: 530875,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.937353,
    long: 15.507667,
  },
  {
    town: 'Stárkov',
    townCode: 574465,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54936,
    lat: 50.534022,
    long: 16.158279,
  },
  {
    town: 'Starosedlský Hrádek',
    townCode: 564583,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.57629,
    long: 14.008329,
  },
  {
    town: 'Starovice',
    townCode: 584894,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69301,
    lat: 48.951684,
    long: 16.706715,
  },
  {
    town: 'Starovičky',
    townCode: 584908,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69301,
    lat: 48.907566,
    long: 16.775476,
  },
  {
    town: 'Starý Bydžov',
    townCode: 573132,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50357,
    lat: 50.25854,
    long: 15.452434,
  },
  {
    town: 'Starý Hrozenkov',
    townCode: 592609,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68774,
    lat: 48.965972,
    long: 17.86312,
  },
  {
    town: 'Starý Jičín',
    townCode: 599905,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74231,
    lat: 49.576961,
    long: 17.961801,
  },
  {
    town: 'Starý Kolín',
    townCode: 533700,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28123,
    lat: 50.009872,
    long: 15.293985,
  },
  {
    town: 'Starý Mateřov',
    townCode: 575739,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 50.001737,
    long: 15.71522,
  },
  {
    town: 'Starý Petřín',
    townCode: 594806,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67106,
    lat: 48.890137,
    long: 15.734188,
  },
  {
    town: 'Starý Plzenec',
    townCode: 558371,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33202,
    lat: 49.697786,
    long: 13.47361,
  },
  {
    town: 'Starý Poddvorov',
    townCode: 586561,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69616,
    lat: 48.878704,
    long: 16.981633,
  },
  {
    town: 'Starý Šachov',
    townCode: 545538,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.715168,
    long: 14.360479,
  },
  {
    town: 'Starý Vestec',
    townCode: 534889,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28916,
    lat: 50.144821,
    long: 14.846456,
  },
  {
    town: 'Stařeč',
    townCode: 591742,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67522,
    lat: 49.19793,
    long: 15.828017,
  },
  {
    town: 'Stařechovice',
    townCode: 590053,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79841,
    lat: 49.532985,
    long: 17.053825,
  },
  {
    town: 'Staříč',
    townCode: 552569,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73943,
    lat: 49.686041,
    long: 18.272916,
  },
  {
    town: 'Stašov',
    townCode: 578801,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.674979,
    long: 16.369023,
  },
  {
    town: 'Stašov',
    townCode: 531766,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.883446,
    long: 13.95763,
  },
  {
    town: 'Statenice',
    townCode: 539686,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25262,
    lat: 50.142677,
    long: 14.318642,
  },
  {
    town: 'Stavenice',
    townCode: 570281,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78973,
    lat: 49.786942,
    long: 16.973733,
  },
  {
    town: 'Stavěšice',
    townCode: 586579,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69638,
    lat: 49.001739,
    long: 17.030565,
  },
  {
    town: 'Stéblová',
    townCode: 572934,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53345,
    lat: 50.092124,
    long: 15.746276,
  },
  {
    town: 'Stebno',
    townCode: 546925,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.615203,
    long: 14.01732,
  },
  {
    town: 'Stěbořice',
    townCode: 510343,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74751,
    lat: 49.937181,
    long: 17.805574,
  },
  {
    town: 'Stehelčeves',
    townCode: 532851,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27342,
    lat: 50.171748,
    long: 14.190956,
  },
  {
    town: 'Stehlovice',
    townCode: 529885,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.393498,
    long: 14.322986,
  },
  {
    town: 'Stěžery',
    townCode: 570931,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50321,
    lat: 50.215821,
    long: 15.748412,
  },
  {
    town: 'Stínava',
    townCode: 590061,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79803,
    lat: 49.495308,
    long: 16.934611,
  },
  {
    town: 'Stod',
    townCode: 558389,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.639199,
    long: 13.164846,
  },
  {
    town: 'Stochov',
    townCode: 532860,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27303,
    lat: 50.146411,
    long: 13.96356,
  },
  {
    town: 'Stojčín',
    townCode: 561452,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39468,
    lat: 49.237781,
    long: 15.222001,
  },
  {
    town: 'Stojice',
    townCode: 575755,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.956461,
    long: 15.614128,
  },
  {
    town: 'Stolany',
    townCode: 547891,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.9279,
    long: 15.745214,
  },
  {
    town: 'Stonařov',
    townCode: 587931,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58833,
    lat: 49.282212,
    long: 15.585729,
  },
  {
    town: 'Stonava',
    townCode: 599140,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73534,
    lat: 49.817011,
    long: 18.525286,
  },
  {
    town: 'Stošíkovice na Louce',
    townCode: 594814,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.896689,
    long: 16.214975,
  },
  {
    town: 'Stožec',
    townCode: 550523,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38444,
    lat: 48.859471,
    long: 13.821516,
  },
  {
    town: 'Stožice',
    townCode: 530034,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.132595,
    long: 14.150308,
  },
  {
    town: 'Stračov',
    townCode: 570958,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50314,
    lat: 50.301628,
    long: 15.64079,
  },
  {
    town: 'Stradonice',
    townCode: 599441,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27371,
    lat: 50.291461,
    long: 14.047036,
  },
  {
    town: 'Stradouň',
    townCode: 572306,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53863,
    lat: 49.97246,
    long: 16.065657,
  },
  {
    town: 'Strahovice',
    townCode: 512869,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74724,
    lat: 50.002181,
    long: 18.087213,
  },
  {
    town: 'Strachoňovice',
    townCode: 587940,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.135205,
    long: 15.488129,
  },
  {
    town: 'Strachotice',
    townCode: 594822,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67129,
    lat: 48.796236,
    long: 16.1724,
  },
  {
    town: 'Strachotín',
    townCode: 584916,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69301,
    lat: 48.905517,
    long: 16.651453,
  },
  {
    town: 'Strachujov',
    townCode: 596809,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59242,
    lat: 49.613204,
    long: 16.226861,
  },
  {
    town: 'Strakonice',
    townCode: 550787,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.260504,
    long: 13.910408,
  },
  {
    town: 'Strakov',
    townCode: 578819,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.866605,
    long: 16.366914,
  },
  {
    town: 'Straky',
    townCode: 537853,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28925,
    lat: 50.23368,
    long: 14.959345,
  },
  {
    town: 'Strančice',
    townCode: 538809,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25163,
    lat: 49.948217,
    long: 14.677553,
  },
  {
    town: 'Stránecká Zhoř',
    townCode: 596817,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59442,
    lat: 49.380122,
    long: 15.927483,
  },
  {
    town: 'Strání',
    townCode: 592617,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68765,
    lat: 48.902257,
    long: 17.706822,
  },
  {
    town: 'Stránka',
    townCode: 531731,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27735,
    lat: 50.423083,
    long: 14.661242,
  },
  {
    town: 'Stranný',
    townCode: 599379,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25756,
    lat: 49.753854,
    long: 14.494082,
  },
  {
    town: 'Strašice',
    townCode: 551775,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.202554,
    long: 13.729712,
  },
  {
    town: 'Strašice',
    townCode: 560162,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33845,
    lat: 49.735624,
    long: 13.757656,
  },
  {
    town: 'Strašín',
    townCode: 557129,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.179345,
    long: 13.640501,
  },
  {
    town: 'Straškov-Vodochody',
    townCode: 565679,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41184,
    lat: 50.363689,
    long: 14.249643,
  },
  {
    town: 'Strašnov',
    townCode: 536709,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29431,
    lat: 50.351613,
    long: 14.889289,
  },
  {
    town: 'Strašov',
    townCode: 575763,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.087564,
    long: 15.522806,
  },
  {
    town: 'Stratov',
    townCode: 537861,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28922,
    lat: 50.19305,
    long: 14.90991,
  },
  {
    town: 'Stráž',
    townCode: 554316,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.414854,
    long: 12.913028,
  },
  {
    town: 'Stráž',
    townCode: 561207,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34802,
    lat: 49.668894,
    long: 12.775569,
  },
  {
    town: 'Stráž nad Nežárkou',
    townCode: 547221,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37802,
    lat: 49.069814,
    long: 14.905614,
  },
  {
    town: 'Stráž nad Nisou',
    townCode: 544477,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46303,
    lat: 50.791093,
    long: 15.026936,
  },
  {
    town: 'Stráž nad Ohří',
    townCode: 555584,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36301,
    lat: 50.337331,
    long: 13.051067,
  },
  {
    town: 'Stráž pod Ralskem',
    townCode: 562092,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47127,
    lat: 50.702903,
    long: 14.801127,
  },
  {
    town: 'Strážek',
    townCode: 596825,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59253,
    lat: 49.440836,
    long: 16.193422,
  },
  {
    town: 'Stražisko',
    townCode: 590070,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79844,
    lat: 49.543242,
    long: 16.930233,
  },
  {
    town: 'Strážiště',
    townCode: 571881,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29413,
    lat: 50.592452,
    long: 14.929303,
  },
  {
    town: 'Strážkovice',
    townCode: 545082,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.899683,
    long: 14.569486,
  },
  {
    town: 'Strážná',
    townCode: 580988,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.911309,
    long: 16.71062,
  },
  {
    town: 'Strážné',
    townCode: 579696,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54352,
    lat: 50.663681,
    long: 15.615183,
  },
  {
    town: 'Strážnice',
    townCode: 586587,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69662,
    lat: 48.901117,
    long: 17.31691,
  },
  {
    town: 'Strážný',
    townCode: 550531,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38443,
    lat: 48.908412,
    long: 13.720476,
  },
  {
    town: 'Strážov',
    townCode: 557137,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.30337,
    long: 13.246341,
  },
  {
    town: 'Strážovice',
    townCode: 586595,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69638,
    lat: 49.009307,
    long: 17.047511,
  },
  {
    town: 'Strenice',
    townCode: 536717,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29430,
    lat: 50.392653,
    long: 14.82316,
  },
  {
    town: 'Strhaře',
    townCode: 582379,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.435714,
    long: 16.436401,
  },
  {
    town: 'Strmilov',
    townCode: 547239,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.158567,
    long: 15.199439,
  },
  {
    town: 'Strojetice',
    townCode: 599361,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25765,
    lat: 49.651638,
    long: 15.066126,
  },
  {
    town: 'Stropešín',
    townCode: 587460,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67555,
    lat: 49.154144,
    long: 16.077352,
  },
  {
    town: 'Struhařov',
    townCode: 530689,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.765636,
    long: 14.762317,
  },
  {
    town: 'Struhařov',
    townCode: 538825,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25164,
    lat: 49.952026,
    long: 14.74454,
  },
  {
    town: 'Strukov',
    townCode: 569054,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78401,
    lat: 49.733438,
    long: 17.175596,
  },
  {
    town: 'Strunkovice nad Blanicí',
    townCode: 550540,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38426,
    lat: 49.084131,
    long: 14.055317,
  },
  {
    town: 'Strunkovice nad Volyňkou',
    townCode: 536784,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.2086,
    long: 13.889431,
  },
  {
    town: 'Strupčice',
    townCode: 563358,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43114,
    lat: 50.471126,
    long: 13.530649,
  },
  {
    town: 'Stružinec',
    townCode: 577545,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51251,
    lat: 50.550949,
    long: 15.358086,
  },
  {
    town: 'Stružná',
    townCode: 555592,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36471,
    lat: 50.183216,
    long: 13.005785,
  },
  {
    town: 'Stružnice',
    townCode: 562106,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47002,
    lat: 50.696974,
    long: 14.450096,
  },
  {
    town: 'Strýčice1)',
    townCode: 536032,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.011922,
    long: 14.266127,
  },
  {
    town: 'Středokluky',
    townCode: 539708,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25268,
    lat: 50.132287,
    long: 14.234301,
  },
  {
    town: 'Střelice',
    townCode: 583910,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66447,
    lat: 49.152312,
    long: 16.50409,
  },
  {
    town: 'Střelice',
    townCode: 594831,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.994181,
    long: 15.983267,
  },
  {
    town: 'Střelice',
    townCode: 540056,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.630615,
    long: 13.134702,
  },
  {
    town: 'Střelná',
    townCode: 544914,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75612,
    lat: 49.177303,
    long: 18.097917,
  },
  {
    town: 'Střelské Hoštice',
    townCode: 551791,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38715,
    lat: 49.297703,
    long: 13.75606,
  },
  {
    town: 'Střemošice',
    townCode: 572314,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53854,
    lat: 49.89166,
    long: 16.072158,
  },
  {
    town: 'Střemy',
    townCode: 535214,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27734,
    lat: 50.384262,
    long: 14.565624,
  },
  {
    town: 'Střeň',
    townCode: 547018,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78332,
    lat: 49.69162,
    long: 17.153923,
  },
  {
    town: 'Střevač',
    townCode: 573540,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50722,
    lat: 50.404458,
    long: 15.274587,
  },
  {
    town: 'Střezetice',
    townCode: 570966,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50312,
    lat: 50.258368,
    long: 15.718242,
  },
  {
    town: 'Střezimíř',
    townCode: 530701,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25787,
    lat: 49.532109,
    long: 14.611434,
  },
  {
    town: 'Stříbrná',
    townCode: 560651,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35801,
    lat: 50.356766,
    long: 12.526519,
  },
  {
    town: 'Stříbrná Skalice',
    townCode: 533718,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28167,
    lat: 49.897765,
    long: 14.846268,
  },
  {
    town: 'Stříbrné Hory',
    townCode: 569534,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.601344,
    long: 15.691053,
  },
  {
    town: 'Stříbrnice',
    townCode: 552887,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75201,
    lat: 49.328553,
    long: 17.24617,
  },
  {
    town: 'Stříbrnice',
    townCode: 592625,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68709,
    lat: 49.05671,
    long: 17.307593,
  },
  {
    town: 'Stříbro',
    townCode: 561215,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.753048,
    long: 13.004203,
  },
  {
    town: 'Stříbřec',
    townCode: 547247,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37818,
    lat: 49.029989,
    long: 14.878351,
  },
  {
    town: 'Střílky',
    townCode: 589039,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76804,
    lat: 49.142634,
    long: 17.211177,
  },
  {
    town: 'Střítež',
    townCode: 551538,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.775738,
    long: 14.434542,
  },
  {
    town: 'Střítež',
    townCode: 587958,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58811,
    lat: 49.443643,
    long: 15.598749,
  },
  {
    town: 'Střítež',
    townCode: 537594,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.364014,
    long: 15.126619,
  },
  {
    town: 'Střítež',
    townCode: 554871,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67401,
    lat: 49.191417,
    long: 15.893355,
  },
  {
    town: 'Střítež',
    townCode: 549886,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59251,
    lat: 49.440602,
    long: 16.256802,
  },
  {
    town: 'Střítež',
    townCode: 552674,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73959,
    lat: 49.67941,
    long: 18.569214,
  },
  {
    town: 'Střítež nad Bečvou',
    townCode: 544922,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75652,
    lat: 49.458663,
    long: 18.056978,
  },
  {
    town: 'Střítež nad Ludinou',
    townCode: 517909,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75363,
    lat: 49.609436,
    long: 17.739016,
  },
  {
    town: 'Střítež pod Křemešníkem',
    townCode: 561487,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.434133,
    long: 15.320258,
  },
  {
    town: 'Střížov',
    townCode: 545091,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.890503,
    long: 14.527777,
  },
  {
    town: 'Střížovice',
    townCode: 508152,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.140007,
    long: 15.156956,
  },
  {
    town: 'Střížovice',
    townCode: 558401,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33207,
    lat: 49.611889,
    long: 13.458498,
  },
  {
    town: 'Střížovice',
    townCode: 589047,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.257184,
    long: 17.449702,
  },
  {
    town: 'Studánka',
    townCode: 561223,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.780682,
    long: 12.603786,
  },
  {
    town: 'Studená',
    townCode: 547263,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37856,
    lat: 49.185258,
    long: 15.286981,
  },
  {
    town: 'Studená',
    townCode: 553603,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.960729,
    long: 13.643134,
  },
  {
    town: 'Studené',
    townCode: 580996,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56164,
    lat: 50.066658,
    long: 16.589294,
  },
  {
    town: 'Studenec',
    townCode: 591769,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67502,
    lat: 49.20022,
    long: 16.064912,
  },
  {
    town: 'Studenec',
    townCode: 577553,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51233,
    lat: 50.553543,
    long: 15.54947,
  },
  {
    town: 'Studeněves',
    townCode: 551457,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27379,
    lat: 50.224222,
    long: 14.044495,
  },
  {
    town: 'Studénka',
    townCode: 599921,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74213,
    lat: 49.723516,
    long: 18.078634,
  },
  {
    town: 'Studený',
    townCode: 530719,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.607512,
    long: 15.127817,
  },
  {
    town: 'Studnice',
    townCode: 593605,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68308,
    lat: 49.375694,
    long: 16.881134,
  },
  {
    town: 'Studnice',
    townCode: 591777,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.291088,
    long: 16.029048,
  },
  {
    town: 'Studnice',
    townCode: 574481,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54948,
    lat: 50.421368,
    long: 16.089978,
  },
  {
    town: 'Studnice',
    townCode: 572322,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.738058,
    long: 15.90302,
  },
  {
    town: 'Stupava',
    townCode: 592633,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68601,
    lat: 49.117266,
    long: 17.248767,
  },
  {
    town: 'Stvolínky',
    townCode: 562114,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47102,
    lat: 50.632379,
    long: 14.428717,
  },
  {
    town: 'Stvolová',
    townCode: 582620,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67961,
    lat: 49.589318,
    long: 16.540541,
  },
  {
    town: 'Sudějov',
    townCode: 531391,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.860798,
    long: 15.103948,
  },
  {
    town: 'Sudice',
    townCode: 582395,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.53,
    long: 16.668628,
  },
  {
    town: 'Sudice',
    townCode: 591785,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67573,
    lat: 49.181993,
    long: 16.238291,
  },
  {
    town: 'Sudice',
    townCode: 510378,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74725,
    lat: 50.031637,
    long: 18.068504,
  },
  {
    town: 'Sudislav nad Orlicí',
    townCode: 581003,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 49.989392,
    long: 16.313242,
  },
  {
    town: 'Sudkov',
    townCode: 541109,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78821,
    lat: 49.919123,
    long: 16.945268,
  },
  {
    town: 'Sudoměř',
    townCode: 565920,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29425,
    lat: 50.445088,
    long: 14.739481,
  },
  {
    town: 'Sudoměřice',
    townCode: 586609,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69666,
    lat: 48.867328,
    long: 17.256869,
  },
  {
    town: 'Sudoměřice u Bechyně',
    townCode: 553166,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39172,
    lat: 49.289825,
    long: 14.538534,
  },
  {
    town: 'Sudoměřice u Tábora',
    townCode: 553174,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39136,
    lat: 49.510295,
    long: 14.658595,
  },
  {
    town: 'Sudovo Hlavno',
    townCode: 571954,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29476,
    lat: 50.262851,
    long: 14.685423,
  },
  {
    town: 'Sudslava',
    townCode: 581011,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56113,
    lat: 50.040677,
    long: 16.286549,
  },
  {
    town: 'Suchá',
    townCode: 587982,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58833,
    lat: 49.301108,
    long: 15.577541,
  },
  {
    town: 'Suchá Lhota',
    townCode: 578835,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.877328,
    long: 16.173642,
  },
  {
    town: 'Suchá Loz',
    townCode: 592641,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68753,
    lat: 48.970109,
    long: 17.713899,
  },
  {
    town: 'Suchdol',
    townCode: 590088,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79845,
    lat: 49.547269,
    long: 16.896773,
  },
  {
    town: 'Suchdol',
    townCode: 534439,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28502,
    lat: 49.95257,
    long: 15.166616,
  },
  {
    town: 'Suchdol nad Lužnicí',
    townCode: 547280,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37806,
    lat: 48.893435,
    long: 14.877056,
  },
  {
    town: 'Suchdol nad Odrou',
    townCode: 599930,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74201,
    lat: 49.65582,
    long: 17.928263,
  },
  {
    town: 'Suchodol',
    townCode: 541371,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.724148,
    long: 14.082522,
  },
  {
    town: 'Suchohrdly',
    townCode: 555231,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.866218,
    long: 16.089121,
  },
  {
    town: 'Suchohrdly u Miroslavi',
    townCode: 594849,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67172,
    lat: 48.943156,
    long: 16.363302,
  },
  {
    town: 'Suchomasty',
    townCode: 531782,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26722,
    lat: 49.895459,
    long: 14.056714,
  },
  {
    town: 'Suchonice',
    townCode: 569771,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78357,
    lat: 49.527138,
    long: 17.382014,
  },
  {
    town: 'Suchov',
    townCode: 586617,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69671,
    lat: 48.907522,
    long: 17.563562,
  },
  {
    town: 'Suchovršice',
    townCode: 579726,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54232,
    lat: 50.523502,
    long: 15.99831,
  },
  {
    town: 'Suchý',
    townCode: 582409,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.482895,
    long: 16.762483,
  },
  {
    town: 'Suchý Důl',
    townCode: 574490,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54962,
    lat: 50.540173,
    long: 16.265476,
  },
  {
    town: 'Sukorady',
    townCode: 548880,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.325546,
    long: 15.582808,
  },
  {
    town: 'Sukorady',
    townCode: 536768,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29406,
    lat: 50.426341,
    long: 15.029101,
  },
  {
    town: 'Sulejovice',
    townCode: 565695,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41111,
    lat: 50.498891,
    long: 14.037519,
  },
  {
    town: 'Sulice',
    townCode: 538833,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25168,
    lat: 49.925727,
    long: 14.556739,
  },
  {
    town: 'Sulíkov',
    townCode: 582417,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.544691,
    long: 16.489716,
  },
  {
    town: 'Sulimov',
    townCode: 589055,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.226782,
    long: 17.422982,
  },
  {
    town: 'Sulislav',
    townCode: 561231,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.748658,
    long: 13.072824,
  },
  {
    town: 'Sulkovec',
    townCode: 596833,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.60943,
    long: 16.309674,
  },
  {
    town: 'Supíkovice',
    townCode: 541117,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79051,
    lat: 50.297785,
    long: 17.255253,
  },
  {
    town: 'Sušice',
    townCode: 518026,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75111,
    lat: 49.486027,
    long: 17.537486,
  },
  {
    town: 'Sušice',
    townCode: 557153,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.231776,
    long: 13.520509,
  },
  {
    town: 'Sušice',
    townCode: 592650,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68704,
    lat: 49.122346,
    long: 17.452331,
  },
  {
    town: 'Svárov',
    townCode: 599433,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.062028,
    long: 14.15064,
  },
  {
    town: 'Svárov',
    townCode: 592668,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.116539,
    long: 17.62464,
  },
  {
    town: 'Svatá',
    townCode: 531791,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.939239,
    long: 13.961726,
  },
  {
    town: 'Svatá Maří',
    townCode: 550558,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38501,
    lat: 49.064631,
    long: 13.831531,
  },
  {
    town: 'Svatava',
    townCode: 538434,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35703,
    lat: 50.192341,
    long: 12.625358,
  },
  {
    town: 'Svaté Pole',
    townCode: 541389,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.751419,
    long: 14.169084,
  },
  {
    town: 'Svatobořice-Mistřín',
    townCode: 586625,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69604,
    lat: 48.977127,
    long: 17.089396,
  },
  {
    town: 'Svatojanský Újezd',
    townCode: 573302,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50781,
    lat: 50.42605,
    long: 15.543039,
  },
  {
    town: 'Svatoňovice',
    townCode: 547131,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74787,
    lat: 49.793607,
    long: 17.667329,
  },
  {
    town: 'Svatoslav',
    townCode: 583928,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.30187,
    long: 16.308896,
  },
  {
    town: 'Svatoslav',
    townCode: 591793,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67507,
    lat: 49.31921,
    long: 15.848599,
  },
  {
    town: 'Svatý Jan',
    townCode: 541397,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26256,
    lat: 49.636938,
    long: 14.311096,
  },
  {
    town: 'Svatý Jan nad Malší',
    townCode: 545104,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37323,
    lat: 48.824139,
    long: 14.508621,
  },
  {
    town: 'Svatý Jan pod Skalou',
    townCode: 531804,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 49.969011,
    long: 14.133272,
  },
  {
    town: 'Svatý Jiří',
    townCode: 580708,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 49.972104,
    long: 16.270429,
  },
  {
    town: 'Svatý Mikuláš',
    townCode: 534196,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.991014,
    long: 15.350597,
  },
  {
    town: 'Svébohov',
    townCode: 541125,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.92004,
    long: 16.839277,
  },
  {
    town: 'Svémyslice',
    townCode: 598305,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25091,
    lat: 50.146005,
    long: 14.648214,
  },
  {
    town: 'Svépravice',
    townCode: 598763,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.495694,
    long: 15.232792,
  },
  {
    town: 'Svéradice',
    townCode: 557161,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.371445,
    long: 13.739694,
  },
  {
    town: 'Svésedlice',
    townCode: 552429,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78354,
    lat: 49.572579,
    long: 17.381252,
  },
  {
    town: 'Světce',
    townCode: 561029,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.270655,
    long: 14.941505,
  },
  {
    town: 'Světec',
    townCode: 567841,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41753,
    lat: 50.576236,
    long: 13.811707,
  },
  {
    town: 'Světí',
    townCode: 548154,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50312,
    lat: 50.257478,
    long: 15.775579,
  },
  {
    town: 'Světice',
    townCode: 538841,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.970179,
    long: 14.665911,
  },
  {
    town: 'Světlá',
    townCode: 586064,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67963,
    lat: 49.565958,
    long: 16.718297,
  },
  {
    town: 'Světlá Hora',
    townCode: 597872,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79331,
    lat: 50.046192,
    long: 17.399982,
  },
  {
    town: 'Světlá nad Sázavou',
    townCode: 569569,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.66811,
    long: 15.404038,
  },
  {
    town: 'Světlá pod Ještědem',
    townCode: 564427,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46343,
    lat: 50.711344,
    long: 14.986005,
  },
  {
    town: 'Světlík',
    townCode: 545813,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38216,
    lat: 48.731761,
    long: 14.21107,
  },
  {
    town: 'Světnov',
    townCode: 596841,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59102,
    lat: 49.620631,
    long: 15.955318,
  },
  {
    town: 'Sviadnov',
    townCode: 569631,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73925,
    lat: 49.689354,
    long: 18.327726,
  },
  {
    town: 'Svídnice',
    townCode: 548693,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.086151,
    long: 16.223384,
  },
  {
    town: 'Svídnice',
    townCode: 572331,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53824,
    lat: 49.890007,
    long: 15.813804,
  },
  {
    town: 'Svijanský Újezd',
    townCode: 564435,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46345,
    lat: 50.587332,
    long: 15.043456,
  },
  {
    town: 'Svijany',
    townCode: 564443,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46346,
    lat: 50.572684,
    long: 15.063976,
  },
  {
    town: 'Svinaře',
    townCode: 531812,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26728,
    lat: 49.891728,
    long: 14.1844,
  },
  {
    town: 'Svinařov',
    townCode: 532908,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27305,
    lat: 50.181412,
    long: 14.050377,
  },
  {
    town: 'Svinčany',
    townCode: 575771,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.976687,
    long: 15.639615,
  },
  {
    town: 'Svinošice',
    townCode: 582433,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.334534,
    long: 16.576,
  },
  {
    town: 'Sviny',
    townCode: 553182,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.187242,
    long: 14.63601,
  },
  {
    town: 'Sviny',
    townCode: 596850,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59451,
    lat: 49.364289,
    long: 16.085112,
  },
  {
    town: 'Svitávka',
    townCode: 582441,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67932,
    lat: 49.501876,
    long: 16.598037,
  },
  {
    town: 'Svitavy',
    townCode: 577731,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56802,
    lat: 49.755263,
    long: 16.469286,
  },
  {
    town: 'Svoboda nad Úpou',
    townCode: 579734,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54224,
    lat: 50.626061,
    long: 15.816588,
  },
  {
    town: 'Svobodné Heřmanice',
    townCode: 597881,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79313,
    lat: 49.946147,
    long: 17.674365,
  },
  {
    town: 'Svojanov',
    townCode: 578843,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56973,
    lat: 49.624723,
    long: 16.410306,
  },
  {
    town: 'Svojek',
    townCode: 577561,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 50791,
    lat: 50.553516,
    long: 15.455663,
  },
  {
    town: 'Svojetice',
    townCode: 538850,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25162,
    lat: 49.971526,
    long: 14.7386,
  },
  {
    town: 'Svojetín',
    townCode: 542458,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27004,
    lat: 50.190121,
    long: 13.621021,
  },
  {
    town: 'Svojkov',
    townCode: 546283,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47153,
    lat: 50.719575,
    long: 14.599127,
  },
  {
    town: 'Svojkovice',
    townCode: 587991,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.166246,
    long: 15.635608,
  },
  {
    town: 'Svojkovice',
    townCode: 541176,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33822,
    lat: 49.759974,
    long: 13.648336,
  },
  {
    town: 'Svojšice',
    townCode: 575780,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53362,
    lat: 49.965437,
    long: 15.601078,
  },
  {
    town: 'Svojšice',
    townCode: 533726,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28107,
    lat: 50.003239,
    long: 15.043205,
  },
  {
    town: 'Svojšice',
    townCode: 564273,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.572827,
    long: 14.042977,
  },
  {
    town: 'Svojšín',
    townCode: 561258,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.766164,
    long: 12.910779,
  },
  {
    town: 'Svor',
    townCode: 562131,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47151,
    lat: 50.7919,
    long: 14.596917,
  },
  {
    town: 'Svrabov',
    townCode: 563170,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39131,
    lat: 49.447575,
    long: 14.626643,
  },
  {
    town: 'Svratka',
    townCode: 596868,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59202,
    lat: 49.710763,
    long: 16.032241,
  },
  {
    town: 'Svratouch',
    townCode: 572349,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53942,
    lat: 49.72454,
    long: 16.034289,
  },
  {
    town: 'Svrkyně',
    townCode: 571342,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25264,
    lat: 50.171469,
    long: 14.294955,
  },
  {
    town: 'Sychrov',
    townCode: 564451,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46344,
    lat: 50.626916,
    long: 15.088809,
  },
  {
    town: 'Sýkořice',
    townCode: 542466,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27024,
    lat: 50.034689,
    long: 13.931831,
  },
  {
    town: 'Synalov',
    townCode: 582450,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.432831,
    long: 16.413973,
  },
  {
    town: 'Synkov-Slemeno',
    townCode: 576816,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51601,
    lat: 50.145372,
    long: 16.219056,
  },
  {
    town: 'Syrov',
    townCode: 598771,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.578021,
    long: 15.177802,
  },
  {
    town: 'Syrovátka',
    townCode: 571008,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.154859,
    long: 15.662838,
  },
  {
    town: 'Syrovice',
    townCode: 583936,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66467,
    lat: 49.079913,
    long: 16.546565,
  },
  {
    town: 'Syrovín',
    townCode: 586633,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69684,
    lat: 49.025923,
    long: 17.264039,
  },
  {
    town: 'Syřenov',
    townCode: 577570,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51251,
    lat: 50.498928,
    long: 15.427821,
  },
  {
    town: 'Sytno',
    townCode: 557081,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.739789,
    long: 13.041764,
  },
  {
    town: 'Šabina',
    townCode: 538396,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.135748,
    long: 12.582432,
  },
  {
    town: 'Šafov',
    townCode: 594865,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67106,
    lat: 48.866906,
    long: 15.734756,
  },
  {
    town: 'Šakvice',
    townCode: 584924,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69167,
    lat: 48.897558,
    long: 16.714344,
  },
  {
    town: 'Šanov',
    townCode: 594873,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67168,
    lat: 48.800986,
    long: 16.378684,
  },
  {
    town: 'Šanov',
    townCode: 542474,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27031,
    lat: 50.087735,
    long: 13.631307,
  },
  {
    town: 'Šanov',
    townCode: 585807,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76321,
    lat: 49.045564,
    long: 17.898513,
  },
  {
    town: 'Šaplava',
    townCode: 571016,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50353,
    lat: 50.315142,
    long: 15.542057,
  },
  {
    town: 'Šaratice',
    townCode: 593613,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68352,
    lat: 49.117564,
    long: 16.803613,
  },
  {
    town: 'Šardice',
    townCode: 586641,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69613,
    lat: 48.964128,
    long: 17.028222,
  },
  {
    town: 'Šárovcova Lhota',
    townCode: 573256,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50759,
    lat: 50.407609,
    long: 15.562386,
  },
  {
    town: 'Šarovy',
    townCode: 585815,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76351,
    lat: 49.148682,
    long: 17.606966,
  },
  {
    town: 'Šatov',
    townCode: 594881,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67122,
    lat: 48.793274,
    long: 16.010024,
  },
  {
    town: 'Šebestěnice',
    townCode: 531421,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.829543,
    long: 15.365413,
  },
  {
    town: 'Šebetov',
    townCode: 582468,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67935,
    lat: 49.548719,
    long: 16.711728,
  },
  {
    town: 'Šebířov',
    townCode: 553204,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.566211,
    long: 14.82603,
  },
  {
    town: 'Šebkovice',
    townCode: 591807,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67545,
    lat: 49.123204,
    long: 15.813715,
  },
  {
    town: 'Šebrov-Kateřina',
    townCode: 582476,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.328598,
    long: 16.602548,
  },
  {
    town: 'Šedivec',
    townCode: 581038,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.04929,
    long: 16.535815,
  },
  {
    town: 'Šelešovice',
    townCode: 557188,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76701,
    lat: 49.254875,
    long: 17.36013,
  },
  {
    town: 'Šemnice',
    townCode: 555614,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36272,
    lat: 50.237016,
    long: 12.976213,
  },
  {
    town: 'Šenov',
    townCode: 598798,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73934,
    lat: 49.793249,
    long: 18.376174,
  },
  {
    town: 'Šenov u Nového Jičína',
    townCode: 554171,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74242,
    lat: 49.604647,
    long: 18.003387,
  },
  {
    town: 'Šerkovice',
    townCode: 583944,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.38568,
    long: 16.430063,
  },
  {
    town: 'Šestajovice',
    townCode: 547654,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.341229,
    long: 16.008082,
  },
  {
    town: 'Šestajovice',
    townCode: 538876,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25092,
    lat: 50.10852,
    long: 14.681812,
  },
  {
    town: 'Šetějovice',
    townCode: 532509,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.645276,
    long: 15.222583,
  },
  {
    town: 'Ševětín',
    townCode: 545121,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37363,
    lat: 49.100158,
    long: 14.572298,
  },
  {
    town: 'Šilheřovice',
    townCode: 510432,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74715,
    lat: 49.926122,
    long: 18.270274,
  },
  {
    town: 'Šimanov',
    townCode: 588008,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58842,
    lat: 49.458171,
    long: 15.450115,
  },
  {
    town: 'Šimonovice',
    townCode: 564460,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46312,
    lat: 50.706477,
    long: 15.052732,
  },
  {
    town: 'Šindelová',
    townCode: 560677,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35801,
    lat: 50.318764,
    long: 12.603439,
  },
  {
    town: 'Šípy',
    townCode: 598496,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27034,
    lat: 50.014425,
    long: 13.616563,
  },
  {
    town: 'Široká Niva',
    townCode: 597899,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 50.063922,
    long: 17.480203,
  },
  {
    town: 'Široký Důl',
    townCode: 578851,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57201,
    lat: 49.746139,
    long: 16.220866,
  },
  {
    town: 'Šišma',
    townCode: 552950,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75111,
    lat: 49.464011,
    long: 17.588144,
  },
  {
    town: 'Šitbořice',
    townCode: 584932,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69176,
    lat: 49.014427,
    long: 16.77986,
  },
  {
    town: 'Škrdlovice',
    townCode: 596876,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.634772,
    long: 15.926038,
  },
  {
    town: 'Škvorec',
    townCode: 538884,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25083,
    lat: 50.046972,
    long: 14.730519,
  },
  {
    town: 'Škvořetice',
    townCode: 551830,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.402515,
    long: 13.949224,
  },
  {
    town: 'Šlapanice',
    townCode: 583952,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66451,
    lat: 49.168729,
    long: 16.727418,
  },
  {
    town: 'Šlapanice',
    townCode: 532916,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27372,
    lat: 50.314773,
    long: 14.111319,
  },
  {
    town: 'Šlapanov',
    townCode: 569585,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58251,
    lat: 49.542525,
    long: 15.657789,
  },
  {
    town: 'Šléglov',
    townCode: 570117,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78825,
    lat: 50.153075,
    long: 16.982641,
  },
  {
    town: 'Šluknov',
    townCode: 562858,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40777,
    lat: 51.003793,
    long: 14.452699,
  },
  {
    town: 'Šonov',
    townCode: 574511,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54971,
    lat: 50.590932,
    long: 16.401645,
  },
  {
    town: 'Šošůvka',
    townCode: 582484,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67913,
    lat: 49.410633,
    long: 16.751985,
  },
  {
    town: 'Špičky',
    townCode: 570061,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75366,
    lat: 49.548258,
    long: 17.807885,
  },
  {
    town: 'Špindlerův Mlýn',
    townCode: 579742,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54351,
    lat: 50.72625,
    long: 15.609549,
  },
  {
    town: 'Štáblovice',
    townCode: 568333,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74782,
    lat: 49.880131,
    long: 17.818639,
  },
  {
    town: 'Šťáhlavy',
    townCode: 558427,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33203,
    lat: 49.675659,
    long: 13.504047,
  },
  {
    town: 'Štarnov',
    townCode: 552011,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78314,
    lat: 49.686232,
    long: 17.272686,
  },
  {
    town: 'Štědrá',
    townCode: 555622,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36452,
    lat: 50.058313,
    long: 13.114279,
  },
  {
    town: 'Štěchov',
    townCode: 582492,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.452359,
    long: 16.506182,
  },
  {
    town: 'Štěchovice',
    townCode: 536920,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.255508,
    long: 13.765623,
  },
  {
    town: 'Štěchovice',
    townCode: 539732,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25207,
    lat: 49.851197,
    long: 14.405534,
  },
  {
    town: 'Štěkeň',
    townCode: 551856,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38751,
    lat: 49.267249,
    long: 14.005988,
  },
  {
    town: 'Štěměchy',
    townCode: 591815,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67527,
    lat: 49.193393,
    long: 15.714768,
  },
  {
    town: 'Štěnovice',
    townCode: 558435,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33209,
    lat: 49.670623,
    long: 13.399739,
  },
  {
    town: 'Štěnovický Borek',
    townCode: 539741,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33209,
    lat: 49.649772,
    long: 13.426875,
  },
  {
    town: 'Štěpánkovice',
    townCode: 510483,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74728,
    lat: 49.95748,
    long: 18.037518,
  },
  {
    town: 'Štěpánov',
    townCode: 505161,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78313,
    lat: 49.684136,
    long: 17.220518,
  },
  {
    town: 'Štěpánov nad Svratkou',
    townCode: 596884,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59263,
    lat: 49.504688,
    long: 16.339224,
  },
  {
    town: 'Štěpánovice',
    townCode: 545139,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37373,
    lat: 49.00193,
    long: 14.653443,
  },
  {
    town: 'Štěpánovice',
    townCode: 583961,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66602,
    lat: 49.373052,
    long: 16.387683,
  },
  {
    town: 'Štěpkov',
    townCode: 591823,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67526,
    lat: 49.084115,
    long: 15.650302,
  },
  {
    town: 'Šternberk',
    townCode: 505188,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78501,
    lat: 49.730542,
    long: 17.298995,
  },
  {
    town: 'Štětí',
    townCode: 565709,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41108,
    lat: 50.453087,
    long: 14.374322,
  },
  {
    town: 'Štětkovice',
    townCode: 541419,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26401,
    lat: 49.670811,
    long: 14.506319,
  },
  {
    town: 'Štíhlice',
    townCode: 571644,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 50.005666,
    long: 14.780051,
  },
  {
    town: 'Štichov',
    townCode: 566101,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.585019,
    long: 13.048969,
  },
  {
    town: 'Štichovice',
    townCode: 578797,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.977911,
    long: 13.302933,
  },
  {
    town: 'Štipoklasy',
    townCode: 530930,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.824707,
    long: 15.213391,
  },
  {
    town: 'Štítary',
    townCode: 594890,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.935202,
    long: 15.844388,
  },
  {
    town: 'Štítina',
    townCode: 510491,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74791,
    lat: 49.914966,
    long: 18.012559,
  },
  {
    town: 'Štítná nad Vláří-Popov',
    townCode: 585831,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76333,
    lat: 49.070718,
    long: 17.972465,
  },
  {
    town: 'Štítov',
    townCode: 579343,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.666038,
    long: 13.678024,
  },
  {
    town: 'Štíty',
    townCode: 541168,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78991,
    lat: 49.961321,
    long: 16.765863,
  },
  {
    town: 'Štoky',
    townCode: 569593,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58253,
    lat: 49.502586,
    long: 15.588733,
  },
  {
    town: 'Štramberk',
    townCode: 599948,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74266,
    lat: 49.591905,
    long: 18.117521,
  },
  {
    town: 'Študlov',
    townCode: 578860,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.602645,
    long: 16.498432,
  },
  {
    town: 'Študlov',
    townCode: 544931,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75612,
    lat: 49.162525,
    long: 18.083277,
  },
  {
    town: 'Šubířov',
    townCode: 590096,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79852,
    lat: 49.602264,
    long: 16.813444,
  },
  {
    town: 'Šumavské Hoštice',
    townCode: 550574,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38471,
    lat: 49.039501,
    long: 13.872365,
  },
  {
    town: 'Šumice',
    townCode: 594903,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67175,
    lat: 48.9922,
    long: 16.437469,
  },
  {
    town: 'Šumice',
    townCode: 592676,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68731,
    lat: 49.028682,
    long: 17.72216,
  },
  {
    town: 'Šumná',
    townCode: 594911,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.922527,
    long: 15.871054,
  },
  {
    town: 'Šumperk',
    townCode: 523704,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78701,
    lat: 49.977941,
    long: 16.971875,
  },
  {
    town: 'Šumvald',
    townCode: 505218,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78385,
    lat: 49.831136,
    long: 17.132851,
  },
  {
    town: 'Švábenice',
    townCode: 593621,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68323,
    lat: 49.278501,
    long: 17.123499,
  },
  {
    town: 'Švábov',
    townCode: 547255,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58851,
    lat: 49.308525,
    long: 15.357131,
  },
  {
    town: 'Švihov',
    townCode: 557200,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34012,
    lat: 49.481466,
    long: 13.284281,
  },
  {
    town: 'Švihov',
    townCode: 565326,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27033,
    lat: 50.109935,
    long: 13.5644,
  },
  {
    town: 'Tábor',
    townCode: 552046,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39002,
    lat: 49.413089,
    long: 14.677566,
  },
  {
    town: 'Tachlovice',
    townCode: 531821,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25217,
    lat: 50.014555,
    long: 14.240788,
  },
  {
    town: 'Tachov',
    townCode: 553638,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.543414,
    long: 14.638554,
  },
  {
    town: 'Tachov',
    townCode: 560715,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34701,
    lat: 49.79888,
    long: 12.636292,
  },
  {
    town: 'Tálín',
    townCode: 549932,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39815,
    lat: 49.247661,
    long: 14.227263,
  },
  {
    town: 'Tanvald',
    townCode: 563820,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46841,
    lat: 50.737629,
    long: 15.307982,
  },
  {
    town: 'Tasov',
    townCode: 586650,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69663,
    lat: 48.906964,
    long: 17.429767,
  },
  {
    town: 'Tasov',
    townCode: 591831,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67579,
    lat: 49.288374,
    long: 16.094889,
  },
  {
    town: 'Tasovice',
    townCode: 582506,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.496043,
    long: 16.441633,
  },
  {
    town: 'Tasovice',
    townCode: 594920,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67125,
    lat: 48.836196,
    long: 16.155687,
  },
  {
    town: 'Tašov',
    townCode: 568287,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.614624,
    long: 14.135906,
  },
  {
    town: 'Tatce',
    townCode: 537888,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28911,
    lat: 50.091224,
    long: 14.977345,
  },
  {
    town: 'Tatenice',
    townCode: 581046,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56131,
    lat: 49.871076,
    long: 16.697311,
  },
  {
    town: 'Tatiná',
    townCode: 578983,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.848699,
    long: 13.299824,
  },
  {
    town: 'Tatobity',
    townCode: 577596,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51253,
    lat: 50.571343,
    long: 15.273268,
  },
  {
    town: 'Tatrovice',
    townCode: 538663,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35735,
    lat: 50.276819,
    long: 12.697409,
  },
  {
    town: 'Tavíkovice',
    townCode: 594938,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67140,
    lat: 49.033846,
    long: 16.103265,
  },
  {
    town: 'Tečovice',
    townCode: 549649,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76302,
    lat: 49.221167,
    long: 17.587443,
  },
  {
    town: 'Tehov',
    townCode: 530751,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.735542,
    long: 14.966838,
  },
  {
    town: 'Tehov',
    townCode: 538892,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25101,
    lat: 49.97162,
    long: 14.693897,
  },
  {
    town: 'Tehovec',
    townCode: 599719,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25162,
    lat: 49.981597,
    long: 14.730399,
  },
  {
    town: 'Těchařovice',
    townCode: 529664,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.599507,
    long: 14.048897,
  },
  {
    town: 'Těchlovice',
    townCode: 571024,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.207992,
    long: 15.711159,
  },
  {
    town: 'Těchlovice',
    townCode: 555193,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.696428,
    long: 14.205036,
  },
  {
    town: 'Těchobuz',
    townCode: 561355,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.510188,
    long: 14.930738,
  },
  {
    town: 'Těchonín',
    townCode: 581054,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56166,
    lat: 50.065031,
    long: 16.618015,
  },
  {
    town: 'Telč',
    townCode: 588024,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.183338,
    long: 15.454373,
  },
  {
    town: 'Telecí',
    townCode: 578878,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56994,
    lat: 49.694722,
    long: 16.180806,
  },
  {
    town: 'Telnice',
    townCode: 583979,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66459,
    lat: 49.101969,
    long: 16.71785,
  },
  {
    town: 'Telnice',
    townCode: 568295,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40338,
    lat: 50.733064,
    long: 13.957891,
  },
  {
    town: 'Temelín',
    townCode: 545155,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37301,
    lat: 49.19294,
    long: 14.348847,
  },
  {
    town: 'Temešvár',
    townCode: 562271,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.356486,
    long: 14.263631,
  },
  {
    town: 'Těmice',
    townCode: 586668,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69684,
    lat: 49.00165,
    long: 17.265026,
  },
  {
    town: 'Těmice',
    townCode: 548936,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39496,
    lat: 49.351896,
    long: 15.060549,
  },
  {
    town: 'Těně',
    townCode: 560189,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33845,
    lat: 49.7513,
    long: 13.796268,
  },
  {
    town: 'Teplá',
    townCode: 555631,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36461,
    lat: 49.981953,
    long: 12.86316,
  },
  {
    town: 'Teplice',
    townCode: 567442,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.644558,
    long: 13.835384,
  },
  {
    town: 'Teplice nad Bečvou',
    townCode: 519031,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.528613,
    long: 17.74019,
  },
  {
    town: 'Teplice nad Metují',
    townCode: 574538,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54957,
    lat: 50.59443,
    long: 16.170483,
  },
  {
    town: 'Teplička',
    townCode: 537845,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36464,
    lat: 50.148702,
    long: 12.85168,
  },
  {
    town: 'Teplýšovice',
    townCode: 530760,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.806208,
    long: 14.801688,
  },
  {
    town: 'Terešov',
    townCode: 566802,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.896783,
    long: 13.69985,
  },
  {
    town: 'Terezín',
    townCode: 586676,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69614,
    lat: 48.955636,
    long: 16.942659,
  },
  {
    town: 'Terezín',
    townCode: 565717,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41155,
    lat: 50.511102,
    long: 14.150658,
  },
  {
    town: 'Těrlicko',
    townCode: 599158,
    district: 'Karviná',
    lau: 'CZ0803',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73542,
    lat: 49.752419,
    long: 18.48302,
  },
  {
    town: 'Těšany',
    townCode: 583995,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66454,
    lat: 49.039658,
    long: 16.770132,
  },
  {
    town: 'Těšetice',
    townCode: 594946,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.888944,
    long: 16.158304,
  },
  {
    town: 'Těšetice',
    townCode: 505269,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78346,
    lat: 49.593272,
    long: 17.126175,
  },
  {
    town: 'Těškov',
    townCode: 546526,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.802297,
    long: 13.698135,
  },
  {
    town: 'Těškovice',
    townCode: 512745,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74764,
    lat: 49.814189,
    long: 18.02101,
  },
  {
    town: 'Těšovice',
    townCode: 550582,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.057215,
    long: 14.024005,
  },
  {
    town: 'Těšovice',
    townCode: 579360,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35601,
    lat: 50.182307,
    long: 12.676998,
  },
  {
    town: 'Tetčice',
    townCode: 583987,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66417,
    lat: 49.170348,
    long: 16.405736,
  },
  {
    town: 'Tetín',
    townCode: 572756,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50771,
    lat: 50.42462,
    long: 15.636457,
  },
  {
    town: 'Tetín',
    townCode: 531839,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 49.94942,
    long: 14.102357,
  },
  {
    town: 'Tetov',
    townCode: 575810,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.080585,
    long: 15.445738,
  },
  {
    town: 'Tchořovice',
    townCode: 536598,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.437148,
    long: 13.809985,
  },
  {
    town: 'Tichá',
    townCode: 599956,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74274,
    lat: 49.570086,
    long: 18.221589,
  },
  {
    town: 'Tichonice',
    townCode: 530778,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25763,
    lat: 49.777164,
    long: 14.992382,
  },
  {
    town: 'Tichov',
    townCode: 535184,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76601,
    lat: 49.177486,
    long: 17.982741,
  },
  {
    town: 'Tis',
    townCode: 569615,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58243,
    lat: 49.705057,
    long: 15.493338,
  },
  {
    town: 'Tis u Blatna',
    townCode: 559482,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33165,
    lat: 50.085845,
    long: 13.347908,
  },
  {
    town: 'Tisá',
    townCode: 568309,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40336,
    lat: 50.784605,
    long: 14.031415,
  },
  {
    town: 'Tísek',
    townCode: 599964,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74301,
    lat: 49.792766,
    long: 18.014705,
  },
  {
    town: 'Tisem',
    townCode: 532592,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25756,
    lat: 49.755736,
    long: 14.608061,
  },
  {
    town: 'Tismice',
    townCode: 533734,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.056273,
    long: 14.821163,
  },
  {
    town: 'Tisová',
    townCode: 581062,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.936258,
    long: 16.224633,
  },
  {
    town: 'Tisová',
    townCode: 541621,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34801,
    lat: 49.765288,
    long: 12.713935,
  },
  {
    town: 'Tisovec',
    townCode: 572381,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53973,
    lat: 49.824479,
    long: 15.914659,
  },
  {
    town: 'Tišice',
    townCode: 535222,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27715,
    lat: 50.269904,
    long: 14.554222,
  },
  {
    town: 'Tišnov',
    townCode: 584002,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.348818,
    long: 16.424485,
  },
  {
    town: 'Tišnovská Nová Ves',
    townCode: 596892,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59451,
    lat: 49.383986,
    long: 16.293684,
  },
  {
    town: 'Tištín',
    townCode: 590100,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79829,
    lat: 49.306988,
    long: 17.165505,
  },
  {
    town: 'Tlučná',
    townCode: 559491,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33026,
    lat: 49.724362,
    long: 13.235453,
  },
  {
    town: 'Tlumačov',
    townCode: 554341,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.40364,
    long: 12.929095,
  },
  {
    town: 'Tlumačov',
    townCode: 585858,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76362,
    lat: 49.253605,
    long: 17.495694,
  },
  {
    town: 'Tlustice',
    townCode: 531847,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26801,
    lat: 49.850393,
    long: 13.885465,
  },
  {
    town: 'Tmaň',
    townCode: 531855,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26721,
    lat: 49.907174,
    long: 14.033932,
  },
  {
    town: 'Točník',
    townCode: 534463,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.8855,
    long: 13.882878,
  },
  {
    town: 'Tochovice',
    townCode: 541427,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26281,
    lat: 49.59559,
    long: 13.992506,
  },
  {
    town: 'Tojice',
    townCode: 578614,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.492585,
    long: 13.62662,
  },
  {
    town: 'Tomice',
    townCode: 532541,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25768,
    lat: 49.645143,
    long: 15.157197,
  },
  {
    town: 'Topolany',
    townCode: 593630,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.277451,
    long: 17.040411,
  },
  {
    town: 'Topolná',
    townCode: 592692,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68711,
    lat: 49.121967,
    long: 17.544444,
  },
  {
    town: 'Toušice',
    townCode: 533742,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.987988,
    long: 15.006578,
  },
  {
    town: 'Toužetín',
    townCode: 566829,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.315391,
    long: 13.886229,
  },
  {
    town: 'Toužim',
    townCode: 555657,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36401,
    lat: 50.060604,
    long: 12.985171,
  },
  {
    town: 'Tovačov',
    townCode: 519146,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75101,
    lat: 49.429711,
    long: 17.285739,
  },
  {
    town: 'Tovéř',
    townCode: 552089,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78316,
    lat: 49.640125,
    long: 17.31912,
  },
  {
    town: 'Traplice',
    townCode: 592706,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68704,
    lat: 49.130976,
    long: 17.436325,
  },
  {
    town: 'Travčice',
    townCode: 565741,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.503389,
    long: 14.189878,
  },
  {
    town: 'Trboušany',
    townCode: 584011,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66464,
    lat: 49.050783,
    long: 16.46295,
  },
  {
    town: 'Trhanov',
    townCode: 554359,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34533,
    lat: 49.420341,
    long: 12.845635,
  },
  {
    town: 'Trhová Kamenice',
    townCode: 572390,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53952,
    lat: 49.786894,
    long: 15.816049,
  },
  {
    town: 'Trhové Dušníky',
    townCode: 598429,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26101,
    lat: 49.71355,
    long: 14.012935,
  },
  {
    town: 'Trhové Sviny',
    townCode: 545171,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.842418,
    long: 14.639338,
  },
  {
    town: 'Trhový Štěpánov',
    townCode: 530816,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25763,
    lat: 49.711576,
    long: 15.013668,
  },
  {
    town: 'Trmice',
    townCode: 553697,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40004,
    lat: 50.642967,
    long: 13.994605,
  },
  {
    town: 'Trnava',
    townCode: 591840,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67401,
    lat: 49.254784,
    long: 15.924247,
  },
  {
    town: 'Trnava',
    townCode: 585866,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76318,
    lat: 49.296132,
    long: 17.842017,
  },
  {
    town: 'Trnávka',
    townCode: 569755,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74258,
    lat: 49.684846,
    long: 18.178045,
  },
  {
    town: 'Trnávka',
    townCode: 530794,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.032844,
    long: 15.461124,
  },
  {
    town: 'Trnov',
    townCode: 576824,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51733,
    lat: 50.244775,
    long: 16.164517,
  },
  {
    town: 'Trnová',
    townCode: 559504,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33013,
    lat: 49.861152,
    long: 13.323963,
  },
  {
    town: 'Trnová',
    townCode: 598313,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.915541,
    long: 14.357824,
  },
  {
    town: 'Trnovany',
    townCode: 542407,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.543317,
    long: 14.17905,
  },
  {
    town: 'Trnové Pole',
    townCode: 594954,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.94504,
    long: 16.409578,
  },
  {
    town: 'Trojanovice',
    townCode: 599999,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74401,
    lat: 49.520494,
    long: 18.238113,
  },
  {
    town: 'Trojovice',
    townCode: 572403,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53833,
    lat: 49.932925,
    long: 15.919674,
  },
  {
    town: 'Trokavec',
    townCode: 579246,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.647028,
    long: 13.702351,
  },
  {
    town: 'Troskotovice',
    townCode: 594962,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67178,
    lat: 48.919119,
    long: 16.437643,
  },
  {
    town: 'Troskovice',
    townCode: 577600,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51263,
    lat: 50.511687,
    long: 15.22242,
  },
  {
    town: 'Trotina',
    townCode: 579751,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.409736,
    long: 15.716281,
  },
  {
    town: 'Troubelice',
    townCode: 505293,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78383,
    lat: 49.817411,
    long: 17.08111,
  },
  {
    town: 'Troubky',
    townCode: 519651,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75102,
    lat: 49.432248,
    long: 17.34925,
  },
  {
    town: 'Troubky-Zdislavice',
    townCode: 589080,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76802,
    lat: 49.230501,
    long: 17.268275,
  },
  {
    town: 'Troubsko',
    townCode: 584029,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66441,
    lat: 49.169608,
    long: 16.510886,
  },
  {
    town: 'Trpík',
    townCode: 547921,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.847575,
    long: 16.570003,
  },
  {
    town: 'Trpín',
    townCode: 578886,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56974,
    lat: 49.593988,
    long: 16.402214,
  },
  {
    town: 'Trpísty',
    townCode: 561291,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.822747,
    long: 13.058639,
  },
  {
    town: 'Trpišovice',
    townCode: 569623,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.655284,
    long: 15.332281,
  },
  {
    town: 'Trstěnice',
    townCode: 594971,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67171,
    lat: 48.986862,
    long: 16.195522,
  },
  {
    town: 'Trstěnice',
    townCode: 554855,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.91921,
    long: 12.676134,
  },
  {
    town: 'Trstěnice',
    townCode: 578894,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56957,
    lat: 49.794239,
    long: 16.348852,
  },
  {
    town: 'Tršice',
    townCode: 505366,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78357,
    lat: 49.541173,
    long: 17.42708,
  },
  {
    town: 'Trubín',
    townCode: 533106,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26701,
    lat: 49.94378,
    long: 14.002294,
  },
  {
    town: 'Trubská',
    townCode: 531880,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 49.95498,
    long: 13.993555,
  },
  {
    town: 'Truskovice',
    townCode: 536512,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.104163,
    long: 14.161196,
  },
  {
    town: 'Trusnov',
    townCode: 575828,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.000215,
    long: 16.044093,
  },
  {
    town: 'Trutnov',
    townCode: 579025,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54101,
    lat: 50.565484,
    long: 15.909192,
  },
  {
    town: 'Tržek',
    townCode: 572616,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.886335,
    long: 16.260047,
  },
  {
    town: 'Třanovice',
    townCode: 552623,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73953,
    lat: 49.712553,
    long: 18.529296,
  },
  {
    town: 'Třebařov',
    townCode: 578908,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56933,
    lat: 49.829794,
    long: 16.702624,
  },
  {
    town: 'Třebčice',
    townCode: 578592,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33501,
    lat: 49.483479,
    long: 13.612175,
  },
  {
    town: 'Třebechovice pod Orebem',
    townCode: 571041,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50346,
    lat: 50.201066,
    long: 15.992336,
  },
  {
    town: 'Třebějice',
    townCode: 563153,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.244526,
    long: 14.81988,
  },
  {
    town: 'Třebelovice',
    townCode: 591858,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67532,
    lat: 49.022254,
    long: 15.666335,
  },
  {
    town: 'Třebeň',
    townCode: 539023,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35134,
    lat: 50.128744,
    long: 12.400268,
  },
  {
    town: 'Třebenice',
    townCode: 591866,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.163856,
    long: 16.015873,
  },
  {
    town: 'Třebenice',
    townCode: 565768,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41113,
    lat: 50.476429,
    long: 13.990159,
  },
  {
    town: 'Třebestovice',
    townCode: 537896,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28912,
    lat: 50.124705,
    long: 14.958358,
  },
  {
    town: 'Třebešice',
    townCode: 532304,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.775348,
    long: 14.831949,
  },
  {
    town: 'Třebešice',
    townCode: 530981,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.927948,
    long: 15.337909,
  },
  {
    town: 'Třebešov',
    townCode: 576832,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51601,
    lat: 50.16845,
    long: 16.204241,
  },
  {
    town: 'Třebětice',
    townCode: 562327,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.047741,
    long: 15.52082,
  },
  {
    town: 'Třebětice',
    townCode: 589098,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.319485,
    long: 17.519351,
  },
  {
    town: 'Třebětín',
    townCode: 530972,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.77084,
    long: 15.269464,
  },
  {
    town: 'Třebíč',
    townCode: 590266,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67401,
    lat: 49.214887,
    long: 15.879652,
  },
  {
    town: 'Třebihošť',
    townCode: 579769,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.433387,
    long: 15.709795,
  },
  {
    town: 'Třebichovice',
    townCode: 532959,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27306,
    lat: 50.190464,
    long: 14.079146,
  },
  {
    town: 'Třebívlice',
    townCode: 565776,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41115,
    lat: 50.45817,
    long: 13.899372,
  },
  {
    town: 'Třebíz',
    townCode: 532967,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27375,
    lat: 50.269721,
    long: 13.990901,
  },
  {
    town: 'Třebnouševes',
    townCode: 573612,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50801,
    lat: 50.339344,
    long: 15.651767,
  },
  {
    town: 'Třeboc',
    townCode: 542504,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27054,
    lat: 50.214417,
    long: 13.752838,
  },
  {
    town: 'Třebohostice',
    townCode: 551899,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38737,
    lat: 49.33264,
    long: 13.861096,
  },
  {
    town: 'Třebom',
    townCode: 569101,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74725,
    lat: 50.046244,
    long: 18.025387,
  },
  {
    town: 'Třeboň',
    townCode: 547336,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.003615,
    long: 14.764232,
  },
  {
    town: 'Třebonín',
    townCode: 571741,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28544,
    lat: 49.869804,
    long: 15.313026,
  },
  {
    town: 'Třebosice',
    townCode: 572985,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.997348,
    long: 15.734932,
  },
  {
    town: 'Třebotov',
    townCode: 539759,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25226,
    lat: 49.972514,
    long: 14.291274,
  },
  {
    town: 'Třebovice',
    townCode: 581071,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56124,
    lat: 49.859351,
    long: 16.502143,
  },
  {
    town: 'Třebovle',
    townCode: 533751,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 50.027347,
    long: 14.961866,
  },
  {
    town: 'Třebsko',
    townCode: 541451,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.625764,
    long: 13.96765,
  },
  {
    town: 'Třebusice',
    townCode: 532975,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27341,
    lat: 50.200879,
    long: 14.180749,
  },
  {
    town: 'Třebušín',
    townCode: 565792,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.599744,
    long: 14.20553,
  },
  {
    town: 'Třemešná',
    townCode: 597911,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79382,
    lat: 50.20503,
    long: 17.57542,
  },
  {
    town: 'Třemešné',
    townCode: 561304,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34806,
    lat: 49.625373,
    long: 12.695768,
  },
  {
    town: 'Třemošná',
    townCode: 559521,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.815946,
    long: 13.395104,
  },
  {
    town: 'Třemošnice',
    townCode: 572411,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53843,
    lat: 49.869219,
    long: 15.580129,
  },
  {
    town: 'Třesov',
    townCode: 550311,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67502,
    lat: 49.180335,
    long: 16.082925,
  },
  {
    town: 'Třesovice',
    townCode: 571059,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50315,
    lat: 50.265178,
    long: 15.688982,
  },
  {
    town: 'Třešovice',
    townCode: 536679,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.211424,
    long: 13.98145,
  },
  {
    town: 'Třešť',
    townCode: 588032,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58901,
    lat: 49.290971,
    long: 15.483401,
  },
  {
    town: 'Třeštice',
    townCode: 588041,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.245602,
    long: 15.453316,
  },
  {
    town: 'Třeština',
    townCode: 553336,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78973,
    lat: 49.796306,
    long: 16.963987,
  },
  {
    town: 'Tři Dvory',
    townCode: 533769,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.032056,
    long: 15.256593,
  },
  {
    town: 'Tři Sekery',
    townCode: 554880,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.942277,
    long: 12.616745,
  },
  {
    town: 'Tři Studně',
    townCode: 587753,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59204,
    lat: 49.612941,
    long: 16.036598,
  },
  {
    town: 'Třibřichy',
    townCode: 504921,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.965357,
    long: 15.739289,
  },
  {
    town: 'Třinec',
    townCode: 598810,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73961,
    lat: 49.677731,
    long: 18.67089,
  },
  {
    town: 'Třtěnice',
    townCode: 573639,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50704,
    lat: 50.377493,
    long: 15.469231,
  },
  {
    town: 'Třtice',
    townCode: 542512,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27101,
    lat: 50.185105,
    long: 13.863591,
  },
  {
    town: 'Tučapy',
    townCode: 553239,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39126,
    lat: 49.291392,
    long: 14.803517,
  },
  {
    town: 'Tučapy',
    townCode: 593648,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.233446,
    long: 16.918474,
  },
  {
    town: 'Tučapy',
    townCode: 592714,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68709,
    lat: 49.048213,
    long: 17.331526,
  },
  {
    town: 'Tučín',
    townCode: 520047,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75116,
    lat: 49.45409,
    long: 17.515128,
  },
  {
    town: 'Tuhaň',
    townCode: 546267,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.536579,
    long: 14.467408,
  },
  {
    town: 'Tuhaň',
    townCode: 531561,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27741,
    lat: 50.295483,
    long: 14.517383,
  },
  {
    town: 'Tuchlovice',
    townCode: 532983,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27302,
    lat: 50.138132,
    long: 13.991262,
  },
  {
    town: 'Tuchoměřice',
    townCode: 539767,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25267,
    lat: 50.135539,
    long: 14.282293,
  },
  {
    town: 'Tuchoraz',
    townCode: 533777,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.048724,
    long: 14.849303,
  },
  {
    town: 'Tuchořice',
    townCode: 566853,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43969,
    lat: 50.28475,
    long: 13.662622,
  },
  {
    town: 'Tuklaty',
    townCode: 533785,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25082,
    lat: 50.084879,
    long: 14.769602,
  },
  {
    town: 'Tulešice',
    townCode: 594989,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67173,
    lat: 49.038646,
    long: 16.207235,
  },
  {
    town: 'Tuněchody',
    townCode: 572420,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53701,
    lat: 49.978962,
    long: 15.84134,
  },
  {
    town: 'Tupadly',
    townCode: 534480,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28563,
    lat: 49.869103,
    long: 15.40356,
  },
  {
    town: 'Tupadly',
    townCode: 529583,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.441913,
    long: 14.475036,
  },
  {
    town: 'Tupesy',
    townCode: 592722,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68707,
    lat: 49.084369,
    long: 17.369935,
  },
  {
    town: 'Turkovice',
    townCode: 575844,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53363,
    lat: 49.952551,
    long: 15.548856,
  },
  {
    town: 'Turnov',
    townCode: 577626,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51101,
    lat: 50.587385,
    long: 15.156909,
  },
  {
    town: 'Turovec',
    townCode: 551601,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39121,
    lat: 49.378459,
    long: 14.769036,
  },
  {
    town: 'Turovice',
    townCode: 552836,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75114,
    lat: 49.423817,
    long: 17.580887,
  },
  {
    town: 'Tursko',
    townCode: 539775,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25265,
    lat: 50.19134,
    long: 14.32199,
  },
  {
    town: 'Tuř',
    townCode: 573647,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.395077,
    long: 15.417033,
  },
  {
    town: 'Tuřany',
    townCode: 539619,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35002,
    lat: 50.08412,
    long: 12.522102,
  },
  {
    town: 'Tuřany',
    townCode: 532177,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27379,
    lat: 50.232342,
    long: 14.029138,
  },
  {
    town: 'Tuřice',
    townCode: 570982,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29474,
    lat: 50.248907,
    long: 14.769264,
  },
  {
    town: 'Tušovice',
    townCode: 598330,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.575713,
    long: 14.030638,
  },
  {
    town: 'Tutleky',
    townCode: 576841,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.134014,
    long: 16.241556,
  },
  {
    town: 'Tužice',
    townCode: 553522,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34142,
    lat: 49.335115,
    long: 13.511527,
  },
  {
    town: 'Tvarožná',
    townCode: 584037,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66405,
    lat: 49.19187,
    long: 16.771563,
  },
  {
    town: 'Tvarožná Lhota',
    townCode: 586684,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69662,
    lat: 48.877349,
    long: 17.359497,
  },
  {
    town: 'Tvorovice',
    townCode: 590118,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79823,
    lat: 49.374487,
    long: 17.22203,
  },
  {
    town: 'Tvořihráz',
    townCode: 594997,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67134,
    lat: 48.917649,
    long: 16.135878,
  },
  {
    town: 'Tvrdkov',
    townCode: 551821,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79344,
    lat: 49.895592,
    long: 17.178202,
  },
  {
    town: 'Tvrdonice',
    townCode: 584941,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69153,
    lat: 48.760582,
    long: 16.994567,
  },
  {
    town: 'Tvrzice',
    townCode: 550604,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.121841,
    long: 13.967232,
  },
  {
    town: 'Týček',
    townCode: 546534,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.869348,
    long: 13.794421,
  },
  {
    town: 'Tymákov',
    townCode: 558460,
    district: 'Plzeň-město',
    lau: 'CZ0323',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33201,
    lat: 49.719174,
    long: 13.509931,
  },
  {
    town: 'Týn nad Bečvou',
    townCode: 570079,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75131,
    lat: 49.51705,
    long: 17.618164,
  },
  {
    town: 'Týn nad Vltavou',
    townCode: 545201,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.223502,
    long: 14.42067,
  },
  {
    town: 'Týnec',
    townCode: 584959,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69154,
    lat: 48.779531,
    long: 17.013324,
  },
  {
    town: 'Týnec',
    townCode: 541885,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34021,
    lat: 49.347334,
    long: 13.264018,
  },
  {
    town: 'Týnec nad Labem',
    townCode: 533807,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28126,
    lat: 50.042117,
    long: 15.358462,
  },
  {
    town: 'Týnec nad Sázavou',
    townCode: 530841,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25741,
    lat: 49.833579,
    long: 14.58994,
  },
  {
    town: 'Týniště',
    townCode: 539929,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.521194,
    long: 13.417703,
  },
  {
    town: 'Týniště nad Orlicí',
    townCode: 576859,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51721,
    lat: 50.151203,
    long: 16.078551,
  },
  {
    town: 'Týnišťko',
    townCode: 575861,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.999487,
    long: 16.097653,
  },
  {
    town: 'Úbislavice',
    townCode: 573655,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50792,
    lat: 50.473031,
    long: 15.47042,
  },
  {
    town: 'Ublo',
    townCode: 585874,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76312,
    lat: 49.233156,
    long: 17.901231,
  },
  {
    town: 'Úboč',
    townCode: 566161,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.443698,
    long: 13.086983,
  },
  {
    town: 'Ubušínek',
    townCode: 549959,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.610581,
    long: 16.281794,
  },
  {
    town: 'Údlice',
    townCode: 563382,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43141,
    lat: 50.440706,
    long: 13.457492,
  },
  {
    town: 'Údrnice',
    townCode: 573663,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.374485,
    long: 15.261676,
  },
  {
    town: 'Uhelná',
    townCode: 541214,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79070,
    lat: 50.365038,
    long: 17.027399,
  },
  {
    town: 'Uhelná Příbram',
    townCode: 569640,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58245,
    lat: 49.768087,
    long: 15.585655,
  },
  {
    town: 'Úherce',
    townCode: 546411,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.701479,
    long: 13.213823,
  },
  {
    town: 'Úherce',
    townCode: 546178,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.298161,
    long: 13.949094,
  },
  {
    town: 'Uherčice',
    townCode: 584967,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69162,
    lat: 48.967902,
    long: 16.653546,
  },
  {
    town: 'Uherčice',
    townCode: 595004,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.913336,
    long: 15.630477,
  },
  {
    town: 'Úherčice',
    townCode: 530697,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.919564,
    long: 15.677746,
  },
  {
    town: 'Uherské Hradiště',
    townCode: 592005,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68601,
    lat: 49.059897,
    long: 17.49595,
  },
  {
    town: 'Uhersko',
    townCode: 575879,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53373,
    lat: 49.992474,
    long: 16.017879,
  },
  {
    town: 'Uherský Brod',
    townCode: 592731,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68801,
    lat: 49.030373,
    long: 17.649938,
  },
  {
    town: 'Uherský Ostroh',
    townCode: 592749,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68724,
    lat: 48.985657,
    long: 17.389953,
  },
  {
    town: 'Úhlejov',
    townCode: 573671,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50771,
    lat: 50.427287,
    long: 15.687441,
  },
  {
    town: 'Uhlířov',
    townCode: 568341,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74784,
    lat: 49.897154,
    long: 17.841402,
  },
  {
    town: 'Uhlířská Lhota',
    townCode: 533815,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28126,
    lat: 50.079045,
    long: 15.391155,
  },
  {
    town: 'Uhlířské Janovice',
    townCode: 534498,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.880291,
    long: 15.06492,
  },
  {
    town: 'Úholičky',
    townCode: 571351,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25264,
    lat: 50.16146,
    long: 14.335349,
  },
  {
    town: 'Úhonice',
    townCode: 532991,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25218,
    lat: 50.043449,
    long: 14.186328,
  },
  {
    town: 'Úhořilka',
    townCode: 548537,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58253,
    lat: 49.524779,
    long: 15.530975,
  },
  {
    town: 'Úhřetice',
    townCode: 572446,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53832,
    lat: 49.979251,
    long: 15.867345,
  },
  {
    town: 'Úhřetická Lhota',
    townCode: 575887,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53002,
    lat: 49.988669,
    long: 15.872852,
  },
  {
    town: 'Uhřice',
    townCode: 582531,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67963,
    lat: 49.595164,
    long: 16.735111,
  },
  {
    town: 'Uhřice',
    townCode: 586692,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69634,
    lat: 49.050447,
    long: 16.947682,
  },
  {
    town: 'Uhřice',
    townCode: 550191,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68333,
    lat: 49.172448,
    long: 17.078762,
  },
  {
    town: 'Uhřice',
    townCode: 589110,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76833,
    lat: 49.281835,
    long: 17.201536,
  },
  {
    town: 'Uhřičice',
    townCode: 552879,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75201,
    lat: 49.371673,
    long: 17.290435,
  },
  {
    town: 'Uhřínov',
    townCode: 596906,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59441,
    lat: 49.349931,
    long: 15.938057,
  },
  {
    town: 'Uhy',
    townCode: 533009,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27324,
    lat: 50.284336,
    long: 14.273969,
  },
  {
    town: 'Ujčov',
    townCode: 596914,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59262,
    lat: 49.488459,
    long: 16.331188,
  },
  {
    town: 'Újezd',
    townCode: 595012,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67140,
    lat: 49.023647,
    long: 16.053361,
  },
  {
    town: 'Újezd',
    townCode: 596922,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59212,
    lat: 49.509261,
    long: 15.870346,
  },
  {
    town: 'Újezd',
    townCode: 505501,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78396,
    lat: 49.764066,
    long: 17.180511,
  },
  {
    town: 'Újezd',
    townCode: 554383,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.435642,
    long: 12.869668,
  },
  {
    town: 'Újezd',
    townCode: 531901,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26761,
    lat: 49.831356,
    long: 13.837576,
  },
  {
    town: 'Újezd',
    townCode: 585882,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76325,
    lat: 49.168187,
    long: 17.906215,
  },
  {
    town: 'Újezd nade Mží',
    townCode: 566594,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33033,
    lat: 49.788854,
    long: 13.195175,
  },
  {
    town: 'Újezd pod Troskami',
    townCode: 573680,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51263,
    lat: 50.506631,
    long: 15.262655,
  },
  {
    town: 'Újezd u Boskovic',
    townCode: 534692,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.463998,
    long: 16.654269,
  },
  {
    town: 'Újezd u Brna',
    townCode: 584045,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66453,
    lat: 49.104448,
    long: 16.757474,
  },
  {
    town: 'Újezd u Černé Hory',
    townCode: 582557,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.370995,
    long: 16.543917,
  },
  {
    town: 'Újezd u Chocně',
    townCode: 581089,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 50.026995,
    long: 16.164691,
  },
  {
    town: 'Újezd u Plánice',
    townCode: 578321,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.417621,
    long: 13.457818,
  },
  {
    town: 'Újezd u Přelouče',
    townCode: 575909,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.102031,
    long: 15.494626,
  },
  {
    town: 'Újezd u Rosic',
    townCode: 584053,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.222512,
    long: 16.253748,
  },
  {
    town: 'Újezd u Sezemic',
    townCode: 572888,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53304,
    lat: 50.114148,
    long: 15.855832,
  },
  {
    town: 'Újezd u Svatého Kříže',
    townCode: 546551,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.859837,
    long: 13.56961,
  },
  {
    town: 'Újezd u Tišnova',
    townCode: 549908,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59455,
    lat: 49.365622,
    long: 16.32465,
  },
  {
    town: 'Újezdec',
    townCode: 507644,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.207626,
    long: 14.784836,
  },
  {
    town: 'Újezdec',
    townCode: 537535,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.108008,
    long: 13.964075,
  },
  {
    town: 'Újezdec',
    townCode: 578916,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.877862,
    long: 16.206035,
  },
  {
    town: 'Újezdec',
    townCode: 599492,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27745,
    lat: 50.283451,
    long: 14.420989,
  },
  {
    town: 'Újezdec',
    townCode: 592757,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68741,
    lat: 49.036216,
    long: 17.272063,
  },
  {
    town: 'Újezdeček',
    townCode: 567850,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.645818,
    long: 13.789867,
  },
  {
    town: 'Ujkovice',
    townCode: 570761,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.366961,
    long: 15.099546,
  },
  {
    town: 'Úlehle',
    townCode: 536695,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.201553,
    long: 13.838465,
  },
  {
    town: 'Úlibice',
    townCode: 573698,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50707,
    lat: 50.43413,
    long: 15.437401,
  },
  {
    town: 'Úlice',
    townCode: 559555,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33033,
    lat: 49.760902,
    long: 13.148283,
  },
  {
    town: 'Úmonín',
    townCode: 534501,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28546,
    lat: 49.888776,
    long: 15.271497,
  },
  {
    town: 'Úmyslovice',
    townCode: 537900,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29001,
    lat: 50.203491,
    long: 15.177694,
  },
  {
    town: 'Únanov',
    townCode: 595021,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67131,
    lat: 48.900923,
    long: 16.063609,
  },
  {
    town: 'Unčín',
    townCode: 596931,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59242,
    lat: 49.607762,
    long: 16.245786,
  },
  {
    town: 'Únehle',
    townCode: 541435,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.791701,
    long: 13.015482,
  },
  {
    town: 'Únějovice',
    townCode: 554391,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.462139,
    long: 13.118705,
  },
  {
    town: 'Úněšov',
    townCode: 559563,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33038,
    lat: 49.882689,
    long: 13.149299,
  },
  {
    town: 'Únětice',
    townCode: 540528,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.584402,
    long: 13.470115,
  },
  {
    town: 'Únětice',
    townCode: 539805,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25262,
    lat: 50.150214,
    long: 14.354207,
  },
  {
    town: 'Unhošť',
    townCode: 533017,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.085455,
    long: 14.130183,
  },
  {
    town: 'Únice',
    townCode: 563951,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.312345,
    long: 13.868508,
  },
  {
    town: 'Uničov',
    townCode: 505587,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78391,
    lat: 49.771013,
    long: 17.121542,
  },
  {
    town: 'Unín',
    townCode: 582565,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67924,
    lat: 49.382277,
    long: 16.491456,
  },
  {
    town: 'Unkovice',
    townCode: 584061,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66463,
    lat: 49.019318,
    long: 16.604146,
  },
  {
    town: 'Úpice',
    townCode: 579777,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54232,
    lat: 50.512472,
    long: 16.016173,
  },
  {
    town: 'Úpohlavy',
    townCode: 565806,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.463202,
    long: 14.035645,
  },
  {
    town: 'Urbanice',
    townCode: 513717,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50327,
    lat: 50.18002,
    long: 15.727458,
  },
  {
    town: 'Urbanice',
    townCode: 575917,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 49.974044,
    long: 15.567111,
  },
  {
    town: 'Urbanov',
    townCode: 588067,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58862,
    lat: 49.214457,
    long: 15.514113,
  },
  {
    town: 'Určice',
    townCode: 590126,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79804,
    lat: 49.430551,
    long: 17.073015,
  },
  {
    town: 'Úsilné',
    townCode: 535494,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37010,
    lat: 49.01349,
    long: 14.507364,
  },
  {
    town: 'Úsilov',
    townCode: 554405,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34506,
    lat: 49.396955,
    long: 13.127071,
  },
  {
    town: 'Úsobí',
    townCode: 569658,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58254,
    lat: 49.5143,
    long: 15.502573,
  },
  {
    town: 'Úsobrno',
    townCode: 582573,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67939,
    lat: 49.589023,
    long: 16.762988,
  },
  {
    town: 'Úsov',
    townCode: 541222,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78973,
    lat: 49.798406,
    long: 17.010654,
  },
  {
    town: 'Ústí',
    townCode: 588075,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58842,
    lat: 49.47362,
    long: 15.414883,
  },
  {
    town: 'Ústí',
    townCode: 520306,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.516945,
    long: 17.766477,
  },
  {
    town: 'Ústí',
    townCode: 570371,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75501,
    lat: 49.308336,
    long: 18.003211,
  },
  {
    town: 'ÚSTÍ NAD LABEM',
    townCode: 554804,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40001,
    lat: 50.661216,
    long: 14.053246,
  },
  {
    town: 'Ústí nad Orlicí',
    townCode: 579891,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 49.97228,
    long: 16.399762,
  },
  {
    town: 'Ústín',
    townCode: 552364,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78346,
    lat: 49.587135,
    long: 17.157685,
  },
  {
    town: 'Ústrašice',
    townCode: 599123,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39002,
    lat: 49.34038,
    long: 14.68458,
  },
  {
    town: 'Ústrašín',
    townCode: 537608,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.382588,
    long: 15.16866,
  },
  {
    town: 'Ústup',
    townCode: 553883,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67974,
    lat: 49.565027,
    long: 16.463018,
  },
  {
    town: 'Úsuší',
    townCode: 584070,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.334845,
    long: 16.356089,
  },
  {
    town: 'Úštěk',
    townCode: 565814,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41145,
    lat: 50.585804,
    long: 14.34769,
  },
  {
    town: 'Útěchov',
    townCode: 572624,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.728486,
    long: 16.64466,
  },
  {
    town: 'Útěchovice',
    townCode: 548987,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.478174,
    long: 15.116486,
  },
  {
    town: 'Útěchovice pod Stražištěm',
    townCode: 562033,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.538607,
    long: 15.0292,
  },
  {
    town: 'Útěchovičky',
    townCode: 537730,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.460685,
    long: 15.099772,
  },
  {
    town: 'Úterý',
    townCode: 559571,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33041,
    lat: 49.940181,
    long: 13.00429,
  },
  {
    town: 'Útušice',
    townCode: 558486,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33209,
    lat: 49.677894,
    long: 13.382148,
  },
  {
    town: 'Útvina',
    townCode: 555681,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36401,
    lat: 50.070847,
    long: 12.954852,
  },
  {
    town: 'Úvalno',
    townCode: 597937,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79391,
    lat: 50.047254,
    long: 17.744838,
  },
  {
    town: 'Úvaly',
    townCode: 538957,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25082,
    lat: 50.073837,
    long: 14.730945,
  },
  {
    town: 'Uzenice',
    townCode: 551937,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.473354,
    long: 13.959944,
  },
  {
    town: 'Uzeničky',
    townCode: 536890,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38801,
    lat: 49.488972,
    long: 13.952507,
  },
  {
    town: 'Úžice',
    townCode: 534510,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.872126,
    long: 14.9728,
  },
  {
    town: 'Úžice',
    townCode: 535257,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27745,
    lat: 50.253007,
    long: 14.378957,
  },
  {
    town: 'Vacenovice',
    townCode: 586706,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69606,
    lat: 48.945204,
    long: 17.174146,
  },
  {
    town: 'Václavice',
    townCode: 532061,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25601,
    lat: 49.789406,
    long: 14.61365,
  },
  {
    town: 'Václavov u Bruntálu',
    townCode: 597945,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.979799,
    long: 17.371834,
  },
  {
    town: 'Václavovice',
    townCode: 598836,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73934,
    lat: 49.755403,
    long: 18.372312,
  },
  {
    town: 'Václavy',
    townCode: 565512,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.063791,
    long: 13.59452,
  },
  {
    town: 'Vacov',
    townCode: 550621,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38486,
    lat: 49.13697,
    long: 13.729209,
  },
  {
    town: 'Vacovice',
    townCode: 536504,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.140476,
    long: 13.781044,
  },
  {
    town: 'Val',
    townCode: 553255,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.146155,
    long: 14.756143,
  },
  {
    town: 'Val',
    townCode: 576875,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51801,
    lat: 50.311302,
    long: 16.181692,
  },
  {
    town: 'Valašská Bystřice',
    townCode: 544949,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75627,
    lat: 49.415172,
    long: 18.109885,
  },
  {
    town: 'Valašská Polanka',
    townCode: 544990,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75611,
    lat: 49.262249,
    long: 17.996783,
  },
  {
    town: 'Valašská Senice',
    townCode: 553026,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75614,
    lat: 49.225377,
    long: 18.11706,
  },
  {
    town: 'Valašské Klobouky',
    townCode: 585891,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76601,
    lat: 49.139664,
    long: 18.00857,
  },
  {
    town: 'Valašské Meziříčí',
    townCode: 545058,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75701,
    lat: 49.471904,
    long: 17.971237,
  },
  {
    town: 'Valašské Příkazy',
    townCode: 545112,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75612,
    lat: 49.165971,
    long: 18.053888,
  },
  {
    town: 'Valdice',
    townCode: 573701,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50711,
    lat: 50.455113,
    long: 15.384989,
  },
  {
    town: 'Valdíkov',
    townCode: 587699,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67503,
    lat: 49.247109,
    long: 15.985337,
  },
  {
    town: 'Valeč',
    townCode: 555690,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36453,
    lat: 50.174239,
    long: 13.254676,
  },
  {
    town: 'Valeč',
    townCode: 591874,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67553,
    lat: 49.144404,
    long: 16.03579,
  },
  {
    town: 'Valchov',
    townCode: 582581,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.470283,
    long: 16.71998,
  },
  {
    town: 'Valkeřice',
    townCode: 562874,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40724,
    lat: 50.701933,
    long: 14.322006,
  },
  {
    town: 'Valšov',
    townCode: 551783,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79201,
    lat: 49.933456,
    long: 17.43824,
  },
  {
    town: 'Valtice',
    townCode: 584975,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69142,
    lat: 48.74079,
    long: 16.755094,
  },
  {
    town: 'Valtrovice',
    townCode: 595039,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67128,
    lat: 48.793826,
    long: 16.221077,
  },
  {
    town: 'Valy',
    townCode: 539481,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.976907,
    long: 12.654905,
  },
  {
    town: 'Valy',
    townCode: 575925,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.029694,
    long: 15.61687,
  },
  {
    town: 'Vamberk',
    townCode: 576883,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51754,
    lat: 50.117657,
    long: 16.290779,
  },
  {
    town: 'Vanov',
    townCode: 588083,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.207777,
    long: 15.413736,
  },
  {
    town: 'Vanovice',
    townCode: 582590,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67936,
    lat: 49.567378,
    long: 16.666313,
  },
  {
    town: 'Vanůvek',
    townCode: 588091,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.222589,
    long: 15.422729,
  },
  {
    town: 'Vápenice',
    townCode: 592773,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68774,
    lat: 48.967992,
    long: 17.843216,
  },
  {
    town: 'Vápenná',
    townCode: 541249,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79064,
    lat: 50.283473,
    long: 17.097722,
  },
  {
    town: 'Vápenný Podol',
    townCode: 572454,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.889133,
    long: 15.66685,
  },
  {
    town: 'Vápno',
    townCode: 575933,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.10432,
    long: 15.533003,
  },
  {
    town: 'Vápovice',
    townCode: 588105,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.154876,
    long: 15.580807,
  },
  {
    town: 'Varnsdorf',
    townCode: 562882,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40747,
    lat: 50.911648,
    long: 14.618348,
  },
  {
    town: 'Varvažov',
    townCode: 562211,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.439009,
    long: 14.142696,
  },
  {
    town: 'Vatín',
    townCode: 596949,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.525037,
    long: 15.96732,
  },
  {
    town: 'Vavřinec',
    townCode: 582603,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67913,
    lat: 49.402702,
    long: 16.719949,
  },
  {
    town: 'Vavřinec',
    townCode: 534528,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.913742,
    long: 15.033253,
  },
  {
    town: 'Vážany',
    townCode: 582611,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.53129,
    long: 16.688799,
  },
  {
    town: 'Vážany',
    townCode: 593656,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.244453,
    long: 17.050332,
  },
  {
    town: 'Vážany',
    townCode: 592781,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68737,
    lat: 49.034552,
    long: 17.312035,
  },
  {
    town: 'Vážany nad Litavou',
    townCode: 593664,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68401,
    lat: 49.128919,
    long: 16.857178,
  },
  {
    town: 'Včelákov',
    townCode: 572462,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53957,
    lat: 49.817781,
    long: 15.884462,
  },
  {
    town: 'Včelná',
    townCode: 545228,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37382,
    lat: 48.923831,
    long: 14.453933,
  },
  {
    town: 'Včelnička',
    townCode: 549002,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39470,
    lat: 49.304506,
    long: 15.042508,
  },
  {
    town: 'Věcov',
    townCode: 596957,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59244,
    lat: 49.616241,
    long: 16.170047,
  },
  {
    town: 'Vědomice',
    townCode: 565831,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.43399,
    long: 14.254008,
  },
  {
    town: 'Vedrovice',
    townCode: 595047,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67175,
    lat: 49.020997,
    long: 16.378598,
  },
  {
    town: 'Věchnov',
    townCode: 596965,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.499464,
    long: 16.279089,
  },
  {
    town: 'Vejprnice',
    townCode: 559580,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33027,
    lat: 49.729991,
    long: 13.276386,
  },
  {
    town: 'Vejprty',
    townCode: 563404,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43191,
    lat: 50.492426,
    long: 13.032237,
  },
  {
    town: 'Vejvanov',
    townCode: 560227,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33828,
    lat: 49.868769,
    long: 13.652523,
  },
  {
    town: 'Vejvanovice',
    townCode: 572471,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53862,
    lat: 49.971029,
    long: 15.880178,
  },
  {
    town: 'Velatice',
    townCode: 584096,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66405,
    lat: 49.197473,
    long: 16.753684,
  },
  {
    town: 'Velečín',
    townCode: 578924,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33165,
    lat: 50.074416,
    long: 13.401709,
  },
  {
    town: 'Velehrad',
    townCode: 592790,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68706,
    lat: 49.105527,
    long: 17.394372,
  },
  {
    town: 'Velemín',
    townCode: 565849,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41131,
    lat: 50.53909,
    long: 13.976864,
  },
  {
    town: 'Velemyšleves',
    townCode: 566870,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.402684,
    long: 13.563783,
  },
  {
    town: 'Veleň',
    townCode: 538965,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25063,
    lat: 50.173318,
    long: 14.554314,
  },
  {
    town: 'Velenice',
    townCode: 562173,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47002,
    lat: 50.719064,
    long: 14.664004,
  },
  {
    town: 'Velenice',
    townCode: 536083,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28901,
    lat: 50.214463,
    long: 15.226475,
  },
  {
    town: 'Velenka',
    townCode: 534871,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28912,
    lat: 50.139824,
    long: 14.895712,
  },
  {
    town: 'Velenov',
    townCode: 530824,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68001,
    lat: 49.48694,
    long: 16.73287,
  },
  {
    town: 'Velešín',
    townCode: 545821,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.829589,
    long: 14.462614,
  },
  {
    town: 'Velešovice',
    townCode: 593681,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68301,
    lat: 49.179261,
    long: 16.849241,
  },
  {
    town: 'Veletiny',
    townCode: 592803,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68733,
    lat: 49.037101,
    long: 17.562531,
  },
  {
    town: 'Veletov',
    townCode: 533823,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.028423,
    long: 15.304983,
  },
  {
    town: 'Velhartice',
    townCode: 557366,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34142,
    lat: 49.265299,
    long: 13.389852,
  },
  {
    town: 'Velichov',
    townCode: 555703,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36301,
    lat: 50.284179,
    long: 13.009826,
  },
  {
    town: 'Velichovky',
    townCode: 574554,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55211,
    lat: 50.356869,
    long: 15.84179,
  },
  {
    town: 'Veliká Ves',
    townCode: 538973,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25070,
    lat: 50.243718,
    long: 14.455186,
  },
  {
    town: 'Veliká Ves',
    townCode: 563412,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44101,
    lat: 50.269771,
    long: 13.37473,
  },
  {
    town: 'Velim',
    townCode: 533831,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28101,
    lat: 50.059756,
    long: 15.107217,
  },
  {
    town: 'Veliny',
    townCode: 575941,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53401,
    lat: 50.071154,
    long: 16.053816,
  },
  {
    town: 'Veliš',
    townCode: 573728,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50721,
    lat: 50.407596,
    long: 15.317707,
  },
  {
    town: 'Veliš',
    townCode: 530867,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25706,
    lat: 49.668658,
    long: 14.823244,
  },
  {
    town: 'Velká Bíteš',
    townCode: 596973,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59501,
    lat: 49.288727,
    long: 16.225957,
  },
  {
    town: 'Velká Buková',
    townCode: 542563,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27023,
    lat: 50.03466,
    long: 13.847293,
  },
  {
    town: 'Velká Bukovina',
    townCode: 562891,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40729,
    lat: 50.730538,
    long: 14.396877,
  },
  {
    town: 'Velká Bystřice',
    townCode: 505609,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78353,
    lat: 49.594326,
    long: 17.364082,
  },
  {
    town: 'Velká Dobrá',
    townCode: 533025,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27361,
    lat: 50.109746,
    long: 14.069904,
  },
  {
    town: 'Velká Hleďsebe',
    townCode: 539279,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.966767,
    long: 12.666767,
  },
  {
    town: 'Velká Chmelištná',
    townCode: 529699,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27034,
    lat: 50.063738,
    long: 13.551658,
  },
  {
    town: 'Velká Chyška',
    townCode: 549011,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39428,
    lat: 49.511858,
    long: 15.037368,
  },
  {
    town: 'Velká Jesenice',
    townCode: 574562,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55224,
    lat: 50.361175,
    long: 16.037736,
  },
  {
    town: 'Velká Kraš',
    townCode: 553468,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79058,
    lat: 50.363176,
    long: 17.146487,
  },
  {
    town: 'Velká Lečice',
    townCode: 513539,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26205,
    lat: 49.814815,
    long: 14.323587,
  },
  {
    town: 'Velká Lhota',
    townCode: 545147,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75701,
    lat: 49.437895,
    long: 18.035719,
  },
  {
    town: 'Velká Losenice',
    townCode: 596981,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59211,
    lat: 49.580804,
    long: 15.836834,
  },
  {
    town: 'Velká nad Veličkou',
    townCode: 586714,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69674,
    lat: 48.882667,
    long: 17.520706,
  },
  {
    town: 'Velká Polom',
    townCode: 510882,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74764,
    lat: 49.863692,
    long: 18.093414,
  },
  {
    town: 'Velká Skrovnice',
    townCode: 581101,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56201,
    lat: 50.030493,
    long: 16.317005,
  },
  {
    town: 'Velká Štáhle',
    townCode: 551694,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79351,
    lat: 49.9298,
    long: 17.35708,
  },
  {
    town: 'Velká Turná',
    townCode: 536741,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38601,
    lat: 49.340306,
    long: 13.958805,
  },
  {
    town: 'Velké Albrechtice',
    townCode: 568422,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74291,
    lat: 49.750537,
    long: 18.044045,
  },
  {
    town: 'Velké Bílovice',
    townCode: 584983,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69102,
    lat: 48.849388,
    long: 16.892379,
  },
  {
    town: 'Velké Březno',
    townCode: 568350,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40323,
    lat: 50.662808,
    long: 14.141852,
  },
  {
    town: 'Velké Hamry',
    townCode: 563838,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46845,
    lat: 50.713834,
    long: 15.315498,
  },
  {
    town: 'Velké Heraltice',
    townCode: 510891,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74775,
    lat: 49.975025,
    long: 17.728896,
  },
  {
    town: 'Velké Hostěrádky',
    townCode: 584991,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69174,
    lat: 49.033238,
    long: 16.870336,
  },
  {
    town: 'Velké Hoštice',
    townCode: 510939,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74731,
    lat: 49.936189,
    long: 17.973904,
  },
  {
    town: 'Velké Hydčice',
    townCode: 557374,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.299235,
    long: 13.668052,
  },
  {
    town: 'Velké Chvojno',
    townCode: 555223,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40334,
    lat: 50.731698,
    long: 14.036815,
  },
  {
    town: 'Velké Janovice',
    townCode: 596990,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.587942,
    long: 16.220152,
  },
  {
    town: 'Velké Karlovice',
    townCode: 545163,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75606,
    lat: 49.360736,
    long: 18.283665,
  },
  {
    town: 'Velké Kunětice',
    townCode: 569453,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79052,
    lat: 50.316673,
    long: 17.266034,
  },
  {
    town: 'Velké Losiny',
    townCode: 541265,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78815,
    lat: 50.03207,
    long: 17.040687,
  },
  {
    town: 'Velké Meziříčí',
    townCode: 597007,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.356189,
    long: 16.013158,
  },
  {
    town: 'Velké Němčice',
    townCode: 585009,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69163,
    lat: 48.991777,
    long: 16.672186,
  },
  {
    town: 'Velké Opatovice',
    townCode: 582646,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67963,
    lat: 49.612471,
    long: 16.679574,
  },
  {
    town: 'Velké Pavlovice',
    townCode: 585017,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69106,
    lat: 48.904792,
    long: 16.816155,
  },
  {
    town: 'Velké Petrovice',
    townCode: 574571,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54954,
    lat: 50.517437,
    long: 16.206593,
  },
  {
    town: 'Velké Popovice',
    townCode: 538981,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25169,
    lat: 49.922621,
    long: 14.63945,
  },
  {
    town: 'Velké Poříčí',
    townCode: 547646,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54932,
    lat: 50.46187,
    long: 16.189414,
  },
  {
    town: 'Velké Přílepy',
    townCode: 539813,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25264,
    lat: 50.160605,
    long: 14.314579,
  },
  {
    town: 'Velké Přítočno',
    townCode: 533033,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27351,
    lat: 50.116572,
    long: 14.128345,
  },
  {
    town: 'Velké Svatoňovice',
    townCode: 579785,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54235,
    lat: 50.531736,
    long: 16.02864,
  },
  {
    town: 'Velké Tresné',
    townCode: 587893,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.575246,
    long: 16.380585,
  },
  {
    town: 'Velké Všelisy',
    townCode: 536857,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29427,
    lat: 50.379137,
    long: 14.745169,
  },
  {
    town: 'Velké Žernoseky',
    townCode: 565857,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41201,
    lat: 50.539512,
    long: 14.063884,
  },
  {
    town: 'Velký Beranov',
    townCode: 588113,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58821,
    lat: 49.405141,
    long: 15.667107,
  },
  {
    town: 'Velký Bor',
    townCode: 557382,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34101,
    lat: 49.365032,
    long: 13.701518,
  },
  {
    town: 'Velký Borek',
    townCode: 535265,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27731,
    lat: 50.345385,
    long: 14.515362,
  },
  {
    town: 'Velký Chlumec',
    townCode: 531910,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.82779,
    long: 14.087127,
  },
  {
    town: 'Velký Karlov',
    townCode: 545325,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67128,
    lat: 48.804633,
    long: 16.305563,
  },
  {
    town: 'Velký Luh',
    townCode: 578002,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35134,
    lat: 50.19907,
    long: 12.372344,
  },
  {
    town: 'Velký Malahov',
    townCode: 554413,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.623677,
    long: 12.955437,
  },
  {
    town: 'Velký Ořechov',
    townCode: 585912,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76307,
    lat: 49.109464,
    long: 17.668544,
  },
  {
    town: 'Velký Osek',
    townCode: 533840,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28151,
    lat: 50.098769,
    long: 15.186392,
  },
  {
    town: 'Velký Ratmírov',
    townCode: 562599,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37701,
    lat: 49.177749,
    long: 14.937594,
  },
  {
    town: 'Velký Rybník',
    townCode: 549045,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.490331,
    long: 15.308075,
  },
  {
    town: 'Velký Šenov',
    townCode: 562912,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40778,
    lat: 50.990885,
    long: 14.374393,
  },
  {
    town: 'Velký Třebešov',
    townCode: 574589,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55202,
    lat: 50.392984,
    long: 16.006468,
  },
  {
    town: 'Velký Týnec',
    townCode: 505650,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78372,
    lat: 49.552072,
    long: 17.33766,
  },
  {
    town: 'Velký Újezd',
    townCode: 505668,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78355,
    lat: 49.578679,
    long: 17.483576,
  },
  {
    town: 'Velký Valtinov',
    townCode: 562203,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47125,
    lat: 50.743566,
    long: 14.735433,
  },
  {
    town: 'Velký Vřešťov',
    townCode: 579793,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54454,
    lat: 50.358583,
    long: 15.751652,
  },
  {
    town: 'Vělopolí',
    townCode: 552615,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73959,
    lat: 49.700533,
    long: 18.571008,
  },
  {
    town: 'Veltěže',
    townCode: 566896,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.353316,
    long: 13.875325,
  },
  {
    town: 'Veltruby',
    townCode: 533858,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.070692,
    long: 15.184648,
  },
  {
    town: 'Veltrusy',
    townCode: 535273,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27746,
    lat: 50.270563,
    long: 14.328679,
  },
  {
    town: 'Velvary',
    townCode: 533041,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27324,
    lat: 50.281619,
    long: 14.236266,
  },
  {
    town: 'Vémyslice',
    townCode: 595055,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67142,
    lat: 49.022141,
    long: 16.256897,
  },
  {
    town: 'Vendolí',
    townCode: 578932,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56914,
    lat: 49.739926,
    long: 16.413371,
  },
  {
    town: 'Vendryně',
    townCode: 554928,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73994,
    lat: 49.666714,
    long: 18.713186,
  },
  {
    town: 'Vepříkov',
    townCode: 569674,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.744231,
    long: 15.571018,
  },
  {
    town: 'Vepřová',
    townCode: 597015,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59211,
    lat: 49.612545,
    long: 15.82748,
  },
  {
    town: 'Verměřovice',
    townCode: 581119,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56152,
    lat: 50.005589,
    long: 16.562656,
  },
  {
    town: 'Verneřice',
    townCode: 562921,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40725,
    lat: 50.661245,
    long: 14.301255,
  },
  {
    town: 'Vernéřovice',
    townCode: 547743,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54982,
    lat: 50.614973,
    long: 16.221073,
  },
  {
    town: 'Vernířovice',
    townCode: 554146,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78815,
    lat: 50.031808,
    long: 17.130104,
  },
  {
    town: 'Věrovany',
    townCode: 552119,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78375,
    lat: 49.461184,
    long: 17.288054,
  },
  {
    town: 'Verušičky',
    townCode: 555711,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36452,
    lat: 50.14131,
    long: 13.173868,
  },
  {
    town: 'Veřovice',
    townCode: 500259,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74273,
    lat: 49.539264,
    long: 18.114362,
  },
  {
    town: 'Ves Touškov',
    townCode: 558494,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33301,
    lat: 49.661704,
    long: 13.119336,
  },
  {
    town: 'Vesce',
    townCode: 553263,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.249796,
    long: 14.676986,
  },
  {
    town: 'Veselá',
    townCode: 549053,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39470,
    lat: 49.319162,
    long: 15.226841,
  },
  {
    town: 'Veselá',
    townCode: 577642,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51252,
    lat: 50.546714,
    long: 15.308967,
  },
  {
    town: 'Veselá',
    townCode: 560235,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33701,
    lat: 49.695183,
    long: 13.602933,
  },
  {
    town: 'Veselá',
    townCode: 585921,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 49.237591,
    long: 17.775561,
  },
  {
    town: 'Veselé',
    townCode: 562939,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40502,
    lat: 50.784784,
    long: 14.37384,
  },
  {
    town: 'Veselí',
    townCode: 575968,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53501,
    lat: 50.011243,
    long: 15.618926,
  },
  {
    town: 'Veselí nad Lužnicí',
    townCode: 553271,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.186616,
    long: 14.699294,
  },
  {
    town: 'Veselí nad Moravou',
    townCode: 586722,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69801,
    lat: 48.952477,
    long: 17.381015,
  },
  {
    town: 'Veselice',
    townCode: 565725,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29404,
    lat: 50.396148,
    long: 15.127224,
  },
  {
    town: 'Veselíčko',
    townCode: 549975,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39842,
    lat: 49.388105,
    long: 14.35687,
  },
  {
    town: 'Veselíčko',
    townCode: 520420,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75125,
    lat: 49.532193,
    long: 17.509241,
  },
  {
    town: 'Veselý Žďár',
    townCode: 569682,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.639737,
    long: 15.526155,
  },
  {
    town: 'Vestec',
    townCode: 547565,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55205,
    lat: 50.421946,
    long: 16.02139,
  },
  {
    town: 'Vestec',
    townCode: 537942,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28933,
    lat: 50.23837,
    long: 15.146101,
  },
  {
    town: 'Vestec',
    townCode: 513458,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25242,
    lat: 49.9806,
    long: 14.504981,
  },
  {
    town: 'Věstín',
    townCode: 597031,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59265,
    lat: 49.566977,
    long: 16.340016,
  },
  {
    town: 'Věšín',
    townCode: 541508,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26243,
    lat: 49.615355,
    long: 13.824322,
  },
  {
    town: 'Věteřov',
    townCode: 586731,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69701,
    lat: 49.028625,
    long: 17.056248,
  },
  {
    town: 'Větrný Jeníkov',
    townCode: 588121,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58842,
    lat: 49.475877,
    long: 15.478957,
  },
  {
    town: 'Větrušice',
    townCode: 538990,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25067,
    lat: 50.190903,
    long: 14.383516,
  },
  {
    town: 'Větřkovice',
    townCode: 570036,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74743,
    lat: 49.780606,
    long: 17.820558,
  },
  {
    town: 'Větřní',
    townCode: 545830,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38211,
    lat: 48.774351,
    long: 14.286258,
  },
  {
    town: 'Vevčice',
    townCode: 595063,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67153,
    lat: 48.962305,
    long: 16.044533,
  },
  {
    town: 'Veverská Bítýška',
    townCode: 584100,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66471,
    lat: 49.276013,
    long: 16.436969,
  },
  {
    town: 'Veverské Knínice',
    townCode: 584118,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66481,
    lat: 49.236997,
    long: 16.401931,
  },
  {
    town: 'Věž',
    townCode: 569691,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58256,
    lat: 49.563955,
    long: 15.459156,
  },
  {
    town: 'Věžky',
    townCode: 552755,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75119,
    lat: 49.405119,
    long: 17.42328,
  },
  {
    town: 'Věžky',
    townCode: 589128,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76833,
    lat: 49.28519,
    long: 17.281547,
  },
  {
    town: 'Věžná',
    townCode: 549061,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.414284,
    long: 14.988823,
  },
  {
    town: 'Věžná',
    townCode: 597040,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.460826,
    long: 16.271321,
  },
  {
    town: 'Věžnice',
    townCode: 569704,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58252,
    lat: 49.514522,
    long: 15.695774,
  },
  {
    town: 'Věžnice',
    townCode: 588130,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58827,
    lat: 49.480083,
    long: 15.695408,
  },
  {
    town: 'Věžnička',
    townCode: 588148,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.46043,
    long: 15.70555,
  },
  {
    town: 'Věžovatá Pláně',
    townCode: 536300,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.77629,
    long: 14.409159,
  },
  {
    town: 'Vchynice',
    townCode: 565865,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.510608,
    long: 14.020198,
  },
  {
    town: 'Víceměřice',
    townCode: 590134,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79826,
    lat: 49.344156,
    long: 17.171909,
  },
  {
    town: 'Vícemil',
    townCode: 561037,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.263954,
    long: 14.894383,
  },
  {
    town: 'Vícenice',
    townCode: 588342,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67602,
    lat: 49.08913,
    long: 15.812238,
  },
  {
    town: 'Vícenice u Náměště nad Oslavou',
    townCode: 511242,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.202721,
    long: 16.126096,
  },
  {
    town: 'Vícov',
    townCode: 590142,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79803,
    lat: 49.488573,
    long: 16.959663,
  },
  {
    town: 'Vidče',
    townCode: 545198,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75653,
    lat: 49.441612,
    long: 18.094836,
  },
  {
    town: 'Vídeň',
    townCode: 597058,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59401,
    lat: 49.392227,
    long: 16.03173,
  },
  {
    town: 'Vidice',
    townCode: 554421,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34601,
    lat: 49.613863,
    long: 12.835622,
  },
  {
    town: 'Vidice',
    townCode: 534536,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28401,
    lat: 49.91671,
    long: 15.165597,
  },
  {
    town: 'Vidim',
    townCode: 531936,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.467953,
    long: 14.525934,
  },
  {
    town: 'Vidlatá Seč',
    townCode: 578941,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57001,
    lat: 49.836139,
    long: 16.205311,
  },
  {
    town: 'Vidnava',
    townCode: 541303,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79055,
    lat: 50.372435,
    long: 17.18636,
  },
  {
    town: 'Vidochov',
    townCode: 573736,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50901,
    lat: 50.512639,
    long: 15.565907,
  },
  {
    town: 'Vidonín',
    townCode: 597066,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59457,
    lat: 49.379842,
    long: 16.222546,
  },
  {
    town: 'Vidov',
    townCode: 535737,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37007,
    lat: 48.926848,
    long: 14.494749,
  },
  {
    town: 'Vigantice',
    townCode: 545210,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75661,
    lat: 49.443885,
    long: 18.184136,
  },
  {
    town: 'Víchová nad Jizerou',
    townCode: 577651,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51241,
    lat: 50.630181,
    long: 15.487779,
  },
  {
    town: 'Vikantice',
    townCode: 553191,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78825,
    lat: 50.13639,
    long: 16.99307,
  },
  {
    town: 'Vikýřovice',
    townCode: 569445,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78813,
    lat: 49.976988,
    long: 17.013562,
  },
  {
    town: 'Vílanec',
    townCode: 588156,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58835,
    lat: 49.334609,
    long: 15.576862,
  },
  {
    town: 'Vilantice',
    townCode: 574597,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.365933,
    long: 15.788877,
  },
  {
    town: 'Vilémov',
    townCode: 569712,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58283,
    lat: 49.815761,
    long: 15.53594,
  },
  {
    town: 'Vilémov',
    townCode: 568961,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78322,
    lat: 49.635568,
    long: 16.99541,
  },
  {
    town: 'Vilémov',
    townCode: 562947,
    district: 'Děčín',
    lau: 'CZ0421',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40780,
    lat: 50.990647,
    long: 14.335423,
  },
  {
    town: 'Vilémov',
    townCode: 563439,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43154,
    lat: 50.301078,
    long: 13.312156,
  },
  {
    town: 'Vilémovice',
    townCode: 582654,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67906,
    lat: 49.363886,
    long: 16.746834,
  },
  {
    town: 'Vilémovice',
    townCode: 569721,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58401,
    lat: 49.686513,
    long: 15.321935,
  },
  {
    town: 'Vilice',
    townCode: 553280,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.564574,
    long: 14.864415,
  },
  {
    town: 'Vimperk',
    townCode: 550647,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38501,
    lat: 49.052562,
    long: 13.774586,
  },
  {
    town: 'Vinary',
    townCode: 571083,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50353,
    lat: 50.289608,
    long: 15.428963,
  },
  {
    town: 'Vinary',
    townCode: 572489,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53863,
    lat: 49.959207,
    long: 16.060381,
  },
  {
    town: 'Vinaře',
    townCode: 534544,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.909198,
    long: 15.501395,
  },
  {
    town: 'Vinařice',
    townCode: 534234,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26701,
    lat: 49.892649,
    long: 14.098173,
  },
  {
    town: 'Vinařice',
    townCode: 533050,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27307,
    lat: 50.175951,
    long: 14.091171,
  },
  {
    town: 'Vinařice',
    townCode: 565628,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29441,
    lat: 50.373911,
    long: 14.952383,
  },
  {
    town: 'Vinařice',
    townCode: 566918,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43915,
    lat: 50.265764,
    long: 13.822865,
  },
  {
    town: 'Vincencov',
    townCode: 544710,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79804,
    lat: 49.405804,
    long: 17.062571,
  },
  {
    town: 'Vinec',
    townCode: 570842,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29301,
    lat: 50.394714,
    long: 14.869901,
  },
  {
    town: 'Viničné Šumice',
    townCode: 584126,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66406,
    lat: 49.213678,
    long: 16.825512,
  },
  {
    town: 'Vintířov',
    townCode: 560685,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35735,
    lat: 50.233928,
    long: 12.717598,
  },
  {
    town: 'Vír',
    townCode: 597074,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59266,
    lat: 49.557484,
    long: 16.32369,
  },
  {
    town: 'Víska',
    townCode: 573582,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58301,
    lat: 49.770412,
    long: 15.652667,
  },
  {
    town: 'Víska u Jevíčka',
    townCode: 578959,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.652641,
    long: 16.707835,
  },
  {
    town: 'Vísky',
    townCode: 582662,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67933,
    lat: 49.538535,
    long: 16.625711,
  },
  {
    town: 'Vísky',
    townCode: 579289,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33843,
    lat: 49.651304,
    long: 13.682749,
  },
  {
    town: 'Višňová',
    townCode: 507652,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.219107,
    long: 14.841334,
  },
  {
    town: 'Višňová',
    townCode: 564494,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46401,
    lat: 50.966732,
    long: 15.02506,
  },
  {
    town: 'Višňová',
    townCode: 541516,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26261,
    lat: 49.705897,
    long: 14.145576,
  },
  {
    town: 'Višňové',
    townCode: 595071,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67138,
    lat: 48.982515,
    long: 16.150357,
  },
  {
    town: 'Vítanov',
    townCode: 572497,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.749189,
    long: 15.88183,
  },
  {
    town: 'Vitčice',
    townCode: 590151,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79827,
    lat: 49.311939,
    long: 17.240961,
  },
  {
    town: 'Vítějeves',
    townCode: 578967,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56906,
    lat: 49.615824,
    long: 16.465469,
  },
  {
    town: 'Vitějovice',
    townCode: 550655,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38427,
    lat: 49.046493,
    long: 14.073468,
  },
  {
    town: 'Vítězná',
    townCode: 579815,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54462,
    lat: 50.488959,
    long: 15.802302,
  },
  {
    town: 'Vitice',
    townCode: 533866,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28106,
    lat: 50.031106,
    long: 14.914611,
  },
  {
    town: 'Vitín',
    townCode: 535893,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37363,
    lat: 49.089591,
    long: 14.545974,
  },
  {
    town: 'Vitiněves',
    townCode: 573752,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.393404,
    long: 15.378316,
  },
  {
    town: 'Vítkov',
    townCode: 511021,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74901,
    lat: 49.774549,
    long: 17.749517,
  },
  {
    town: 'Vítkovice',
    townCode: 577669,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51238,
    lat: 50.679115,
    long: 15.531308,
  },
  {
    town: 'Vítonice',
    townCode: 595080,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67161,
    lat: 48.919467,
    long: 16.198985,
  },
  {
    town: 'Vítonice',
    townCode: 589136,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76861,
    lat: 49.447233,
    long: 17.693071,
  },
  {
    town: 'Vizovice',
    townCode: 585939,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76312,
    lat: 49.223073,
    long: 17.854921,
  },
  {
    town: 'Vižina',
    townCode: 534048,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26724,
    lat: 49.857297,
    long: 14.10473,
  },
  {
    town: 'Vlačice',
    townCode: 534552,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.943143,
    long: 15.437595,
  },
  {
    town: 'Vladislav',
    townCode: 591904,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67501,
    lat: 49.21027,
    long: 15.988403,
  },
  {
    town: 'Vlachova Lhota',
    townCode: 586994,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76601,
    lat: 49.149968,
    long: 17.953557,
  },
  {
    town: 'Vlachovice',
    townCode: 587869,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59231,
    lat: 49.597135,
    long: 16.041266,
  },
  {
    town: 'Vlachovice',
    townCode: 585955,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76324,
    lat: 49.123872,
    long: 17.940124,
  },
  {
    town: 'Vlachovo Březí',
    townCode: 550663,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38422,
    lat: 49.081457,
    long: 13.958519,
  },
  {
    town: 'Vlasatice',
    townCode: 585025,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69130,
    lat: 48.933846,
    long: 16.484529,
  },
  {
    town: 'Vlastec',
    townCode: 598844,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.365671,
    long: 14.211797,
  },
  {
    town: 'Vlastějovice',
    townCode: 534561,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28523,
    lat: 49.731406,
    long: 15.174893,
  },
  {
    town: 'Vlastiboř',
    townCode: 553298,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.258041,
    long: 14.63683,
  },
  {
    town: 'Vlastiboř',
    townCode: 563846,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.664974,
    long: 15.311826,
  },
  {
    town: 'Vlastibořice',
    townCode: 564516,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46344,
    lat: 50.618816,
    long: 15.052112,
  },
  {
    town: 'Vlastislav',
    townCode: 565873,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41114,
    lat: 50.497071,
    long: 13.955542,
  },
  {
    town: 'Vlašim',
    townCode: 530883,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.706428,
    long: 14.89891,
  },
  {
    town: 'Vlčatín',
    townCode: 591912,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67505,
    lat: 49.305945,
    long: 15.949022,
  },
  {
    town: 'Vlčetínec',
    townCode: 598640,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.264592,
    long: 15.054625,
  },
  {
    town: 'Vlčeves',
    townCode: 563447,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.357129,
    long: 14.900608,
  },
  {
    town: 'Vlčí',
    townCode: 566691,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.511993,
    long: 13.360356,
  },
  {
    town: 'Vlčí Habřina',
    townCode: 575984,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.085931,
    long: 15.596053,
  },
  {
    town: 'Vlčice',
    townCode: 579823,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54101,
    lat: 50.562693,
    long: 15.821685,
  },
  {
    town: 'Vlčice',
    townCode: 541346,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79065,
    lat: 50.345377,
    long: 17.046051,
  },
  {
    town: 'Vlčkov',
    townCode: 581127,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56002,
    lat: 49.907677,
    long: 16.350071,
  },
  {
    town: 'Vlčková',
    townCode: 585963,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76319,
    lat: 49.31062,
    long: 17.763428,
  },
  {
    town: 'Vlčkovice v Podkrkonoší',
    townCode: 579831,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.411116,
    long: 15.918264,
  },
  {
    town: 'Vlčnov',
    townCode: 592820,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68761,
    lat: 49.009996,
    long: 17.581938,
  },
  {
    town: 'Vlčtejn',
    townCode: 540706,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.614724,
    long: 13.495764,
  },
  {
    town: 'Vlkančice',
    townCode: 533874,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.901994,
    long: 14.897229,
  },
  {
    town: 'Vlkaneč',
    townCode: 534579,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28564,
    lat: 49.806485,
    long: 15.403224,
  },
  {
    town: 'Vlkanov',
    townCode: 569739,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58291,
    lat: 49.715726,
    long: 15.356843,
  },
  {
    town: 'Vlkanov',
    townCode: 566250,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34522,
    lat: 49.488639,
    long: 12.80529,
  },
  {
    town: 'Vlkava',
    townCode: 565571,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29443,
    lat: 50.271435,
    long: 14.961431,
  },
  {
    town: 'Vlkoš',
    townCode: 586749,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69641,
    lat: 48.989701,
    long: 17.163666,
  },
  {
    town: 'Vlkoš',
    townCode: 547433,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75119,
    lat: 49.395884,
    long: 17.419119,
  },
  {
    town: 'Vlkov',
    townCode: 535915,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.113445,
    long: 14.522263,
  },
  {
    town: 'Vlkov',
    townCode: 553310,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.151291,
    long: 14.725326,
  },
  {
    town: 'Vlkov',
    townCode: 597082,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59453,
    lat: 49.324479,
    long: 16.200393,
  },
  {
    town: 'Vlkov',
    townCode: 574601,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.312721,
    long: 15.898493,
  },
  {
    town: 'Vlkov pod Oškobrhem',
    townCode: 537951,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28904,
    lat: 50.156096,
    long: 15.22052,
  },
  {
    town: 'Vlkovice',
    townCode: 539376,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.948927,
    long: 12.739122,
  },
  {
    town: 'Vlksice',
    townCode: 598852,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.481012,
    long: 14.441291,
  },
  {
    town: 'Vnorovy',
    townCode: 586757,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69661,
    lat: 48.931064,
    long: 17.350609,
  },
  {
    town: 'Voděrady',
    townCode: 582671,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67901,
    lat: 49.481598,
    long: 16.557996,
  },
  {
    town: 'Voděrady',
    townCode: 576891,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51734,
    lat: 50.208788,
    long: 16.153245,
  },
  {
    town: 'Voděrady',
    townCode: 581143,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.949695,
    long: 16.285165,
  },
  {
    town: 'Vodice',
    townCode: 553328,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39153,
    lat: 49.464414,
    long: 14.909084,
  },
  {
    town: 'Vodňany',
    townCode: 551953,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38901,
    lat: 49.147997,
    long: 14.175231,
  },
  {
    town: 'Vodochody',
    townCode: 539015,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25069,
    lat: 50.206369,
    long: 14.398885,
  },
  {
    town: 'Vodranty',
    townCode: 531014,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.890465,
    long: 15.336406,
  },
  {
    town: 'Vodslivy',
    townCode: 532614,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25724,
    lat: 49.84965,
    long: 14.837298,
  },
  {
    town: 'Vohančice',
    townCode: 584134,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.321692,
    long: 16.39396,
  },
  {
    town: 'Vochov',
    townCode: 559601,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33023,
    lat: 49.757083,
    long: 13.278711,
  },
  {
    town: 'Vojkov',
    townCode: 530891,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25753,
    lat: 49.65232,
    long: 14.519906,
  },
  {
    town: 'Vojkovice',
    townCode: 584142,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66701,
    lat: 49.05148,
    long: 16.608308,
  },
  {
    town: 'Vojkovice',
    townCode: 555738,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36273,
    lat: 50.303424,
    long: 13.016307,
  },
  {
    town: 'Vojkovice',
    townCode: 552488,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.68244,
    long: 18.468124,
  },
  {
    town: 'Vojkovice',
    townCode: 535290,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27744,
    lat: 50.296287,
    long: 14.375238,
  },
  {
    town: 'Vojníkov',
    townCode: 562289,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.35378,
    long: 14.177156,
  },
  {
    town: 'Vojnův Městec',
    townCode: 597091,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.679555,
    long: 15.878389,
  },
  {
    town: 'Vojslavice',
    townCode: 549126,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.593204,
    long: 15.229069,
  },
  {
    town: 'Vojtanov',
    townCode: 539074,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35134,
    lat: 50.166294,
    long: 12.317021,
  },
  {
    town: 'Vojtěchov',
    townCode: 572501,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.788649,
    long: 15.973606,
  },
  {
    town: 'Vokov',
    townCode: 599239,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.395631,
    long: 15.219887,
  },
  {
    town: 'Volanice',
    townCode: 573761,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50703,
    lat: 50.335635,
    long: 15.398381,
  },
  {
    town: 'Volárna',
    townCode: 533882,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.091878,
    long: 15.240554,
  },
  {
    town: 'Volary',
    townCode: 550671,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38451,
    lat: 48.908916,
    long: 13.886674,
  },
  {
    town: 'Volduchy',
    townCode: 560251,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33822,
    lat: 49.776171,
    long: 13.623155,
  },
  {
    town: 'Voleč',
    townCode: 575992,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.117449,
    long: 15.572804,
  },
  {
    town: 'Volenice',
    townCode: 551961,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.252497,
    long: 13.747986,
  },
  {
    town: 'Volenice',
    townCode: 541524,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.547875,
    long: 13.883773,
  },
  {
    town: 'Volevčice',
    townCode: 588164,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.211082,
    long: 15.444727,
  },
  {
    town: 'Volevčice',
    townCode: 546437,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.434989,
    long: 13.690498,
  },
  {
    town: 'Volfartice',
    townCode: 562220,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47112,
    lat: 50.730204,
    long: 14.453036,
  },
  {
    town: 'Volfířov',
    townCode: 547441,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38001,
    lat: 49.106922,
    long: 15.370353,
  },
  {
    town: 'Volyně',
    townCode: 551970,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38701,
    lat: 49.165886,
    long: 13.886339,
  },
  {
    town: 'Vonoklasy',
    townCode: 539830,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25228,
    lat: 49.950219,
    long: 14.276801,
  },
  {
    town: 'Vortová',
    townCode: 572527,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53961,
    lat: 49.713143,
    long: 15.93634,
  },
  {
    town: 'Votice',
    townCode: 530905,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25901,
    lat: 49.64023,
    long: 14.63819,
  },
  {
    town: 'Voznice',
    townCode: 541541,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.817253,
    long: 14.21665,
  },
  {
    town: 'Vrábče',
    townCode: 545261,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.917453,
    long: 14.376014,
  },
  {
    town: 'Vraclav',
    townCode: 581151,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56542,
    lat: 49.968138,
    long: 16.090073,
  },
  {
    town: 'Vracov',
    townCode: 586765,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69642,
    lat: 48.975328,
    long: 17.211104,
  },
  {
    town: 'Vracovice',
    townCode: 550019,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.902225,
    long: 15.898792,
  },
  {
    town: 'Vracovice',
    townCode: 530913,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25801,
    lat: 49.662562,
    long: 14.932317,
  },
  {
    town: 'Vračovice-Orlov',
    townCode: 548022,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.952537,
    long: 16.252476,
  },
  {
    town: 'Vraňany',
    townCode: 535303,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27707,
    lat: 50.317291,
    long: 14.361804,
  },
  {
    town: 'Vrančice',
    townCode: 564362,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.610735,
    long: 14.041861,
  },
  {
    town: 'Vrané nad Vltavou',
    townCode: 539848,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25246,
    lat: 49.938512,
    long: 14.383447,
  },
  {
    town: 'Vranov',
    townCode: 584151,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66432,
    lat: 49.309357,
    long: 16.613878,
  },
  {
    town: 'Vranov',
    townCode: 579491,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.764487,
    long: 13.042022,
  },
  {
    town: 'Vranov',
    townCode: 530921,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25722,
    lat: 49.853416,
    long: 14.777021,
  },
  {
    town: 'Vranov nad Dyjí',
    townCode: 595098,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67103,
    lat: 48.894799,
    long: 15.812799,
  },
  {
    town: 'Vranová',
    townCode: 582689,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67962,
    lat: 49.553154,
    long: 16.525131,
  },
  {
    town: 'Vranová Lhota',
    townCode: 578975,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 57101,
    lat: 49.710743,
    long: 16.825363,
  },
  {
    town: 'Vranovice',
    townCode: 585033,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69125,
    lat: 48.966097,
    long: 16.606707,
  },
  {
    town: 'Vranovice',
    townCode: 541567,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.622726,
    long: 13.899074,
  },
  {
    town: 'Vranovice-Kelčice',
    townCode: 590177,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79808,
    lat: 49.400982,
    long: 17.111366,
  },
  {
    town: 'Vranovská Ves',
    townCode: 595101,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67151,
    lat: 48.951592,
    long: 15.918586,
  },
  {
    town: 'Vraný',
    townCode: 533068,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27373,
    lat: 50.327189,
    long: 14.017251,
  },
  {
    town: 'Vratěnín',
    townCode: 595110,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.904186,
    long: 15.595278,
  },
  {
    town: 'Vratimov',
    townCode: 598879,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73932,
    lat: 49.77005,
    long: 18.310255,
  },
  {
    town: 'Vratislávka',
    townCode: 597104,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59451,
    lat: 49.386513,
    long: 16.244137,
  },
  {
    town: 'Vrátkov',
    townCode: 564826,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28201,
    lat: 50.047055,
    long: 14.834885,
  },
  {
    town: 'Vrátno',
    townCode: 572021,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29426,
    lat: 50.432702,
    long: 14.693699,
  },
  {
    town: 'Vráto',
    townCode: 535796,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.988054,
    long: 14.527017,
  },
  {
    town: 'Vráž',
    townCode: 549991,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39832,
    lat: 49.383148,
    long: 14.12798,
  },
  {
    town: 'Vráž',
    townCode: 531944,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26711,
    lat: 49.983443,
    long: 14.12902,
  },
  {
    town: 'Vražkov',
    townCode: 565881,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.373533,
    long: 14.268153,
  },
  {
    town: 'Vražné',
    townCode: 554910,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74235,
    lat: 49.628789,
    long: 17.866773,
  },
  {
    town: 'Vrážné',
    townCode: 572292,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.675991,
    long: 16.778122,
  },
  {
    town: 'Vrbátky',
    townCode: 590185,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79813,
    lat: 49.508146,
    long: 17.200051,
  },
  {
    town: 'Vrbatův Kostelec',
    townCode: 572535,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53956,
    lat: 49.856443,
    long: 15.941145,
  },
  {
    town: 'Vrbčany',
    townCode: 533891,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.050307,
    long: 14.992861,
  },
  {
    town: 'Vrbice',
    townCode: 529915,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38473,
    lat: 49.141384,
    long: 13.715891,
  },
  {
    town: 'Vrbice',
    townCode: 585041,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69109,
    lat: 48.915184,
    long: 16.897893,
  },
  {
    town: 'Vrbice',
    townCode: 566675,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36453,
    lat: 50.14965,
    long: 13.233839,
  },
  {
    town: 'Vrbice',
    townCode: 572128,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50703,
    lat: 50.369139,
    long: 15.428878,
  },
  {
    town: 'Vrbice',
    townCode: 548707,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51741,
    lat: 50.08923,
    long: 16.251784,
  },
  {
    town: 'Vrbice',
    townCode: 599611,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28904,
    lat: 50.181015,
    long: 15.230617,
  },
  {
    town: 'Vrbice',
    townCode: 565890,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41164,
    lat: 50.4833,
    long: 14.286605,
  },
  {
    town: 'Vrbičany',
    townCode: 571431,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27374,
    lat: 50.308192,
    long: 13.995897,
  },
  {
    town: 'Vrbičany',
    townCode: 565903,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41121,
    lat: 50.462705,
    long: 14.084782,
  },
  {
    town: 'Vrbka',
    townCode: 542393,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76821,
    lat: 49.228329,
    long: 17.413233,
  },
  {
    town: 'Vrbno nad Lesy',
    townCode: 566926,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43906,
    lat: 50.32262,
    long: 13.907083,
  },
  {
    town: 'Vrbno pod Pradědem',
    townCode: 597961,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79326,
    lat: 50.121048,
    long: 17.383262,
  },
  {
    town: 'Vrbová Lhota',
    townCode: 537977,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28911,
    lat: 50.112053,
    long: 15.062754,
  },
  {
    town: 'Vrbovec',
    townCode: 595128,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67124,
    lat: 48.799878,
    long: 16.100716,
  },
  {
    town: 'Vrcovice',
    townCode: 550001,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.344758,
    long: 14.174529,
  },
  {
    town: 'Vrčeň',
    townCode: 558559,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33541,
    lat: 49.508064,
    long: 13.618988,
  },
  {
    town: 'Vrdy',
    townCode: 534587,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28571,
    lat: 49.921633,
    long: 15.472535,
  },
  {
    town: 'Vrhaveč',
    townCode: 557455,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33901,
    lat: 49.345613,
    long: 13.29636,
  },
  {
    town: 'Vrchlabí',
    townCode: 579858,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54301,
    lat: 50.617189,
    long: 15.605106,
  },
  {
    town: 'Vrchoslavice',
    townCode: 590193,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79827,
    lat: 49.332781,
    long: 17.219343,
  },
  {
    town: 'Vrchotovy Janovice',
    townCode: 530948,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25753,
    lat: 49.666919,
    long: 14.577909,
  },
  {
    town: 'Vrchovany',
    townCode: 562238,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.55324,
    long: 14.57122,
  },
  {
    town: 'Vrchovnice',
    townCode: 548057,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.323032,
    long: 15.757627,
  },
  {
    town: 'Vrchy',
    townCode: 569747,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74245,
    lat: 49.75108,
    long: 17.871191,
  },
  {
    town: 'Vroutek',
    townCode: 566934,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43982,
    lat: 50.180096,
    long: 13.37997,
  },
  {
    town: 'Vrskmaň',
    townCode: 563463,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43115,
    lat: 50.488266,
    long: 13.495732,
  },
  {
    town: 'Vršce',
    townCode: 573795,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50733,
    lat: 50.323952,
    long: 15.323155,
  },
  {
    town: 'Vršovice',
    townCode: 511161,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74761,
    lat: 49.884925,
    long: 17.93542,
  },
  {
    town: 'Vršovice',
    townCode: 546887,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.368582,
    long: 13.842119,
  },
  {
    town: 'Vršovka',
    townCode: 574627,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54901,
    lat: 50.323287,
    long: 16.120261,
  },
  {
    town: 'Vrutice',
    townCode: 565911,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41147,
    lat: 50.502216,
    long: 14.289857,
  },
  {
    town: 'Vřesina',
    townCode: 568244,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74720,
    lat: 49.945634,
    long: 18.190598,
  },
  {
    town: 'Vřesina',
    townCode: 500291,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74285,
    lat: 49.824282,
    long: 18.125802,
  },
  {
    town: 'Vřeskovice',
    townCode: 566055,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33401,
    lat: 49.525544,
    long: 13.271216,
  },
  {
    town: 'Vřesník',
    townCode: 549029,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50771,
    lat: 50.438105,
    long: 15.628263,
  },
  {
    town: 'Vřesová',
    townCode: 560707,
    district: 'Sokolov',
    lau: 'CZ0413',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35735,
    lat: 50.259197,
    long: 12.696593,
  },
  {
    town: 'Vřesovice',
    townCode: 586773,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69648,
    lat: 49.059182,
    long: 17.215114,
  },
  {
    town: 'Vřesovice',
    townCode: 590207,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79809,
    lat: 49.401769,
    long: 17.139043,
  },
  {
    town: 'Vsetín',
    townCode: 541630,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75501,
    lat: 49.339025,
    long: 17.993952,
  },
  {
    town: 'Vstiš',
    townCode: 558567,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33441,
    lat: 49.645645,
    long: 13.249051,
  },
  {
    town: 'Všehrdy',
    townCode: 566497,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.963781,
    long: 13.585179,
  },
  {
    town: 'Všehrdy',
    townCode: 563471,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43001,
    lat: 50.420047,
    long: 13.461343,
  },
  {
    town: 'Všechlapy',
    townCode: 532266,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25726,
    lat: 49.779125,
    long: 14.914341,
  },
  {
    town: 'Všechlapy',
    townCode: 537985,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28802,
    lat: 50.221181,
    long: 15.028509,
  },
  {
    town: 'Všechovice',
    townCode: 584169,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66603,
    lat: 49.357215,
    long: 16.494182,
  },
  {
    town: 'Všechovice',
    townCode: 521531,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75353,
    lat: 49.462861,
    long: 17.758247,
  },
  {
    town: 'Všejany',
    townCode: 536938,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29443,
    lat: 50.25487,
    long: 14.953611,
  },
  {
    town: 'Všekary',
    townCode: 566071,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34562,
    lat: 49.603515,
    long: 13.042559,
  },
  {
    town: 'Všelibice',
    townCode: 564532,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46348,
    lat: 50.64615,
    long: 14.95149,
  },
  {
    town: 'Všemina',
    townCode: 585971,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76315,
    lat: 49.2811,
    long: 17.876932,
  },
  {
    town: 'Všemyslice',
    townCode: 545287,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37501,
    lat: 49.217064,
    long: 14.35799,
  },
  {
    town: 'Všeň',
    townCode: 577677,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51265,
    lat: 50.557553,
    long: 15.105323,
  },
  {
    town: 'Všenice',
    townCode: 566799,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33824,
    lat: 49.817992,
    long: 13.560771,
  },
  {
    town: 'Všenory',
    townCode: 539856,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25231,
    lat: 49.928938,
    long: 14.304031,
  },
  {
    town: 'Všepadly',
    townCode: 554448,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34543,
    lat: 49.45098,
    long: 13.105384,
  },
  {
    town: 'Všeradice',
    townCode: 531952,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26726,
    lat: 49.873756,
    long: 14.104868,
  },
  {
    town: 'Všeradov',
    townCode: 572543,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.747799,
    long: 15.837299,
  },
  {
    town: 'Všeruby',
    townCode: 554456,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34507,
    lat: 49.340829,
    long: 12.983339,
  },
  {
    town: 'Všeruby',
    townCode: 559628,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33016,
    lat: 49.841781,
    long: 13.229541,
  },
  {
    town: 'Všestary',
    townCode: 571091,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50312,
    lat: 50.255417,
    long: 15.760224,
  },
  {
    town: 'Všestary',
    townCode: 539031,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25163,
    lat: 49.958709,
    long: 14.68537,
  },
  {
    town: 'Všestudy',
    townCode: 535311,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27746,
    lat: 50.290915,
    long: 14.342686,
  },
  {
    town: 'Všestudy',
    townCode: 563480,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43111,
    lat: 50.457467,
    long: 13.507709,
  },
  {
    town: 'Všesulov',
    townCode: 565130,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27034,
    lat: 50.039761,
    long: 13.610986,
  },
  {
    town: 'Všetaty',
    townCode: 535320,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27716,
    lat: 50.281971,
    long: 14.593081,
  },
  {
    town: 'Všetaty',
    townCode: 542598,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27021,
    lat: 50.046201,
    long: 13.757751,
  },
  {
    town: 'Vševily',
    townCode: 598437,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26272,
    lat: 49.565277,
    long: 13.882648,
  },
  {
    town: 'Výčapy',
    townCode: 591939,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67401,
    lat: 49.143644,
    long: 15.877648,
  },
  {
    town: 'Vydří',
    townCode: 562629,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37802,
    lat: 49.09253,
    long: 14.945728,
  },
  {
    town: 'Vykáň',
    townCode: 537993,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28915,
    lat: 50.119966,
    long: 14.816787,
  },
  {
    town: 'Vyklantice',
    townCode: 549134,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39427,
    lat: 49.554788,
    long: 15.040579,
  },
  {
    town: 'Výkleky',
    townCode: 547450,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75125,
    lat: 49.554998,
    long: 17.475728,
  },
  {
    town: 'Výprachtice',
    townCode: 581178,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56134,
    lat: 49.987302,
    long: 16.663918,
  },
  {
    town: 'Výrava',
    townCode: 571105,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50303,
    lat: 50.269739,
    long: 15.979052,
  },
  {
    town: 'Výrov',
    townCode: 566969,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 49.961857,
    long: 13.462671,
  },
  {
    town: 'Výrovice',
    townCode: 595136,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67134,
    lat: 48.928356,
    long: 16.120391,
  },
  {
    town: 'Vyskeř',
    townCode: 577685,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51264,
    lat: 50.529406,
    long: 15.15805,
  },
  {
    town: 'Vyskytná',
    townCode: 549142,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39405,
    lat: 49.428265,
    long: 15.365624,
  },
  {
    town: 'Vyskytná nad Jihlavou',
    townCode: 588172,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58841,
    lat: 49.419455,
    long: 15.508243,
  },
  {
    town: 'Výsluní',
    townCode: 563498,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43183,
    lat: 50.466591,
    long: 13.237511,
  },
  {
    town: 'Vysočany',
    townCode: 582701,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67913,
    lat: 49.432008,
    long: 16.811126,
  },
  {
    town: 'Vysočany',
    townCode: 595144,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.941156,
    long: 15.689792,
  },
  {
    town: 'Vysočina',
    townCode: 572551,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53901,
    lat: 49.76477,
    long: 15.829087,
  },
  {
    town: 'Vysoká',
    townCode: 530654,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.562373,
    long: 15.622295,
  },
  {
    town: 'Vysoká',
    townCode: 597970,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79399,
    lat: 50.26149,
    long: 17.590344,
  },
  {
    town: 'Vysoká',
    townCode: 578991,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56943,
    lat: 49.663714,
    long: 16.810197,
  },
  {
    town: 'Vysoká',
    townCode: 535338,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27724,
    lat: 50.412655,
    long: 14.538285,
  },
  {
    town: 'Vysoká Lhota',
    townCode: 561771,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.416842,
    long: 15.042363,
  },
  {
    town: 'Vysoká Libyně',
    townCode: 530280,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33141,
    lat: 50.021988,
    long: 13.450793,
  },
  {
    town: 'Vysoká nad Labem',
    townCode: 571113,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50331,
    lat: 50.153472,
    long: 15.824842,
  },
  {
    town: 'Vysoká Pec',
    townCode: 578029,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36221,
    lat: 50.348275,
    long: 12.696743,
  },
  {
    town: 'Vysoká Pec',
    townCode: 563501,
    district: 'Chomutov',
    lau: 'CZ0422',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43159,
    lat: 50.520381,
    long: 13.470366,
  },
  {
    town: 'Vysoká Srbská',
    townCode: 574635,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54931,
    lat: 50.487806,
    long: 16.22766,
  },
  {
    town: 'Vysoká u Příbramě',
    townCode: 541583,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26242,
    lat: 49.63432,
    long: 13.948497,
  },
  {
    town: 'Vysoké',
    townCode: 588334,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.5819,
    long: 15.965315,
  },
  {
    town: 'Vysoké Chvojno',
    townCode: 576000,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53321,
    lat: 50.109088,
    long: 15.973593,
  },
  {
    town: 'Vysoké Mýto',
    townCode: 581186,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.954364,
    long: 16.164268,
  },
  {
    town: 'Vysoké nad Jizerou',
    townCode: 577693,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51211,
    lat: 50.685688,
    long: 15.401633,
  },
  {
    town: 'Vysoké Pole',
    townCode: 585980,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76325,
    lat: 49.177519,
    long: 17.93744,
  },
  {
    town: 'Vysoké Popovice',
    townCode: 584177,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.183126,
    long: 16.284964,
  },
  {
    town: 'Vysoké Studnice',
    townCode: 588181,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58821,
    lat: 49.394112,
    long: 15.73023,
  },
  {
    town: 'Vysoké Veselí',
    townCode: 573809,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50703,
    lat: 50.331055,
    long: 15.436421,
  },
  {
    town: 'Vysokov',
    townCode: 574643,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54912,
    lat: 50.403868,
    long: 16.116742,
  },
  {
    town: 'Vysoký Chlumec',
    townCode: 541591,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26252,
    lat: 49.617757,
    long: 14.389867,
  },
  {
    town: 'Vysoký Újezd',
    townCode: 548677,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51771,
    lat: 50.24034,
    long: 16.020182,
  },
  {
    town: 'Vysoký Újezd',
    townCode: 513482,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25744,
    lat: 49.813385,
    long: 14.476422,
  },
  {
    town: 'Vysoký Újezd',
    townCode: 531961,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26716,
    lat: 49.992234,
    long: 14.206303,
  },
  {
    town: 'Vystrčenovice',
    townCode: 588199,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.151246,
    long: 15.53056,
  },
  {
    town: 'Vystrkov',
    townCode: 561797,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39601,
    lat: 49.51978,
    long: 15.348901,
  },
  {
    town: 'Vyšehněvice',
    townCode: 576018,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53341,
    lat: 50.102402,
    long: 15.583741,
  },
  {
    town: 'Vyšehoří',
    townCode: 570095,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.93371,
    long: 16.87848,
  },
  {
    town: 'Vyšehořovice',
    townCode: 539040,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25087,
    lat: 50.117881,
    long: 14.773799,
  },
  {
    town: 'Vyškov',
    townCode: 592889,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68201,
    lat: 49.277552,
    long: 16.996199,
  },
  {
    town: 'Výškov',
    townCode: 566951,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.394975,
    long: 13.670442,
  },
  {
    town: 'Vyškovec',
    townCode: 592838,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68774,
    lat: 48.94083,
    long: 17.853445,
  },
  {
    town: 'Vyšní Lhoty',
    townCode: 552682,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73951,
    lat: 49.635907,
    long: 18.457023,
  },
  {
    town: 'Výšovice',
    townCode: 590215,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79809,
    lat: 49.416444,
    long: 17.13914,
  },
  {
    town: 'Vyšší Brod',
    townCode: 545848,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38273,
    lat: 48.616082,
    long: 14.311919,
  },
  {
    town: 'Výžerky',
    townCode: 564796,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.945155,
    long: 14.883469,
  },
  {
    town: 'Vyžice',
    townCode: 547841,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53803,
    lat: 49.923275,
    long: 15.621171,
  },
  {
    town: 'Vyžlovka',
    townCode: 533904,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.984752,
    long: 14.789195,
  },
  {
    town: 'Xaverov',
    townCode: 571415,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28506,
    lat: 49.842785,
    long: 14.884454,
  },
  {
    town: 'Zábeštní Lhota',
    townCode: 547514,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75127,
    lat: 49.511965,
    long: 17.431217,
  },
  {
    town: 'Záblatí',
    townCode: 508683,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37901,
    lat: 49.107283,
    long: 14.686266,
  },
  {
    town: 'Záblatí',
    townCode: 550680,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38433,
    lat: 48.998654,
    long: 13.931392,
  },
  {
    town: 'Záblatí',
    townCode: 597112,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59453,
    lat: 49.320849,
    long: 16.166438,
  },
  {
    town: 'Záborná',
    townCode: 588202,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.486751,
    long: 15.756929,
  },
  {
    town: 'Záboří',
    townCode: 545317,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37384,
    lat: 48.990054,
    long: 14.26727,
  },
  {
    town: 'Záboří',
    townCode: 551988,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38734,
    lat: 49.378898,
    long: 13.827052,
  },
  {
    town: 'Záboří nad Labem',
    townCode: 534595,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28574,
    lat: 50.025315,
    long: 15.349976,
  },
  {
    town: 'Zábrdí',
    townCode: 537195,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.028068,
    long: 13.939516,
  },
  {
    town: 'Zábrodí',
    townCode: 574651,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54941,
    lat: 50.459652,
    long: 16.11255,
  },
  {
    town: 'Zabrušany',
    townCode: 567868,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41771,
    lat: 50.605057,
    long: 13.787596,
  },
  {
    town: 'Zábřeh',
    townCode: 541354,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.8827,
    long: 16.872332,
  },
  {
    town: 'Zábřezí-Řečice',
    townCode: 548839,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.411359,
    long: 15.735635,
  },
  {
    town: 'Zadní Chodov',
    townCode: 541362,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34815,
    lat: 49.890602,
    long: 12.654668,
  },
  {
    town: 'Zadní Střítež',
    townCode: 563927,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.494184,
    long: 14.916811,
  },
  {
    town: 'Zadní Třebaň',
    townCode: 531979,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26729,
    lat: 49.918124,
    long: 14.208189,
  },
  {
    town: 'Zadní Vydří',
    townCode: 587231,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.134444,
    long: 15.417199,
  },
  {
    town: 'Zadní Zhořec',
    townCode: 597121,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.431175,
    long: 15.939309,
  },
  {
    town: 'Zádolí',
    townCode: 581194,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56601,
    lat: 49.903246,
    long: 16.127162,
  },
  {
    town: 'Zádub-Závišín',
    townCode: 539431,
    district: 'Cheb',
    lau: 'CZ0411',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 35301,
    lat: 49.971876,
    long: 12.744072,
  },
  {
    town: 'Zádveřice-Raková',
    townCode: 585998,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76312,
    lat: 49.216644,
    long: 17.805635,
  },
  {
    town: 'Zahájí',
    townCode: 536016,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37348,
    lat: 49.089687,
    long: 14.370905,
  },
  {
    town: 'Zahnašovice',
    townCode: 589152,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.304651,
    long: 17.560195,
  },
  {
    town: 'Zahorčice',
    townCode: 536482,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38719,
    lat: 49.208759,
    long: 13.817615,
  },
  {
    town: 'Záhornice',
    townCode: 534471,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28903,
    lat: 50.247737,
    long: 15.291028,
  },
  {
    town: 'Záhorovice',
    townCode: 592846,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68771,
    lat: 49.022764,
    long: 17.779332,
  },
  {
    town: 'Zahořany',
    townCode: 554464,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.434161,
    long: 13.002035,
  },
  {
    town: 'Zahořany',
    townCode: 571288,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25210,
    lat: 49.849446,
    long: 14.295423,
  },
  {
    town: 'Záhoří',
    townCode: 507695,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37821,
    lat: 49.212955,
    long: 14.798462,
  },
  {
    town: 'Záhoří',
    townCode: 550027,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39818,
    lat: 49.343828,
    long: 14.212649,
  },
  {
    town: 'Záhoří',
    townCode: 599000,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39165,
    lat: 49.239696,
    long: 14.513589,
  },
  {
    town: 'Záhoří',
    townCode: 577707,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51301,
    lat: 50.61161,
    long: 15.274194,
  },
  {
    town: 'Zahrádka',
    townCode: 591947,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67571,
    lat: 49.244522,
    long: 16.098416,
  },
  {
    town: 'Zahrádka',
    townCode: 578827,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33035,
    lat: 49.880856,
    long: 13.211746,
  },
  {
    town: 'Zahrádky',
    townCode: 547468,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37853,
    lat: 49.20085,
    long: 15.241907,
  },
  {
    town: 'Zahrádky',
    townCode: 562246,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47101,
    lat: 50.634208,
    long: 14.524708,
  },
  {
    town: 'Záchlumí',
    townCode: 581208,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56186,
    lat: 50.095447,
    long: 16.376348,
  },
  {
    town: 'Záchlumí',
    townCode: 541664,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.80022,
    long: 12.965032,
  },
  {
    town: 'Zachotín',
    townCode: 549177,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.462434,
    long: 15.347987,
  },
  {
    town: 'Zachrašťany',
    townCode: 571130,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.211244,
    long: 15.483086,
  },
  {
    town: 'Zaječí',
    townCode: 585050,
    district: 'Břeclav',
    lau: 'CZ0644',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69105,
    lat: 48.87305,
    long: 16.766566,
  },
  {
    town: 'Zaječice',
    townCode: 572578,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53835,
    lat: 49.910081,
    long: 15.884208,
  },
  {
    town: 'Zaječov',
    townCode: 531995,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26763,
    lat: 49.774455,
    long: 13.840825,
  },
  {
    town: 'Zájezd',
    townCode: 571598,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27343,
    lat: 50.166081,
    long: 14.220609,
  },
  {
    town: 'Zájezdec',
    townCode: 547859,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53851,
    lat: 49.931755,
    long: 15.926941,
  },
  {
    town: 'Zajíčkov',
    townCode: 561975,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.378057,
    long: 15.258087,
  },
  {
    town: 'Zákolany',
    townCode: 533092,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27328,
    lat: 50.196515,
    long: 14.247943,
  },
  {
    town: 'Zakřany',
    townCode: 584185,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.170641,
    long: 16.32536,
  },
  {
    town: 'Zákupy',
    townCode: 562262,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47123,
    lat: 50.684854,
    long: 14.645335,
  },
  {
    town: 'Zálesí',
    townCode: 595152,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67102,
    lat: 48.954232,
    long: 15.782156,
  },
  {
    town: 'Zálesná Zhoř',
    townCode: 584193,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.250286,
    long: 16.28985,
  },
  {
    town: 'Zalešany',
    townCode: 513202,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.03578,
    long: 15.007909,
  },
  {
    town: 'Zálezlice',
    townCode: 535354,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27745,
    lat: 50.307557,
    long: 14.438251,
  },
  {
    town: 'Zálezly',
    townCode: 550698,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38481,
    lat: 49.10755,
    long: 13.894683,
  },
  {
    town: 'Zaloňov',
    townCode: 574660,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55101,
    lat: 50.374068,
    long: 15.88795,
  },
  {
    town: 'Zálší',
    townCode: 553361,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.218022,
    long: 14.599292,
  },
  {
    town: 'Zálší',
    townCode: 581216,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 49.965363,
    long: 16.240831,
  },
  {
    town: 'Zalužany',
    townCode: 541613,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26284,
    lat: 49.542353,
    long: 14.085834,
  },
  {
    town: 'Záluží',
    townCode: 532002,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26761,
    lat: 49.842798,
    long: 13.860599,
  },
  {
    town: 'Záluží',
    townCode: 542482,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41301,
    lat: 50.460172,
    long: 14.32257,
  },
  {
    town: 'Zálužice',
    townCode: 530603,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.321307,
    long: 13.604272,
  },
  {
    town: 'Záměl',
    townCode: 576921,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51743,
    lat: 50.096649,
    long: 16.298906,
  },
  {
    town: 'Zámostí-Blata',
    townCode: 549193,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50601,
    lat: 50.470898,
    long: 15.264128,
  },
  {
    town: 'Zámrsk',
    townCode: 581224,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56543,
    lat: 49.986276,
    long: 16.128847,
  },
  {
    town: 'Zámrsky',
    townCode: 522775,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75301,
    lat: 49.50645,
    long: 17.827929,
  },
  {
    town: 'Zápy',
    townCode: 505781,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25001,
    lat: 50.1651,
    long: 14.680157,
  },
  {
    town: 'Zárubice',
    townCode: 591955,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67552,
    lat: 49.124327,
    long: 15.981536,
  },
  {
    town: 'Záryby',
    townCode: 535362,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27713,
    lat: 50.220678,
    long: 14.625983,
  },
  {
    town: 'Zářecká Lhota',
    townCode: 581232,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56501,
    lat: 49.993208,
    long: 16.246224,
  },
  {
    town: 'Záříčí',
    townCode: 589161,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76811,
    lat: 49.382726,
    long: 17.352936,
  },
  {
    town: 'Zásada',
    townCode: 563854,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46825,
    lat: 50.697784,
    long: 15.27004,
  },
  {
    town: 'Zásmuky',
    townCode: 533921,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28144,
    lat: 49.954806,
    long: 15.030686,
  },
  {
    town: 'Zastávka',
    townCode: 584207,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.188096,
    long: 16.363201,
  },
  {
    town: 'Zástřizly',
    townCode: 587257,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76805,
    lat: 49.149944,
    long: 17.23521,
  },
  {
    town: 'Zašová',
    townCode: 545236,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75651,
    lat: 49.474196,
    long: 18.044471,
  },
  {
    town: 'Zašovice',
    townCode: 591963,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67521,
    lat: 49.258337,
    long: 15.72578,
  },
  {
    town: 'Zátor',
    townCode: 597988,
    district: 'Bruntál',
    lau: 'CZ0801',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 79316,
    lat: 50.034227,
    long: 17.593061,
  },
  {
    town: 'Závada',
    townCode: 553492,
    district: 'Opava',
    lau: 'CZ0805',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74719,
    lat: 49.954135,
    long: 18.165759,
  },
  {
    town: 'Zavidov',
    townCode: 542601,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27035,
    lat: 50.056797,
    long: 13.620408,
  },
  {
    town: 'Závist',
    townCode: 586005,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67922,
    lat: 49.375272,
    long: 16.57215,
  },
  {
    town: 'Závišice',
    townCode: 568473,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74221,
    lat: 49.613357,
    long: 18.103114,
  },
  {
    town: 'Zavlekov',
    townCode: 557463,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34142,
    lat: 49.337465,
    long: 13.49054,
  },
  {
    town: 'Závraty',
    townCode: 599778,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37001,
    lat: 48.93815,
    long: 14.381608,
  },
  {
    town: 'Zbečno',
    townCode: 542610,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27024,
    lat: 50.0419,
    long: 13.920468,
  },
  {
    town: 'Zbelítov',
    townCode: 550035,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.456735,
    long: 14.329173,
  },
  {
    town: 'Zbenice',
    townCode: 564320,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26231,
    lat: 49.592261,
    long: 14.089159,
  },
  {
    town: 'Zběšičky',
    townCode: 550043,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39843,
    lat: 49.392605,
    long: 14.426574,
  },
  {
    town: 'Zbilidy',
    townCode: 588211,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58842,
    lat: 49.443804,
    long: 15.422783,
  },
  {
    town: 'Zbinohy',
    townCode: 588229,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58842,
    lat: 49.48738,
    long: 15.480494,
  },
  {
    town: 'Zbiroh',
    townCode: 560260,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.860345,
    long: 13.772729,
  },
  {
    town: 'Zbizuby',
    townCode: 534609,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28504,
    lat: 49.831085,
    long: 15.047665,
  },
  {
    town: 'Zblovice',
    townCode: 595161,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67107,
    lat: 48.957838,
    long: 15.70531,
  },
  {
    town: 'Zborov',
    townCode: 570338,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.943754,
    long: 16.835964,
  },
  {
    town: 'Zborovice',
    townCode: 589187,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76832,
    lat: 49.248989,
    long: 17.284751,
  },
  {
    town: 'Zborovy',
    townCode: 578312,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34034,
    lat: 49.381199,
    long: 13.515763,
  },
  {
    town: 'Zbožíčko',
    townCode: 599697,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28925,
    lat: 50.225835,
    long: 14.939922,
  },
  {
    town: 'Zbraslav',
    townCode: 584215,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66484,
    lat: 49.221653,
    long: 16.294251,
  },
  {
    town: 'Zbraslavec',
    townCode: 582727,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67972,
    lat: 49.483999,
    long: 16.528495,
  },
  {
    town: 'Zbraslavice',
    townCode: 534617,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28521,
    lat: 49.811891,
    long: 15.183296,
  },
  {
    town: 'Zbrašín',
    townCode: 566977,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.299412,
    long: 13.766026,
  },
  {
    town: 'Zbůch',
    townCode: 559661,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33022,
    lat: 49.678509,
    long: 13.225754,
  },
  {
    town: 'Zbuzany',
    townCode: 539872,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25225,
    lat: 50.024277,
    long: 14.286854,
  },
  {
    town: 'Zbyslavice',
    townCode: 568449,
    district: 'Ostrava-město',
    lau: 'CZ0806',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74283,
    lat: 49.805441,
    long: 18.075576,
  },
  {
    town: 'Zbýšov',
    townCode: 584223,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66411,
    lat: 49.155344,
    long: 16.349616,
  },
  {
    town: 'Zbýšov',
    townCode: 593699,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68352,
    lat: 49.131422,
    long: 16.80578,
  },
  {
    town: 'Zbýšov',
    townCode: 534625,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28565,
    lat: 49.811657,
    long: 15.353208,
  },
  {
    town: 'Zbytiny',
    townCode: 550701,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38441,
    lat: 48.942727,
    long: 13.978153,
  },
  {
    town: 'Zděchov',
    townCode: 545244,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75607,
    lat: 49.261068,
    long: 18.077943,
  },
  {
    town: 'Zdechovice',
    townCode: 573744,
    district: 'Hradec Králové',
    lau: 'CZ0521',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50401,
    lat: 50.224827,
    long: 15.56176,
  },
  {
    town: 'Zdechovice',
    townCode: 576026,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53311,
    lat: 50.013006,
    long: 15.46958,
  },
  {
    town: 'Zdelov',
    townCode: 576930,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51721,
    lat: 50.100779,
    long: 16.142255,
  },
  {
    town: 'Zdemyslice',
    townCode: 558583,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.607059,
    long: 13.519921,
  },
  {
    town: 'Zdeňkov',
    townCode: 588245,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.140036,
    long: 15.62007,
  },
  {
    town: 'Zderaz',
    townCode: 573876,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53944,
    lat: 49.828645,
    long: 16.100192,
  },
  {
    town: 'Zdětín',
    townCode: 590223,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79843,
    lat: 49.50595,
    long: 16.988886,
  },
  {
    town: 'Zdětín',
    townCode: 571814,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29471,
    lat: 50.312702,
    long: 14.812523,
  },
  {
    town: 'Zdiby',
    townCode: 539058,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25066,
    lat: 50.168096,
    long: 14.451284,
  },
  {
    town: 'Zdice',
    townCode: 532011,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26751,
    lat: 49.912178,
    long: 13.977574,
  },
  {
    town: 'Zdíkov',
    townCode: 550728,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38472,
    lat: 49.084672,
    long: 13.697479,
  },
  {
    town: 'Zdislava',
    townCode: 564541,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46353,
    lat: 50.765065,
    long: 14.876403,
  },
  {
    town: 'Zdislavice',
    townCode: 531022,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25764,
    lat: 49.686587,
    long: 14.974594,
  },
  {
    town: 'Zdobín',
    townCode: 548847,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54401,
    lat: 50.415397,
    long: 15.704708,
  },
  {
    town: 'Zdobnice',
    townCode: 576948,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51601,
    lat: 50.238579,
    long: 16.408683,
  },
  {
    town: 'Zdounky',
    townCode: 589195,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76802,
    lat: 49.227808,
    long: 17.319096,
  },
  {
    town: 'Zduchovice',
    townCode: 513512,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26263,
    lat: 49.638685,
    long: 14.209044,
  },
  {
    town: 'Zelená Hora',
    townCode: 593702,
    district: 'Vyškov',
    lau: 'CZ0646',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 68321,
    lat: 49.329083,
    long: 17.01382,
  },
  {
    town: 'Zelenecká Lhota',
    townCode: 573183,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50723,
    lat: 50.401703,
    long: 15.178861,
  },
  {
    town: 'Zeleneč',
    townCode: 539066,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25091,
    lat: 50.133721,
    long: 14.660805,
  },
  {
    town: 'Zemětice',
    townCode: 558591,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33452,
    lat: 49.578482,
    long: 13.186446,
  },
  {
    town: 'Zhoř',
    townCode: 550060,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39901,
    lat: 49.501316,
    long: 14.382796,
  },
  {
    town: 'Zhoř',
    townCode: 582735,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67923,
    lat: 49.414782,
    long: 16.47899,
  },
  {
    town: 'Zhoř',
    townCode: 588253,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58826,
    lat: 49.4427,
    long: 15.771449,
  },
  {
    town: 'Zhoř',
    townCode: 541460,
    district: 'Tachov',
    lau: 'CZ0327',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34901,
    lat: 49.660005,
    long: 12.969779,
  },
  {
    town: 'Zhoř u Mladé Vožice',
    townCode: 599034,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39143,
    lat: 49.5436,
    long: 14.764978,
  },
  {
    town: 'Zhoř u Tábora',
    townCode: 560430,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39002,
    lat: 49.357623,
    long: 14.657625,
  },
  {
    town: 'Zhořec',
    townCode: 561363,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.489741,
    long: 14.962556,
  },
  {
    town: 'Zichovec',
    townCode: 571423,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27374,
    lat: 50.271159,
    long: 13.926136,
  },
  {
    town: 'Zlámanec',
    townCode: 592854,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68712,
    lat: 49.129954,
    long: 17.628309,
  },
  {
    town: 'Zlatá',
    townCode: 513644,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25083,
    lat: 50.04033,
    long: 14.710148,
  },
  {
    town: 'Zlatá Koruna',
    townCode: 545864,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38202,
    lat: 48.854873,
    long: 14.369638,
  },
  {
    town: 'Zlatá Olešnice',
    townCode: 579866,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54101,
    lat: 50.61779,
    long: 15.944887,
  },
  {
    town: 'Zlatá Olešnice',
    townCode: 563862,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46847,
    lat: 50.708647,
    long: 15.353616,
  },
  {
    town: 'Zlaté Hory',
    townCode: 597996,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79376,
    lat: 50.263894,
    long: 17.396122,
  },
  {
    town: 'Zlátenka',
    townCode: 598666,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39501,
    lat: 49.423554,
    long: 15.058658,
  },
  {
    town: 'Zlatníky-Hodkovice',
    townCode: 539881,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25241,
    lat: 49.960627,
    long: 14.480805,
  },
  {
    town: 'Zlechov',
    townCode: 592862,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68710,
    lat: 49.074059,
    long: 17.379491,
  },
  {
    town: 'ZLÍN',
    townCode: 585068,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76001,
    lat: 49.224537,
    long: 17.662863,
  },
  {
    town: 'Zliv',
    townCode: 545341,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37344,
    lat: 49.066188,
    long: 14.366234,
  },
  {
    town: 'Zlobice',
    townCode: 589217,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76831,
    lat: 49.301917,
    long: 17.312714,
  },
  {
    town: 'Zlončice',
    townCode: 531511,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27801,
    lat: 50.228883,
    long: 14.35768,
  },
  {
    town: 'Zlonice',
    townCode: 533114,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27371,
    lat: 50.287603,
    long: 14.092247,
  },
  {
    town: 'Zlonín',
    townCode: 539082,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25064,
    lat: 50.215834,
    long: 14.507857,
  },
  {
    town: 'Zlosyň',
    townCode: 535389,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27744,
    lat: 50.278049,
    long: 14.368713,
  },
  {
    town: 'Zlukov',
    townCode: 599271,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.193033,
    long: 14.745188,
  },
  {
    town: 'Znětínek',
    townCode: 597139,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59444,
    lat: 49.469654,
    long: 15.926644,
  },
  {
    town: 'Znojmo',
    townCode: 593711,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66902,
    lat: 48.856011,
    long: 16.054368,
  },
  {
    town: 'Zruč nad Sázavou',
    townCode: 534633,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28522,
    lat: 49.740205,
    long: 15.106164,
  },
  {
    town: 'Zruč-Senec',
    townCode: 559679,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33008,
    lat: 49.8031,
    long: 13.419093,
  },
  {
    town: 'Zubčice',
    townCode: 545872,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.794137,
    long: 14.40728,
  },
  {
    town: 'Zubrnice',
    townCode: 568384,
    district: 'Ústí nad Labem',
    lau: 'CZ0427',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 40002,
    lat: 50.649558,
    long: 14.220493,
  },
  {
    town: 'Zubří',
    townCode: 597147,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59231,
    lat: 49.571209,
    long: 16.123791,
  },
  {
    town: 'Zubří',
    townCode: 545252,
    district: 'Vsetín',
    lau: 'CZ0723',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 75654,
    lat: 49.466126,
    long: 18.092595,
  },
  {
    town: 'Zvánovice',
    townCode: 539091,
    district: 'Praha-východ',
    lau: 'CZ0209',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25165,
    lat: 49.93205,
    long: 14.780336,
  },
  {
    town: 'Zvěrkovice',
    townCode: 591980,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67602,
    lat: 49.02563,
    long: 15.863268,
  },
  {
    town: 'Zvěrotice',
    townCode: 553409,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39201,
    lat: 49.272067,
    long: 14.744794,
  },
  {
    town: 'Zvěřínek',
    townCode: 534862,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28913,
    lat: 50.153287,
    long: 15.005845,
  },
  {
    town: 'Zvěstov',
    townCode: 531049,
    district: 'Benešov',
    lau: 'CZ0201',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25706,
    lat: 49.632768,
    long: 14.792228,
  },
  {
    town: 'Zvěstovice',
    townCode: 548626,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58282,
    lat: 49.848023,
    long: 15.512694,
  },
  {
    town: 'Zvíkov',
    townCode: 535591,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37372,
    lat: 48.980946,
    long: 14.617022,
  },
  {
    town: 'Zvíkov',
    townCode: 536237,
    district: 'Český Krumlov',
    lau: 'CZ0312',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38232,
    lat: 48.802632,
    long: 14.448859,
  },
  {
    town: 'Zvíkovec',
    townCode: 541061,
    district: 'Rokycany',
    lau: 'CZ0326',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33808,
    lat: 49.954183,
    long: 13.688647,
  },
  {
    town: 'Zvíkovské Podhradí',
    townCode: 562165,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39701,
    lat: 49.426678,
    long: 14.200666,
  },
  {
    town: 'Zvole',
    townCode: 597155,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59256,
    lat: 49.494545,
    long: 16.174948,
  },
  {
    town: 'Zvole',
    townCode: 541478,
    district: 'Šumperk',
    lau: 'CZ0715',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78901,
    lat: 49.839915,
    long: 16.914445,
  },
  {
    town: 'Zvole',
    townCode: 539902,
    district: 'Praha-západ',
    lau: 'CZ020A',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 25245,
    lat: 49.934765,
    long: 14.417796,
  },
  {
    town: 'Zvoleněves',
    townCode: 533122,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27325,
    lat: 50.231256,
    long: 14.182316,
  },
  {
    town: 'Zvolenovice',
    townCode: 588261,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58856,
    lat: 49.163385,
    long: 15.505675,
  },
  {
    town: 'Zvotoky',
    townCode: 536873,
    district: 'Strakonice',
    lau: 'CZ0316',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38716,
    lat: 49.212476,
    long: 13.757754,
  },
  {
    town: 'Žabčice',
    townCode: 584231,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66463,
    lat: 49.011697,
    long: 16.602677,
  },
  {
    town: 'Žabeň',
    townCode: 552691,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73925,
    lat: 49.708875,
    long: 18.304316,
  },
  {
    town: 'Žabonosy',
    townCode: 513261,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28002,
    lat: 50.035467,
    long: 15.027312,
  },
  {
    town: 'Žabovřesky',
    townCode: 545368,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37341,
    lat: 49.002908,
    long: 14.334957,
  },
  {
    town: 'Žabovřesky nad Ohří',
    townCode: 565938,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41002,
    lat: 50.413264,
    long: 14.091136,
  },
  {
    town: 'Žacléř',
    townCode: 579874,
    district: 'Trutnov',
    lau: 'CZ0525',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54201,
    lat: 50.663393,
    long: 15.91074,
  },
  {
    town: 'Žádovice',
    townCode: 586781,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69649,
    lat: 49.013463,
    long: 17.197031,
  },
  {
    town: 'Žákava',
    townCode: 530182,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33204,
    lat: 49.630078,
    long: 13.530832,
  },
  {
    town: 'Žákovice',
    townCode: 523453,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75354,
    lat: 49.454345,
    long: 17.660074,
  },
  {
    town: 'Žáky',
    townCode: 534641,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28601,
    lat: 49.885374,
    long: 15.3684,
  },
  {
    town: 'Žalany',
    townCode: 567876,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41763,
    lat: 50.59013,
    long: 13.906447,
  },
  {
    town: 'Žalhostice',
    townCode: 565946,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41101,
    lat: 50.523199,
    long: 14.091474,
  },
  {
    town: 'Žalkovice',
    townCode: 589225,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76823,
    lat: 49.372004,
    long: 17.436042,
  },
  {
    town: 'Žamberk',
    townCode: 581259,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.087401,
    long: 16.465301,
  },
  {
    town: 'Žampach',
    townCode: 581267,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56401,
    lat: 50.038071,
    long: 16.427306,
  },
  {
    town: 'Žandov',
    townCode: 562297,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47107,
    lat: 50.714039,
    long: 14.396344,
  },
  {
    town: 'Žár',
    townCode: 545376,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37401,
    lat: 48.806971,
    long: 14.708287,
  },
  {
    town: 'Žáravice',
    townCode: 576042,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53316,
    lat: 50.105854,
    long: 15.557217,
  },
  {
    town: 'Žarošice',
    townCode: 586790,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69634,
    lat: 49.040748,
    long: 16.967239,
  },
  {
    town: 'Žárovná',
    townCode: 529923,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.046302,
    long: 13.899419,
  },
  {
    town: 'Žatčany',
    townCode: 584240,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66453,
    lat: 49.087986,
    long: 16.733849,
  },
  {
    town: 'Žatec',
    townCode: 588270,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58862,
    lat: 49.206444,
    long: 15.509005,
  },
  {
    town: 'Žatec',
    townCode: 566985,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.327276,
    long: 13.545886,
  },
  {
    town: 'Ždánice',
    townCode: 586803,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69632,
    lat: 49.067387,
    long: 17.027619,
  },
  {
    town: 'Ždánice',
    townCode: 597163,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59301,
    lat: 49.54756,
    long: 16.262191,
  },
  {
    town: 'Ždánice',
    townCode: 513164,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28163,
    lat: 49.969517,
    long: 14.959179,
  },
  {
    town: 'Ždánov',
    townCode: 554472,
    district: 'Domažlice',
    lau: 'CZ0321',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34401,
    lat: 49.461029,
    long: 12.854517,
  },
  {
    town: 'Žďár',
    townCode: 529761,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37842,
    lat: 49.254193,
    long: 15.076662,
  },
  {
    town: 'Žďár',
    townCode: 598861,
    district: 'Písek',
    lau: 'CZ0314',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39811,
    lat: 49.233222,
    long: 14.227928,
  },
  {
    town: 'Žďár',
    townCode: 582743,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67902,
    lat: 49.421675,
    long: 16.697884,
  },
  {
    town: 'Žďár',
    townCode: 536971,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29412,
    lat: 50.543762,
    long: 15.080449,
  },
  {
    town: 'Žďár',
    townCode: 598518,
    district: 'Rakovník',
    lau: 'CZ020C',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27033,
    lat: 50.058554,
    long: 13.459724,
  },
  {
    town: 'Žďár nad Metují',
    townCode: 574686,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54955,
    lat: 50.538847,
    long: 16.213389,
  },
  {
    town: 'Žďár nad Orlicí',
    townCode: 576956,
    district: 'Rychnov nad Kněžnou',
    lau: 'CZ0524',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 51723,
    lat: 50.119855,
    long: 16.069446,
  },
  {
    town: 'Žďár nad Sázavou',
    townCode: 595209,
    district: 'Žďár nad Sázavou',
    lau: 'CZ0635',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 59101,
    lat: 49.564288,
    long: 15.939507,
  },
  {
    town: 'Žďárec',
    townCode: 597171,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 59456,
    lat: 49.379867,
    long: 16.266562,
  },
  {
    town: 'Žďárek',
    townCode: 544604,
    district: 'Liberec',
    lau: 'CZ0513',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46344,
    lat: 50.640548,
    long: 15.111598,
  },
  {
    town: 'Žďárky',
    townCode: 574694,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 54937,
    lat: 50.469046,
    long: 16.227922,
  },
  {
    town: 'Žďárná',
    townCode: 582751,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67952,
    lat: 49.468738,
    long: 16.758612,
  },
  {
    town: 'Ždírec',
    townCode: 530662,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58001,
    lat: 49.629262,
    long: 15.642039,
  },
  {
    town: 'Ždírec',
    townCode: 588288,
    district: 'Jihlava',
    lau: 'CZ0632',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58813,
    lat: 49.454999,
    long: 15.678575,
  },
  {
    town: 'Ždírec',
    townCode: 514195,
    district: 'Česká Lípa',
    lau: 'CZ0511',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 47201,
    lat: 50.515564,
    long: 14.624388,
  },
  {
    town: 'Ždírec',
    townCode: 558605,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33601,
    lat: 49.551092,
    long: 13.572958,
  },
  {
    town: 'Ždírec nad Doubravou',
    townCode: 569780,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58263,
    lat: 49.696057,
    long: 15.813706,
  },
  {
    town: 'Žebrák',
    townCode: 532029,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26753,
    lat: 49.875844,
    long: 13.897457,
  },
  {
    town: 'Žehuň',
    townCode: 538035,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28905,
    lat: 50.135585,
    long: 15.291395,
  },
  {
    town: 'Žehušice',
    townCode: 534650,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28575,
    lat: 49.969555,
    long: 15.407492,
  },
  {
    town: 'Želatovice',
    townCode: 523640,
    district: 'Přerov',
    lau: 'CZ0714',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 75116,
    lat: 49.444143,
    long: 17.506312,
  },
  {
    town: 'Želeč',
    townCode: 553417,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39174,
    lat: 49.318442,
    long: 14.646734,
  },
  {
    town: 'Želeč',
    townCode: 590240,
    district: 'Prostějov',
    lau: 'CZ0713',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79807,
    lat: 49.346065,
    long: 17.097896,
  },
  {
    town: 'Želechovice',
    townCode: 552399,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78391,
    lat: 49.754196,
    long: 17.144047,
  },
  {
    town: 'Želechovice nad Dřevnicí',
    townCode: 500011,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76311,
    lat: 49.218113,
    long: 17.747486,
  },
  {
    town: 'Želenice',
    townCode: 599425,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27341,
    lat: 50.210487,
    long: 14.164618,
  },
  {
    town: 'Želenice',
    townCode: 567426,
    district: 'Most',
    lau: 'CZ0425',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43401,
    lat: 50.527718,
    long: 13.726169,
  },
  {
    town: 'Želešice',
    townCode: 584266,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66443,
    lat: 49.116986,
    long: 16.581479,
  },
  {
    town: 'Želetava',
    townCode: 591998,
    district: 'Třebíč',
    lau: 'CZ0634',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 67526,
    lat: 49.141973,
    long: 15.673101,
  },
  {
    town: 'Želetice',
    townCode: 586811,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69637,
    lat: 49.014333,
    long: 17.008221,
  },
  {
    town: 'Želetice',
    townCode: 595179,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67134,
    lat: 48.936428,
    long: 16.182913,
  },
  {
    town: 'Železná',
    townCode: 599417,
    district: 'Beroun',
    lau: 'CZ0202',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26601,
    lat: 50.009803,
    long: 14.091043,
  },
  {
    town: 'Železná Ruda',
    townCode: 557528,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34004,
    lat: 49.137543,
    long: 13.235305,
  },
  {
    town: 'Železné',
    townCode: 584274,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66601,
    lat: 49.359718,
    long: 16.45055,
  },
  {
    town: 'Železnice',
    townCode: 573825,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50713,
    lat: 50.472837,
    long: 15.384697,
  },
  {
    town: 'Železný Brod',
    townCode: 563871,
    district: 'Jablonec nad Nisou',
    lau: 'CZ0512',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 46822,
    lat: 50.64284,
    long: 15.254186,
  },
  {
    town: 'Želiv',
    townCode: 549215,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39444,
    lat: 49.529938,
    long: 15.221912,
  },
  {
    town: 'Želivsko',
    townCode: 572195,
    district: 'Svitavy',
    lau: 'CZ0533',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56904,
    lat: 49.641253,
    long: 16.570083,
  },
  {
    town: 'Želízy',
    townCode: 535397,
    district: 'Mělník',
    lau: 'CZ0206',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27721,
    lat: 50.423837,
    long: 14.464874,
  },
  {
    town: 'Želkovice',
    townCode: 530565,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.464261,
    long: 13.876828,
  },
  {
    town: 'Želnava',
    townCode: 550761,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38451,
    lat: 48.812147,
    long: 13.965123,
  },
  {
    town: 'Ženklava',
    townCode: 568732,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74267,
    lat: 49.563672,
    long: 18.107297,
  },
  {
    town: 'Žeranovice',
    townCode: 589233,
    district: 'Kroměříž',
    lau: 'CZ0721',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76901,
    lat: 49.291574,
    long: 17.604528,
  },
  {
    town: 'Žeravice',
    townCode: 586820,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69647,
    lat: 49.022984,
    long: 17.23737,
  },
  {
    town: 'Žeraviny',
    townCode: 586838,
    district: 'Hodonín',
    lau: 'CZ0645',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 69663,
    lat: 48.908328,
    long: 17.391624,
  },
  {
    town: 'Žerčice',
    townCode: 536989,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29446,
    lat: 50.374263,
    long: 15.036019,
  },
  {
    town: 'Žeretice',
    townCode: 573833,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50702,
    lat: 50.353646,
    long: 15.411844,
  },
  {
    town: 'Žermanice',
    townCode: 568163,
    district: 'Frýdek-Místek',
    lau: 'CZ0802',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 73937,
    lat: 49.738583,
    long: 18.442932,
  },
  {
    town: 'Žernov',
    townCode: 574708,
    district: 'Náchod',
    lau: 'CZ0523',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 55203,
    lat: 50.430501,
    long: 16.05755,
  },
  {
    town: 'Žernov',
    townCode: 577723,
    district: 'Semily',
    lau: 'CZ0514',
    region: 'Liberecký kraj',
    nuts: 'CZ051',
    zip: 51263,
    lat: 50.556845,
    long: 15.26975,
  },
  {
    town: 'Žernovice',
    townCode: 537209,
    district: 'Prachatice',
    lau: 'CZ0315',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 38301,
    lat: 49.028655,
    long: 14.039648,
  },
  {
    town: 'Žernovník',
    townCode: 582760,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67921,
    lat: 49.407034,
    long: 16.545573,
  },
  {
    town: 'Žerotice',
    townCode: 595187,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67134,
    lat: 48.92681,
    long: 16.168847,
  },
  {
    town: 'Žerotín',
    townCode: 505862,
    district: 'Olomouc',
    lau: 'CZ0712',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 78401,
    lat: 49.724632,
    long: 17.186914,
  },
  {
    town: 'Žerotín',
    townCode: 543012,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 44001,
    lat: 50.286331,
    long: 13.912212,
  },
  {
    town: 'Žerůtky',
    townCode: 582778,
    district: 'Blansko',
    lau: 'CZ0641',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67971,
    lat: 49.440351,
    long: 16.536844,
  },
  {
    town: 'Žerůtky',
    townCode: 595195,
    district: 'Znojmo',
    lau: 'CZ0647',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 67151,
    lat: 48.906004,
    long: 15.963194,
  },
  {
    town: 'Židlochovice',
    townCode: 584282,
    district: 'Brno-venkov',
    lau: 'CZ0643',
    region: 'Jihomoravský kraj',
    nuts: 'CZ064',
    zip: 66701,
    lat: 49.039624,
    long: 16.618911,
  },
  {
    town: 'Židněves',
    townCode: 536997,
    district: 'Mladá Boleslav',
    lau: 'CZ0207',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 29406,
    lat: 50.41173,
    long: 14.994635,
  },
  {
    town: 'Židovice',
    townCode: 573841,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50732,
    lat: 50.295469,
    long: 15.32061,
  },
  {
    town: 'Židovice',
    townCode: 565954,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41183,
    lat: 50.446388,
    long: 14.233166,
  },
  {
    town: 'Žihle',
    townCode: 559695,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33165,
    lat: 50.04502,
    long: 13.37513,
  },
  {
    town: 'Žihobce',
    townCode: 557536,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.215645,
    long: 13.631095,
  },
  {
    town: 'Žichlínek',
    townCode: 581275,
    district: 'Ústí nad Orlicí',
    lau: 'CZ0534',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 56301,
    lat: 49.884005,
    long: 16.636393,
  },
  {
    town: 'Žichovice',
    townCode: 557544,
    district: 'Klatovy',
    lau: 'CZ0322',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 34201,
    lat: 49.267334,
    long: 13.627949,
  },
  {
    town: 'Žilina',
    townCode: 533149,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27301,
    lat: 50.099975,
    long: 14.005859,
  },
  {
    town: 'Žilov',
    townCode: 559709,
    district: 'Plzeň-sever',
    lau: 'CZ0325',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33011,
    lat: 49.840106,
    long: 13.313289,
  },
  {
    town: 'Žim',
    townCode: 567884,
    district: 'Teplice',
    lau: 'CZ0426',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41501,
    lat: 50.585066,
    long: 13.965364,
  },
  {
    town: 'Žimutice',
    townCode: 545384,
    district: 'České Budějovice',
    lau: 'CZ0311',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37366,
    lat: 49.20382,
    long: 14.510527,
  },
  {
    town: 'Žinkovy',
    townCode: 558630,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33554,
    lat: 49.483512,
    long: 13.489551,
  },
  {
    town: 'Žirov',
    townCode: 561908,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39301,
    lat: 49.464349,
    long: 15.323704,
  },
  {
    town: 'Žirovnice',
    townCode: 549231,
    district: 'Pelhřimov',
    lau: 'CZ0633',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 39468,
    lat: 49.253284,
    long: 15.18834,
  },
  {
    town: 'Žíšov',
    townCode: 563897,
    district: 'Tábor',
    lau: 'CZ0317',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 39181,
    lat: 49.200048,
    long: 14.69348,
  },
  {
    town: 'Žitenice',
    townCode: 565962,
    district: 'Litoměřice',
    lau: 'CZ0423',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 41141,
    lat: 50.555387,
    long: 14.156757,
  },
  {
    town: 'Žítková',
    townCode: 592871,
    district: 'Uherské Hradiště',
    lau: 'CZ0722',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 68774,
    lat: 48.980354,
    long: 17.880344,
  },
  {
    town: 'Žitovlice',
    townCode: 503410,
    district: 'Nymburk',
    lau: 'CZ0208',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28934,
    lat: 50.294076,
    long: 15.137094,
  },
  {
    town: 'Živanice',
    townCode: 576051,
    district: 'Pardubice',
    lau: 'CZ0532',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53342,
    lat: 50.062251,
    long: 15.644886,
  },
  {
    town: 'Životice',
    townCode: 540137,
    district: 'Plzeň-jih',
    lau: 'CZ0324',
    region: 'Plzeňský kraj',
    nuts: 'CZ032',
    zip: 33544,
    lat: 49.466586,
    long: 13.685301,
  },
  {
    town: 'Životice u Nového Jičína',
    townCode: 547000,
    district: 'Nový Jičín',
    lau: 'CZ0804',
    region: 'Moravskoslezský kraj',
    nuts: 'CZ080',
    zip: 74272,
    lat: 49.557223,
    long: 18.047353,
  },
  {
    town: 'Žiželice',
    townCode: 533947,
    district: 'Kolín',
    lau: 'CZ0204',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28129,
    lat: 50.132019,
    long: 15.393302,
  },
  {
    town: 'Žiželice',
    townCode: 567019,
    district: 'Louny',
    lau: 'CZ0424',
    region: 'Ústecký kraj',
    nuts: 'CZ042',
    zip: 43801,
    lat: 50.367513,
    long: 13.540101,
  },
  {
    town: 'Žižice',
    townCode: 533157,
    district: 'Kladno',
    lau: 'CZ0203',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 27401,
    lat: 50.246382,
    long: 14.154001,
  },
  {
    town: 'Žižkovo Pole',
    townCode: 569801,
    district: 'Havlíčkův Brod',
    lau: 'CZ0631',
    region: 'Kraj Vysočina',
    nuts: 'CZ063',
    zip: 58222,
    lat: 49.610734,
    long: 15.735236,
  },
  {
    town: 'Žlebské Chvalovice',
    townCode: 574091,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53843,
    lat: 49.892807,
    long: 15.566816,
  },
  {
    town: 'Žleby',
    townCode: 534668,
    district: 'Kutná Hora',
    lau: 'CZ0205',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 28561,
    lat: 49.889685,
    long: 15.488634,
  },
  {
    town: 'Žlunice',
    townCode: 573850,
    district: 'Jičín',
    lau: 'CZ0522',
    region: 'Královéhradecký kraj',
    nuts: 'CZ052',
    zip: 50734,
    lat: 50.30222,
    long: 15.382081,
  },
  {
    town: 'Žlutava',
    townCode: 586013,
    district: 'Zlín',
    lau: 'CZ0724',
    region: 'Zlínský kraj',
    nuts: 'CZ072',
    zip: 76361,
    lat: 49.199857,
    long: 17.49048,
  },
  {
    town: 'Žlutice',
    townCode: 555762,
    district: 'Karlovy Vary',
    lau: 'CZ0412',
    region: 'Karlovarský kraj',
    nuts: 'CZ041',
    zip: 36452,
    lat: 50.092028,
    long: 13.163084,
  },
  {
    town: 'Žulová',
    townCode: 541575,
    district: 'Jeseník',
    lau: 'CZ0711',
    region: 'Olomoucký kraj',
    nuts: 'CZ071',
    zip: 79065,
    lat: 50.30943,
    long: 17.098814,
  },
  {
    town: 'Žumberk',
    townCode: 572641,
    district: 'Chrudim',
    lau: 'CZ0531',
    region: 'Pardubický kraj',
    nuts: 'CZ053',
    zip: 53836,
    lat: 49.873077,
    long: 15.858205,
  },
  {
    town: 'Županovice',
    townCode: 562424,
    district: 'Jindřichův Hradec',
    lau: 'CZ0313',
    region: 'Jihočeský kraj',
    nuts: 'CZ031',
    zip: 37881,
    lat: 48.957211,
    long: 15.506224,
  },
  {
    town: 'Županovice',
    townCode: 564338,
    district: 'Příbram',
    lau: 'CZ020B',
    region: 'Středočeský kraj',
    nuts: 'CZ020',
    zip: 26301,
    lat: 49.707893,
    long: 14.298816,
  },
];

export type TownCode = typeof townCodes[number];
